webpackJsonp([4],{

/***/ "+1+X":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var _default = {
  ENTER_ENTITY: 'map/ENTER_ENTITY',
  LEAVE_ENTITY: 'map/LEAVE_ENTITY',
  UNSET_HOVER_STATE: 'map/UNSET_HOVER_STATE',
  SET_BOUNDS: 'map/SET_BOUNDS',
  SET_ALL_FEATURE_BOUNDS: 'map/SET_ALL_FEATURE_BOUNDS',
  SET_CENTER: 'map/SET_CENTER',
  OPEN_MAP_PANEL: 'map/OPEN_MAP_PANEL',
  CLOSE_MAP_PANEL: 'map/CLOSE_MAP_PANEL',
  SET_VIEW_MODE: 'map/SET_VIEW_MODE'
};
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_default, 'default', '/code/src/state/ducks/map/types.js');
}();

;

/***/ }),

/***/ "+1dm":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"statusItem":"location-tooltip-statusItem--2c7GS","statusText":"location-tooltip-statusText--2HcDC","batteryContainer":"location-tooltip-batteryContainer--1ZNqO","batteryIcon":"location-tooltip-batteryIcon--m7F8V"};

/***/ }),

/***/ "+EKX":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SVG = function (_React$Component) {
  _inherits(SVG, _React$Component);

  function SVG() {
    _classCallCheck(this, SVG);

    return _possibleConstructorReturn(this, (SVG.__proto__ || Object.getPrototypeOf(SVG)).apply(this, arguments));
  }

  _createClass(SVG, [{
    key: "render",
    value: function render() {
      return _react2.default.createElement(
        "svg",
        _extends({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 126", fill: "currentColor" }, this.props),
        _react2.default.createElement("path", { className: "st0", d: "M32 3.5h-3V1H0v16h29v-2.5h3v-11zM28 16H1V2h27v14zm3-2.5h-2v-9h2v9z" }),
        _react2.default.createElement("path", { className: "st0", d: "M3 4h3v10H3zm4 0h3v10H7zm4 0h3v10h-3zm4 0h3v10h-3zm4 0h3v10h-3zm4 0h3v10h-3zm9 17.5h-3V19H0v16h29v-2.5h3v-11zM28 34H1V20h27v14zm3-2.5h-2v-9h2v9z" }),
        _react2.default.createElement("path", { className: "st0", d: "M3 22h3v10H3zm4 0h3v10H7zm4 0h3v10h-3zm4 0h3v10h-3zm4 0h3v10h-3zm13 35.5h-3V55H0v16h29v-2.5h3v-11zM28 70H1V56h27v14zm3-2.5h-2v-9h2v9z" }),
        _react2.default.createElement("path", { className: "st0", d: "M3 58h3v10H3zm4 0h3v10H7zm4 0h3v10h-3zm21 17.5h-3V73H0v16h29v-2.5h3v-11zM28 88H1V74h27v14zm3-2.5h-2v-9h2v9z" }),
        _react2.default.createElement("path", { className: "st0", d: "M3 76h3v10H3zm4 0h3v10H7zm25 17.5h-3V91H0v16h29v-2.5h3v-11zM28 106H1V92h27v14zm3-2.5h-2v-9h2v9z" }),
        _react2.default.createElement("path", { className: "st0", d: "M3 94h3v10H3zm26 17.5V109H0v16h29v-2.5h3v-11h-3zm-1 0V124H1v-14h27v1.5zm3 10h-2v-9h2v9zM32 39.5h-3V37H0v16h29v-2.5h3v-11zM28 52H1V38h27v14zm3-2.5h-2v-9h2v9z" }),
        _react2.default.createElement("path", { className: "st0", d: "M3 40h3v10H3zm4 0h3v10H7zm4 0h3v10h-3zm4 0h3v10h-3z" })
      );
    }
  }]);

  return SVG;
}(_react2.default.Component);

var _default = SVG;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(SVG, "SVG", "/code/src/icons/battery.sprite.inline.svg");

  __REACT_HOT_LOADER__.register(_default, "default", "/code/src/icons/battery.sprite.inline.svg");
}();

;

/***/ }),

/***/ "+NKF":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = PathSuggestionTooltip;

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _Tooltip = __webpack_require__("lhKr");

var _Tooltip2 = _interopRequireDefault(_Tooltip);

var _TooltipItem = __webpack_require__("my8f");

var _TooltipItem2 = _interopRequireDefault(_TooltipItem);

var _formatFloat = __webpack_require__("MyD5");

var _formatFloat2 = _interopRequireDefault(_formatFloat);

var _formatMinutesSeconds = __webpack_require__("/rNx");

var _formatMinutesSeconds2 = _interopRequireDefault(_formatMinutesSeconds);

var _segmentTooltip = __webpack_require__("UitP");

var _segmentTooltip2 = _interopRequireDefault(_segmentTooltip);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function PathSuggestionTooltip(_ref) {
  var distance = _ref.distance,
      expectedTravelTime = _ref.expectedTravelTime;

  /*
   * @TODO Put this in a helper function or use a library to do this kind of stuff.
   * Even better, we could do this conversion in GraphQL
   */
  var distanceInMiles = distance * 0.000621371;
  return _react2.default.createElement(
    _Tooltip2.default,
    { sticky: true, offset: [5, -10], className: _segmentTooltip2.default.main },
    _react2.default.createElement(
      'div',
      { className: _segmentTooltip2.default.distance },
      _react2.default.createElement(
        _TooltipItem2.default,
        { label: 'distance' },
        (0, _formatFloat2.default)(distanceInMiles) + ' miles'
      )
    ),
    _react2.default.createElement(
      _TooltipItem2.default,
      { label: 'travel time' },
      (0, _formatMinutesSeconds2.default)(expectedTravelTime)
    )
  );
}

PathSuggestionTooltip.propTypes = {
  distance: _propTypes.number.isRequired,
  expectedTravelTime: _propTypes.number.isRequired
};
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(PathSuggestionTooltip, 'PathSuggestionTooltip', '/code/src/components/Map/CreateSegment/PathSuggestionTooltip/index.js');
}();

;

/***/ }),

/***/ "+e/g":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n  query CreateSegmentMap {\n    locations {\n      id\n      lat\n      lng\n      name\n      trackingDevice {\n        id\n        name\n        status\n        batteryVoltage\n        temperature\n        reportInterval\n        lastUpdate\n        numberOfHitsToday\n      }\n    }\n    segments {\n      id\n      path\n      bounds\n      from {\n        id\n        name\n      }\n      to {\n        id\n        name\n      }\n    }\n  }\n'], ['\n  query CreateSegmentMap {\n    locations {\n      id\n      lat\n      lng\n      name\n      trackingDevice {\n        id\n        name\n        status\n        batteryVoltage\n        temperature\n        reportInterval\n        lastUpdate\n        numberOfHitsToday\n      }\n    }\n    segments {\n      id\n      path\n      bounds\n      from {\n        id\n        name\n      }\n      to {\n        id\n        name\n      }\n    }\n  }\n']);

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _reactApollo = __webpack_require__("3zLD");

var _reactRedux = __webpack_require__("RH2O");

var _segmentCreation = __webpack_require__("ZaDe");

var _map = __webpack_require__("YByT");

var _locationShape = __webpack_require__("1itO");

var _locationShape2 = _interopRequireDefault(_locationShape);

var _coord = __webpack_require__("w0mN");

var _coord2 = _interopRequireDefault(_coord);

var _LoadingIndicator = __webpack_require__("G+3p");

var _LoadingIndicator2 = _interopRequireDefault(_LoadingIndicator);

var _filterAvailableLocations = __webpack_require__("xM1A");

var _filterAvailableLocations2 = _interopRequireDefault(_filterAvailableLocations);

var _LocationMarkerGroup = __webpack_require__("3U6A");

var _LocationMarkerGroup2 = _interopRequireDefault(_LocationMarkerGroup);

var _SegmentGroup = __webpack_require__("Yu6W");

var _SegmentGroup2 = _interopRequireDefault(_SegmentGroup);

var _CreateSegment = __webpack_require__("nvBr");

var _CreateSegment2 = _interopRequireDefault(_CreateSegment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var CreateSegmentMapQuery = (0, _reactApollo.gql)(_templateObject);

var CreateSegmentMap = function (_Component) {
  _inherits(CreateSegmentMap, _Component);

  function CreateSegmentMap() {
    _classCallCheck(this, CreateSegmentMap);

    return _possibleConstructorReturn(this, (CreateSegmentMap.__proto__ || Object.getPrototypeOf(CreateSegmentMap)).apply(this, arguments));
  }

  _createClass(CreateSegmentMap, [{
    key: 'componentWillUpdate',
    value: function componentWillUpdate(nextProps) {
      var locations = nextProps.data.locations,
          setAllFeatureBounds = nextProps.setAllFeatureBounds;

      /* only update bounds on first data render */

      if (this.props.data.loading && !nextProps.loading) {
        var bounds = locations.reduce(function (acc, v) {
          return [].concat(_toConsumableArray(acc), [[v.lat, v.lng]]);
        }, []);
        setAllFeatureBounds(bounds);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          _props$data = _props.data,
          loading = _props$data.loading,
          locations = _props$data.locations,
          segments = _props$data.segments,
          pathSuggestions = _props.pathSuggestions,
          selectedPathSuggestion = _props.selectedPathSuggestion,
          createdSegmentId = _props.createdSegmentId,
          selectedLocations = _props.selectedLocations;


      if (loading) {
        return _react2.default.createElement(_LoadingIndicator2.default, null);
      }

      var showPathSuggestions = Boolean(pathSuggestions && pathSuggestions.length > 0);
      var isFlowFinished = Boolean(createdSegmentId);

      // These locations should be allowed to receive click events
      var validNextLocations = (0, _filterAvailableLocations2.default)(locations, segments, selectedLocations);

      return _react2.default.createElement(
        'div',
        { className: _CreateSegment2.default.main },
        _react2.default.createElement(_LocationMarkerGroup2.default, {
          locations: locations,
          disableInteraction: isFlowFinished,
          validNextLocations: validNextLocations
        }),
        _react2.default.createElement(_SegmentGroup2.default, {
          segments: segments,
          showPathSuggestions: showPathSuggestions,
          pathSuggestions: Boolean(pathSuggestions) && pathSuggestions,
          selectedPathSuggestion: Boolean(selectedPathSuggestion) && selectedPathSuggestion,
          disableInteraction: isFlowFinished
        })
      );
    }
  }]);

  return CreateSegmentMap;
}(_react.Component);

CreateSegmentMap.propTypes = {
  data: (0, _propTypes.shape)({
    loading: _propTypes.bool.isRequired,
    locations: (0, _propTypes.arrayOf)(_locationShape2.default),
    segments: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
      id: _propTypes.string,
      path: (0, _propTypes.arrayOf)(_coord2.default),
      from: _locationShape2.default,
      to: _locationShape2.default
    }))
  }).isRequired,
  pathSuggestions: (0, _propTypes.arrayOf)((0, _propTypes.shape)({})),
  selectedPathSuggestion: (0, _propTypes.shape)({ id: _propTypes.string }),
  createdSegmentId: _propTypes.string,
  selectedLocations: (0, _propTypes.arrayOf)(_propTypes.string)
};

var mapStateToProps = function mapStateToProps(_ref) {
  var map = _ref.map,
      segmentCreation = _ref.segmentCreation;
  return {
    viewMode: map.viewMode,
    selectedLocations: segmentCreation.selectedLocations,
    pathSuggestions: segmentCreation.pathSuggestions,
    createdSegmentId: segmentCreation.createdSegmentId,
    selectedPathSuggestion: segmentCreation.selectedPathSuggestion
  };
};

var ConnectedCreateSegmentMapWithData = (0, _reactApollo.compose)((0, _reactRedux.connect)(mapStateToProps, _extends({}, _map.operations, _segmentCreation.operations)), (0, _reactApollo.graphql)(CreateSegmentMapQuery, {}))(CreateSegmentMap);

var _default = ConnectedCreateSegmentMapWithData;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(CreateSegmentMapQuery, 'CreateSegmentMapQuery', '/code/src/components/Map/CreateSegment/index.js');

  __REACT_HOT_LOADER__.register(CreateSegmentMap, 'CreateSegmentMap', '/code/src/components/Map/CreateSegment/index.js');

  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/code/src/components/Map/CreateSegment/index.js');

  __REACT_HOT_LOADER__.register(ConnectedCreateSegmentMapWithData, 'ConnectedCreateSegmentMapWithData', '/code/src/components/Map/CreateSegment/index.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/code/src/components/Map/CreateSegment/index.js');
}();

;

/***/ }),

/***/ "+vyF":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SVG = function (_React$Component) {
  _inherits(SVG, _React$Component);

  function SVG() {
    _classCallCheck(this, SVG);

    return _possibleConstructorReturn(this, (SVG.__proto__ || Object.getPrototypeOf(SVG)).apply(this, arguments));
  }

  _createClass(SVG, [{
    key: "render",
    value: function render() {
      return _react2.default.createElement(
        "svg",
        _extends({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 14 91", fill: "currentColor" }, this.props),
        _react2.default.createElement("path", { d: "M3.2 0L0 3.3v11.3l7 6.7 7-6.7V0zM4.8 39.4L3 41.3v6.4l4 3.8 4-3.8v-8.3H4.8zM3.2 69.1L0 72.4v11.3l7 6.7 7-6.7V69.1zM6 25.4h2v10H6zM6 55.4h2v10H6z" })
      );
    }
  }]);

  return SVG;
}(_react2.default.Component);

var _default = SVG;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(SVG, "SVG", "/code/src/icons/panel-route.inline.svg");

  __REACT_HOT_LOADER__.register(_default, "default", "/code/src/icons/panel-route.inline.svg");
}();

;

/***/ }),

/***/ "/4Jr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"main":"tooltip-item-main--3AUU8","status-ok":"tooltip-item-status-ok--1SeoY","status-warning":"tooltip-item-status-warning--1egbC","status-problem":"tooltip-item-status-problem--MRf5q","status-disconnected":"tooltip-item-status-disconnected--1D1UQ","isLocation":"tooltip-item-isLocation--jHq3R","label":"tooltip-item-label--1lRg9","content":"tooltip-item-content--26FQA"};

/***/ }),

/***/ "/De5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SVG = function (_React$Component) {
  _inherits(SVG, _React$Component);

  function SVG() {
    _classCallCheck(this, SVG);

    return _possibleConstructorReturn(this, (SVG.__proto__ || Object.getPrototypeOf(SVG)).apply(this, arguments));
  }

  _createClass(SVG, [{
    key: "render",
    value: function render() {
      return _react2.default.createElement(
        "svg",
        _extends({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 97 21.8", fill: "currentColor" }, this.props),
        _react2.default.createElement(
          "title",
          null,
          "bluecyber"
        ),
        _react2.default.createElement("path", { d: "M0 15.2V.4C0 .2.2 0 .4 0h2.1c.2 0 .4.2.4.4v5.1c.4-.6.8-1 1.4-1.4.6-.3 1.2-.5 2-.5s1.5.2 2 .5 1.1.8 1.4 1.3c.4.5.7 1.2.8 2s.3 1.5.3 2.4c0 .9-.1 1.7-.3 2.4-.2.7-.5 1.4-.8 1.9-.4.6-.9 1-1.4 1.3-.6.3-1.3.5-2 .5-.8 0-1.5-.2-2-.5-.6-.3-1-.8-1.4-1.4v1.2c0 .2-.2.4-.4.4H.4c-.2 0-.4-.2-.4-.4zm2.9-4.6c0 .9.2 1.7.6 2.2.4.5 1.1.8 2 .8.7 0 1.3-.2 1.8-.6.4-.4.6-1 .6-1.6V8.1c0-.7-.2-1.2-.6-1.6-.4-.4-1-.6-1.8-.6-.9 0-1.6.3-2 .8-.4.5-.6 1.3-.6 2.2v1.7zm10 4.6V.4c0-.2.2-.4.4-.4h2.1c.2 0 .4.2.4.4v14.8c0 .2-.2.4-.4.4h-2.1c-.2 0-.4-.2-.4-.4zm5.4-3.6V4.3c0-.2.2-.4.4-.4h2.1c.2 0 .4.2.4.4v7c0 .7.1 1.2.4 1.6.3.4.7.6 1.4.6.8 0 1.4-.3 1.8-.8.4-.5.7-1.2.7-2.1V4.3c0-.2.2-.4.4-.4H28c.2 0 .4.2.4.4v10.9c0 .2-.2.4-.4.4h-2.1c-.2 0-.4-.2-.4-.4v-1.3c-.4.6-.8 1.1-1.4 1.5-.6.3-1.3.5-2.1.5-1.3 0-2.2-.4-2.8-1.1-.6-.8-.9-1.9-.9-3.2zm24-1.8c0-1 .1-1.8.4-2.6.2-.8.6-1.4 1.1-2 .5-.5 1-.9 1.7-1.2.6-.3 1.4-.4 2.2-.4.6 0 1.2.1 1.8.2.6.2 1.1.4 1.5.8.5.3.8.8 1.1 1.3.2.4.4.9.5 1.4 0 .3-.1.5-.4.5h-2c-.2 0-.4-.1-.4-.3-.1-.6-.3-1-.6-1.2-.7-.3-1.2-.4-1.8-.4-.6 0-1.1.2-1.5.6-.4.4-.6.9-.6 1.7v3.2c0 .7.2 1.3.6 1.7.4.4.9.6 1.6.6.6 0 1.2-.2 1.5-.5.3-.3.5-.7.6-1.3 0-.2.2-.3.4-.3h2c.3 0 .4.2.4.5-.1.5-.2 1-.5 1.4-.3.5-.6 1-1.1 1.3-.4.4-1 .6-1.5.8-.6.2-1.2.3-1.8.3-.9 0-1.6-.1-2.3-.4-.7-.3-1.2-.7-1.7-1.2s-.8-1.2-1-1.9c-.1-.8-.2-1.7-.2-2.6zm13.3 11.4l1.9-5.6-4-11.2c-.1-.3.1-.5.4-.5H56c.2 0 .3.1.4.3l2.5 8.1h.1l2.5-8.1c.1-.2.2-.3.4-.3H64c.3 0 .5.3.4.5l-5.8 17c-.1.2-.2.3-.4.3H56c-.3.1-.5-.2-.4-.5zm10.3-6V.4c0-.2.2-.4.4-.4h2.1c.2 0 .4.2.4.4v5.1c.4-.6.8-1 1.4-1.4.6-.3 1.2-.5 2-.5s1.5.2 2 .5c.6.3 1.1.8 1.4 1.3.4.5.7 1.2.8 2 .2.8.3 1.5.3 2.4 0 .9-.1 1.7-.3 2.4-.2.7-.5 1.4-.8 1.9-.4.6-.9 1-1.4 1.3-.6.3-1.3.5-2 .5-.8 0-1.5-.2-2-.5-.6-.3-1-.8-1.4-1.4v1.2c0 .2-.2.4-.4.4h-2.1c-.2 0-.4-.2-.4-.4zm2.9-4.6c0 .9.2 1.7.6 2.2.4.5 1.1.8 2 .8.7 0 1.3-.2 1.8-.6.4-.4.6-1 .6-1.6V8.1c0-.7-.2-1.2-.6-1.6-.4-.4-1-.6-1.8-.6-.9 0-1.6.3-2 .8-.4.5-.6 1.3-.6 2.2v1.7zm-30.4 1.5c-.2-.1-.5 0-.6.2-.1.4-.3.7-.6.9-.4.3-.9.5-1.5.5s-1.2-.2-1.6-.6c-.5-.4-.7-.9-.7-1.6v-.8h7.1c.2 0 .4-.2.4-.4v-1c0-.8-.1-1.5-.4-2.2-.2-.7-.6-1.3-1.1-1.8-.5-.5-1-.9-1.7-1.2-.6-.3-1.4-.4-2.2-.4-.8 0-1.5.1-2.2.4-.6.3-1.2.7-1.7 1.2s-.8 1.2-1.1 1.9c-.3.8-.4 1.6-.4 2.5 0 .9.1 1.8.4 2.5.2.8.6 1.4 1 1.9.5.5 1 1 1.7 1.3.7.3 1.4.4 2.2.4 1.4 0 2.6-.4 3.5-1.1.5-.4.9-.9 1.2-1.4.1-.2 0-.5-.2-.6l-1.5-.6zm-5-4.1c0-.6.2-1.2.7-1.6.4-.4 1-.6 1.6-.6.7 0 1.2.2 1.7.6.4.5.6 1 .6 1.6v.4h-4.6V8zm52.9 4.1c-.2-.1-.5 0-.6.2-.1.4-.3.7-.6.9-.4.3-.9.5-1.5.5s-1.2-.2-1.6-.6c-.5-.4-.7-.9-.7-1.6v-.8h7.1c.2 0 .4-.2.4-.4v-1c0-.8-.1-1.5-.4-2.2-.2-.7-.6-1.3-1.1-1.8-.5-.5-1-.9-1.7-1.2-.6-.3-1.4-.4-2.2-.4-.8 0-1.5.1-2.2.4-.6.3-1.2.7-1.7 1.2s-.8 1.2-1.1 1.9c-.3.8-.4 1.6-.4 2.5 0 .9.1 1.8.4 2.5.2.8.6 1.4 1 1.9.5.5 1 1 1.7 1.3.7.3 1.4.4 2.2.4 1.4 0 2.6-.4 3.5-1.1.5-.4.9-.9 1.2-1.4.1-.2 0-.5-.2-.6l-1.5-.6zm-5-4.1c0-.6.2-1.2.7-1.6.4-.4 1-.6 1.6-.6.7 0 1.2.2 1.7.6.4.4.7.9.7 1.6v.4h-4.6V8zm15.3-4.1h-4.8l-1.3 1.7v9.6c0 .2.2.4.4.4H93c.2 0 .4-.2.4-.4v-9h3.3c.1 0 .3-.2.3-.5V4.3c0-.2-.2-.4-.4-.4z" })
      );
    }
  }]);

  return SVG;
}(_react2.default.Component);

var _default = SVG;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(SVG, "SVG", "/code/src/icons/bluecyber-wordmark.inline.svg");

  __REACT_HOT_LOADER__.register(_default, "default", "/code/src/icons/bluecyber-wordmark.inline.svg");
}();

;

/***/ }),

/***/ "/rNx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = formatMinutesSeconds;
/*
Because this function is used internally by DaysHoursMinutesSeconds, that one
could be used anywhere instead of this function, but I'll leave it for clearity.

These time formating functions would eventually be replaced with some library
probably. For now they are lean and simple.

@TODO Look into alternatives someday.
*/
function formatAsText(minutes, seconds) {
  if (minutes === 0) {
    return seconds + ' sec';
  }
  return minutes + ' min';
}

function formatAsClock(minutes, seconds) {
  var minutesStr = '' + minutes;
  var secondsStr = '' + seconds;

  // return `${minutesStr.padStart(2, '0')}:${secondsStr.padStart(2, '0')}`;
  return minutesStr + ':' + secondsStr.padStart(2, '0');
}

function formatMinutesSeconds(seconds) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var useClockFormat = options.useClockFormat;

  var minutes = Math.floor(seconds / 60);
  var remainingSeconds = Math.floor(seconds - minutes * 60);

  return useClockFormat ? formatAsClock(minutes, remainingSeconds) : formatAsText(minutes, remainingSeconds);
}
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(formatAsText, 'formatAsText', '/code/src/helpers/formatMinutesSeconds.js');

  __REACT_HOT_LOADER__.register(formatAsClock, 'formatAsClock', '/code/src/helpers/formatMinutesSeconds.js');

  __REACT_HOT_LOADER__.register(formatMinutesSeconds, 'formatMinutesSeconds', '/code/src/helpers/formatMinutesSeconds.js');
}();

;

/***/ }),

/***/ "/vAk":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reducers = __webpack_require__("EAeD");

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_reducers).default;
  }
});

var _types = __webpack_require__("37Gh");

Object.defineProperty(exports, 'types', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_types).default;
  }
});

var _selectors = __webpack_require__("l2jl");

Object.defineProperty(exports, 'selectors', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_selectors).default;
  }
});

var _operations = __webpack_require__("Rb1U");

Object.defineProperty(exports, 'operations', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_operations).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }
}();

;

/***/ }),

/***/ "/x1K":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RoutesListItem = RoutesListItem;

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__("RH2O");

var _propTypes = __webpack_require__("KSGD");

var _classnames = __webpack_require__("HW6M");

var _classnames2 = _interopRequireDefault(_classnames);

var _RouteNameDisplay = __webpack_require__("Re8b");

var _RouteNameDisplay2 = _interopRequireDefault(_RouteNameDisplay);

var _Trendline = __webpack_require__("cH2h");

var _Trendline2 = _interopRequireDefault(_Trendline);

var _NumberDisplay = __webpack_require__("EUU4");

var _NumberDisplay2 = _interopRequireDefault(_NumberDisplay);

var _SpeedDisplay = __webpack_require__("g7vI");

var _SpeedDisplay2 = _interopRequireDefault(_SpeedDisplay);

var _SpeedTrendIcon = __webpack_require__("sCW4");

var _SpeedTrendIcon2 = _interopRequireDefault(_SpeedTrendIcon);

var _RoutesListItem = __webpack_require__("an/p");

var _RoutesListItem2 = _interopRequireDefault(_RoutesListItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function RoutesListItem(_ref) {
  var route = _ref.route,
      sortValue = _ref.sortValue,
      currentHover = _ref.currentHover;
  var from = route.from,
      to = route.to,
      status = route.status,
      speedLastHour = route.speedLastHour,
      liveSpeed = route.liveSpeed,
      travelTimeIndex = route.travelTimeIndex;

  var isReporting = status !== 'disconnected';

  var travelTimeLastHour = speedLastHour.map(function (v) {
    return -v;
  });
  var speedTrend = 'up';

  var isHovered = Boolean(currentHover && currentHover.id === route.id);

  return _react2.default.createElement(
    'div',
    { className: (0, _classnames2.default)(_RoutesListItem2.default.main, _RoutesListItem2.default['status-' + status]) },
    _react2.default.createElement(
      'div',
      { className: _RoutesListItem2.default.liveDisplay },
      isReporting ? _react2.default.createElement(_SpeedTrendIcon2.default, { trend: speedTrend, className: _RoutesListItem2.default.trendIcon }) : _react2.default.createElement(
        'div',
        { className: _RoutesListItem2.default.statusText },
        'N/A'
      )
    ),
    _react2.default.createElement(_RouteNameDisplay2.default, {
      className: _RoutesListItem2.default.route,
      fromLocationName: from.name,
      toLocationName: to.name,
      status: status
    }),
    _react2.default.createElement(
      'div',
      { className: _RoutesListItem2.default.numberDisplay },
      sortValue === 'tti' ? _react2.default.createElement(_NumberDisplay2.default, { value: travelTimeIndex, status: status, isHovered: isHovered }) : _react2.default.createElement(_SpeedDisplay2.default, { value: liveSpeed, status: status, isHovered: isHovered })
    ),
    _react2.default.createElement(
      'div',
      { className: _RoutesListItem2.default.trendLine },
      sortValue === 'tti' ? _react2.default.createElement(_Trendline2.default, { trendData: speedLastHour, width: 48, height: 27 }) : _react2.default.createElement(_Trendline2.default, { trendData: travelTimeLastHour, width: 48, height: 27 })
    )
  );
}

RoutesListItem.propTypes = {
  route: (0, _propTypes.shape)({ id: _propTypes.string }).isRequired,
  sortValue: _propTypes.string.isRequired,
  currentHover: (0, _propTypes.shape)({ id: _propTypes.string, type: _propTypes.string })
};

var mapStateToProps = function mapStateToProps(_ref2) {
  var map = _ref2.map;
  return {
    currentHover: map.currentHover
  };
};

var ConnectedRoutesListItem = (0, _reactRedux.connect)(mapStateToProps)(RoutesListItem);

var _default = ConnectedRoutesListItem;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(RoutesListItem, 'RoutesListItem', '/code/src/components/DataPanel/Overview/RoutesListItem/index.js');

  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/code/src/components/DataPanel/Overview/RoutesListItem/index.js');

  __REACT_HOT_LOADER__.register(ConnectedRoutesListItem, 'ConnectedRoutesListItem', '/code/src/components/DataPanel/Overview/RoutesListItem/index.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/code/src/components/DataPanel/Overview/RoutesListItem/index.js');
}();

;

/***/ }),

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("j1ja");
module.exports = __webpack_require__("EAxn");


/***/ }),

/***/ "1BE/":
/***/ (function(module, exports) {

module.exports = "/location-warning-31a261984c8fc1823d6859198f4c8fcc.svg";

/***/ }),

/***/ "1itO":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("KSGD");

var _trackingDeviceShape = __webpack_require__("1oTp");

var _trackingDeviceShape2 = _interopRequireDefault(_trackingDeviceShape);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = (0, _propTypes.shape)({
  id: _propTypes.string,
  lat: _propTypes.number,
  lng: _propTypes.number,
  segments: _propTypes.array,
  name: _propTypes.string,
  trackingDevice: _trackingDeviceShape2.default
});

exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_default, 'default', '/code/src/propTypes/locationShape.js');
}();

;

/***/ }),

/***/ "1oTp":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("KSGD");

var _deviceStatus = __webpack_require__("2Ejm");

var _deviceStatus2 = _interopRequireDefault(_deviceStatus);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = (0, _propTypes.shape)({
  id: _propTypes.string,
  name: _propTypes.string,
  status: _deviceStatus2.default.isRequired,
  batteryVoltage: _propTypes.number,
  temperature: _propTypes.number,
  numberOfHitsToday: _propTypes.number,
  reportInterval: _propTypes.number,
  lastUpdate: _propTypes.string
});

exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_default, 'default', '/code/src/propTypes/trackingDeviceShape.js');
}();

;

/***/ }),

/***/ "2689":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"main":"time-display-main--2-tly","status-ok":"time-display-status-ok--qbgFK","status-warning":"time-display-status-warning--3BgBP","status-problem":"time-display-status-problem--2SQ8s","status-disconnected":"time-display-status-disconnected--2OoK7"};

/***/ }),

/***/ "2Cva":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _templateObject = _taggedTemplateLiteral(['\n  query Location($id: ID!) {\n    location(id: $id) {\n      id\n      lat\n      lng\n      name\n      trackingDevice {\n        id\n        name\n        status\n        batteryVoltage\n        temperature\n        lastUpdate\n        reportInterval\n        numberOfHitsToday\n        reportedHitsToday {\n          timestamp\n          value\n        }\n        uptime\n      }\n    }\n  }\n'], ['\n  query Location($id: ID!) {\n    location(id: $id) {\n      id\n      lat\n      lng\n      name\n      trackingDevice {\n        id\n        name\n        status\n        batteryVoltage\n        temperature\n        lastUpdate\n        reportInterval\n        numberOfHitsToday\n        reportedHitsToday {\n          timestamp\n          value\n        }\n        uptime\n      }\n    }\n  }\n']);

exports.Location = Location;

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _reactApollo = __webpack_require__("3zLD");

var _reactRedux = __webpack_require__("RH2O");

var _IconButton = __webpack_require__("Lj8m");

var _IconButton2 = _interopRequireDefault(_IconButton);

var _DeviceStatusText = __webpack_require__("t8Hm");

var _DeviceStatusText2 = _interopRequireDefault(_DeviceStatusText);

var _LoadingIndicator = __webpack_require__("G+3p");

var _LoadingIndicator2 = _interopRequireDefault(_LoadingIndicator);

var _BatteryIcon = __webpack_require__("fNy8");

var _BatteryIcon2 = _interopRequireDefault(_BatteryIcon);

var _formatNextUpdate = __webpack_require__("7p3X");

var _formatNextUpdate2 = _interopRequireDefault(_formatNextUpdate);

var _formatLastUpdate = __webpack_require__("xPfo");

var _formatLastUpdate2 = _interopRequireDefault(_formatLastUpdate);

var _formatDaysHoursMinutesSeconds = __webpack_require__("qjr7");

var _formatDaysHoursMinutesSeconds2 = _interopRequireDefault(_formatDaysHoursMinutesSeconds);

var _formatMinutesSeconds = __webpack_require__("/rNx");

var _formatMinutesSeconds2 = _interopRequireDefault(_formatMinutesSeconds);

var _formatInteger = __webpack_require__("r4MO");

var _formatInteger2 = _interopRequireDefault(_formatInteger);

var _chevronInline = __webpack_require__("PRyc");

var _chevronInline2 = _interopRequireDefault(_chevronInline);

var _Layout = __webpack_require__("h5Sy");

var _Layout2 = _interopRequireDefault(_Layout);

var _LocationHeader = __webpack_require__("k5Ik");

var _LocationHeader2 = _interopRequireDefault(_LocationHeader);

var _DeviceContainer = __webpack_require__("PeXy");

var _DeviceContainer2 = _interopRequireDefault(_DeviceContainer);

var _HorizontalSection = __webpack_require__("uNFV");

var _HorizontalSection2 = _interopRequireDefault(_HorizontalSection);

var _TripletRow = __webpack_require__("5En4");

var _TripletRow2 = _interopRequireDefault(_TripletRow);

var _TripletItem = __webpack_require__("uqaq");

var _TripletItem2 = _interopRequireDefault(_TripletItem);

var _Chart = __webpack_require__("Wh2a");

var _Chart2 = _interopRequireDefault(_Chart);

var _GridRow = __webpack_require__("DWOx");

var _GridRow2 = _interopRequireDefault(_GridRow);

var _GridItem = __webpack_require__("3/U4");

var _GridItem2 = _interopRequireDefault(_GridItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var LocationQuery = (0, _reactApollo.gql)(_templateObject);

function Location(_ref) {
  var data = _ref.data;

  if (data.loading) {
    return _react2.default.createElement(
      _Layout2.default,
      {
        backTo: '/map/live/locations',
        title: 'Location',
        header: _react2.default.createElement(_LocationHeader2.default, { status: 'ok', name: '...', isLoading: true })
      },
      _react2.default.createElement(_LoadingIndicator2.default, null)
    );
  }

  var status = data.location.trackingDevice.status;

  var _data$location = data.location,
      name = _data$location.name,
      trackingDevice = _data$location.trackingDevice;
  var deviceId = trackingDevice.id,
      numberOfHitsToday = trackingDevice.numberOfHitsToday,
      reportedHitsToday = trackingDevice.reportedHitsToday,
      lastUpdate = trackingDevice.lastUpdate,
      reportInterval = trackingDevice.reportInterval,
      batteryVoltage = trackingDevice.batteryVoltage,
      temperature = trackingDevice.temperature,
      uptime = trackingDevice.uptime;


  var isDeviceOnline = status !== 'disconnected';

  return _react2.default.createElement(
    _Layout2.default,
    {
      backTo: '/map/live/locations',
      title: 'All locations',
      header: _react2.default.createElement(_LocationHeader2.default, { status: status, name: name })
    },
    _react2.default.createElement(
      _DeviceContainer2.default,
      { status: status },
      _react2.default.createElement(
        _TripletRow2.default,
        { title: 'Device' },
        _react2.default.createElement(
          _TripletItem2.default,
          { title: 'name' },
          trackingDevice.name
        ),
        _react2.default.createElement(
          _TripletItem2.default,
          { title: 'status', status: status, containsDevice: true },
          _react2.default.createElement(_DeviceStatusText2.default, { status: status })
        )
      ),
      _react2.default.createElement(_Chart2.default, {
        title: 'Number of hits today',
        reportedValues: reportedHitsToday,
        calculateCrosshairA: function calculateCrosshairA(_ref2) {
          var reported = _ref2.reported;
          return {
            value: (0, _formatInteger2.default)(reported),
            title: 'hits'
          };
        }
      }),
      _react2.default.createElement(
        _GridRow2.default,
        { title: 'Location' },
        _react2.default.createElement(
          _GridItem2.default,
          { label: 'hits today' },
          (0, _formatInteger2.default)(numberOfHitsToday)
        ),
        isDeviceOnline ? _react2.default.createElement(
          _GridItem2.default,
          { label: 'next update' },
          (0, _formatNextUpdate2.default)(lastUpdate, reportInterval)
        ) : _react2.default.createElement(
          _GridItem2.default,
          { label: 'last update' },
          (0, _formatLastUpdate2.default)(lastUpdate)
        ),
        _react2.default.createElement(
          _GridItem2.default,
          { label: 'report interval' },
          (0, _formatMinutesSeconds2.default)(reportInterval)
        )
      ),
      _react2.default.createElement(
        _GridRow2.default,
        { title: 'Device' },
        _react2.default.createElement(
          _GridItem2.default,
          { label: batteryVoltage + 'V' },
          _react2.default.createElement(_BatteryIcon2.default, { batteryVoltage: batteryVoltage })
        ),
        _react2.default.createElement(
          _GridItem2.default,
          { label: 'device temp' },
          temperature + '\xB0F'
        ),
        _react2.default.createElement(
          _GridItem2.default,
          { label: 'uptime' },
          uptime > 0 ? (0, _formatDaysHoursMinutesSeconds2.default)(uptime) : 'None'
        )
      ),
      _react2.default.createElement(
        _HorizontalSection2.default,
        { center: true },
        _react2.default.createElement(
          _IconButton2.default,
          {
            label: 'details page',
            linkTo: '/segments/' + deviceId,
            disabled: true,
            asLink: true,
            iconRight: true
          },
          _react2.default.createElement(_chevronInline2.default, null)
        )
      )
    )
  );
}

Location.propTypes = {
  data: (0, _propTypes.shape)({
    loading: _propTypes.bool.isRequired,
    location: (0, _propTypes.shape)({})
  }).isRequired
};

var mapStateToProps = function mapStateToProps(_ref3, ownProps) {
  var map = _ref3.map;
  return _extends({
    currentHover: map.currentHover
  }, ownProps);
};

var ConnectedLocationWithData = (0, _reactApollo.compose)((0, _reactRedux.connect)(mapStateToProps), (0, _reactApollo.graphql)(LocationQuery, {
  options: function options(_ref4) {
    var params = _ref4.params;
    return {
      variables: {
        id: params.id
      }
    };
  }
}))(Location);

var _default = ConnectedLocationWithData;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(LocationQuery, 'LocationQuery', '/code/src/components/DataPanel/Details/Location/index.js');

  __REACT_HOT_LOADER__.register(Location, 'Location', '/code/src/components/DataPanel/Details/Location/index.js');

  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/code/src/components/DataPanel/Details/Location/index.js');

  __REACT_HOT_LOADER__.register(ConnectedLocationWithData, 'ConnectedLocationWithData', '/code/src/components/DataPanel/Details/Location/index.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/code/src/components/DataPanel/Details/Location/index.js');
}();

;

/***/ }),

/***/ "2Ejm":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("KSGD");

var _default = (0, _propTypes.oneOf)(['ok', 'warning', 'disconnected']);

exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_default, 'default', '/code/src/propTypes/deviceStatus.js');
}();

;

/***/ }),

/***/ "2ShL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"content":"app-content--fNsQq"};

/***/ }),

/***/ "2bM4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SVG = function (_React$Component) {
  _inherits(SVG, _React$Component);

  function SVG() {
    _classCallCheck(this, SVG);

    return _possibleConstructorReturn(this, (SVG.__proto__ || Object.getPrototypeOf(SVG)).apply(this, arguments));
  }

  _createClass(SVG, [{
    key: "render",
    value: function render() {
      return _react2.default.createElement(
        "svg",
        _extends({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 18.12 18.12" }, this.props),
        _react2.default.createElement("path", { fill: "none", stroke: "currentColor", strokeMiterlimit: "10", strokeWidth: "3", d: "M1.06 17.06l16-16m0 16l-16-16" })
      );
    }
  }]);

  return SVG;
}(_react2.default.Component);

var _default = SVG;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(SVG, "SVG", "/code/src/icons/close.inline.svg");

  __REACT_HOT_LOADER__.register(_default, "default", "/code/src/icons/close.inline.svg");
}();

;

/***/ }),

/***/ "2usA":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.requestLogout = requestLogout;

var _types = __webpack_require__("yyqx");

var _types2 = _interopRequireDefault(_types);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable import/prefer-default-export */
function requestLogout() {
  return {
    type: _types2.default.LOGOUT_REQUEST
  };
}
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(requestLogout, 'requestLogout', '/code/src/state/ducks/auth/actions.js');
}();

;

/***/ }),

/***/ "3/U4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = GridItem;

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _classnames = __webpack_require__("HW6M");

var _classnames2 = _interopRequireDefault(_classnames);

var _segmentStatus = __webpack_require__("fX1p");

var _segmentStatus2 = _interopRequireDefault(_segmentStatus);

var _GridItem = __webpack_require__("BiFx");

var _GridItem2 = _interopRequireDefault(_GridItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Note that order of title and content is reversed by CSS in order to keep
 * markup correct.
 */
function GridItem(_ref) {
  var label = _ref.label,
      children = _ref.children,
      status = _ref.status;

  return _react2.default.createElement(
    'dl',
    {
      className: (0, _classnames2.default)(_GridItem2.default.main, _defineProperty({}, _GridItem2.default['status-' + status], Boolean(status)))
    },
    _react2.default.createElement(
      'dt',
      { className: _GridItem2.default.label },
      label
    ),
    _react2.default.createElement(
      'dd',
      { className: _GridItem2.default.content },
      children
    )
  );
}

GridItem.propTypes = {
  label: _propTypes.string.isRequired,
  children: _propTypes.node.isRequired,
  status: _segmentStatus2.default
};
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(GridItem, 'GridItem', '/code/src/components/DataPanel/GridItem/index.js');
}();

;

/***/ }),

/***/ "37Gh":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }
}();

;

/***/ }),

/***/ "3C90":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__("HW6M");

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = __webpack_require__("KSGD");

var _locationShape = __webpack_require__("1itO");

var _locationShape2 = _interopRequireDefault(_locationShape);

var _sortInline = __webpack_require__("sppZ");

var _sortInline2 = _interopRequireDefault(_sortInline);

var _formatUrl = __webpack_require__("6suu");

var _formatUrl2 = _interopRequireDefault(_formatUrl);

var _Sorting = __webpack_require__("cf0Y");

var _Sorting2 = _interopRequireDefault(_Sorting);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SORT_ASC = 'asc';
var SORT_DSC = 'dsc';

/**
 * This is generic sorting component. It takes a list of options from which it
 * knows what buttons to create and how they interact with the query
 * part of the url.
 *
 * The object uses the "function as child" pattern to pass its output to the
 * child component. The active sorting type and order are passed in this way. The
 * child function can then decide how to interpret these values and sort its
 * data accordingly. This makes that the component only needs to care about
 * layout and url interaction and not know about sorting logic which would likely
 * be different for each use case.
 */
function Sorting(_ref) {
  var className = _ref.className,
      text = _ref.text,
      location = _ref.location,
      queryValueKey = _ref.queryValueKey,
      queryOrderKey = _ref.queryOrderKey,
      options = _ref.options,
      children = _ref.children,
      historyReplace = _ref.historyReplace;

  // Take the sorting value from the url query and fallback to whatever option
  // has been marked as default.
  var currentSortValue = location.query[queryValueKey] || options.find(function (_ref2) {
    var isDefault = _ref2.isDefault;
    return isDefault === true;
  }).queryValue;

  // Take the sorting order from the url query and fallback to whatever initial
  // value has been set for the currently active option.
  var currentSortOrder = location.query[queryOrderKey] || options.find(function (_ref3) {
    var queryValue = _ref3.queryValue;
    return queryValue === currentSortValue;
  }).initialOrder;

  var pathname = location.pathname,
      query = location.query;


  return _react2.default.createElement(
    'div',
    { className: (0, _classnames2.default)(_Sorting2.default.main, className) },
    _react2.default.createElement(
      'div',
      { className: _Sorting2.default.header },
      _react2.default.createElement(
        'span',
        { className: _Sorting2.default.label },
        text
      ),
      _react2.default.createElement(
        'ul',
        { className: _Sorting2.default.buttonList },
        options.map(function (_ref4) {
          var _extends2, _cx;

          var label = _ref4.label,
              queryValue = _ref4.queryValue,
              initialOrder = _ref4.initialOrder;

          var isActive = queryValue === currentSortValue;

          var nextOrder = isActive ? currentSortOrder === SORT_ASC ? SORT_DSC : SORT_ASC : initialOrder;

          var nextLocation = {
            pathname: pathname,
            query: _extends({}, query, (_extends2 = {}, _defineProperty(_extends2, queryValueKey, queryValue), _defineProperty(_extends2, queryOrderKey, nextOrder), _extends2))
          };
          var nextUrl = (0, _formatUrl2.default)(nextLocation);

          return _react2.default.createElement(
            'li',
            { key: label, className: _Sorting2.default.buttonListItem },
            _react2.default.createElement(
              'a',
              {
                className: (0, _classnames2.default)(_Sorting2.default.button, (_cx = {}, _defineProperty(_cx, _Sorting2.default.isActive, isActive), _defineProperty(_cx, _Sorting2.default.asc, isActive && currentSortOrder === SORT_ASC), _defineProperty(_cx, _Sorting2.default.dsc, isActive && currentSortOrder === SORT_DSC), _cx)),
                href: nextUrl,
                onClick: function onClick(evt) {
                  evt.preventDefault();
                  historyReplace(nextLocation);
                }
              },
              label,
              _react2.default.createElement(
                'span',
                {
                  className: (0, _classnames2.default)(_Sorting2.default.sortOrderIndicator, _defineProperty({}, _Sorting2.default.flip, isActive && currentSortOrder === SORT_DSC))
                },
                _react2.default.createElement(_sortInline2.default, { className: _Sorting2.default.sortIcon }),
                _react2.default.createElement(_sortInline2.default, { className: _Sorting2.default.sortIcon })
              )
            )
          );
        })
      )
    ),
    _react2.default.createElement(
      'div',
      { className: _Sorting2.default.content },
      children({ sortValue: currentSortValue, sortOrder: currentSortOrder })
    )
  );
}

Sorting.propTypes = {
  className: _propTypes.string,
  location: _locationShape2.default.isRequired,
  queryValueKey: _propTypes.string.isRequired,
  queryOrderKey: _propTypes.string.isRequired,
  text: _propTypes.string,
  options: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    label: _propTypes.string.isRequired,
    queryValue: _propTypes.string.isRequired,
    initialSorting: (0, _propTypes.oneOf)([SORT_ASC, SORT_DSC]),
    isDefault: _propTypes.bool
  })),
  children: _propTypes.func.isRequired,
  historyReplace: _propTypes.func.isRequired
};

var _default = Sorting;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(SORT_ASC, 'SORT_ASC', '/code/src/components/DataPanel/Overview/Sorting/index.js');

  __REACT_HOT_LOADER__.register(SORT_DSC, 'SORT_DSC', '/code/src/components/DataPanel/Overview/Sorting/index.js');

  __REACT_HOT_LOADER__.register(Sorting, 'Sorting', '/code/src/components/DataPanel/Overview/Sorting/index.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/code/src/components/DataPanel/Overview/Sorting/index.js');
}();

;

/***/ }),

/***/ "3U6A":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.LocationMarkerGroup = LocationMarkerGroup;

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _reactRedux = __webpack_require__("RH2O");

var _locationShape = __webpack_require__("1itO");

var _locationShape2 = _interopRequireDefault(_locationShape);

var _segmentCreation = __webpack_require__("ZaDe");

var _map = __webpack_require__("YByT");

var _LocationMarker = __webpack_require__("tbgJ");

var _LocationMarker2 = _interopRequireDefault(_LocationMarker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var noop = function noop(_) {
  return _;
};

function LocationMarkerGroup(_ref) {
  var locations = _ref.locations,
      selectedLocations = _ref.selectedLocations,
      selectLocation = _ref.selectLocation,
      deselectLocation = _ref.deselectLocation,
      currentHover = _ref.currentHover,
      enterEntity = _ref.enterEntity,
      leaveEntity = _ref.leaveEntity,
      disableInteraction = _ref.disableInteraction,
      validNextLocations = _ref.validNextLocations;

  // eslint-disable-next-line global-require
  var _require = __webpack_require__("Zz/N"),
      FeatureGroup = _require.FeatureGroup;

  var hoveredId = currentHover && currentHover.id;
  var hasTwoLocations = selectedLocations && selectedLocations.length === 2;

  return _react2.default.createElement(
    FeatureGroup,
    null,
    locations.map(function (location) {
      var locationId = location.id,
          trackingDevice = location.trackingDevice,
          lat = location.lat,
          lng = location.lng,
          name = location.name;


      var isSelected = selectedLocations && selectedLocations.includes(locationId);
      var isActive = isSelected || locationId === hoveredId;

      var shouldBeInteractive = !disableInteraction && Boolean(validNextLocations.find(function (validLocation) {
        return validLocation.id === locationId;
      }));

      var handleSelect = function handleSelect() {
        if (isSelected) {
          deselectLocation(locationId);
        } else if (!hasTwoLocations) {
          selectLocation(locationId);
        }
        /* you should not be able to select more then two locations */
      };

      return _react2.default.createElement(_LocationMarker2.default, {
        key: '' + locationId,
        trackingDevice: trackingDevice,
        position: [lat, lng],
        name: name,
        id: locationId,
        onSelect: shouldBeInteractive ? handleSelect : noop,
        onEnter: shouldBeInteractive ? function () {
          return enterEntity({
            id: locationId,
            type: 'location'
          });
        } : noop,
        onLeave: shouldBeInteractive ? function () {
          return leaveEntity({
            id: locationId,
            type: 'location'
          });
        } : noop,
        isActive: isActive,
        isFaded: !shouldBeInteractive
      });
    })
  );
}

LocationMarkerGroup.propTypes = {
  locations: (0, _propTypes.arrayOf)(_locationShape2.default).isRequired,
  selectLocation: _propTypes.func.isRequired,
  deselectLocation: _propTypes.func.isRequired,
  enterEntity: _propTypes.func.isRequired,
  leaveEntity: _propTypes.func.isRequired,
  selectedLocations: (0, _propTypes.arrayOf)(_propTypes.string),
  currentHover: (0, _propTypes.shape)({
    id: _propTypes.string.isRequired
  }),
  disableInteraction: _propTypes.bool.isRequired,
  validNextLocations: (0, _propTypes.arrayOf)(_locationShape2.default)
};

var mapStateToProps = function mapStateToProps(_ref2) {
  var map = _ref2.map,
      segmentCreation = _ref2.segmentCreation;
  return {
    currentHover: map.currentHover,
    selectedLocations: segmentCreation.selectedLocations
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps, _extends({}, _map.operations, _segmentCreation.operations))(LocationMarkerGroup);

exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(noop, 'noop', '/code/src/components/Map/CreateSegment/LocationMarkerGroup/index.js');

  __REACT_HOT_LOADER__.register(LocationMarkerGroup, 'LocationMarkerGroup', '/code/src/components/Map/CreateSegment/LocationMarkerGroup/index.js');

  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/code/src/components/Map/CreateSegment/LocationMarkerGroup/index.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/code/src/components/Map/CreateSegment/LocationMarkerGroup/index.js');
}();

;

/***/ }),

/***/ "3a2E":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _auth = __webpack_require__("D5y+");

Object.defineProperty(exports, 'auth', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_auth).default;
  }
});

var _user = __webpack_require__("/vAk");

Object.defineProperty(exports, 'user', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_user).default;
  }
});

var _map = __webpack_require__("YByT");

Object.defineProperty(exports, 'map', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_map).default;
  }
});

var _segmentCreation = __webpack_require__("ZaDe");

Object.defineProperty(exports, 'segmentCreation', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_segmentCreation).default;
  }
});

var _routeCreation = __webpack_require__("tEHQ");

Object.defineProperty(exports, 'routeCreation', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_routeCreation).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }
}();

;

/***/ }),

/***/ "3kDo":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"main":"navigation-main--2gRgR","logo":"navigation-logo--27H0o","icon":"navigation-icon--1d_8V","wordmark":"navigation-wordmark--IeJfd","list":"navigation-list--3myYf","item":"navigation-item--27RJu","link":"navigation-link--3g-98","corner":"navigation-corner--1WqAp","activeLink":"navigation-activeLink--nB-4P"};

/***/ }),

/***/ "3pOm":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var _default = {
  SELECT_SEGMENT: 'routeCreation/SELECT_SEGMENT',
  DESELECT_SEGMENT: 'routeCreation/DESELECT_SEGMENT',
  SET_CREATED_ROUTE_ID: 'routeCreation/SET_CREATED_ROUTE_ID',
  CLEAR_CREATE_ROUTE: 'routeCreation/CLEAR_CREATE_ROUTE'
};
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_default, 'default', '/code/src/state/ducks/routeCreation/types.js');
}();

;

/***/ }),

/***/ "4cE6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"buttonBase":"ListItem-buttonBase--2Ofnw","shadowBottom":"ListItem-shadowBottom--3r856","shadowBottomHover":"ListItem-shadowBottomHover--3cN5J","shadowListItem":"ListItem-shadowListItem--fa4A1","shadowRight":"ListItem-shadowRight--2M7y4","shadowLeft":"ListItem-shadowLeft--2yaq0","shadowAround":"ListItem-shadowAround--JVlZ8","shadowAroundHover":"ListItem-shadowAroundHover--uQg_M","shadowButton":"ListItem-shadowButton--ylHRj","shadowButtonHover":"ListItem-shadowButtonHover--2UXj9","main":"ListItem-main--2663Q ListItem-shadowListItem--fa4A1","link":"ListItem-link--6TWgk","plus":"ListItem-plus--2c-pr","plusIcon":"ListItem-plusIcon--3TT7W","isActive":"ListItem-isActive--2vVg_"};

/***/ }),

/***/ "4lJq":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var _default = {};
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_default, "default", "/code/src/state/ducks/auth/selectors.js");
}();

;

/***/ }),

/***/ "55NV":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SVG = function (_React$Component) {
  _inherits(SVG, _React$Component);

  function SVG() {
    _classCallCheck(this, SVG);

    return _possibleConstructorReturn(this, (SVG.__proto__ || Object.getPrototypeOf(SVG)).apply(this, arguments));
  }

  _createClass(SVG, [{
    key: "render",
    value: function render() {
      return _react2.default.createElement(
        "svg",
        _extends({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 8 40", fill: "currentColor" }, this.props),
        _react2.default.createElement("path", { className: "st0", d: "M1.9 0L0 1.9v6.3l4 3.7 4-3.7V0zM0 29.9v6.3l4 3.7 4-3.7V28H1.9zM3 13v3H2l-1 1v4.7l2 1.7V27h2v-3.6l2-1.7V16H5v-3z" })
      );
    }
  }]);

  return SVG;
}(_react2.default.Component);

var _default = SVG;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(SVG, "SVG", "/code/src/icons/route.inline.svg");

  __REACT_HOT_LOADER__.register(_default, "default", "/code/src/icons/route.inline.svg");
}();

;

/***/ }),

/***/ "5En4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = TripletRow;

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _bind = __webpack_require__("T2Un");

var _bind2 = _interopRequireDefault(_bind);

var _TripletRow = __webpack_require__("9XvQ");

var _TripletRow2 = _interopRequireDefault(_TripletRow);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cx = _bind2.default.bind(_TripletRow2.default);

function TripletRow(_ref) {
  var title = _ref.title,
      withBorder = _ref.withBorder,
      children = _ref.children;

  var childrenArray = _react2.default.Children.toArray(children);
  var tripletRowClass = cx({
    main: true,
    withBorder: withBorder
  });
  return _react2.default.createElement(
    'div',
    { className: tripletRowClass },
    title && _react2.default.createElement(
      'h3',
      { className: _TripletRow2.default.title },
      title
    ),
    _react2.default.createElement(
      'dl',
      { className: _TripletRow2.default.rowItemsContainer },
      childrenArray.map(function (child) {
        return child;
      })
    )
  );
}

TripletRow.propTypes = {
  title: _propTypes.string,
  children: _propTypes.node.isRequired,
  withBorder: _propTypes.bool
};

TripletRow.defaultProps = {
  title: null,
  withBorder: false
};
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(cx, 'cx', '/code/src/components/DataPanel/TripletRow/index.js');

  __REACT_HOT_LOADER__.register(TripletRow, 'TripletRow', '/code/src/components/DataPanel/TripletRow/index.js');
}();

;

/***/ }),

/***/ "5QWJ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var _default = {
  SELECT_LOCATION: 'segmentCreation/SELECT_LOCATION',
  DESELECT_LOCATION: 'segmentCreation/DESELECT_LOCATION',
  FLIP_SELECTED_LOCATIONS: 'segmentCreation/FLIP_SELECTED_LOCATIONS',
  SELECT_PATH_SUGGESTION: 'segmentCreation/SELECT_PATH_SUGGESTION',
  SET_PATH_SUGGESTIONS: 'segmentCreation/SET_PATH_SUGGESTIONS',
  SET_CREATED_SEGMENT_ID: 'segmentCreation/SET_CREATED_SEGMENT_ID',
  CLEAR_CREATE_SEGMENT: 'segmentCreation/CLEAR_CREATE_SEGMENT',
  START_CREATE_OPPOSITE_SEGMENT: 'segmentCreation/START_CREATE_OPPOSITE_SEGMENT'
};
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_default, 'default', '/code/src/state/ducks/segmentCreation/types.js');
}();

;

/***/ }),

/***/ "5R4Q":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"main":"Settings-main--pCF0N","fieldsetContent":"Settings-fieldsetContent--1_kwD","radioInput":"Settings-radioInput--1SlNZ","createLinks":"Settings-createLinks--yqfep"};

/***/ }),

/***/ "5d5i":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = routeCreation;

var _types = __webpack_require__("3pOm");

var _types2 = _interopRequireDefault(_types);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var initialState = {
  selectedSegments: [],
  createdRouteId: null
};

function routeCreation() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case _types2.default.SELECT_SEGMENT:
      return _extends({}, state, {
        selectedSegments: [].concat(_toConsumableArray(state.selectedSegments), [action.payload.id])
      });

    case _types2.default.DESELECT_SEGMENT:
      return _extends({}, state, {
        selectedSegments: state.selectedSegments.filter(function (id) {
          return id !== action.payload.id;
        })
      });

    case _types2.default.SET_CREATED_ROUTE_ID:
      return _extends({}, state, {
        createdRouteId: action.payload.id
      });

    case _types2.default.CLEAR_CREATE_ROUTE:
      return _extends({}, initialState);

    default:
      return state;
  }
}
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(initialState, 'initialState', '/code/src/state/ducks/routeCreation/reducers.js');

  __REACT_HOT_LOADER__.register(routeCreation, 'routeCreation', '/code/src/state/ducks/routeCreation/reducers.js');
}();

;

/***/ }),

/***/ "5iSJ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = coord;

var _invariant = __webpack_require__("crWv");

var _invariant2 = _interopRequireDefault(_invariant);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
  Loosly inspired by
  https://stackoverflow.com/questions/42659728/react-proptypes-array-with-specific-length

  This prop type checks weather the value is  [number, number] exactly. If it is used
  in an arrayOf proptype like arrayOf(coord) then this function is passed an array.
  That's why the check is made on type array at the start
  */

function isValid(value) {
  return Array.isArray(value) && value.length === 2 && value.every(Number.isFinite);
}

function coord(props, propName, componentName) {
  if (Array.isArray(props)) {
    props.forEach(function (item, index) {
      (0, _invariant2.default)(isValid(item), 'Array item index ' + index + ' is ' + item + ', but needs to be an array of two numbers');
    });
  }

  var value = props[propName];

  if (!value) return; // not required

  (0, _invariant2.default)(isValid(value), componentName + ' ' + propName + ' needs to be an array of two numbers');
}
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(isValid, 'isValid', '/code/src/propTypes/twoNumbers.js');

  __REACT_HOT_LOADER__.register(coord, 'coord', '/code/src/propTypes/twoNumbers.js');
}();

;

/***/ }),

/***/ "5qIW":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = SegmentHeader;

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__("CIox");

var _propTypes = __webpack_require__("KSGD");

var _classnames = __webpack_require__("HW6M");

var _classnames2 = _interopRequireDefault(_classnames);

var _panelSegmentInline = __webpack_require__("lk4o");

var _panelSegmentInline2 = _interopRequireDefault(_panelSegmentInline);

var _panelSegmentBrokenInline = __webpack_require__("rm5e");

var _panelSegmentBrokenInline2 = _interopRequireDefault(_panelSegmentBrokenInline);

var _panelSwitchInline = __webpack_require__("7jAy");

var _panelSwitchInline2 = _interopRequireDefault(_panelSwitchInline);

var _segmentStatus = __webpack_require__("fX1p");

var _segmentStatus2 = _interopRequireDefault(_segmentStatus);

var _SegmentHeader = __webpack_require__("yv7l");

var _SegmentHeader2 = _interopRequireDefault(_SegmentHeader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function SegmentHeader(_ref) {
  var fromName = _ref.fromName,
      toName = _ref.toName,
      status = _ref.status,
      oppositeSegmentId = _ref.oppositeSegmentId,
      isLoading = _ref.isLoading;

  return _react2.default.createElement(
    'div',
    {
      className: (0, _classnames2.default)(_SegmentHeader2.default.main, _defineProperty({}, _SegmentHeader2.default.isLoading, isLoading))
    },
    _react2.default.createElement(
      'header',
      { className: _SegmentHeader2.default.header },
      _react2.default.createElement(
        'h1',
        { className: _SegmentHeader2.default.title },
        'Segment'
      )
    ),
    _react2.default.createElement(
      'div',
      { className: _SegmentHeader2.default.content },
      _react2.default.createElement(
        'div',
        { className: _SegmentHeader2.default.icon },
        status !== 'disconnected' ? _react2.default.createElement(_panelSegmentInline2.default, { height: 72 }) : _react2.default.createElement(_panelSegmentBrokenInline2.default, { height: 72 })
      ),
      _react2.default.createElement(
        'h2',
        { className: _SegmentHeader2.default.text },
        _react2.default.createElement(
          'div',
          { className: _SegmentHeader2.default.textGroup },
          _react2.default.createElement(
            'div',
            { className: _SegmentHeader2.default.label },
            'from'
          ),
          _react2.default.createElement(
            'div',
            { className: _SegmentHeader2.default.name },
            fromName
          )
        ),
        _react2.default.createElement(
          'div',
          { className: _SegmentHeader2.default.textGroup },
          _react2.default.createElement(
            'div',
            { className: _SegmentHeader2.default.label },
            'to'
          ),
          _react2.default.createElement(
            'div',
            { className: _SegmentHeader2.default.name },
            toName
          )
        )
      ),
      oppositeSegmentId && _react2.default.createElement(
        'div',
        { className: _SegmentHeader2.default.switchButtonWrapper },
        _react2.default.createElement(
          _reactRouter.Link,
          { to: '/map/live/segments/' + oppositeSegmentId, className: _SegmentHeader2.default.switchButton },
          _react2.default.createElement(_panelSwitchInline2.default, { className: _SegmentHeader2.default.switchButtonIcon, style: { width: '1.5em' } })
        )
      )
    )
  );
}

SegmentHeader.propTypes = {
  fromName: _propTypes.string.isRequired,
  toName: _propTypes.string.isRequired,
  status: _segmentStatus2.default.isRequired,
  oppositeSegmentId: _propTypes.string,
  isLoading: _propTypes.bool
};
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(SegmentHeader, 'SegmentHeader', '/code/src/components/DataPanel/Details/SegmentHeader/index.js');
}();

;

/***/ }),

/***/ "6suu":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports.default = formatUrl;
function formatQueryString(queryObj) {
  return Object.entries(queryObj).reduce(function (acc, _ref, index) {
    var _ref2 = _slicedToArray(_ref, 2),
        key = _ref2[0],
        value = _ref2[1];

    if (index === 0) {
      return '?' + key + '=' + value;
    }
    return acc + '&' + key + '=' + value;
  }, '');
}

/**
 * Format an url based on pathname and a query object, similar to react router
 * Link does with "to" prop. This doesn't support things like hash yet.
 */
function formatUrl(_ref3) {
  var pathname = _ref3.pathname,
      query = _ref3.query;

  return '' + pathname + formatQueryString(query);
}
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(formatQueryString, 'formatQueryString', '/code/src/helpers/formatUrl.js');

  __REACT_HOT_LOADER__.register(formatUrl, 'formatUrl', '/code/src/helpers/formatUrl.js');
}();

;

/***/ }),

/***/ "7H5I":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Footer;

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__("HW6M");

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = __webpack_require__("KSGD");

var _IconButton = __webpack_require__("Lj8m");

var _IconButton2 = _interopRequireDefault(_IconButton);

var _closeInline = __webpack_require__("2bM4");

var _closeInline2 = _interopRequireDefault(_closeInline);

var _plusInline = __webpack_require__("Htlj");

var _plusInline2 = _interopRequireDefault(_plusInline);

var _chevronInline = __webpack_require__("PRyc");

var _chevronInline2 = _interopRequireDefault(_chevronInline);

var _Footer = __webpack_require__("H2II");

var _Footer2 = _interopRequireDefault(_Footer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Footer(_ref) {
  var className = _ref.className,
      onCancel = _ref.onCancel,
      onDone = _ref.onDone,
      onNew = _ref.onNew,
      onClose = _ref.onClose,
      isFinalStep = _ref.isFinalStep,
      isFinished = _ref.isFinished,
      createNewLabel = _ref.createNewLabel,
      waitForResponse = _ref.waitForResponse;

  if (!isFinished) {
    return _react2.default.createElement(
      'div',
      { className: (0, _classnames2.default)(_Footer2.default.main, className) },
      _react2.default.createElement(
        _IconButton2.default,
        { onClick: onCancel, label: 'cancel', disabled: waitForResponse, isSecondary: true },
        _react2.default.createElement(_closeInline2.default, { className: _Footer2.default.icon })
      ),
      _react2.default.createElement(
        _IconButton2.default,
        {
          onClick: onDone,
          label: 'done',
          disabled: !isFinalStep || waitForResponse,
          iconRight: true
        },
        _react2.default.createElement(_chevronInline2.default, null)
      )
    );
  }
  return _react2.default.createElement(
    'div',
    { className: (0, _classnames2.default)(_Footer2.default.main, className) },
    _react2.default.createElement(
      _IconButton2.default,
      { onClick: onClose, label: 'close', isSecondary: true },
      _react2.default.createElement(_closeInline2.default, null)
    ),
    _react2.default.createElement(
      _IconButton2.default,
      { onClick: onNew, label: createNewLabel },
      _react2.default.createElement(_plusInline2.default, null)
    )
  );
}

Footer.propTypes = {
  onCancel: _propTypes.func.isRequired,
  onDone: _propTypes.func.isRequired,
  onNew: _propTypes.func.isRequired,
  onClose: _propTypes.func.isRequired,
  isFinalStep: _propTypes.bool.isRequired,
  isFinished: _propTypes.bool.isRequired,
  createNewLabel: _propTypes.string.isRequired,
  className: _propTypes.string,
  waitForResponse: _propTypes.bool
};

Footer.defaultProps = {
  createNewLabel: 'create new'
};
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(Footer, 'Footer', '/code/src/components/MapPanel/Footer/index.js');
}();

;

/***/ }),

/***/ "7Jp7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = TimeDisplay;

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__("HW6M");

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = __webpack_require__("KSGD");

var _formatMinutesSeconds = __webpack_require__("/rNx");

var _formatMinutesSeconds2 = _interopRequireDefault(_formatMinutesSeconds);

var _segmentStatus = __webpack_require__("fX1p");

var _segmentStatus2 = _interopRequireDefault(_segmentStatus);

var _timeDisplay = __webpack_require__("2689");

var _timeDisplay2 = _interopRequireDefault(_timeDisplay);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function TimeDisplay(_ref) {
  var value = _ref.value,
      status = _ref.status;

  return _react2.default.createElement(
    'span',
    { className: (0, _classnames2.default)(_timeDisplay2.default.main, _timeDisplay2.default['status-' + status]) },
    (0, _formatMinutesSeconds2.default)(value, {
      useClockFormat: true
    })
  );
}

TimeDisplay.propTypes = {
  value: _propTypes.number.isRequired,
  status: _segmentStatus2.default
};
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(TimeDisplay, 'TimeDisplay', '/code/src/components/TimeDisplay/index.js');
}();

;

/***/ }),

/***/ "7cX+":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _templateObject = _taggedTemplateLiteral(['\n  query Route($id: ID!) {\n    route(id: $id) {\n      id\n      status\n      liveSpeed\n      normalSpeed\n      speedLimit\n      tripsToday\n      liveTravelTime\n      expectedTravelTime\n      travelTimeIndex\n      numberOfTripsToday\n      numberOfTripsSinceLastUpdate\n      oppositeRouteId\n      liveTravelTimeToday {\n        timestamp\n        value\n      }\n      expectedTravelTimeToday {\n        timestamp\n        value\n      }\n      from {\n        id\n        name\n        trackingDevice {\n          id\n          lastUpdate\n          reportInterval\n        }\n      }\n      to {\n        id\n        name\n        trackingDevice {\n          id\n          lastUpdate\n          reportInterval\n        }\n      }\n      segments {\n        id\n        status\n        expectedTravelTime\n        travelTimeIndex\n        numberOfTripsToday\n        numberOfTripsSinceLastUpdate\n        liveSpeed\n        speedLastHour\n        from {\n          id\n          name\n        }\n        to {\n          id\n          name\n        }\n      }\n    }\n  }\n'], ['\n  query Route($id: ID!) {\n    route(id: $id) {\n      id\n      status\n      liveSpeed\n      normalSpeed\n      speedLimit\n      tripsToday\n      liveTravelTime\n      expectedTravelTime\n      travelTimeIndex\n      numberOfTripsToday\n      numberOfTripsSinceLastUpdate\n      oppositeRouteId\n      liveTravelTimeToday {\n        timestamp\n        value\n      }\n      expectedTravelTimeToday {\n        timestamp\n        value\n      }\n      from {\n        id\n        name\n        trackingDevice {\n          id\n          lastUpdate\n          reportInterval\n        }\n      }\n      to {\n        id\n        name\n        trackingDevice {\n          id\n          lastUpdate\n          reportInterval\n        }\n      }\n      segments {\n        id\n        status\n        expectedTravelTime\n        travelTimeIndex\n        numberOfTripsToday\n        numberOfTripsSinceLastUpdate\n        liveSpeed\n        speedLastHour\n        from {\n          id\n          name\n        }\n        to {\n          id\n          name\n        }\n      }\n    }\n  }\n']);

exports.Route = Route;

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _reactRedux = __webpack_require__("RH2O");

var _reactApollo = __webpack_require__("3zLD");

var _map = __webpack_require__("YByT");

var _formatMinutesSeconds = __webpack_require__("/rNx");

var _formatMinutesSeconds2 = _interopRequireDefault(_formatMinutesSeconds);

var _formatNextUpdate = __webpack_require__("7p3X");

var _formatNextUpdate2 = _interopRequireDefault(_formatNextUpdate);

var _formatLastUpdate = __webpack_require__("xPfo");

var _formatLastUpdate2 = _interopRequireDefault(_formatLastUpdate);

var _formatInteger = __webpack_require__("r4MO");

var _formatInteger2 = _interopRequireDefault(_formatInteger);

var _formatFloat = __webpack_require__("MyD5");

var _formatFloat2 = _interopRequireDefault(_formatFloat);

var _classnames = __webpack_require__("HW6M");

var _classnames2 = _interopRequireDefault(_classnames);

var _IconButton = __webpack_require__("Lj8m");

var _IconButton2 = _interopRequireDefault(_IconButton);

var _chevronInline = __webpack_require__("PRyc");

var _chevronInline2 = _interopRequireDefault(_chevronInline);

var _LoadingIndicator = __webpack_require__("G+3p");

var _LoadingIndicator2 = _interopRequireDefault(_LoadingIndicator);

var _TimeDisplay = __webpack_require__("7Jp7");

var _TimeDisplay2 = _interopRequireDefault(_TimeDisplay);

var _SpeedDisplay = __webpack_require__("g7vI");

var _SpeedDisplay2 = _interopRequireDefault(_SpeedDisplay);

var _RouteSegments = __webpack_require__("paDu");

var _RouteSegments2 = _interopRequireDefault(_RouteSegments);

var _Layout = __webpack_require__("h5Sy");

var _Layout2 = _interopRequireDefault(_Layout);

var _RouteHeader = __webpack_require__("d4HL");

var _RouteHeader2 = _interopRequireDefault(_RouteHeader);

var _TripletRow = __webpack_require__("5En4");

var _TripletRow2 = _interopRequireDefault(_TripletRow);

var _TripletItem = __webpack_require__("uqaq");

var _TripletItem2 = _interopRequireDefault(_TripletItem);

var _HorizontalSection = __webpack_require__("uNFV");

var _HorizontalSection2 = _interopRequireDefault(_HorizontalSection);

var _GridRow = __webpack_require__("DWOx");

var _GridRow2 = _interopRequireDefault(_GridRow);

var _GridItem = __webpack_require__("3/U4");

var _GridItem2 = _interopRequireDefault(_GridItem);

var _Chart = __webpack_require__("Wh2a");

var _Chart2 = _interopRequireDefault(_Chart);

var _SpeedTrendIcon = __webpack_require__("sCW4");

var _SpeedTrendIcon2 = _interopRequireDefault(_SpeedTrendIcon);

var _route = __webpack_require__("W6I0");

var _route2 = _interopRequireDefault(_route);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var RouteQuery = (0, _reactApollo.gql)(_templateObject);

function Route(_ref) {
  var data = _ref.data,
      selectEntity = _ref.selectEntity,
      enterEntity = _ref.enterEntity,
      leaveEntity = _ref.leaveEntity;

  if (data.loading) {
    return _react2.default.createElement(
      _Layout2.default,
      {
        backTo: '/map/live/routes',
        title: 'Routes',
        header: _react2.default.createElement(_RouteHeader2.default, { status: 'ok', fromName: '...', toName: '...', isLoading: true })
      },
      _react2.default.createElement(_LoadingIndicator2.default, null)
    );
  }

  if (!data.route) {
    return _react2.default.createElement(
      'div',
      null,
      'Failed to find route for id: ',
      data.variables.id
    );
  }

  var _data$route = data.route,
      status = _data$route.status,
      oppositeRouteId = _data$route.oppositeRouteId,
      _data$route$from = _data$route.from,
      fromDevice = _data$route$from.trackingDevice,
      fromLocationName = _data$route$from.name,
      _data$route$to = _data$route.to,
      toDevice = _data$route$to.trackingDevice,
      toLocationName = _data$route$to.name,
      liveTravelTime = _data$route.liveTravelTime,
      expectedTravelTime = _data$route.expectedTravelTime,
      liveTravelTimeToday = _data$route.liveTravelTimeToday,
      expectedTravelTimeToday = _data$route.expectedTravelTimeToday,
      travelTimeIndex = _data$route.travelTimeIndex,
      liveSpeed = _data$route.liveSpeed,
      normalSpeed = _data$route.normalSpeed,
      speedLimit = _data$route.speedLimit,
      segments = _data$route.segments,
      id = _data$route.id;


  var isReporting = status !== 'disconnected';
  var reportInterval = Math.max(fromDevice.reportInterval, toDevice.reportInterval);
  var lastUpdate = fromDevice.lastUpdate;
  var speedTrend = 'up';

  var numberOfTripsToday = segments.reduce(function (acc, curr) {
    return acc + curr.numberOfTripsToday;
  }, 0);
  var numberOfTripsSinceLastUpdate = segments.reduce(function (acc, curr) {
    return acc + curr.numberOfTripsSinceLastUpdate;
  }, 0);

  return _react2.default.createElement(
    _Layout2.default,
    {
      backTo: '/map/live/routes',
      title: 'All routes',
      header: _react2.default.createElement(_RouteHeader2.default, {
        status: status,
        fromName: fromLocationName,
        toName: toLocationName,
        oppositeRouteId: oppositeRouteId
      })
    },
    isReporting ? _react2.default.createElement(
      _TripletRow2.default,
      { title: 'Travel time' },
      _react2.default.createElement(
        _TripletItem2.default,
        { title: 'live', unitName: 'min', status: status },
        _react2.default.createElement(_TimeDisplay2.default, { value: liveTravelTime, status: status }),
        _react2.default.createElement(_SpeedTrendIcon2.default, {
          trend: speedTrend,
          className: (0, _classnames2.default)(_route2.default.trendIcon, _defineProperty({}, _route2.default['status-' + status], status))
        })
      ),
      _react2.default.createElement(
        _TripletItem2.default,
        { title: 'expected', unitName: 'min' },
        _react2.default.createElement(_TimeDisplay2.default, { value: expectedTravelTime })
      ),
      _react2.default.createElement(
        _TripletItem2.default,
        { title: 'index' },
        (0, _formatFloat2.default)(travelTimeIndex)
      )
    ) : _react2.default.createElement(
      _TripletRow2.default,
      { title: 'Travel time' },
      _react2.default.createElement(
        _TripletItem2.default,
        { title: 'live', unitName: 'min', status: status },
        _react2.default.createElement(
          'span',
          null,
          '-'
        )
      ),
      _react2.default.createElement(
        _TripletItem2.default,
        { title: 'expected', unitName: 'min', status: status },
        _react2.default.createElement(
          'span',
          null,
          '-'
        )
      ),
      _react2.default.createElement(
        _TripletItem2.default,
        { title: 'index', status: status },
        _react2.default.createElement(
          'span',
          null,
          '-'
        )
      )
    ),
    _react2.default.createElement(_Chart2.default, {
      reportedValues: liveTravelTimeToday,
      expectedValues: expectedTravelTimeToday,
      calculateCrosshairA: function calculateCrosshairA(_ref2) {
        var reported = _ref2.reported;
        return {
          value: (0, _formatMinutesSeconds2.default)(reported, {
            useClockFormat: true
          }),
          title: 'TT'
        };
      },
      calculateCrosshairB: function calculateCrosshairB(_ref3) {
        var reported = _ref3.reported,
            expected = _ref3.expected;
        return {
          value: (0, _formatFloat2.default)(reported / expected),
          title: 'TTI'
        };
      }
    }),
    _react2.default.createElement(
      _GridRow2.default,
      { title: 'Speed' },
      _react2.default.createElement(
        _GridItem2.default,
        { label: 'live speed', status: status },
        isReporting ? _react2.default.createElement(_SpeedDisplay2.default, { status: status, value: liveSpeed, unit: 'MPH', trend: speedTrend }) : '-'
      ),
      _react2.default.createElement(
        _GridItem2.default,
        { label: 'speed limit' },
        _react2.default.createElement(_SpeedDisplay2.default, { value: speedLimit, unit: 'MPH' })
      ),
      _react2.default.createElement(
        _GridItem2.default,
        { label: 'expected speed' },
        _react2.default.createElement(_SpeedDisplay2.default, { value: normalSpeed, unit: 'MPH' })
      )
    ),
    _react2.default.createElement(
      _GridRow2.default,
      { title: 'Updates' },
      _react2.default.createElement(
        _GridItem2.default,
        { label: 'trips today' },
        (0, _formatInteger2.default)(numberOfTripsToday)
      ),
      _react2.default.createElement(
        _GridItem2.default,
        { label: 'trips last update' },
        (0, _formatInteger2.default)(numberOfTripsSinceLastUpdate)
      ),
      isReporting ? _react2.default.createElement(
        _GridItem2.default,
        { label: 'next update' },
        (0, _formatNextUpdate2.default)(lastUpdate, reportInterval)
      ) : _react2.default.createElement(
        _GridItem2.default,
        { label: 'last update' },
        (0, _formatLastUpdate2.default)(lastUpdate)
      )
    ),
    _react2.default.createElement(_RouteSegments2.default, {
      title: 'segments in route',
      segments: segments,
      selectEntity: selectEntity,
      enterEntity: enterEntity,
      leaveEntity: leaveEntity
    }),
    _react2.default.createElement(
      _HorizontalSection2.default,
      { center: true },
      _react2.default.createElement(
        _IconButton2.default,
        { label: 'details page', linkTo: '/segments/' + id, disabled: true, asLink: true, iconRight: true },
        _react2.default.createElement(_chevronInline2.default, null)
      )
    )
  );
}

Route.propTypes = {
  data: (0, _propTypes.shape)({
    loading: _propTypes.bool.isRequired,
    location: (0, _propTypes.shape)({}),
    route: (0, _propTypes.shape)({
      id: _propTypes.string.isRequired
    })
  }).isRequired,
  selectEntity: _propTypes.func.isRequired,
  enterEntity: _propTypes.func.isRequired,
  leaveEntity: _propTypes.func.isRequired
};

var mapStateToProps = function mapStateToProps(_, ownProps) {
  return _extends({}, ownProps);
};

var ConnectedRouteWithData = (0, _reactApollo.compose)((0, _reactRedux.connect)(mapStateToProps, _extends({}, _map.operations)), (0, _reactApollo.graphql)(RouteQuery, {
  options: function options(_ref4) {
    var params = _ref4.params;
    return {
      variables: {
        id: params.id
      }
    };
  }
}))(Route);

var _default = ConnectedRouteWithData;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(RouteQuery, 'RouteQuery', '/code/src/components/DataPanel/Details/Route/index.js');

  __REACT_HOT_LOADER__.register(Route, 'Route', '/code/src/components/DataPanel/Details/Route/index.js');

  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/code/src/components/DataPanel/Details/Route/index.js');

  __REACT_HOT_LOADER__.register(ConnectedRouteWithData, 'ConnectedRouteWithData', '/code/src/components/DataPanel/Details/Route/index.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/code/src/components/DataPanel/Details/Route/index.js');
}();

;

/***/ }),

/***/ "7jAy":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SVG = function (_React$Component) {
  _inherits(SVG, _React$Component);

  function SVG() {
    _classCallCheck(this, SVG);

    return _possibleConstructorReturn(this, (SVG.__proto__ || Object.getPrototypeOf(SVG)).apply(this, arguments));
  }

  _createClass(SVG, [{
    key: "render",
    value: function render() {
      return _react2.default.createElement(
        "svg",
        _extends({ viewBox: "0 0 30 32", xmlns: "http://www.w3.org/2000/svg", fill: "currentColor" }, this.props),
        _react2.default.createElement("path", { d: "M27.866 15.298l1.415-1.414-7.026-7.026-7.025 7.026 1.414 1.414 5.61-5.612" }),
        _react2.default.createElement("path", { d: "M21.255 25.266l-5.328 5.328 1.414 1.414 5.915-5.914V8.272h-2M1.388 16.655L-.026 18.07 7 25.093l7.026-7.025-1.414-1.415L7 22.265" }),
        _react2.default.createElement("path", { d: "M13.01 1.677L11.594.263 6 5.858V23.68h2V6.686" })
      );
    }
  }]);

  return SVG;
}(_react2.default.Component);

var _default = SVG;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(SVG, "SVG", "/code/src/icons/panel-switch.inline.svg");

  __REACT_HOT_LOADER__.register(_default, "default", "/code/src/icons/panel-switch.inline.svg");
}();

;

/***/ }),

/***/ "7p3X":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = formatNextUpdate;

var _formatMinutesSeconds = __webpack_require__("/rNx");

var _formatMinutesSeconds2 = _interopRequireDefault(_formatMinutesSeconds);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function formatNextUpdate(lastUpdate, reportInterval) {
  var lastUpdateDate = new Date(lastUpdate);
  var nowInSecs = Date.now() / 1000;
  var lastUpdateInSecs = lastUpdateDate.getTime() / 1000;
  var nextUpdateInSecs = lastUpdateInSecs - nowInSecs + reportInterval;

  if (nextUpdateInSecs < 0) return 'Now';

  return (0, _formatMinutesSeconds2.default)(nextUpdateInSecs, { useClockFormat: true });
}
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(formatNextUpdate, 'formatNextUpdate', '/code/src/helpers/formatNextUpdate.js');
}();

;

/***/ }),

/***/ "7uQU":
/***/ (function(module, exports) {

module.exports = "/location-warning-31a261984c8fc1823d6859198f4c8fcc.svg";

/***/ }),

/***/ "8LQ0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = SegmentTooltip;

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _classnames = __webpack_require__("HW6M");

var _classnames2 = _interopRequireDefault(_classnames);

var _Tooltip = __webpack_require__("lhKr");

var _Tooltip2 = _interopRequireDefault(_Tooltip);

var _TooltipItem = __webpack_require__("my8f");

var _TooltipItem2 = _interopRequireDefault(_TooltipItem);

var _segmentInline = __webpack_require__("JMsO");

var _segmentInline2 = _interopRequireDefault(_segmentInline);

var _segmentBrokenInline = __webpack_require__("E2tk");

var _segmentBrokenInline2 = _interopRequireDefault(_segmentBrokenInline);

var _segmentStatus = __webpack_require__("fX1p");

var _segmentStatus2 = _interopRequireDefault(_segmentStatus);

var _segmentTooltip = __webpack_require__("ptpK");

var _segmentTooltip2 = _interopRequireDefault(_segmentTooltip);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// @TODO use new components: WithTrend, SpeedDisplay, TimeDisplay, SegmentNameDisplay
function SegmentTooltip(_ref) {
  var status = _ref.status,
      name = _ref.name;

  var isReporting = status !== 'disconnected';

  return _react2.default.createElement(
    _Tooltip2.default,
    { sticky: true, offset: [5, -10], className: (0, _classnames2.default)(_segmentTooltip2.default.main, _segmentTooltip2.default['status-' + status]) },
    _react2.default.createElement(
      _TooltipItem2.default,
      { label: 'segment' },
      _react2.default.createElement(
        'div',
        { className: _segmentTooltip2.default.segment },
        isReporting ? _react2.default.createElement(_segmentInline2.default, { className: _segmentTooltip2.default.segmentIcon }) : _react2.default.createElement(_segmentBrokenInline2.default, { className: _segmentTooltip2.default.segmentIcon }),
        _react2.default.createElement(
          'div',
          { className: _segmentTooltip2.default.segmentName },
          _react2.default.createElement(
            'div',
            null,
            name.from
          ),
          _react2.default.createElement(
            'div',
            null,
            name.to
          )
        )
      )
    )
  );
}

SegmentTooltip.propTypes = {
  status: _segmentStatus2.default.isRequired,
  name: (0, _propTypes.shape)({ to: _propTypes.string.isRequired, from: _propTypes.string.isRequired }).isRequired
};
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(SegmentTooltip, 'SegmentTooltip', '/code/src/components/Map/CreateRoute/SegmentTooltip/index.js');
}();

;

/***/ }),

/***/ "8R2t":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }
}();

;

/***/ }),

/***/ "9/r9":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = SegmentTooltip;

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _classnames = __webpack_require__("HW6M");

var _classnames2 = _interopRequireDefault(_classnames);

var _Tooltip = __webpack_require__("lhKr");

var _Tooltip2 = _interopRequireDefault(_Tooltip);

var _TooltipItem = __webpack_require__("my8f");

var _TooltipItem2 = _interopRequireDefault(_TooltipItem);

var _SpeedTrendIcon = __webpack_require__("sCW4");

var _SpeedTrendIcon2 = _interopRequireDefault(_SpeedTrendIcon);

var _segmentSmallInline = __webpack_require__("duV/");

var _segmentSmallInline2 = _interopRequireDefault(_segmentSmallInline);

var _segmentSmallBrokenInline = __webpack_require__("ilXI");

var _segmentSmallBrokenInline2 = _interopRequireDefault(_segmentSmallBrokenInline);

var _formatMinutesSeconds = __webpack_require__("/rNx");

var _formatMinutesSeconds2 = _interopRequireDefault(_formatMinutesSeconds);

var _segmentStatus = __webpack_require__("fX1p");

var _segmentStatus2 = _interopRequireDefault(_segmentStatus);

var _segmentTooltip = __webpack_require__("zHhQ");

var _segmentTooltip2 = _interopRequireDefault(_segmentTooltip);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// @TODO use new components: WithTrend, SpeedDisplay, TimeDisplay, SegmentNameDisplay
function SegmentTooltip(_ref) {
  var status = _ref.status,
      name = _ref.name,
      liveTravelTime = _ref.liveTravelTime,
      speedTrend = _ref.speedTrend;

  var isReporting = status !== 'disconnected';

  return _react2.default.createElement(
    _Tooltip2.default,
    { sticky: true, offset: [5, -10], className: (0, _classnames2.default)(_segmentTooltip2.default.main, _segmentTooltip2.default['status-' + status]) },
    _react2.default.createElement(
      _TooltipItem2.default,
      { label: isReporting ? 'travel time' : 'status', status: status },
      isReporting ? _react2.default.createElement(
        'div',
        { className: _segmentTooltip2.default.liveTravelTime },
        speedTrend && _react2.default.createElement(_SpeedTrendIcon2.default, { trend: speedTrend, className: _segmentTooltip2.default.trendIcon }),
        _react2.default.createElement(
          'span',
          { className: _segmentTooltip2.default.speedNumber },
          (0, _formatMinutesSeconds2.default)(liveTravelTime, { useClockFormat: true })
        )
      ) : _react2.default.createElement(
        'div',
        { className: _segmentTooltip2.default.statusText },
        'Disconnected'
      )
    ),
    _react2.default.createElement(
      _TooltipItem2.default,
      { label: 'segment' },
      _react2.default.createElement(
        'div',
        { className: _segmentTooltip2.default.segment },
        isReporting ? _react2.default.createElement(_segmentSmallInline2.default, { width: 8, className: _segmentTooltip2.default.segmentIcon }) : _react2.default.createElement(_segmentSmallBrokenInline2.default, { width: 8, className: _segmentTooltip2.default.segmentIcon }),
        _react2.default.createElement(
          'div',
          { className: _segmentTooltip2.default.segmentName },
          _react2.default.createElement(
            'div',
            null,
            name.from
          ),
          _react2.default.createElement(
            'div',
            null,
            name.to
          )
        )
      )
    )
  );
}

SegmentTooltip.propTypes = {
  status: _segmentStatus2.default.isRequired,
  name: (0, _propTypes.shape)({ to: _propTypes.string.isRequired, from: _propTypes.string.isRequired }).isRequired,
  liveTravelTime: _propTypes.number.isRequired,
  speedTrend: (0, _propTypes.oneOf)(['up', 'down'])
};
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(SegmentTooltip, 'SegmentTooltip', '/code/src/components/Map/MapComponents/SegmentTooltip/index.js');
}();

;

/***/ }),

/***/ "9XvQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"main":"TripletRow-main--2CCun","title":"TripletRow-title--JMtsF","rowItemsContainer":"TripletRow-rowItemsContainer---mSnq","withBorder":"TripletRow-withBorder--1wxXe"};

/***/ }),

/***/ "9pd4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"outlineBase":"ExistingSegmentPath-outlineBase--3-BsE","isActive":"ExistingSegmentPath-isActive--2fh6M","selected":"ExistingSegmentPath-selected--7Mc_X","underlineBase":"ExistingSegmentPath-underlineBase--5Xl6l","lineBase":"ExistingSegmentPath-lineBase--20ouR","marching_ants":"ExistingSegmentPath-marching_ants--1H_6s","outline":"ExistingSegmentPath-outline--hc0OX ExistingSegmentPath-outlineBase--3-BsE","underline":"ExistingSegmentPath-underline--67ekM ExistingSegmentPath-underlineBase--5Xl6l","line":"ExistingSegmentPath-line--2Xqjq ExistingSegmentPath-lineBase--20ouR"};

/***/ }),

/***/ "ADHu":
/***/ (function(module, exports) {

module.exports = "/location-problem-7a1c216ccb7a909962e0a32cc0832ae8.svg";

/***/ }),

/***/ "Azcd":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectSegment = selectSegment;
exports.deselectSegment = deselectSegment;
exports.setCreatedRouteId = setCreatedRouteId;
exports.clearCreateRoute = clearCreateRoute;

var _types = __webpack_require__("3pOm");

var _types2 = _interopRequireDefault(_types);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function selectSegment(id) {
  return {
    type: _types2.default.SELECT_SEGMENT,
    payload: {
      id: id
    }
  };
}

function deselectSegment(id) {
  return {
    type: _types2.default.DESELECT_SEGMENT,
    payload: {
      id: id
    }
  };
}

function setCreatedRouteId(id) {
  return {
    type: _types2.default.SET_CREATED_ROUTE_ID,
    payload: {
      id: id
    }
  };
}

function clearCreateRoute() {
  return {
    type: _types2.default.CLEAR_CREATE_ROUTE
  };
}
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(selectSegment, 'selectSegment', '/code/src/state/ducks/routeCreation/actions.js');

  __REACT_HOT_LOADER__.register(deselectSegment, 'deselectSegment', '/code/src/state/ducks/routeCreation/actions.js');

  __REACT_HOT_LOADER__.register(setCreatedRouteId, 'setCreatedRouteId', '/code/src/state/ducks/routeCreation/actions.js');

  __REACT_HOT_LOADER__.register(clearCreateRoute, 'clearCreateRoute', '/code/src/state/ducks/routeCreation/actions.js');
}();

;

/***/ }),

/***/ "B3Ub":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getPriorityForStatus;

var _invariant = __webpack_require__("crWv");

var _invariant2 = _interopRequireDefault(_invariant);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PRIORITY_WEIGHTS = {
  problem: 4,
  disconnected: 3,
  warning: 2,
  ok: 1
};

function getPriorityForStatus(status) {
  var weight = PRIORITY_WEIGHTS[status];
  (0, _invariant2.default)(weight !== undefined, 'No sort weight for status: ' + status);
  return weight;
}
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(PRIORITY_WEIGHTS, 'PRIORITY_WEIGHTS', '/code/src/helpers/getPriorityForStatus.js');

  __REACT_HOT_LOADER__.register(getPriorityForStatus, 'getPriorityForStatus', '/code/src/helpers/getPriorityForStatus.js');
}();

;

/***/ }),

/***/ "BgS3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _segmentStatus = __webpack_require__("fX1p");

var _segmentStatus2 = _interopRequireDefault(_segmentStatus);

var _SegmentPath = __webpack_require__("LoGb");

var _SegmentPath2 = _interopRequireDefault(_SegmentPath);

var _RouteTooltip = __webpack_require__("hoL6");

var _RouteTooltip2 = _interopRequireDefault(_RouteTooltip);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Segment = function (_Component) {
  _inherits(Segment, _Component);

  function Segment() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Segment);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Segment.__proto__ || Object.getPrototypeOf(Segment)).call.apply(_ref, [this].concat(args))), _this), _this.defaultProps = {
      priority: 0
    }, _this.state = {
      travelTimeTrend: null
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Segment, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var trend = nextProps.route.liveTravelTime >= this.props.route.liveTravelTime ? 'up' : 'down';
      this.setState({ travelTimeTrend: trend });
    }
  }, {
    key: 'render',
    value: function render() {
      // eslint-disable-next-line global-require
      var _require = __webpack_require__("Zz/N"),
          FeatureGroup = _require.FeatureGroup;

      var _props = this.props,
          segment = _props.segment,
          isActive = _props.isActive,
          route = _props.route,
          isSelected = _props.isSelected;
      var path = segment.path,
          segmentStatus = segment.status;
      var routeStatus = route.status,
          from = route.from,
          to = route.to,
          liveTravelTime = route.liveTravelTime,
          distance = route.distance;

      var name = { from: from.name, to: to.name };

      return _react2.default.createElement(
        FeatureGroup,
        null,
        _react2.default.createElement(_SegmentPath2.default, {
          latLngList: path,
          status: isSelected ? segmentStatus : routeStatus,
          isActive: isActive
        }),
        _react2.default.createElement(_RouteTooltip2.default, {
          status: routeStatus,
          name: name,
          liveTravelTime: liveTravelTime,
          travelTimeTrend: this.state.travelTimeTrend,
          distance: distance
        })
      );
    }
  }]);

  return Segment;
}(_react.Component);

Segment.propTypes = {
  isSelected: _propTypes.bool.isRequired,
  isActive: _propTypes.bool.isRequired,
  segment: (0, _propTypes.shape)({
    path: (0, _propTypes.arrayOf)((0, _propTypes.arrayOf)(_propTypes.number)).isRequired,
    status: _segmentStatus2.default.isRequired
  }).isRequired,
  route: (0, _propTypes.shape)({
    from: (0, _propTypes.shape)({
      name: _propTypes.string
    }).isRequired,
    to: (0, _propTypes.shape)({
      name: _propTypes.string
    }).isRequired,
    status: _segmentStatus2.default.isRequired,
    liveTravelTime: _propTypes.number.isRequired
  })
};
var _default = Segment;
exports.default = _default;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(Segment, 'Segment', '/code/src/components/Map/MapComponents/RouteSegment/index.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/code/src/components/Map/MapComponents/RouteSegment/index.js');
}();

;

/***/ }),

/***/ "Bi5r":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"buttonBase":"DeviceContainer-buttonBase--1LwtY","shadowBottom":"DeviceContainer-shadowBottom--233gG","shadowBottomHover":"DeviceContainer-shadowBottomHover--3391Z","shadowListItem":"DeviceContainer-shadowListItem--3EIiO","shadowRight":"DeviceContainer-shadowRight--3e3F4","shadowLeft":"DeviceContainer-shadowLeft--1-P3V","shadowAround":"DeviceContainer-shadowAround--2YSTJ","shadowAroundHover":"DeviceContainer-shadowAroundHover--On7fK","shadowButton":"DeviceContainer-shadowButton--3-j7v","shadowButtonHover":"DeviceContainer-shadowButtonHover--1NQov","main":"DeviceContainer-main--2NjA2","content":"DeviceContainer-content--3bOUy DeviceContainer-shadowBottom--233gG"};

/***/ }),

/***/ "BiFx":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"main":"GridItem-main--1xQRB","label":"GridItem-label--2fIFP","content":"GridItem-content--1pibB","status-ok":"GridItem-status-ok--1uxqF","status-warning":"GridItem-status-warning--2YKUZ","status-problem":"GridItem-status-problem--1uLIy","status-disconnected":"GridItem-status-disconnected--1jJ7b"};

/***/ }),

/***/ "C/D4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = sortSegments;

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var isOffline = function isOffline(_ref) {
  var status = _ref.status;
  return status === 'disconnected';
};

var sortSegmentAscending = function sortSegmentAscending(property) {
  return function (a, b) {
    var aIsOffline = isOffline(a);
    var bIsOffline = isOffline(b);

    if (aIsOffline) return -1; // sort a after b
    if (bIsOffline) return 1; // sort a before b

    return a[property] >= b[property] ? 1 : -1;
  };
};

function sortSegments(segments, value, order) {
  var result = [].concat(_toConsumableArray(segments));

  switch (value) {
    case 'tti':
      result.sort(sortSegmentAscending('travelTimeIndex'));
      break;
    case 'speed':
      result.sort(sortSegmentAscending('liveSpeed'));
      break;
    default:
  }

  return order === 'asc' ? result : result.reverse();
}
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(isOffline, 'isOffline', '/code/src/helpers/sortSegments.js');

  __REACT_HOT_LOADER__.register(sortSegmentAscending, 'sortSegmentAscending', '/code/src/helpers/sortSegments.js');

  __REACT_HOT_LOADER__.register(sortSegments, 'sortSegments', '/code/src/helpers/sortSegments.js');
}();

;

/***/ }),

/***/ "CfcP":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _reactRedux = __webpack_require__("RH2O");

var _classnames = __webpack_require__("HW6M");

var _classnames2 = _interopRequireDefault(_classnames);

var _routeCreation = __webpack_require__("tEHQ");

var _InlineButton = __webpack_require__("tcGo");

var _InlineButton2 = _interopRequireDefault(_InlineButton);

var _closeInline = __webpack_require__("2bM4");

var _closeInline2 = _interopRequireDefault(_closeInline);

var _segmentSmallInline = __webpack_require__("duV/");

var _segmentSmallInline2 = _interopRequireDefault(_segmentSmallInline);

var _segmentSmallBrokenInline = __webpack_require__("ilXI");

var _segmentSmallBrokenInline2 = _interopRequireDefault(_segmentSmallBrokenInline);

var _Header = __webpack_require__("z4D3");

var _Header2 = _interopRequireDefault(_Header);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function createRouteItem(segment, showRemoveButton, onClickHandler, hasOneSegment, index, isFinished) {
  var isReporting = segment.status !== 'disconnected';
  return _react2.default.createElement(
    'li',
    { key: 'Via-' + segment.id },
    _react2.default.createElement(
      'div',
      { className: _Header2.default.item },
      _react2.default.createElement(
        'span',
        { className: _Header2.default.segmentNumber },
        index + 1
      ),
      _react2.default.createElement(
        'div',
        { className: _Header2.default.label },
        isReporting ? _react2.default.createElement(_segmentSmallInline2.default, { width: 8, className: _Header2.default.icon }) : _react2.default.createElement(_segmentSmallBrokenInline2.default, { width: 8, className: _Header2.default.icon }),
        _react2.default.createElement(
          'div',
          { className: _Header2.default.labelContent },
          _react2.default.createElement(
            'span',
            null,
            segment.from.name
          ),
          _react2.default.createElement(
            'span',
            null,
            segment.to.name
          )
        )
      ),
      !isFinished && _react2.default.createElement(
        _InlineButton2.default,
        { showLabel: false, onClick: function onClick() {
            return onClickHandler(segment.id);
          } },
        _react2.default.createElement(_closeInline2.default, null)
      )
    ),
    hasOneSegment && _react2.default.createElement(
      'div',
      { className: (0, _classnames2.default)(_Header2.default.label, _Header2.default.emptyListSegment) },
      _react2.default.createElement(
        'div',
        { className: _Header2.default.labelContent },
        _react2.default.createElement(
          'span',
          { className: _Header2.default.hint },
          'Select a second segment'
        )
      )
    )
  );
}

function Header(_ref) {
  var selectedSegments = _ref.selectedSegments,
      deselectSegment = _ref.deselectSegment,
      isFinished = _ref.isFinished;

  var hasMoreSegments = selectedSegments.length === 1;

  if (selectedSegments.length === 0) return null;

  return _react2.default.createElement(
    'ul',
    { className: _Header2.default.main },
    selectedSegments.map(function (segment, index) {
      return createRouteItem(segment, false, deselectSegment, hasMoreSegments, index, isFinished);
    })
  );
}

Header.propTypes = {
  selectedSegments: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    id: _propTypes.string,
    from: (0, _propTypes.shape)({
      id: _propTypes.string,
      name: _propTypes.string
    }),
    to: (0, _propTypes.shape)({
      id: _propTypes.string,
      name: _propTypes.string
    })
  })).isRequired,
  deselectSegment: _propTypes.func.isRequired,
  isFinished: _propTypes.bool.isRequired
};

var ConnectedHeader = (0, _reactRedux.connect)(null, _routeCreation.operations)(Header);

var _default = ConnectedHeader;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(createRouteItem, 'createRouteItem', '/code/src/components/MapPanel/CreateRoute/Header/index.js');

  __REACT_HOT_LOADER__.register(Header, 'Header', '/code/src/components/MapPanel/CreateRoute/Header/index.js');

  __REACT_HOT_LOADER__.register(ConnectedHeader, 'ConnectedHeader', '/code/src/components/MapPanel/CreateRoute/Header/index.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/code/src/components/MapPanel/CreateRoute/Header/index.js');
}();

;

/***/ }),

/***/ "Cvct":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _lodash = __webpack_require__("M4fF");

var _classnames = __webpack_require__("HW6M");

var _classnames2 = _interopRequireDefault(_classnames);

var _WithSubtitle = __webpack_require__("j/Bm");

var _WithSubtitle2 = _interopRequireDefault(_WithSubtitle);

var _Trendline = __webpack_require__("cH2h");

var _Trendline2 = _interopRequireDefault(_Trendline);

var _BatteryIcon = __webpack_require__("fNy8");

var _BatteryIcon2 = _interopRequireDefault(_BatteryIcon);

var _LocationStatusIcon = __webpack_require__("fu+b");

var _LocationStatusIcon2 = _interopRequireDefault(_LocationStatusIcon);

var _deviceStatus = __webpack_require__("2Ejm");

var _deviceStatus2 = _interopRequireDefault(_deviceStatus);

var _LocationsListItem = __webpack_require__("tz4E");

var _LocationsListItem2 = _interopRequireDefault(_LocationsListItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/**
 * Accumulate values by summing each value with the total of the values
 * before it.
 * @param {Array} values
 */
function accumulatePreviousValues(values) {
  return values.reduce(function (acc, v, index) {
    if (index === 0) return [v];
    return [].concat(_toConsumableArray(acc), [v + acc[index - 1]]);
  }, []);
}

function LocationsListItem(_ref) {
  var location = _ref.location;
  var trackingDevice = location.trackingDevice,
      name = location.name;
  var hitsToday = trackingDevice.hitsToday,
      deviceId = trackingDevice.id,
      deviceName = trackingDevice.name,
      batteryVoltage = trackingDevice.batteryVoltage;


  var accumulatedHitsToday = accumulatePreviousValues(hitsToday);
  var status = trackingDevice.status;

  return _react2.default.createElement(
    'div',
    { className: (0, _classnames2.default)(_LocationsListItem2.default.main, _LocationsListItem2.default['status-' + status]) },
    _react2.default.createElement(
      'span',
      { className: _LocationsListItem2.default.location },
      _react2.default.createElement(_LocationStatusIcon2.default, { className: _LocationsListItem2.default.locationIcon, status: status })
    ),
    _react2.default.createElement(
      'div',
      { className: _LocationsListItem2.default.textContainer },
      _react2.default.createElement(
        _WithSubtitle2.default,
        { className: _LocationsListItem2.default.name, title: deviceName || deviceId },
        name
      )
    ),
    _react2.default.createElement(
      'div',
      { className: _LocationsListItem2.default.dataContainer },
      _react2.default.createElement(
        _WithSubtitle2.default,
        { className: _LocationsListItem2.default.battery, title: (0, _lodash.round)(batteryVoltage, 1) + 'V' },
        _react2.default.createElement(_BatteryIcon2.default, { className: _LocationsListItem2.default.batteryIcon, batteryVoltage: batteryVoltage })
      ),
      _react2.default.createElement(
        _WithSubtitle2.default,
        { className: _LocationsListItem2.default.sparkLine, title: 'hits' },
        _react2.default.createElement(_Trendline2.default, { trendData: accumulatedHitsToday, width: 32, height: 12 })
      )
    )
  );
}

LocationsListItem.propTypes = {
  location: (0, _propTypes.shape)({
    name: _propTypes.string.isRequired,
    trackingDevice: (0, _propTypes.shape)({
      status: _deviceStatus2.default.isRequired,
      hitsToday: (0, _propTypes.arrayOf)(_propTypes.number).isRequired,
      id: _propTypes.string.isRequired,
      name: _propTypes.string,
      batteryVoltage: _propTypes.number.isRequired
    })
  }).isRequired
};

var _default = LocationsListItem;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(accumulatePreviousValues, 'accumulatePreviousValues', '/code/src/components/DataPanel/Overview/LocationsListItem/index.js');

  __REACT_HOT_LOADER__.register(LocationsListItem, 'LocationsListItem', '/code/src/components/DataPanel/Overview/LocationsListItem/index.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/code/src/components/DataPanel/Overview/LocationsListItem/index.js');
}();

;

/***/ }),

/***/ "D5y+":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reducers = __webpack_require__("zWno");

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_reducers).default;
  }
});

var _types = __webpack_require__("yyqx");

Object.defineProperty(exports, 'types', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_types).default;
  }
});

var _selectors = __webpack_require__("4lJq");

Object.defineProperty(exports, 'selectors', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_selectors).default;
  }
});

var _operations = __webpack_require__("hYpx");

Object.defineProperty(exports, 'operations', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_operations).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }
}();

;

/***/ }),

/***/ "DEBG":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n  query Segments {\n    segments {\n      id\n      name\n      status\n      from {\n        id\n        name\n        trackingDevice {\n          id\n          status\n        }\n      }\n      to {\n        id\n        name\n        trackingDevice {\n          id\n          status\n        }\n      }\n      path\n    }\n  }\n'], ['\n  query Segments {\n    segments {\n      id\n      name\n      status\n      from {\n        id\n        name\n        trackingDevice {\n          id\n          status\n        }\n      }\n      to {\n        id\n        name\n        trackingDevice {\n          id\n          status\n        }\n      }\n      path\n    }\n  }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  mutation createRoute($segmentIds: [ID!]!) {\n    createRoute(segmentIds: $segmentIds) {\n      id\n    }\n  }\n'], ['\n  mutation createRoute($segmentIds: [ID!]!) {\n    createRoute(segmentIds: $segmentIds) {\n      id\n    }\n  }\n']);

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _reactApollo = __webpack_require__("3zLD");

var _reactRedux = __webpack_require__("RH2O");

var _routeCreation = __webpack_require__("tEHQ");

var _map = __webpack_require__("YByT");

var _locationShape = __webpack_require__("1itO");

var _locationShape2 = _interopRequireDefault(_locationShape);

var _coord = __webpack_require__("w0mN");

var _coord2 = _interopRequireDefault(_coord);

var _filterSegmentsByFrom = __webpack_require__("ajpx");

var _filterSegmentsByFrom2 = _interopRequireDefault(_filterSegmentsByFrom);

var _SegmentNameDisplay = __webpack_require__("k9w0");

var _SegmentNameDisplay2 = _interopRequireDefault(_SegmentNameDisplay);

var _LoadingIndicator = __webpack_require__("G+3p");

var _LoadingIndicator2 = _interopRequireDefault(_LoadingIndicator);

var _Live = __webpack_require__("NsJu");

var _Header = __webpack_require__("CfcP");

var _Header2 = _interopRequireDefault(_Header);

var _List = __webpack_require__("SLyG");

var _List2 = _interopRequireDefault(_List);

var _ListItem = __webpack_require__("j9gU");

var _ListItem2 = _interopRequireDefault(_ListItem);

var _Footer = __webpack_require__("7H5I");

var _Footer2 = _interopRequireDefault(_Footer);

var _Title = __webpack_require__("o77h");

var _Title2 = _interopRequireDefault(_Title);

var _CreateRoute = __webpack_require__("cI+y");

var _CreateRoute2 = _interopRequireDefault(_CreateRoute);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var API_ERROR = '__error__';

var CreateRouteQuery = (0, _reactApollo.gql)(_templateObject);

var CreateRouteMutation = (0, _reactApollo.gql)(_templateObject2);

var CreateRoute = function (_Component) {
  _inherits(CreateRoute, _Component);

  function CreateRoute() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, CreateRoute);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CreateRoute.__proto__ || Object.getPrototypeOf(CreateRoute)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      waitForResponse: false
    }, _this.handleDone = function () {
      var _this2;

      return (_this2 = _this).__handleDone__REACT_HOT_LOADER__.apply(_this2, arguments);
    }, _this.handleClose = function () {
      var _this3;

      return (_this3 = _this).__handleClose__REACT_HOT_LOADER__.apply(_this3, arguments);
    }, _this.handleCancel = function () {
      var _this4;

      return (_this4 = _this).__handleCancel__REACT_HOT_LOADER__.apply(_this4, arguments);
    }, _this.handleNew = function () {
      var _this5;

      return (_this5 = _this).__handleNew__REACT_HOT_LOADER__.apply(_this5, arguments);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(CreateRoute, [{
    key: '__handleDone__REACT_HOT_LOADER__',
    value: function __handleDone__REACT_HOT_LOADER__() {
      var _this6 = this;

      var _props = this.props,
          createRoute = _props.createRoute,
          setCreatedRouteId = _props.setCreatedRouteId;

      createRoute().then(function (result) {
        setCreatedRouteId(result.data.createRoute.id);
        _this6.setState({ waitForResponse: false });
      }).catch(function (err) {
        _this6.setState({ waitForResponse: false });
        throw new Error('Failed to create route: ' + err.message);
      });

      this.setState({ waitForResponse: true });
    }
  }, {
    key: '__handleClose__REACT_HOT_LOADER__',
    value: function __handleClose__REACT_HOT_LOADER__() {
      this.props.finishCreateRoute();
    }
  }, {
    key: '__handleCancel__REACT_HOT_LOADER__',
    value: function __handleCancel__REACT_HOT_LOADER__() {
      this.props.finishCreateRoute();
    }
  }, {
    key: '__handleNew__REACT_HOT_LOADER__',
    value: function __handleNew__REACT_HOT_LOADER__() {
      this.props.clearCreateRoute();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          _props2$data = _props2.data,
          loading = _props2$data.loading,
          segments = _props2$data.segments,
          currentHover = _props2.currentHover,
          enterEntity = _props2.enterEntity,
          leaveEntity = _props2.leaveEntity,
          selectSegment = _props2.selectSegment,
          selectedSegments = _props2.selectedSegments,
          createdRouteId = _props2.createdRouteId;


      if (loading) return _react2.default.createElement(_LoadingIndicator2.default, null);

      var waitForResponse = this.state.waitForResponse;


      var hasError = createdRouteId === API_ERROR;
      var availableSegments = (0, _filterSegmentsByFrom2.default)(segments, selectedSegments);

      var isFinalStep = selectedSegments && selectedSegments.length > 1;
      var isFinished = Boolean(createdRouteId);

      // Show the list if to/from selection is not complete
      var showList = availableSegments.length > 0 && !isFinished;
      var selectedSegmentsObjects = selectedSegments.reduce(function (acc, selectedSegmentId) {
        var _segments$find = segments.find(function (segment) {
          return segment.id === selectedSegmentId;
        }),
            from = _segments$find.from,
            to = _segments$find.to,
            id = _segments$find.id,
            status = _segments$find.status;

        return [].concat(_toConsumableArray(acc), [{ from: from, to: to, id: id, status: status }]);
      }, []);

      return _react2.default.createElement(
        'div',
        { className: _CreateRoute2.default.main },
        _react2.default.createElement(
          'div',
          { className: _CreateRoute2.default.top },
          _react2.default.createElement(
            _Title2.default,
            null,
            'Create new route'
          ),
          _react2.default.createElement(_Header2.default, { selectedSegments: selectedSegmentsObjects, isFinished: isFinished }),
          selectedSegments.length > 0 && showList && _react2.default.createElement(
            'h3',
            { className: _CreateRoute2.default.subtitle },
            'Next available segments'
          )
        ),
        _react2.default.createElement(
          'div',
          { className: _CreateRoute2.default.content },
          showList && _react2.default.createElement(
            _List2.default,
            null,
            availableSegments.map(function (segment) {
              var fromName = segment.from.name,
                  toName = segment.to.name,
                  status = segment.status,
                  segmentId = segment.id;


              var isActive = currentHover && currentHover.id === segment.id;

              return _react2.default.createElement(
                _ListItem2.default,
                {
                  key: 'Segment-' + segmentId,
                  id: segmentId,
                  contentType: 'segment',
                  isActive: isActive,
                  onMouseOver: function onMouseOver() {
                    return enterEntity({ id: segmentId, type: 'segment' });
                  },
                  onMouseOut: function onMouseOut() {
                    return leaveEntity({ id: segmentId, type: 'segment' });
                  },
                  onClick: function onClick() {
                    return selectSegment(segmentId);
                  }
                },
                _react2.default.createElement(
                  'div',
                  { className: _CreateRoute2.default.segmentListItem },
                  _react2.default.createElement(_SegmentNameDisplay2.default, {
                    className: _CreateRoute2.default.segment,
                    fromLocationName: fromName,
                    toLocationName: toName,
                    status: status
                  })
                )
              );
            })
          ),
          isFinished ? hasError ? _react2.default.createElement(
            'div',
            { className: _CreateRoute2.default.text },
            'An error occurred. This has been reported.'
          ) : _react2.default.createElement(
            'div',
            { className: _CreateRoute2.default.text },
            'You have successfully created a new route.'
          ) : null
        ),
        _react2.default.createElement(_Footer2.default, {
          className: _CreateRoute2.default.footer,
          onCancel: this.handleCancel,
          onDone: this.handleDone,
          onNew: this.handleNew,
          onClose: this.handleClose,
          isFinalStep: isFinalStep,
          isFinished: isFinished,
          waitForResponse: waitForResponse
        })
      );
    }
  }]);

  return CreateRoute;
}(_react.Component);

CreateRoute.propTypes = {
  data: (0, _propTypes.shape)({
    loading: _propTypes.bool.isRequired,
    location: (0, _propTypes.shape)({}),
    segments: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
      id: _propTypes.string,
      path: (0, _propTypes.arrayOf)(_coord2.default),
      from: _locationShape2.default,
      to: _locationShape2.default
    }))
  }).isRequired,
  selectSegment: _propTypes.func.isRequired,
  createRoute: _propTypes.func.isRequired,
  setCreatedRouteId: _propTypes.func.isRequired,
  clearCreateRoute: _propTypes.func.isRequired,
  finishCreateRoute: _propTypes.func.isRequired,
  enterEntity: _propTypes.func.isRequired,
  leaveEntity: _propTypes.func.isRequired,
  selectedSegments: (0, _propTypes.arrayOf)(_propTypes.string).isRequired,
  createdRouteId: _propTypes.string,
  currentHover: (0, _propTypes.shape)({
    id: _propTypes.string
  })
};

var mapStateToProps = function mapStateToProps(_ref2) {
  var map = _ref2.map,
      routeCreation = _ref2.routeCreation;
  return {
    currentHover: map.currentHover,
    selectedSegments: routeCreation.selectedSegments,
    createdRouteId: routeCreation.createdRouteId
  };
};

var ConnectedCreateRouteWithData = (0, _reactApollo.compose)((0, _reactRedux.connect)(mapStateToProps, _extends({}, _map.operations, _routeCreation.operations)), (0, _reactApollo.graphql)(CreateRouteQuery, {}), (0, _reactApollo.graphql)(CreateRouteMutation, {
  props: function props(_ref3) {
    var mutate = _ref3.mutate,
        selectedSegments = _ref3.ownProps.selectedSegments;
    return {
      createRoute: function createRoute() {
        return mutate({
          variables: {
            segmentIds: selectedSegments
          },
          refetchQueries: [{
            query: _Live.LiveMapQuery
          }]
        });
      }
    };
  }
}))(CreateRoute);

var _default = ConnectedCreateRouteWithData;
exports.default = _default;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(API_ERROR, 'API_ERROR', '/code/src/components/MapPanel/CreateRoute/index.js');

  __REACT_HOT_LOADER__.register(CreateRouteQuery, 'CreateRouteQuery', '/code/src/components/MapPanel/CreateRoute/index.js');

  __REACT_HOT_LOADER__.register(CreateRouteMutation, 'CreateRouteMutation', '/code/src/components/MapPanel/CreateRoute/index.js');

  __REACT_HOT_LOADER__.register(CreateRoute, 'CreateRoute', '/code/src/components/MapPanel/CreateRoute/index.js');

  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/code/src/components/MapPanel/CreateRoute/index.js');

  __REACT_HOT_LOADER__.register(ConnectedCreateRouteWithData, 'ConnectedCreateRouteWithData', '/code/src/components/MapPanel/CreateRoute/index.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/code/src/components/MapPanel/CreateRoute/index.js');
}();

;

/***/ }),

/***/ "DP/h":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__("CIox");

var _Alerts = __webpack_require__("OZsc");

var _Alerts2 = _interopRequireDefault(_Alerts);

var _Routes = __webpack_require__("xTTB");

var _Routes2 = _interopRequireDefault(_Routes);

var _Segments = __webpack_require__("MBAn");

var _Segments2 = _interopRequireDefault(_Segments);

var _Locations = __webpack_require__("sod9");

var _Locations2 = _interopRequireDefault(_Locations);

var _Segment = __webpack_require__("jCS6");

var _Segment2 = _interopRequireDefault(_Segment);

var _Location = __webpack_require__("2Cva");

var _Location2 = _interopRequireDefault(_Location);

var _Route = __webpack_require__("7cX+");

var _Route2 = _interopRequireDefault(_Route);

var _Settings = __webpack_require__("lpq2");

var _Settings2 = _interopRequireDefault(_Settings);

var _CreateSegment = __webpack_require__("U85F");

var _CreateSegment2 = _interopRequireDefault(_CreateSegment);

var _CreateRoute = __webpack_require__("DEBG");

var _CreateRoute2 = _interopRequireDefault(_CreateRoute);

var _Live = __webpack_require__("NsJu");

var _Live2 = _interopRequireDefault(_Live);

var _CreateSegment3 = __webpack_require__("+e/g");

var _CreateSegment4 = _interopRequireDefault(_CreateSegment3);

var _CreateRoute3 = __webpack_require__("Y51B");

var _CreateRoute4 = _interopRequireDefault(_CreateRoute3);

var _App = __webpack_require__("iUeW");

var _App2 = _interopRequireDefault(_App);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Webpack 2 supports ES2015 `import` by auto-
// chunking assets. Check out the following for more:
// https://gist.github.com/sokra/27b24881210b56bbaff7#code-splitting-with-es6

var handleChunkError = function handleChunkError(cb) {
  return function (err) {
    // eslint-disable-next-line no-console
    console.error(err);
    cb(err);
  };
};

var importHome = function importHome(nextState, cb) {
  __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, "QeAW")).then(function (module) {
    return cb(null, module.default);
  }).catch(handleChunkError(cb));
};

var importMapLayout = function importMapLayout(nextState, cb) {
  __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, "WuGJ")).then(function (module) {
    return cb(null, module.default);
  }).catch(handleChunkError(cb));
};

var importUser = function importUser(nextState, cb) {
  __webpack_require__.e/* import() */(0/* aggressive-merge */).then(__webpack_require__.bind(null, "dpVx")).then(function (module) {
    return cb(null, module.default);
  }).catch(handleChunkError(cb));
};

var importNotFound = function importNotFound(nextState, cb) {
  __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, "G2oq")).then(function (module) {
    return cb(null, module.default);
  }).catch(handleChunkError(cb));
};

// We use `getComponent` to dynamically load routes.
// https://github.com/reactjs/react-router/blob/master/docs/guides/DynamicRouting.md
var routes = _react2.default.createElement(
  _reactRouter.Route,
  { path: '/', component: _App2.default },
  _react2.default.createElement(_reactRouter.IndexRoute, { getComponent: importHome }),
  _react2.default.createElement(
    _reactRouter.Route,
    { path: 'map/live', getComponent: importMapLayout },
    _react2.default.createElement(_reactRouter.IndexRoute, {
      components: {
        main: _Live2.default,
        mapPanel: _Settings2.default
      }
    }),
    _react2.default.createElement(_reactRouter.Route, {
      path: 'locations',
      components: {
        main: _Live2.default,
        dataPanelOverview: _Locations2.default,
        mapPanel: _Settings2.default
      }
    }),
    _react2.default.createElement(_reactRouter.Route, {
      path: 'segments',
      components: {
        main: _Live2.default,
        dataPanelOverview: _Segments2.default,
        mapPanel: _Settings2.default
      }
    }),
    _react2.default.createElement(_reactRouter.Route, {
      path: 'routes',
      components: {
        main: _Live2.default,
        dataPanelOverview: _Routes2.default,
        mapPanel: _Settings2.default
      }
    }),
    _react2.default.createElement(_reactRouter.Route, {
      path: 'alerts',
      components: {
        main: _Live2.default,
        dataPanelOverview: _Alerts2.default,
        mapPanel: _Settings2.default
      }
    }),
    _react2.default.createElement(_reactRouter.Route, {
      path: 'locations/:id',
      components: {
        main: _Live2.default,
        dataPanelDetails: _Location2.default,
        mapPanel: _Settings2.default
      }
    }),
    _react2.default.createElement(_reactRouter.Route, {
      path: 'segments/:id',
      components: {
        main: _Live2.default,
        dataPanelDetails: _Segment2.default,
        mapPanel: _Settings2.default
      }
    }),
    _react2.default.createElement(_reactRouter.Route, {
      path: 'routes/:id',
      components: {
        main: _Live2.default,
        dataPanelDetails: _Route2.default,
        mapPanel: _Settings2.default
      }
    })
  ),
  _react2.default.createElement(
    _reactRouter.Route,
    { path: 'map/create', getComponent: importMapLayout },
    _react2.default.createElement(_reactRouter.Route, {
      path: 'route',
      components: {
        main: _CreateRoute4.default,
        mapPanel: _CreateRoute2.default
      }
    }),
    _react2.default.createElement(_reactRouter.Route, {
      path: 'segment',
      components: {
        main: _CreateSegment4.default,
        mapPanel: _CreateSegment2.default
      }
    })
  ),
  _react2.default.createElement(_reactRouter.Route, { path: 'segments/:id', component: function component() {
      return _react2.default.createElement('div', null);
    } }),
  _react2.default.createElement(_reactRouter.Route, { path: 'routes/:id', component: function component() {
      return _react2.default.createElement('div', null);
    } }),
  _react2.default.createElement(_reactRouter.Route, { path: 'devices/:id', component: function component() {
      return _react2.default.createElement('div', null);
    } }),
  _react2.default.createElement(_reactRouter.Route, { path: 'user', getComponent: importUser }),
  _react2.default.createElement(_reactRouter.Route, { path: '*', getComponent: importNotFound, status: 404 })
);

// Unfortunately, HMR breaks when we dynamically resolve
// routes so we need to require them here as a workaround.
// https://github.com/gaearon/react-hot-loader/issues/288

/* istanbul ignore if */
if (false) {
  require('containers/Home'); // eslint-disable-line global-require
  require('components/Map/Layout'); // eslint-disable-line global-require
  require('containers/User'); // eslint-disable-line global-require
  require('containers/NotFound'); // eslint-disable-line global-require
}

var _default = routes;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(handleChunkError, 'handleChunkError', '/code/src/routes/index.js');

  __REACT_HOT_LOADER__.register(importHome, 'importHome', '/code/src/routes/index.js');

  __REACT_HOT_LOADER__.register(importMapLayout, 'importMapLayout', '/code/src/routes/index.js');

  __REACT_HOT_LOADER__.register(importUser, 'importUser', '/code/src/routes/index.js');

  __REACT_HOT_LOADER__.register(importNotFound, 'importNotFound', '/code/src/routes/index.js');

  __REACT_HOT_LOADER__.register(routes, 'routes', '/code/src/routes/index.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/code/src/routes/index.js');
}();

;

/***/ }),

/***/ "DWOx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = GridRow;

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _GridRow = __webpack_require__("RhGX");

var _GridRow2 = _interopRequireDefault(_GridRow);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function GridRow(_ref) {
  var title = _ref.title,
      children = _ref.children;

  var childrenArray = _react2.default.Children.toArray(children);
  return _react2.default.createElement(
    'div',
    { className: _GridRow2.default.main },
    _react2.default.createElement(
      'div',
      { className: _GridRow2.default.titleContainer },
      _react2.default.createElement(
        'h3',
        { className: _GridRow2.default.title },
        title
      )
    ),
    _react2.default.createElement(
      'div',
      { className: _GridRow2.default.childrenContainer },
      childrenArray.map(function (child) {
        return _react2.default.createElement(
          'div',
          { key: child.props.label, className: _GridRow2.default.item },
          child
        );
      })
    )
  );
}

GridRow.propTypes = {
  title: _propTypes.string.isRequired,
  children: _propTypes.node.isRequired
};
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(GridRow, 'GridRow', '/code/src/components/DataPanel/GridRow/index.js');
}();

;

/***/ }),

/***/ "E2tk":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SVG = function (_React$Component) {
  _inherits(SVG, _React$Component);

  function SVG() {
    _classCallCheck(this, SVG);

    return _possibleConstructorReturn(this, (SVG.__proto__ || Object.getPrototypeOf(SVG)).apply(this, arguments));
  }

  _createClass(SVG, [{
    key: "render",
    value: function render() {
      return _react2.default.createElement(
        "svg",
        _extends({ viewBox: "0 0 33 53", xmlns: "http://www.w3.org/2000/svg", fill: "currentColor" }, this.props),
        _react2.default.createElement(
          "title",
          null,
          "broken segment"
        ),
        _react2.default.createElement("path", { d: "M21 12.4V2.8L23.8 0H33v12.4L27 18zm0 35v-9.6l2.8-2.8H33v12.4L27 53zM0 17h2v9.8H0zM0 4.5v8.3h2V6.5h13v-2zm2 33.1v-6.3H0v7.1L6.6 45H15v-2H7.4z" })
      );
    }
  }]);

  return SVG;
}(_react2.default.Component);

var _default = SVG;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(SVG, "SVG", "/code/src/icons/segment-broken.inline.svg");

  __REACT_HOT_LOADER__.register(_default, "default", "/code/src/icons/segment-broken.inline.svg");
}();

;

/***/ }),

/***/ "E4O7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = addObjectPriority;

var _getPriorityForStatus = __webpack_require__("B3Ub");

var _getPriorityForStatus2 = _interopRequireDefault(_getPriorityForStatus);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function addObjectPriority(object, hoveredId, selectedId) {
  if (hoveredId && object.id === hoveredId) {
    return _extends({}, object, {
      priority: 20
    });
  }

  if (selectedId && object.id === selectedId) {
    return _extends({}, object, {
      priority: 10
    });
  }

  return _extends({}, object, {
    priority: (0, _getPriorityForStatus2.default)(object.status)
  });
}
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(addObjectPriority, 'addObjectPriority', '/code/src/helpers/addObjectPriority.js');
}();

;

/***/ }),

/***/ "EAeD":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = user;

var _jwtDecode = __webpack_require__("ytdl");

var _jwtDecode2 = _interopRequireDefault(_jwtDecode);

var _types = __webpack_require__("yyqx");

var _types2 = _interopRequireDefault(_types);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getUserInfoFromJwt(jwtStr) {
  var jwt = (0, _jwtDecode2.default)(jwtStr);
  return jwt; // return all for now TODO get firstName etc...
}

function user() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  switch (action.type) {
    case _types2.default.LOGIN_SUCCESS:
      return _extends({}, state, getUserInfoFromJwt(action.payload.access_token));

    case _types2.default.LOGOUT_REQUEST:
      return {};

    default:
      return state;
  }
}
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(getUserInfoFromJwt, 'getUserInfoFromJwt', '/code/src/state/ducks/user/reducers.js');

  __REACT_HOT_LOADER__.register(user, 'user', '/code/src/state/ducks/user/reducers.js');
}();

;

/***/ }),

/***/ "EAxn":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__("CIox");

var _reactApollo = __webpack_require__("3zLD");

var _reactDom = __webpack_require__("O27J");

var _reactHotLoader = __webpack_require__("rGbO");

var _reactRouterRedux = __webpack_require__("jZgO");

var _store = __webpack_require__("PIwE");

var _store2 = _interopRequireDefault(_store);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var root = document.querySelector('#root');

// eslint-disable-next-line no-underscore-dangle
var preloadedState = window.__PRELOADED_STATE__;

// Create a GraphQL client
var graphqlEndpoint = "http" + '://' + "graphql.bluemac.cleverfranke-dev.com" + '/graphql';
var apolloClient = new _reactApollo.ApolloClient({
  networkInterface: (0, _reactApollo.createNetworkInterface)({
    uri: graphqlEndpoint
  })
});

// Hydrate the store on the client
var store = (0, _store2.default)(apolloClient, preloadedState);

// Create an enhanced history that syncs navigation events with the store
var history = (0, _reactRouterRedux.syncHistoryWithStore)(_reactRouter.browserHistory, store);

// Include DevTools but only in non-production environments
var isProduction = "production" === 'production';
var noComponent = function noComponent(_) {
  return null;
};
var DevTools = isProduction ? noComponent : __webpack_require__("PIyo").default;

var mount = function mount() {
  // eslint-disable-next-line global-require,import/newline-after-import
  var routes = __webpack_require__("DP/h").default;

  (0, _reactDom.render)(_react2.default.createElement(
    _reactHotLoader.AppContainer,
    null,
    _react2.default.createElement(
      _reactApollo.ApolloProvider,
      { client: apolloClient, store: store },
      _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_reactRouter.Router, { routes: routes, history: history }),
        _react2.default.createElement(DevTools, null)
      )
    )
  ), root);
};

mount();

// Enable the React debugger in the console after the first mount
window.React = _react2.default;

if (!isProduction) {
  /**
   * This adds the Perf addons to the global window so you can debug
   * the performance from within your console
   */
  // eslint-disable-next-line global-require
  window.Perf = __webpack_require__("c+Ld");

  if (false) {
    module.hot.accept('routes', function () {
      (0, _reactDom.unmountComponentAtNode)(root);
      mount();
    });
  }
}
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(root, 'root', '/code/src/client/index.js');

  __REACT_HOT_LOADER__.register(preloadedState, 'preloadedState', '/code/src/client/index.js');

  __REACT_HOT_LOADER__.register(graphqlEndpoint, 'graphqlEndpoint', '/code/src/client/index.js');

  __REACT_HOT_LOADER__.register(apolloClient, 'apolloClient', '/code/src/client/index.js');

  __REACT_HOT_LOADER__.register(store, 'store', '/code/src/client/index.js');

  __REACT_HOT_LOADER__.register(history, 'history', '/code/src/client/index.js');

  __REACT_HOT_LOADER__.register(isProduction, 'isProduction', '/code/src/client/index.js');

  __REACT_HOT_LOADER__.register(noComponent, 'noComponent', '/code/src/client/index.js');

  __REACT_HOT_LOADER__.register(DevTools, 'DevTools', '/code/src/client/index.js');

  __REACT_HOT_LOADER__.register(mount, 'mount', '/code/src/client/index.js');
}();

;

/***/ }),

/***/ "EUU4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = NumberDisplay;

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _bind = __webpack_require__("T2Un");

var _bind2 = _interopRequireDefault(_bind);

var _propTypes = __webpack_require__("KSGD");

var _segmentStatus = __webpack_require__("fX1p");

var _segmentStatus2 = _interopRequireDefault(_segmentStatus);

var _formatFloat = __webpack_require__("MyD5");

var _formatFloat2 = _interopRequireDefault(_formatFloat);

var _numberDisplay = __webpack_require__("k+jW");

var _numberDisplay2 = _interopRequireDefault(_numberDisplay);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var cx = _bind2.default.bind(_numberDisplay2.default);

function NumberDisplay(_ref) {
  var value = _ref.value,
      status = _ref.status,
      unit = _ref.unit,
      isHovered = _ref.isHovered;

  return _react2.default.createElement(
    'div',
    {
      className: cx(_numberDisplay2.default.main, _defineProperty({}, _numberDisplay2.default['status-' + status], isHovered))
    },
    _react2.default.createElement(
      'span',
      { className: _numberDisplay2.default.value },
      (0, _formatFloat2.default)(value)
    ),
    unit && _react2.default.createElement(
      'span',
      { className: _numberDisplay2.default.unit },
      unit
    )
  );
}

NumberDisplay.propTypes = {
  value: _propTypes.number.isRequired,
  status: _segmentStatus2.default.isRequired,
  isHovered: _propTypes.bool,
  unit: (0, _propTypes.oneOf)(['mph', 'kmh'])
};
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(cx, 'cx', '/code/src/components/NumberDisplay/index.js');

  __REACT_HOT_LOADER__.register(NumberDisplay, 'NumberDisplay', '/code/src/components/NumberDisplay/index.js');
}();

;

/***/ }),

/***/ "FQ83":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }
}();

;

/***/ }),

/***/ "FXLg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"main":"Title-main--O63Et"};

/***/ }),

/***/ "FerD":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _coord = __webpack_require__("w0mN");

var _coord2 = _interopRequireDefault(_coord);

var _ExistingSegmentPath = __webpack_require__("nG+W");

var _ExistingSegmentPath2 = _interopRequireDefault(_ExistingSegmentPath);

var _ExistingSegmentTooltip = __webpack_require__("tZDw");

var _ExistingSegmentTooltip2 = _interopRequireDefault(_ExistingSegmentTooltip);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Segment = function (_Component) {
  _inherits(Segment, _Component);

  function Segment() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Segment);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Segment.__proto__ || Object.getPrototypeOf(Segment)).call.apply(_ref, [this].concat(args))), _this), _this.defaultProps = {
      priority: 0
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Segment, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(newProps) {
      if (newProps.isActive !== this.props.isActive) {
        return true;
      }
      if (newProps.priority !== this.props.priority) {
        return true;
      }
      if (newProps.segment.id !== this.props.segment.id) {
        return true;
      }
      return false;
    }
  }, {
    key: 'render',
    value: function render() {
      // eslint-disable-next-line global-require
      var PriorityFeatureGroup = __webpack_require__("c9LL").default;

      var _props = this.props,
          segment = _props.segment,
          priority = _props.priority,
          onEnter = _props.onEnter,
          onLeave = _props.onLeave,
          isActive = _props.isActive;
      var id = segment.id,
          fromName = segment.from.name,
          toName = segment.to.name,
          path = segment.path,
          status = segment.status;

      var name = { from: fromName, to: toName };

      return _react2.default.createElement(
        PriorityFeatureGroup,
        {
          key: 'Segment-' + id + '-' + status + (isActive ? '-active' : ''),
          onMouseover: onEnter,
          onMouseout: onLeave,
          priority: priority
        },
        _react2.default.createElement(_ExistingSegmentPath2.default, { latLngList: path, isActive: isActive }),
        _react2.default.createElement(_ExistingSegmentTooltip2.default, { name: name })
      );
    }
  }]);

  return Segment;
}(_react.Component);

Segment.propTypes = {
  onEnter: _propTypes.func.isRequired,
  onLeave: _propTypes.func.isRequired,
  isActive: _propTypes.bool.isRequired,
  priority: _propTypes.number,
  segment: (0, _propTypes.shape)({
    id: _propTypes.string,
    path: (0, _propTypes.arrayOf)(_coord2.default)
  }).isRequired
};
var _default = Segment;
exports.default = _default;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(Segment, 'Segment', '/code/src/components/Map/CreateSegment/ExistingSegment/index.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/code/src/components/Map/CreateSegment/ExistingSegment/index.js');
}();

;

/***/ }),

/***/ "Fv2x":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"buttonBase":"Layout-buttonBase--3B57j","shadowBottom":"Layout-shadowBottom--2nDl3","shadowBottomHover":"Layout-shadowBottomHover--_E_wF","shadowListItem":"Layout-shadowListItem--1mPQ6","shadowRight":"Layout-shadowRight--1I4nn","shadowLeft":"Layout-shadowLeft--1Sy3V","shadowAround":"Layout-shadowAround--3gmZ5","shadowAroundHover":"Layout-shadowAroundHover--SWgr9","shadowButton":"Layout-shadowButton--1xJbV","shadowButtonHover":"Layout-shadowButtonHover--21_uh","main":"Layout-main--1m16Z","top":"Layout-top--3ul8I","content":"Layout-content--1gFHL","subContent":"Layout-subContent--3JDy0 Layout-shadowAround--3gmZ5"};

/***/ }),

/***/ "G+3p":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = LoadingIndicator;

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _loadingIndicator = __webpack_require__("YCC+");

var _loadingIndicator2 = _interopRequireDefault(_loadingIndicator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function LoadingIndicator() {
  return _react2.default.createElement(
    'div',
    { className: _loadingIndicator2.default.main },
    _react2.default.createElement(
      'span',
      { className: _loadingIndicator2.default.text },
      'Loading'
    )
  );
}
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(LoadingIndicator, 'LoadingIndicator', '/code/src/components/LoadingIndicator/index.js');
}();

;

/***/ }),

/***/ "G3SD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"TripletItem":"TripletItem-TripletItem--C8Vr4","status-ok":"TripletItem-status-ok--21vrK","status-warning":"TripletItem-status-warning--3eVMg","status-problem":"TripletItem-status-problem--bmTKy","status-disconnected":"TripletItem-status-disconnected--3Qkcp","containsDevice":"TripletItem-containsDevice--16X1N","context":"TripletItem-context--23cHo","content":"TripletItem-content--oyh7h","smallerText":"TripletItem-smallerText--2Vqsb"};

/***/ }),

/***/ "G4cM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"buttonBase":"ListItem-buttonBase--1jjpT","shadowBottom":"ListItem-shadowBottom--11BJx","shadowBottomHover":"ListItem-shadowBottomHover--feCNr","shadowListItem":"ListItem-shadowListItem--3i2Kc","shadowRight":"ListItem-shadowRight--1NqZ0","shadowLeft":"ListItem-shadowLeft--CXtgF","shadowAround":"ListItem-shadowAround--3uOEY","shadowAroundHover":"ListItem-shadowAroundHover--2QbGJ","shadowButton":"ListItem-shadowButton--CE_Kp","shadowButtonHover":"ListItem-shadowButtonHover--1Dt4j","main":"ListItem-main--zLeFX ListItem-shadowListItem--3i2Kc","link":"ListItem-link--2pDQE","route":"ListItem-route--1XB66","status-ok":"ListItem-status-ok--2T0Kl","status-warning":"ListItem-status-warning--3hoIZ","status-problem":"ListItem-status-problem--3-nqH","status-disconnected":"ListItem-status-disconnected--1pHG2","segment":"ListItem-segment--1BoKU","location":"ListItem-location--1KPw8"};

/***/ }),

/***/ "GFZ4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"outlineBase":"SegmentPath-outlineBase--3peVU","isActive":"SegmentPath-isActive--2NTQf","selected":"SegmentPath-selected--2FKum","underlineBase":"SegmentPath-underlineBase--cwKcw","lineBase":"SegmentPath-lineBase--19VNi","marching_ants":"SegmentPath-marching_ants--1UqZk","outline":"SegmentPath-outline--3Y9HF SegmentPath-outlineBase--3peVU","underline":"SegmentPath-underline--2nQ-U SegmentPath-underlineBase--cwKcw","line":"SegmentPath-line--33NUO SegmentPath-lineBase--19VNi","status-ok":"SegmentPath-status-ok--3eGTA","status-warning":"SegmentPath-status-warning--I6Mq5","status-problem":"SegmentPath-status-problem--12f1j","status-disconnected":"SegmentPath-status-disconnected--7pGm1"};

/***/ }),

/***/ "H2II":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"main":"Footer-main--2RWAJ"};

/***/ }),

/***/ "HiU3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SVG = function (_React$Component) {
  _inherits(SVG, _React$Component);

  function SVG() {
    _classCallCheck(this, SVG);

    return _possibleConstructorReturn(this, (SVG.__proto__ || Object.getPrototypeOf(SVG)).apply(this, arguments));
  }

  _createClass(SVG, [{
    key: "render",
    value: function render() {
      return _react2.default.createElement(
        "svg",
        _extends({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 30 43.86" }, this.props),
        _react2.default.createElement(
          "title",
          null,
          "location-active"
        ),
        _react2.default.createElement("path", { fill: "currentColor", stroke: "#fff", strokeMiterlimit: "10", strokeWidth: "2", d: "M1 29.5v-22L7.5 1H29v28.5l-14 13-14-13z" }),
        _react2.default.createElement("path", { fill: "#fff", d: "M14.02 24.25l-5.05-4.81 1.73-1.81 3.28 3.12 6.87-6.86 1.77 1.77-8.6 8.59" })
      );
    }
  }]);

  return SVG;
}(_react2.default.Component);

var _default = SVG;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(SVG, "SVG", "/code/src/icons/location-active.inline.svg");

  __REACT_HOT_LOADER__.register(_default, "default", "/code/src/icons/location-active.inline.svg");
}();

;

/***/ }),

/***/ "Htlj":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SVG = function (_React$Component) {
  _inherits(SVG, _React$Component);

  function SVG() {
    _classCallCheck(this, SVG);

    return _possibleConstructorReturn(this, (SVG.__proto__ || Object.getPrototypeOf(SVG)).apply(this, arguments));
  }

  _createClass(SVG, [{
    key: "render",
    value: function render() {
      return _react2.default.createElement(
        "svg",
        _extends({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 21 21", fill: "currentColor" }, this.props),
        _react2.default.createElement("path", { d: "M21 9h-9V0H9v9H0v3h9v9h3v-9h9" })
      );
    }
  }]);

  return SVG;
}(_react2.default.Component);

var _default = SVG;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(SVG, "SVG", "/code/src/icons/plus.inline.svg");

  __REACT_HOT_LOADER__.register(_default, "default", "/code/src/icons/plus.inline.svg");
}();

;

/***/ }),

/***/ "IQ9V":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LocationMarkerGroup = LocationMarkerGroup;

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _reactRedux = __webpack_require__("RH2O");

var _locationShape = __webpack_require__("1itO");

var _locationShape2 = _interopRequireDefault(_locationShape);

var _map = __webpack_require__("YByT");

var _LocationMarker = __webpack_require__("tbgJ");

var _LocationMarker2 = _interopRequireDefault(_LocationMarker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isLocationActive(_ref) {
  var location = _ref.location,
      segments = _ref.segments,
      selectedId = _ref.selectedId,
      hoveredId = _ref.hoveredId;

  // checks if the object.id matches one of the active states
  var idMatchesActiveStates = function idMatchesActiveStates(_ref2) {
    var id = _ref2.id;
    return id === hoveredId || id === selectedId;
  };

  if (idMatchesActiveStates(location)) return true;

  // check wheter id a segment which is connected to the location
  var activeSegment = segments.find(idMatchesActiveStates);

  return activeSegment && (activeSegment.from.id === location.id || activeSegment.to.id === location.id);
}

function LocationMarkerGroup(_ref3) {
  var locations = _ref3.locations,
      segments = _ref3.segments,
      routeParams = _ref3.routeParams,
      currentHover = _ref3.currentHover,
      selectEntity = _ref3.selectEntity,
      enterEntity = _ref3.enterEntity,
      leaveEntity = _ref3.leaveEntity;

  // eslint-disable-next-line global-require
  var _require = __webpack_require__("Zz/N"),
      FeatureGroup = _require.FeatureGroup;

  var selectedId = routeParams.id;
  var hoveredId = currentHover && currentHover.id;

  return _react2.default.createElement(
    FeatureGroup,
    null,
    locations.map(function (location) {
      var id = location.id,
          trackingDevice = location.trackingDevice,
          lat = location.lat,
          lng = location.lng,
          name = location.name;


      var isActive = isLocationActive({
        location: location,
        segments: segments,
        selectedId: selectedId,
        hoveredId: hoveredId
      });
      var isFaded = Boolean(selectedId && id !== selectedId);

      return _react2.default.createElement(_LocationMarker2.default, {
        key: '' + id,
        trackingDevice: trackingDevice,
        position: [lat, lng],
        name: name,
        id: id,
        onSelect: function onSelect() {
          selectEntity({
            id: id,
            type: 'location'
          });
        },
        onEnter: function onEnter() {
          return enterEntity({
            id: id,
            type: 'location'
          });
        },
        onLeave: function onLeave() {
          return leaveEntity({
            id: id,
            type: 'location'
          });
        },
        isActive: isActive,
        isFaded: isFaded
      });
    })
  );
}

LocationMarkerGroup.propTypes = {
  locations: (0, _propTypes.arrayOf)(_locationShape2.default).isRequired,
  segments: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    id: _propTypes.string.isRequired,
    from: (0, _propTypes.shape)({ name: _propTypes.string }).isRequired,
    to: (0, _propTypes.shape)({ name: _propTypes.string }).isRequired
  })).isRequired,
  selectEntity: _propTypes.func.isRequired,
  enterEntity: _propTypes.func.isRequired,
  leaveEntity: _propTypes.func.isRequired,
  routeParams: (0, _propTypes.shape)({
    id: _propTypes.string
  }).isRequired,
  currentHover: (0, _propTypes.shape)({
    id: _propTypes.string.isRequired
  })
};

var mapStateToProps = function mapStateToProps(_ref4) {
  var map = _ref4.map;
  return {
    currentHover: map.currentHover
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps, _map.operations)(LocationMarkerGroup);

exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(isLocationActive, 'isLocationActive', '/code/src/components/Map/MapComponents/LocationMarkerGroup/index.js');

  __REACT_HOT_LOADER__.register(LocationMarkerGroup, 'LocationMarkerGroup', '/code/src/components/Map/MapComponents/LocationMarkerGroup/index.js');

  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/code/src/components/Map/MapComponents/LocationMarkerGroup/index.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/code/src/components/Map/MapComponents/LocationMarkerGroup/index.js');
}();

;

/***/ }),

/***/ "IcA+":
/***/ (function(module, exports) {

module.exports = "/location-inactive-eab929d0d8cb07a136cc8f0ac07176f0.svg";

/***/ }),

/***/ "Imzv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"buttonBase":"NavigationBar-buttonBase--zbQpY","shadowBottom":"NavigationBar-shadowBottom--134Hd","shadowBottomHover":"NavigationBar-shadowBottomHover--tgv6M","shadowListItem":"NavigationBar-shadowListItem--krzgM","shadowRight":"NavigationBar-shadowRight--kSNPg","shadowLeft":"NavigationBar-shadowLeft--2szoK","shadowAround":"NavigationBar-shadowAround--1HAR9","shadowAroundHover":"NavigationBar-shadowAroundHover--1mRU9","shadowButton":"NavigationBar-shadowButton--52mgZ","shadowButtonHover":"NavigationBar-shadowButtonHover--2XtN3","main":"NavigationBar-main--2jpN7 NavigationBar-shadowBottom--134Hd","title":"NavigationBar-title--3hlEL","iconLink":"NavigationBar-iconLink--3xNFF","icon":"NavigationBar-icon--27hZo","backTo":"NavigationBar-backTo--2S_Ti","close":"NavigationBar-close--14iVu"};

/***/ }),

/***/ "JJgR":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _segmentStatus = __webpack_require__("fX1p");

var _segmentStatus2 = _interopRequireDefault(_segmentStatus);

var _coord = __webpack_require__("w0mN");

var _coord2 = _interopRequireDefault(_coord);

var _SegmentPath = __webpack_require__("zILm");

var _SegmentPath2 = _interopRequireDefault(_SegmentPath);

var _SegmentTooltip = __webpack_require__("8LQ0");

var _SegmentTooltip2 = _interopRequireDefault(_SegmentTooltip);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Segment = function (_Component) {
  _inherits(Segment, _Component);

  function Segment() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Segment);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Segment.__proto__ || Object.getPrototypeOf(Segment)).call.apply(_ref, [this].concat(args))), _this), _this.defaultProps = {
      priority: 0
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Segment, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(newProps) {
      if (newProps.isActive !== this.props.isActive) {
        return true;
      }
      if (newProps.isSelected !== this.props.isSelected) {
        return true;
      }
      if (newProps.priority !== this.props.priority) {
        return true;
      }
      if (newProps.segment.id !== this.props.segment.id) {
        return true;
      }
      if (newProps.segment.status !== this.props.segment.status) {
        return true;
      }
      // Not the most reliable way of determining path change, but definitely the fastest
      if (newProps.segment.path.length !== this.props.segment.path.length) {
        return true;
      }
      return false;
    }
  }, {
    key: 'render',
    value: function render() {
      // eslint-disable-next-line global-require
      var PriorityFeatureGroup = __webpack_require__("c9LL").default;

      var _props = this.props,
          segment = _props.segment,
          onEnter = _props.onEnter,
          onLeave = _props.onLeave,
          onSelect = _props.onSelect,
          isActive = _props.isActive,
          isSelected = _props.isSelected;
      var id = segment.id,
          fromName = segment.from.name,
          toName = segment.to.name,
          path = segment.path,
          status = segment.status;

      var name = { from: fromName, to: toName };

      return _react2.default.createElement(
        PriorityFeatureGroup,
        {
          key: 'Segment-' + id + '-' + status + (isActive || isSelected ? '-active' : ''),
          onMouseover: onEnter,
          onMouseout: onLeave,
          onClick: onSelect,
          priority: this.props.priority
        },
        _react2.default.createElement(_SegmentPath2.default, {
          latLngList: path,
          isDisconnected: status === 'disconnected',
          isSelected: isSelected,
          isActive: isActive
        }),
        _react2.default.createElement(_SegmentTooltip2.default, { name: name, status: 'disconnected' })
      );
    }
  }]);

  return Segment;
}(_react.Component);

Segment.propTypes = {
  onSelect: _propTypes.func.isRequired,
  onEnter: _propTypes.func.isRequired,
  onLeave: _propTypes.func.isRequired,
  isActive: _propTypes.bool.isRequired,
  isSelected: _propTypes.bool,
  priority: _propTypes.number,
  segment: (0, _propTypes.shape)({
    id: _propTypes.string,
    path: (0, _propTypes.arrayOf)(_coord2.default),
    liveTravelTime: _propTypes.number.isRequired,
    status: _segmentStatus2.default.isRequired
  }).isRequired
};
var _default = Segment;
exports.default = _default;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(Segment, 'Segment', '/code/src/components/Map/CreateRoute/Segment/index.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/code/src/components/Map/CreateRoute/Segment/index.js');
}();

;

/***/ }),

/***/ "JMsO":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SVG = function (_React$Component) {
  _inherits(SVG, _React$Component);

  function SVG() {
    _classCallCheck(this, SVG);

    return _possibleConstructorReturn(this, (SVG.__proto__ || Object.getPrototypeOf(SVG)).apply(this, arguments));
  }

  _createClass(SVG, [{
    key: "render",
    value: function render() {
      return _react2.default.createElement(
        "svg",
        _extends({ viewBox: "0 0 33 53", xmlns: "http://www.w3.org/2000/svg" }, this.props),
        _react2.default.createElement(
          "title",
          null,
          "segment"
        ),
        _react2.default.createElement("path", { d: "M15 45H6.6L0 38.4V4.5h15v2H2v31.1L7.4 43H15zm6-32.6V2.8L23.8 0H33v12.4L27 18zm0 35v-9.6l2.8-2.8H33v12.4L27 53z", fill: "currentColor" })
      );
    }
  }]);

  return SVG;
}(_react2.default.Component);

var _default = SVG;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(SVG, "SVG", "/code/src/icons/segment.inline.svg");

  __REACT_HOT_LOADER__.register(_default, "default", "/code/src/icons/segment.inline.svg");
}();

;

/***/ }),

/***/ "JNc/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"main":"location-status-icon-main--j-6Jc"};

/***/ }),

/***/ "Lj8m":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = IconButton;

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _reactRouter = __webpack_require__("CIox");

var _classnames = __webpack_require__("HW6M");

var _classnames2 = _interopRequireDefault(_classnames);

var _iconButton = __webpack_require__("ju2b");

var _iconButton2 = _interopRequireDefault(_iconButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function ButtonLayout(_ref) {
  var children = _ref.children,
      label = _ref.label;

  // const Icon = iconComponent; // needs to be pascal cased for jsx
  return _react2.default.createElement(
    'span',
    { className: _iconButton2.default.layout },
    _react2.default.createElement(
      'span',
      { className: _iconButton2.default.iconContainer },
      (0, _react.cloneElement)(children, { className: _iconButton2.default.icon })
    ),
    label && _react2.default.createElement(
      'span',
      { className: _iconButton2.default.label },
      _react2.default.createElement(
        'span',
        { className: _iconButton2.default.labelText },
        label
      )
    )
  );
}

ButtonLayout.propTypes = {
  children: _propTypes.node.isRequired,
  label: _propTypes.string
};

function IconButton(_ref2) {
  var _cx;

  var isSecondary = _ref2.isSecondary,
      iconRight = _ref2.iconRight,
      children = _ref2.children,
      asLink = _ref2.asLink,
      onClick = _ref2.onClick,
      linkTo = _ref2.linkTo,
      label = _ref2.label,
      hasContextBlue = _ref2.hasContextBlue,
      withShadow = _ref2.withShadow,
      withShadowHover = _ref2.withShadowHover,
      disabled = _ref2.disabled;

  var topLevelClassNames = (0, _classnames2.default)(_iconButton2.default.main, (_cx = {}, _defineProperty(_cx, _iconButton2.default.isPrimary, !isSecondary), _defineProperty(_cx, _iconButton2.default.isSecondary, isSecondary), _defineProperty(_cx, _iconButton2.default.iconRight, iconRight), _defineProperty(_cx, _iconButton2.default.hasContextBlue, hasContextBlue), _defineProperty(_cx, _iconButton2.default.withShadow, withShadow), _defineProperty(_cx, _iconButton2.default.withShadowHover, withShadowHover), _defineProperty(_cx, _iconButton2.default.asLink, asLink), _cx));
  /* render the button as a link */
  if (asLink) {
    return _react2.default.createElement(
      _reactRouter.Link,
      { to: linkTo, className: topLevelClassNames, disabled: disabled },
      _react2.default.createElement(
        ButtonLayout,
        {
          label: label,
          className: (0, _classnames2.default)(_iconButton2.default.layout, _defineProperty({}, _iconButton2.default.hasLabel, Boolean(label)))
        },
        children
      )
    );
  }

  /* render the button as a button */
  return _react2.default.createElement(
    'button',
    { onClick: onClick, className: topLevelClassNames, disabled: disabled },
    _react2.default.createElement(
      ButtonLayout,
      {
        label: label,
        className: (0, _classnames2.default)(_iconButton2.default.layout, _defineProperty({}, _iconButton2.default.hasLabel, Boolean(label)))
      },
      children
    )
  );
}

IconButton.propTypes = {
  children: _propTypes.node,
  // requiredness gives lots of errors?
  // children: node.isRequired,
  label: _propTypes.string,
  asLink: _propTypes.bool,
  onClick: _propTypes.func,
  linkTo: _propTypes.string,
  isSecondary: _propTypes.bool,
  iconRight: _propTypes.bool,
  hasContextBlue: _propTypes.bool,
  withShadow: _propTypes.bool,
  withShadowHover: _propTypes.bool,
  disabled: _propTypes.bool
};
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ButtonLayout, 'ButtonLayout', '/code/src/components/IconButton/index.js');

  __REACT_HOT_LOADER__.register(IconButton, 'IconButton', '/code/src/components/IconButton/index.js');
}();

;

/***/ }),

/***/ "LoGb":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _classnames = __webpack_require__("HW6M");

var _classnames2 = _interopRequireDefault(_classnames);

var _segmentStatus = __webpack_require__("fX1p");

var _segmentStatus2 = _interopRequireDefault(_segmentStatus);

var _coord = __webpack_require__("w0mN");

var _coord2 = _interopRequireDefault(_coord);

var _SegmentPath = __webpack_require__("GFZ4");

var _SegmentPath2 = _interopRequireDefault(_SegmentPath);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function SegmentPath(_ref) {
  var latLngList = _ref.latLngList,
      isActive = _ref.isActive,
      status = _ref.status;

  // eslint-disable-next-line global-require
  var _require = __webpack_require__("Zz/N"),
      Polyline = _require.Polyline;

  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(Polyline, {
      className: (0, _classnames2.default)(_SegmentPath2.default.outline, _defineProperty({}, _SegmentPath2.default.isActive, isActive)),
      positions: latLngList
    }),
    isActive && _react2.default.createElement(Polyline, {
      positions: latLngList,
      className: (0, _classnames2.default)(_SegmentPath2.default.underline, _SegmentPath2.default['status-' + status], [_SegmentPath2.default.isActive])
    }),
    _react2.default.createElement(Polyline, {
      positions: latLngList,
      className: (0, _classnames2.default)(_SegmentPath2.default.line, _SegmentPath2.default['status-' + status], _defineProperty({}, _SegmentPath2.default.isActive, isActive))
    })
  );
}

SegmentPath.propTypes = {
  latLngList: (0, _propTypes.arrayOf)(_coord2.default).isRequired,
  status: _segmentStatus2.default.isRequired,
  isActive: _propTypes.bool.isRequired
};

var _default = SegmentPath;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(SegmentPath, 'SegmentPath', '/code/src/components/Map/MapComponents/SegmentPath/index.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/code/src/components/Map/MapComponents/SegmentPath/index.js');
}();

;

/***/ }),

/***/ "MBAn":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _templateObject = _taggedTemplateLiteral(['\n  query Segments {\n    segments {\n      id\n      status\n      expectedTravelTime\n      travelTimeIndex\n      speedLastHour\n      liveSpeed\n      to {\n        id\n        name\n      }\n      from {\n        id\n        name\n      }\n    }\n  }\n'], ['\n  query Segments {\n    segments {\n      id\n      status\n      expectedTravelTime\n      travelTimeIndex\n      speedLastHour\n      liveSpeed\n      to {\n        id\n        name\n      }\n      from {\n        id\n        name\n      }\n    }\n  }\n']);

exports.Segments = Segments;

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _reactApollo = __webpack_require__("3zLD");

var _reactRedux = __webpack_require__("RH2O");

var _map = __webpack_require__("YByT");

var _reactRouterRedux = __webpack_require__("jZgO");

var _LoadingIndicator = __webpack_require__("G+3p");

var _LoadingIndicator2 = _interopRequireDefault(_LoadingIndicator);

var _locationShape = __webpack_require__("1itO");

var _locationShape2 = _interopRequireDefault(_locationShape);

var _sortSegments = __webpack_require__("C/D4");

var _sortSegments2 = _interopRequireDefault(_sortSegments);

var _List = __webpack_require__("U2GG");

var _List2 = _interopRequireDefault(_List);

var _ListLabels = __webpack_require__("nRxE");

var _ListLabels2 = _interopRequireDefault(_ListLabels);

var _ListItem = __webpack_require__("m9jy");

var _ListItem2 = _interopRequireDefault(_ListItem);

var _SegmentsListItem = __webpack_require__("QNwT");

var _SegmentsListItem2 = _interopRequireDefault(_SegmentsListItem);

var _Sorting = __webpack_require__("3C90");

var _Sorting2 = _interopRequireDefault(_Sorting);

var _EmptyPanelState = __webpack_require__("li8v");

var _EmptyPanelState2 = _interopRequireDefault(_EmptyPanelState);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var SegmentsQuery = (0, _reactApollo.gql)(_templateObject);

function Segments(_ref) {
  var data = _ref.data,
      selectEntity = _ref.selectEntity,
      enterEntity = _ref.enterEntity,
      leaveEntity = _ref.leaveEntity,
      currentHover = _ref.currentHover,
      location = _ref.location,
      historyReplace = _ref.historyReplace;

  if (data.loading) {
    return _react2.default.createElement(_LoadingIndicator2.default, null);
  }

  // We don't have any segments yet
  if (!data.segments || data.segments.length === 0) {
    return _react2.default.createElement(_EmptyPanelState2.default, { panelType: 'segment', showLink: true });
  }

  // We do have segments, so show 'm!
  return _react2.default.createElement(
    _Sorting2.default,
    {
      text: 'sort by',
      queryValueKey: 'sort',
      queryOrderKey: 'order',
      options: [{
        label: 'tti',
        queryValue: 'tti',
        initialOrder: 'dsc',
        isDefault: true
      }, { label: 'speed', queryValue: 'speed', initialOrder: 'asc' }],
      location: location,
      historyReplace: historyReplace
    },
    function (_ref2) {
      var sortValue = _ref2.sortValue,
          sortOrder = _ref2.sortOrder;
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_ListLabels2.default, { sortValue: sortValue, location: 'segment' }),
        _react2.default.createElement(
          _List2.default,
          null,
          (0, _sortSegments2.default)(data.segments, sortValue, sortOrder).map(function (segment) {
            var id = segment.id,
                status = segment.status;

            var isActive = currentHover && currentHover.id === id;

            return _react2.default.createElement(
              _ListItem2.default,
              {
                id: id,
                key: id,
                status: status,
                isActive: isActive,
                onClick: function onClick() {
                  return selectEntity({ id: id, type: 'segment' });
                },
                onMouseOver: function onMouseOver() {
                  return enterEntity({ id: id, type: 'segment' });
                },
                onMouseOut: function onMouseOut() {
                  return leaveEntity({ id: id, type: 'segment' });
                },
                contentType: 'segment'
              },
              _react2.default.createElement(_SegmentsListItem2.default, { segment: segment, sortValue: sortValue })
            );
          })
        )
      );
    }
  );
}

Segments.propTypes = {
  data: (0, _propTypes.shape)({
    loading: _propTypes.bool.isRequired,
    location: (0, _propTypes.shape)({})
  }).isRequired,
  selectEntity: _propTypes.func.isRequired,
  enterEntity: _propTypes.func.isRequired,
  leaveEntity: _propTypes.func.isRequired,
  currentHover: (0, _propTypes.shape)({ id: _propTypes.string.isRequired }),
  location: _locationShape2.default.isRequired,
  historyReplace: _propTypes.func.isRequired
};

var mapStateToProps = function mapStateToProps(_ref3, ownProps) {
  var map = _ref3.map;
  return _extends({
    currentHover: map.currentHover
  }, ownProps);
};

var ConnectedSegmentsWithData = (0, _reactApollo.compose)((0, _reactRedux.connect)(mapStateToProps, _extends({}, _map.operations, { historyReplace: _reactRouterRedux.replace })), (0, _reactApollo.graphql)(SegmentsQuery, {
  options: function options(_ref4) {
    var params = _ref4.params;
    return {
      variables: {
        id: params.id
      }
    };
  }
}))(Segments);

var _default = ConnectedSegmentsWithData;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(SegmentsQuery, 'SegmentsQuery', '/code/src/components/DataPanel/Overview/Segments/index.js');

  __REACT_HOT_LOADER__.register(Segments, 'Segments', '/code/src/components/DataPanel/Overview/Segments/index.js');

  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/code/src/components/DataPanel/Overview/Segments/index.js');

  __REACT_HOT_LOADER__.register(ConnectedSegmentsWithData, 'ConnectedSegmentsWithData', '/code/src/components/DataPanel/Overview/Segments/index.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/code/src/components/DataPanel/Overview/Segments/index.js');
}();

;

/***/ }),

/***/ "MNA1":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.SegmentGroup = SegmentGroup;

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__("RH2O");

var _propTypes = __webpack_require__("KSGD");

var _invariant = __webpack_require__("crWv");

var _invariant2 = _interopRequireDefault(_invariant);

var _locationShape = __webpack_require__("1itO");

var _locationShape2 = _interopRequireDefault(_locationShape);

var _Segment = __webpack_require__("pgZ4");

var _Segment2 = _interopRequireDefault(_Segment);

var _coord = __webpack_require__("w0mN");

var _coord2 = _interopRequireDefault(_coord);

var _map = __webpack_require__("YByT");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var priorityWeights = {
  problem: 4,
  disconnected: 3,
  warning: 2,
  ok: 1
};

function getPriorityForStatus(status) {
  var weight = priorityWeights[status];
  (0, _invariant2.default)(weight !== undefined, 'No sort weight for status: ' + status);
  return weight;
}

function addSegmentPriority(segment, hoveredId, selectedId) {
  if (segment.id === hoveredId) {
    return _extends({}, segment, {
      priority: 20
    });
  }

  if (segment.id === selectedId) {
    return _extends({}, segment, {
      priority: 10
    });
  }

  return _extends({}, segment, {
    priority: getPriorityForStatus(segment.status)
  });
}

function SegmentGroup(_ref) {
  var segments = _ref.segments,
      selectEntity = _ref.selectEntity,
      enterEntity = _ref.enterEntity,
      leaveEntity = _ref.leaveEntity,
      routeParams = _ref.routeParams,
      currentHover = _ref.currentHover;

  // eslint-disable-next-line global-require
  var SortingFeatureGroup = __webpack_require__("x6bV").default;
  var selectedId = routeParams.id;
  var hoveredId = currentHover && currentHover.id;

  var sortedSegmentsWithStateAndPriority = segments.map(function (segment) {
    return addSegmentPriority(segment, hoveredId, selectedId);
  }).sort(function (segmentA, segmentB) {
    return segmentA.priority - segmentB.priority;
  });

  return _react2.default.createElement(
    SortingFeatureGroup,
    null,
    sortedSegmentsWithStateAndPriority.map(function (segment) {
      var id = segment.id,
          priority = segment.priority;

      return _react2.default.createElement(_Segment2.default, {
        key: 'segment-' + id,
        priority: priority,
        segment: segment,
        isActive: id === selectedId || id === hoveredId,
        onSelect: function onSelect() {
          selectEntity({
            id: id,
            type: 'segment'
          });
        },
        onEnter: function onEnter() {
          return enterEntity({
            id: id,
            type: 'segment'
          });
        },
        onLeave: function onLeave() {
          return leaveEntity({
            id: id,
            type: 'segment'
          });
        }
      });
    })
  );
}

SegmentGroup.propTypes = {
  segments: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    id: _propTypes.string,
    path: (0, _propTypes.arrayOf)(_coord2.default),
    from: _locationShape2.default,
    to: _locationShape2.default
  })).isRequired,
  selectEntity: _propTypes.func.isRequired,
  enterEntity: _propTypes.func.isRequired,
  leaveEntity: _propTypes.func.isRequired,
  routeParams: (0, _propTypes.shape)({
    id: _propTypes.string
  }).isRequired,
  currentHover: (0, _propTypes.shape)({
    id: _propTypes.string.isRequired
  })
};

var mapStateToProps = function mapStateToProps(_ref2) {
  var map = _ref2.map;
  return {
    currentHover: map.currentHover
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps, _map.operations)(SegmentGroup);

exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(priorityWeights, 'priorityWeights', '/code/src/components/Map/MapComponents/SegmentGroup/index.js');

  __REACT_HOT_LOADER__.register(getPriorityForStatus, 'getPriorityForStatus', '/code/src/components/Map/MapComponents/SegmentGroup/index.js');

  __REACT_HOT_LOADER__.register(addSegmentPriority, 'addSegmentPriority', '/code/src/components/Map/MapComponents/SegmentGroup/index.js');

  __REACT_HOT_LOADER__.register(SegmentGroup, 'SegmentGroup', '/code/src/components/Map/MapComponents/SegmentGroup/index.js');

  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/code/src/components/Map/MapComponents/SegmentGroup/index.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/code/src/components/Map/MapComponents/SegmentGroup/index.js');
}();

;

/***/ }),

/***/ "MtHf":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = NavigationBar;

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__("HW6M");

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = __webpack_require__("KSGD");

var _reactRouter = __webpack_require__("CIox");

var _closeInline = __webpack_require__("2bM4");

var _closeInline2 = _interopRequireDefault(_closeInline);

var _chevronInline = __webpack_require__("PRyc");

var _chevronInline2 = _interopRequireDefault(_chevronInline);

var _NavigationBar = __webpack_require__("Imzv");

var _NavigationBar2 = _interopRequireDefault(_NavigationBar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function NavigationBar(_ref) {
  var closeTo = _ref.closeTo,
      handleClose = _ref.handleClose,
      backTo = _ref.backTo,
      title = _ref.title,
      titleClass = _ref.titleClass;

  var CloseButton = function CloseButton() {
    if (closeTo && !handleClose) {
      return _react2.default.createElement(
        _reactRouter.Link,
        { to: closeTo, disabled: !closeTo, className: (0, _classnames2.default)(_NavigationBar2.default.iconLink, _NavigationBar2.default.close) },
        _react2.default.createElement(
          'span',
          null,
          'close'
        ),
        _react2.default.createElement(_closeInline2.default, { className: _NavigationBar2.default.icon })
      );
    }
    if (handleClose && !closeTo) {
      return _react2.default.createElement(
        'button',
        { onClick: handleClose, className: (0, _classnames2.default)(_NavigationBar2.default.iconLink, _NavigationBar2.default.close) },
        _react2.default.createElement(
          'span',
          null,
          'close'
        ),
        _react2.default.createElement(_closeInline2.default, { className: _NavigationBar2.default.icon })
      );
    }
    return null;
  };

  return _react2.default.createElement(
    'header',
    { className: _NavigationBar2.default.main },
    backTo && _react2.default.createElement(
      _reactRouter.Link,
      { to: backTo, className: (0, _classnames2.default)(_NavigationBar2.default.iconLink, _NavigationBar2.default.backTo) },
      _react2.default.createElement(_chevronInline2.default, { className: _NavigationBar2.default.icon }),
      _react2.default.createElement(
        'span',
        null,
        title
      )
    ),
    !backTo && _react2.default.createElement(
      'h1',
      { className: (0, _classnames2.default)(_NavigationBar2.default.title, titleClass) },
      title
    ),
    _react2.default.createElement(CloseButton, null)
  );
}

NavigationBar.propTypes = {
  closeTo: _propTypes.string,
  handleClose: _propTypes.func,
  backTo: _propTypes.string,
  title: _propTypes.string,
  titleClass: _propTypes.string
};
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(NavigationBar, 'NavigationBar', '/code/src/components/DataPanel/NavigationBar/index.js');
}();

;

/***/ }),

/***/ "MuZ3":
/***/ (function(module, exports) {

module.exports = "/location-active-adc9e5213ce00ff57a2a15aa01bc48e4.svg";

/***/ }),

/***/ "MyD5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = formatFloat;

var _lodash = __webpack_require__("M4fF");

/*
  Format an integer to string, with numDecimals rounding and pad with
  zero's accordingly.
*/
function formatFloat(value) {
  var numDecimals = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

  var roundedValue = (0, _lodash.round)(value, numDecimals);
  var integer = Math.floor(roundedValue);

  // Round needs to be here, otherwise BIG ranges of decimals can happen. Not sure why.
  var decimals = (0, _lodash.round)(roundedValue - integer, numDecimals) * Math.pow(10, numDecimals);
  var decimalsStr = ('' + decimals).padEnd(numDecimals, '0');

  return integer + '.' + decimalsStr;
}
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(formatFloat, 'formatFloat', '/code/src/helpers/formatFloat.js');
}();

;

/***/ }),

/***/ "N7A0":
/***/ (function(module, exports) {

module.exports = "/location-0f9ee7d5ed4f2c2a61cb7bb50d8b60d2.svg";

/***/ }),

/***/ "NX5i":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"status-ok":"device-status-text-status-ok--2QrT4","status-warning":"device-status-text-status-warning--3L7X8","status-disconnected":"device-status-text-status-disconnected--3p-G8"};

/***/ }),

/***/ "Nk6q":
/***/ (function(module, exports) {

module.exports = "/location-inactive-eab929d0d8cb07a136cc8f0ac07176f0.svg";

/***/ }),

/***/ "NsJu":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LiveMapQuery = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n  query LiveMap {\n    locations {\n      id\n      lat\n      lng\n      name\n      trackingDevice {\n        id\n        name\n        status\n        batteryVoltage\n        temperature\n        reportInterval\n        lastUpdate\n        numberOfHitsToday\n      }\n    }\n    segments {\n      id\n      status\n      path\n      bounds\n      liveTravelTime\n      expectedTravelTime\n      oppositeSegmentId\n      liveSpeed\n      from {\n        id\n        name\n      }\n      to {\n        id\n        name\n      }\n    }\n    routes {\n      id\n      status\n      normalSpeed\n      liveSpeed\n      distance\n      liveTravelTime\n      oppositeRouteId\n      from {\n        id\n        name\n      }\n      to {\n        id\n        name\n      }\n      segments {\n        id\n        status\n        path\n        bounds\n        liveTravelTime\n        expectedTravelTime\n        liveSpeed\n        from {\n          id\n          name\n        }\n        to {\n          id\n          name\n        }\n      }\n    }\n  }\n'], ['\n  query LiveMap {\n    locations {\n      id\n      lat\n      lng\n      name\n      trackingDevice {\n        id\n        name\n        status\n        batteryVoltage\n        temperature\n        reportInterval\n        lastUpdate\n        numberOfHitsToday\n      }\n    }\n    segments {\n      id\n      status\n      path\n      bounds\n      liveTravelTime\n      expectedTravelTime\n      oppositeSegmentId\n      liveSpeed\n      from {\n        id\n        name\n      }\n      to {\n        id\n        name\n      }\n    }\n    routes {\n      id\n      status\n      normalSpeed\n      liveSpeed\n      distance\n      liveTravelTime\n      oppositeRouteId\n      from {\n        id\n        name\n      }\n      to {\n        id\n        name\n      }\n      segments {\n        id\n        status\n        path\n        bounds\n        liveTravelTime\n        expectedTravelTime\n        liveSpeed\n        from {\n          id\n          name\n        }\n        to {\n          id\n          name\n        }\n      }\n    }\n  }\n']);

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _reactApollo = __webpack_require__("3zLD");

var _reactRedux = __webpack_require__("RH2O");

var _invariant = __webpack_require__("crWv");

var _invariant2 = _interopRequireDefault(_invariant);

var _PropTypes = __webpack_require__("8xmk");

var _map = __webpack_require__("YByT");

var _SegmentGroup = __webpack_require__("MNA1");

var _SegmentGroup2 = _interopRequireDefault(_SegmentGroup);

var _RouteGroup = __webpack_require__("OEz0");

var _RouteGroup2 = _interopRequireDefault(_RouteGroup);

var _LocationMarkerGroup = __webpack_require__("IQ9V");

var _LocationMarkerGroup2 = _interopRequireDefault(_LocationMarkerGroup);

var _locationShape = __webpack_require__("1itO");

var _locationShape2 = _interopRequireDefault(_locationShape);

var _LoadingIndicator = __webpack_require__("G+3p");

var _LoadingIndicator2 = _interopRequireDefault(_LoadingIndicator);

var _coord = __webpack_require__("w0mN");

var _coord2 = _interopRequireDefault(_coord);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var LiveMapQuery = exports.LiveMapQuery = (0, _reactApollo.gql)(_templateObject);

var LiveMap = function (_Component) {
  _inherits(LiveMap, _Component);

  function LiveMap() {
    _classCallCheck(this, LiveMap);

    return _possibleConstructorReturn(this, (LiveMap.__proto__ || Object.getPrototypeOf(LiveMap)).apply(this, arguments));
  }

  _createClass(LiveMap, [{
    key: 'componentWillUpdate',
    value: function componentWillUpdate(nextProps) {
      var pathname = nextProps.location.pathname,
          _nextProps$data = nextProps.data,
          segments = _nextProps$data.segments,
          locations = _nextProps$data.locations,
          routes = _nextProps$data.routes,
          setBounds = nextProps.setBounds,
          setAllFeatureBounds = nextProps.setAllFeatureBounds,
          setCenter = nextProps.setCenter;

      /* only update bounds on first data render */

      if (this.props.data.loading && !nextProps.loading) {
        var bounds = locations.reduce(function (acc, v) {
          return [].concat(_toConsumableArray(acc), [[v.lat, v.lng]]);
        }, []);
        setAllFeatureBounds(bounds);
        return;
      }

      var oldId = this.props.params.id;
      var newId = nextProps.params.id;


      if (newId && newId !== oldId) {
        if (pathname.includes('locations')) {
          var selectedLocation = locations.find(function (v) {
            return v.id === newId;
          });
          (0, _invariant2.default)(selectedLocation, 'Failed to find id ' + newId + ' in locations collection');
          setCenter([selectedLocation.lat, selectedLocation.lng]);
        } else if (pathname.includes('segments')) {
          var selectedSegment = segments.find(function (v) {
            return v.id === newId;
          });
          (0, _invariant2.default)(selectedSegment, 'Failed to find id ' + newId + ' in segments collection');
          setBounds(selectedSegment.bounds);
        } else if (pathname.includes('routes')) {
          var selectedRoute = routes.find(function (v) {
            return v.id === newId;
          });
          (0, _invariant2.default)(selectedRoute, 'Failed to find id ' + newId + ' in routes collection');

          // @TODO move this to GQL
          var routeBounds = selectedRoute.segments.reduce(function (acc, v) {
            return [].concat(_toConsumableArray(acc), _toConsumableArray(v.bounds));
          }, []);

          setBounds(routeBounds);
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          pathname = _props.location.pathname,
          params = _props.params,
          _props$data = _props.data,
          loading = _props$data.loading,
          segments = _props$data.segments,
          locations = _props$data.locations,
          routes = _props$data.routes,
          viewMode = _props.viewMode;


      if (loading) {
        return _react2.default.createElement(_LoadingIndicator2.default, null);
      }

      /*
        Decide if we need to show routes. The panel routes overrule the viewMode setting. This
        is a bit messy and could probably be improved upon */
      var showRoutes = pathname.includes('routes') || !pathname.includes('segments') && viewMode === 'routes';

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_LocationMarkerGroup2.default, { locations: locations, segments: segments, routeParams: params }),
        showRoutes ? _react2.default.createElement(_RouteGroup2.default, { routes: routes, routeParams: params }) : _react2.default.createElement(_SegmentGroup2.default, { segments: segments, routeParams: params })
      );
    }
  }]);

  return LiveMap;
}(_react.Component);

LiveMap.propTypes = {
  data: (0, _propTypes.shape)({
    loading: _propTypes.bool.isRequired,
    segments: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
      id: _propTypes.string,
      path: (0, _propTypes.arrayOf)(_coord2.default),
      from: _locationShape2.default,
      to: _locationShape2.default
    })),
    locations: (0, _propTypes.arrayOf)(_locationShape2.default)
  }).isRequired,
  location: _PropTypes.locationShape,
  params: (0, _propTypes.shape)({
    id: _propTypes.string
  }).isRequired,
  setBounds: _propTypes.func.isRequired,
  setAllFeatureBounds: _propTypes.func.isRequired,
  setCenter: _propTypes.func.isRequired,
  viewMode: (0, _propTypes.oneOf)(['segments', 'routes']).isRequired
};

var mapStateToProps = function mapStateToProps(_ref) {
  var map = _ref.map;
  return {
    viewMode: map.viewMode
  };
};

var LiveMapWithData = (0, _reactApollo.graphql)(LiveMapQuery)(LiveMap);
var ConnectedLiveMapWithData = (0, _reactRedux.connect)(mapStateToProps, _map.operations)(LiveMapWithData);

var _default = ConnectedLiveMapWithData;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(LiveMapQuery, 'LiveMapQuery', '/code/src/components/Map/Live/index.js');

  __REACT_HOT_LOADER__.register(LiveMap, 'LiveMap', '/code/src/components/Map/Live/index.js');

  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/code/src/components/Map/Live/index.js');

  __REACT_HOT_LOADER__.register(LiveMapWithData, 'LiveMapWithData', '/code/src/components/Map/Live/index.js');

  __REACT_HOT_LOADER__.register(ConnectedLiveMapWithData, 'ConnectedLiveMapWithData', '/code/src/components/Map/Live/index.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/code/src/components/Map/Live/index.js');
}();

;

/***/ }),

/***/ "OEz0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RouteGroup = RouteGroup;

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _reactRedux = __webpack_require__("RH2O");

var _locationShape = __webpack_require__("1itO");

var _locationShape2 = _interopRequireDefault(_locationShape);

var _coord = __webpack_require__("w0mN");

var _coord2 = _interopRequireDefault(_coord);

var _segmentStatus = __webpack_require__("fX1p");

var _segmentStatus2 = _interopRequireDefault(_segmentStatus);

var _map = __webpack_require__("YByT");

var _addObjectPriority = __webpack_require__("E4O7");

var _addObjectPriority2 = _interopRequireDefault(_addObjectPriority);

var _Route = __webpack_require__("zdjT");

var _Route2 = _interopRequireDefault(_Route);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function RouteGroup(_ref) {
  var routes = _ref.routes,
      selectEntity = _ref.selectEntity,
      enterEntity = _ref.enterEntity,
      leaveEntity = _ref.leaveEntity,
      routeParams = _ref.routeParams,
      currentHover = _ref.currentHover;

  // eslint-disable-next-line global-require
  var SortingFeatureGroup = __webpack_require__("x6bV").default;

  var hoveredId = currentHover && currentHover.id;
  var selectedId = routeParams && routeParams.id;

  var sortedRoutesWithPriority = routes.map(function (route) {
    return (0, _addObjectPriority2.default)(route, hoveredId, selectedId);
  }).sort(function (routeA, routeB) {
    return routeA.priority - routeB.priority;
  });

  return _react2.default.createElement(
    SortingFeatureGroup,
    null,
    sortedRoutesWithPriority.map(function (route) {
      return _react2.default.createElement(_Route2.default, {
        key: 'Route-' + route.id + (route.id === selectedId || route.id === currentHover ? '-active' : ''),
        route: route,
        isSelected: route.id === selectedId,
        isHovered: route.id === hoveredId,
        onSelect: function onSelect() {
          selectEntity({
            id: route.id,
            type: 'route'
          });
        },
        onEnter: function onEnter() {
          return enterEntity({
            id: route.id,
            type: 'route'
          });
        },
        onLeave: function onLeave() {
          return leaveEntity({
            id: route.id,
            type: 'route'
          });
        }
      });
    })
  );
}

RouteGroup.propTypes = {
  routes: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    id: _propTypes.string,
    name: _propTypes.string,
    segments: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
      id: _propTypes.string,
      from: _locationShape2.default,
      to: _locationShape2.default,
      path: (0, _propTypes.arrayOf)(_coord2.default),
      liveTravelTime: _propTypes.number.isRequired,
      status: _segmentStatus2.default
    }))
  })).isRequired,
  selectEntity: _propTypes.func.isRequired,
  enterEntity: _propTypes.func.isRequired,
  leaveEntity: _propTypes.func.isRequired,
  routeParams: (0, _propTypes.shape)({
    id: _propTypes.string
  }).isRequired,
  currentHover: (0, _propTypes.shape)({
    id: _propTypes.string.isRequired
  })
};

var mapStateToProps = function mapStateToProps(_ref2) {
  var map = _ref2.map;
  return {
    currentHover: map.currentHover
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps, _map.operations)(RouteGroup);

exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(RouteGroup, 'RouteGroup', '/code/src/components/Map/MapComponents/RouteGroup/index.js');

  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/code/src/components/Map/MapComponents/RouteGroup/index.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/code/src/components/Map/MapComponents/RouteGroup/index.js');
}();

;

/***/ }),

/***/ "OSwL":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = segmentCreation;

var _lodash = __webpack_require__("M4fF");

var _types = __webpack_require__("5QWJ");

var _types2 = _interopRequireDefault(_types);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var initialState = {
  selectedLocations: [],
  selectedPathSuggestion: null,
  pathSuggestions: [],
  createdSegmentId: null
};

function segmentCreation() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case _types2.default.SELECT_LOCATION:
      return _extends({}, state, {
        selectedLocations: [].concat(_toConsumableArray(state.selectedLocations || []), [action.payload.id]),
        pathSuggestions: null, // clear previous suggestions
        selectedPathSuggestion: null
      });

    case _types2.default.DESELECT_LOCATION:
      return _extends({}, state, {
        selectedLocations: state.selectedLocations.filter(function (id) {
          return id !== action.payload.id;
        }),
        pathSuggestions: null, // clear previous suggestions
        selectedPathSuggestion: null
      });

    case _types2.default.FLIP_SELECTED_LOCATIONS:
      return _extends({}, state, {
        selectedLocations: [].concat(_toConsumableArray(state.selectedLocations.reverse())),
        pathSuggestions: null, // clear previous suggestions
        selectedPathSuggestion: null
      });

    case _types2.default.SELECT_PATH_SUGGESTION:
      return _extends({}, state, {
        selectedPathSuggestion: action.payload.pathSuggestion
      });

    case _types2.default.SET_PATH_SUGGESTIONS:
      return _extends({}, state, {
        pathSuggestions: action.payload.pathSuggestions,
        selectedPathSuggestion: (0, _lodash.first)(action.payload.pathSuggestions)
      });

    case _types2.default.SET_CREATED_SEGMENT_ID:
      return _extends({}, state, {
        createdSegmentId: action.payload.id
      });

    case _types2.default.CLEAR_CREATE_SEGMENT:
      return _extends({}, initialState);

    case _types2.default.START_CREATE_OPPOSITE_SEGMENT:
      return _extends({}, initialState, {
        selectedLocations: [].concat(_toConsumableArray(state.selectedLocations.reverse()))
      });

    default:
      return state;
  }
}
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(initialState, 'initialState', '/code/src/state/ducks/segmentCreation/reducers.js');

  __REACT_HOT_LOADER__.register(segmentCreation, 'segmentCreation', '/code/src/state/ducks/segmentCreation/reducers.js');
}();

;

/***/ }),

/***/ "OZsc":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _templateObject = _taggedTemplateLiteral(['\n  query Alerts {\n    locations {\n      id\n      name\n      trackingDevice {\n        id\n        name\n        status\n        batteryVoltage\n        temperature\n        reportInterval\n        lastUpdate\n        numberOfHitsToday\n        hitsToday\n      }\n    }\n  }\n'], ['\n  query Alerts {\n    locations {\n      id\n      name\n      trackingDevice {\n        id\n        name\n        status\n        batteryVoltage\n        temperature\n        reportInterval\n        lastUpdate\n        numberOfHitsToday\n        hitsToday\n      }\n    }\n  }\n']);

exports.Alerts = Alerts;

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _reactApollo = __webpack_require__("3zLD");

var _reactRedux = __webpack_require__("RH2O");

var _map = __webpack_require__("YByT");

var _LoadingIndicator = __webpack_require__("G+3p");

var _LoadingIndicator2 = _interopRequireDefault(_LoadingIndicator);

var _List = __webpack_require__("U2GG");

var _List2 = _interopRequireDefault(_List);

var _ListItem = __webpack_require__("m9jy");

var _ListItem2 = _interopRequireDefault(_ListItem);

var _LocationsListItem = __webpack_require__("Cvct");

var _LocationsListItem2 = _interopRequireDefault(_LocationsListItem);

var _EmptyPanelState = __webpack_require__("li8v");

var _EmptyPanelState2 = _interopRequireDefault(_EmptyPanelState);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var AlertsQuery = (0, _reactApollo.gql)(_templateObject);

function isStatusProblematic(status) {
  if (status === 'warning' || status === 'disconnected') {
    return true;
  }

  return false;
}

function Alerts(_ref) {
  var data = _ref.data,
      selectEntity = _ref.selectEntity,
      enterEntity = _ref.enterEntity,
      leaveEntity = _ref.leaveEntity,
      currentHover = _ref.currentHover;

  if (data.loading) {
    return _react2.default.createElement(_LoadingIndicator2.default, null);
  }

  var items = data.locations.filter(function (_ref2) {
    var trackingDevice = _ref2.trackingDevice;
    return isStatusProblematic(trackingDevice.status);
  });

  // We don't have any alerts yet
  if (!items || items.length === 0) {
    return _react2.default.createElement(_EmptyPanelState2.default, { panelType: 'alert', hideIcon: true });
  }

  return _react2.default.createElement(
    _List2.default,
    null,
    items.map(function (location) {
      var id = location.id,
          trackingDevice = location.trackingDevice;

      var status = trackingDevice.status;
      var isActive = currentHover && currentHover.id === id;
      return _react2.default.createElement(
        _ListItem2.default,
        {
          id: id,
          key: id,
          status: status,
          isActive: isActive,
          onClick: function onClick() {
            return selectEntity({ id: id, type: 'location' });
          },
          onMouseOver: function onMouseOver() {
            return enterEntity({ id: id, type: 'location' });
          },
          onMouseOut: function onMouseOut() {
            return leaveEntity({ id: id, type: 'location' });
          },
          contentType: 'location'
        },
        _react2.default.createElement(_LocationsListItem2.default, { location: location })
      );
    })
  );
}

Alerts.propTypes = {
  data: (0, _propTypes.shape)({
    loading: _propTypes.bool.isRequired,
    location: (0, _propTypes.shape)({})
  }).isRequired,
  selectEntity: _propTypes.func.isRequired,
  enterEntity: _propTypes.func.isRequired,
  leaveEntity: _propTypes.func.isRequired,
  currentHover: (0, _propTypes.shape)({
    id: _propTypes.string.isRequired
  })
};

var mapStateToProps = function mapStateToProps(_ref3, ownProps) {
  var map = _ref3.map;
  return _extends({
    currentHover: map.currentHover
  }, ownProps);
};

var ConnectedAlertsWithData = (0, _reactApollo.compose)((0, _reactRedux.connect)(mapStateToProps, _map.operations), (0, _reactApollo.graphql)(AlertsQuery, {
  options: function options(_ref4) {
    var params = _ref4.params;
    return {
      variables: {
        id: params.id
      }
    };
  }
}))(Alerts);

var _default = ConnectedAlertsWithData;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(AlertsQuery, 'AlertsQuery', '/code/src/components/DataPanel/Overview/Alerts/index.js');

  __REACT_HOT_LOADER__.register(isStatusProblematic, 'isStatusProblematic', '/code/src/components/DataPanel/Overview/Alerts/index.js');

  __REACT_HOT_LOADER__.register(Alerts, 'Alerts', '/code/src/components/DataPanel/Overview/Alerts/index.js');

  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/code/src/components/DataPanel/Overview/Alerts/index.js');

  __REACT_HOT_LOADER__.register(ConnectedAlertsWithData, 'ConnectedAlertsWithData', '/code/src/components/DataPanel/Overview/Alerts/index.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/code/src/components/DataPanel/Overview/Alerts/index.js');
}();

;

/***/ }),

/***/ "Ojwz":
/***/ (function(module, exports) {

module.exports = "/location-active-problem-d3f42fae419e73af205f8c1f8731e65e.svg";

/***/ }),

/***/ "PIwE":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = configureStore;

var _redux = __webpack_require__("2KeS");

var _reactRouterRedux = __webpack_require__("jZgO");

var _reduxForm = __webpack_require__("ao4a");

var _reduxThunk = __webpack_require__("4ufr");

var _reduxThunk2 = _interopRequireDefault(_reduxThunk);

var _reactRouter = __webpack_require__("CIox");

var _ducks = __webpack_require__("3a2E");

var reducers = _interopRequireWildcard(_ducks);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isProduction = "production" === 'production';
var noop = function noop(_) {
  return _;
};

var routerMiddleware = (0, _reactRouterRedux.routerMiddleware)(_reactRouter.browserHistory);

var enhancer = function enhancer(client) {
  return (0, _redux.compose)((0, _redux.applyMiddleware)(_reduxThunk2.default, client.middleware(), routerMiddleware),
  // Only include the DevTools when not in production
  isProduction ? noop : __webpack_require__("PIyo").default.instrument() // eslint-disable-line global-require
  );
};

function configureStore(apolloClient) {
  var initialState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var rootReducer = (0, _redux.combineReducers)(_extends({}, reducers, {
    form: _reduxForm.reducer,
    routing: _reactRouterRedux.routerReducer,
    apollo: apolloClient.reducer()
  }));

  // Note: only Redux >= 3.1.0 supports passing enhancer as third argument.
  // See https://github.com/rackt/redux/releases/tag/v3.1.0
  var store = (0, _redux.createStore)(rootReducer, initialState, enhancer(apolloClient));

  // Hot reload reducers (requires Webpack or Browserify HMR to be enabled)
  /* istanbul ignore if */
  // not sure how to hang the ducks reducers in here.
  // if (!isProduction && module.hot) {
  //   module.hot.accept(
  //     '../reducers',
  //     () => store.replaceReducer(require('../reducers')) // eslint-disable-line global-require
  //   );
  // }

  return store;
}
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(isProduction, 'isProduction', '/code/src/state/store/index.js');

  __REACT_HOT_LOADER__.register(noop, 'noop', '/code/src/state/store/index.js');

  __REACT_HOT_LOADER__.register(routerMiddleware, 'routerMiddleware', '/code/src/state/store/index.js');

  __REACT_HOT_LOADER__.register(enhancer, 'enhancer', '/code/src/state/store/index.js');

  __REACT_HOT_LOADER__.register(configureStore, 'configureStore', '/code/src/state/store/index.js');
}();

;

/***/ }),

/***/ "PIyo":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _reduxDevtools = __webpack_require__("BDh+");

var _reduxDevtoolsLogMonitor = __webpack_require__("j79Z");

var _reduxDevtoolsLogMonitor2 = _interopRequireDefault(_reduxDevtoolsLogMonitor);

var _reduxDevtoolsDockMonitor = __webpack_require__("8tIU");

var _reduxDevtoolsDockMonitor2 = _interopRequireDefault(_reduxDevtoolsDockMonitor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// createDevTools takes a monitor and produces a DevTools component


// Monitors are separate packages, and you can make a custom one
var DevTools = (0, _reduxDevtools.createDevTools)(
// Monitors are individually adjustable with props.
// Consult their repositories to learn about those props.
// Here, we put LogMonitor inside a DockMonitor.
// Note: DockMonitor is visible by default.
_react2.default.createElement(
  _reduxDevtoolsDockMonitor2.default,
  { toggleVisibilityKey: 'ctrl-h', changePositionKey: 'ctrl-q', defaultIsVisible: false },
  _react2.default.createElement(_reduxDevtoolsLogMonitor2.default, { theme: 'solarized' })
));

// Exported from redux-devtools
var _default = DevTools;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(DevTools, 'DevTools', '/code/src/state/containers/DevTools/index.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/code/src/state/containers/DevTools/index.js');
}();

;

/***/ }),

/***/ "PRyc":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SVG = function (_React$Component) {
  _inherits(SVG, _React$Component);

  function SVG() {
    _classCallCheck(this, SVG);

    return _possibleConstructorReturn(this, (SVG.__proto__ || Object.getPrototypeOf(SVG)).apply(this, arguments));
  }

  _createClass(SVG, [{
    key: "render",
    value: function render() {
      return _react2.default.createElement(
        "svg",
        _extends({ viewBox: "0 0 14 19", xmlns: "http://www.w3.org/2000/svg", fill: "currentColor" }, this.props),
        _react2.default.createElement("path", { d: "M.79 8.548c-.69.69-.69 1.81 0 2.5l7.603 7.6a.975.975 0 0 0 .598.248h4.636c.193 0 .24-.112.103-.248l-8.604-8.603-.248-.247L9.57 5.106 13.894.782c.136-.136.09-.248-.103-.247L9.136.552a.972.972 0 0 0-.598.25L.79 8.547z" })
      );
    }
  }]);

  return SVG;
}(_react2.default.Component);

var _default = SVG;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(SVG, "SVG", "/code/src/icons/chevron.inline.svg");

  __REACT_HOT_LOADER__.register(_default, "default", "/code/src/icons/chevron.inline.svg");
}();

;

/***/ }),

/***/ "PeXy":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = DeviceContainer;

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _classnames = __webpack_require__("HW6M");

var _classnames2 = _interopRequireDefault(_classnames);

var _deviceStatus = __webpack_require__("2Ejm");

var _deviceStatus2 = _interopRequireDefault(_deviceStatus);

var _DeviceContainer = __webpack_require__("Bi5r");

var _DeviceContainer2 = _interopRequireDefault(_DeviceContainer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function DeviceContainer(_ref) {
  var children = _ref.children,
      status = _ref.status;

  return _react2.default.createElement(
    'div',
    { className: _DeviceContainer2.default.main },
    _react2.default.createElement(
      'div',
      { className: (0, _classnames2.default)(_DeviceContainer2.default.content, _DeviceContainer2.default['status-' + status]) },
      children
    )
  );
}

DeviceContainer.propTypes = {
  children: _propTypes.node.isRequired,
  status: _deviceStatus2.default.isRequired
};
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(DeviceContainer, 'DeviceContainer', '/code/src/components/DataPanel/Details/DeviceContainer/index.js');
}();

;

/***/ }),

/***/ "Pr6M":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SVG = function (_React$Component) {
  _inherits(SVG, _React$Component);

  function SVG() {
    _classCallCheck(this, SVG);

    return _possibleConstructorReturn(this, (SVG.__proto__ || Object.getPrototypeOf(SVG)).apply(this, arguments));
  }

  _createClass(SVG, [{
    key: "render",
    value: function render() {
      return _react2.default.createElement(
        "svg",
        _extends({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 14 90.4" }, this.props),
        _react2.default.createElement(
          "title",
          null,
          "segment (large)"
        ),
        _react2.default.createElement("path", { d: "M3.2 0L0 3.3v11.3l7 6.7 7-6.7V0H3.2zm0 69.1L0 72.4v11.3l7 6.7 7-6.7V69.1H3.2zM6 27.4h2v36H6z", fill: "currentColor" })
      );
    }
  }]);

  return SVG;
}(_react2.default.Component);

var _default = SVG;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(SVG, "SVG", "/code/src/icons/segment-large.inline.svg");

  __REACT_HOT_LOADER__.register(_default, "default", "/code/src/icons/segment-large.inline.svg");
}();

;

/***/ }),

/***/ "QAri":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"main":"RouteNameDisplay-main--3yIDR","routeIcon":"RouteNameDisplay-routeIcon--386ct","routeName":"RouteNameDisplay-routeName--3B8HB"};

/***/ }),

/***/ "QNwT":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SegmentsListItem = SegmentsListItem;

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _reactRedux = __webpack_require__("RH2O");

var _Trendline = __webpack_require__("cH2h");

var _Trendline2 = _interopRequireDefault(_Trendline);

var _SpeedDisplay = __webpack_require__("g7vI");

var _SpeedDisplay2 = _interopRequireDefault(_SpeedDisplay);

var _NumberDisplay = __webpack_require__("EUU4");

var _NumberDisplay2 = _interopRequireDefault(_NumberDisplay);

var _SegmentNameDisplay = __webpack_require__("k9w0");

var _SegmentNameDisplay2 = _interopRequireDefault(_SegmentNameDisplay);

var _SpeedTrendIcon = __webpack_require__("sCW4");

var _SpeedTrendIcon2 = _interopRequireDefault(_SpeedTrendIcon);

var _SegmentsListItem = __webpack_require__("cKPi");

var _SegmentsListItem2 = _interopRequireDefault(_SegmentsListItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function SegmentsListItem(_ref) {
  var segment = _ref.segment,
      sortValue = _ref.sortValue,
      currentHover = _ref.currentHover;
  var status = segment.status,
      segmentId = segment.id,
      speedLastHour = segment.speedLastHour,
      travelTimeIndex = segment.travelTimeIndex,
      liveSpeed = segment.liveSpeed,
      toName = segment.to.name,
      fromName = segment.from.name;


  var isReporting = status !== 'disconnected';
  var speedTrend = 'up';

  // @TODO move to gql?
  // TTI trend is same as speed but reversed
  var travelTimeLastHour = speedLastHour.map(function (v) {
    return -v;
  });

  var isHovered = Boolean(currentHover && currentHover.id === segmentId);

  return _react2.default.createElement(
    'div',
    { className: _SegmentsListItem2.default.main },
    _react2.default.createElement(
      'div',
      { className: _SegmentsListItem2.default.liveDisplay },
      isReporting ? _react2.default.createElement(_SpeedTrendIcon2.default, { trend: speedTrend, className: _SegmentsListItem2.default.trendIcon }) : _react2.default.createElement(
        'div',
        { className: _SegmentsListItem2.default.statusText },
        'N/A'
      )
    ),
    _react2.default.createElement(_SegmentNameDisplay2.default, {
      className: _SegmentsListItem2.default.segment,
      fromLocationName: fromName,
      toLocationName: toName,
      status: status
    }),
    _react2.default.createElement(
      'div',
      { className: _SegmentsListItem2.default.numberDisplay },
      sortValue === 'tti' ? _react2.default.createElement(_NumberDisplay2.default, { value: travelTimeIndex, status: status, isHovered: isHovered }) : _react2.default.createElement(_SpeedDisplay2.default, { value: liveSpeed, status: status, isHovered: isHovered })
    ),
    _react2.default.createElement(
      'div',
      { className: _SegmentsListItem2.default.trendLine },
      sortValue === 'tti' ? _react2.default.createElement(_Trendline2.default, { trendData: speedLastHour, width: 48, height: 27 }) : _react2.default.createElement(_Trendline2.default, { trendData: travelTimeLastHour, width: 48, height: 27 })
    )
  );
}

SegmentsListItem.propTypes = {
  segment: (0, _propTypes.shape)({
    status: _propTypes.string,
    id: _propTypes.string,
    speedLastHour: _propTypes.array,
    travelTimeIndex: _propTypes.number,
    liveSpeed: _propTypes.number,
    to: _propTypes.object,
    from: _propTypes.object
  }).isRequired,
  sortValue: _propTypes.string.isRequired,
  currentHover: (0, _propTypes.shape)({ id: _propTypes.string, type: _propTypes.string })
};

var mapStateToProps = function mapStateToProps(_ref2) {
  var map = _ref2.map;
  return {
    currentHover: map.currentHover
  };
};

var ConnectedSegmentsListItem = (0, _reactRedux.connect)(mapStateToProps)(SegmentsListItem);

var _default = ConnectedSegmentsListItem;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(SegmentsListItem, 'SegmentsListItem', '/code/src/components/DataPanel/Overview/SegmentsListItem/index.js');

  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/code/src/components/DataPanel/Overview/SegmentsListItem/index.js');

  __REACT_HOT_LOADER__.register(ConnectedSegmentsListItem, 'ConnectedSegmentsListItem', '/code/src/components/DataPanel/Overview/SegmentsListItem/index.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/code/src/components/DataPanel/Overview/SegmentsListItem/index.js');
}();

;

/***/ }),

/***/ "R4EL":
/***/ (function(module, exports) {

module.exports = "/location-active-adc9e5213ce00ff57a2a15aa01bc48e4.svg";

/***/ }),

/***/ "Rb1U":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }
}();

;

/***/ }),

/***/ "Re8b":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = RouteNameDisplay;

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__("HW6M");

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = __webpack_require__("KSGD");

var _segmentStatus = __webpack_require__("fX1p");

var _segmentStatus2 = _interopRequireDefault(_segmentStatus);

var _routeInline = __webpack_require__("55NV");

var _routeInline2 = _interopRequireDefault(_routeInline);

var _segmentSmallBrokenInline = __webpack_require__("ilXI");

var _segmentSmallBrokenInline2 = _interopRequireDefault(_segmentSmallBrokenInline);

var _RouteNameDisplay = __webpack_require__("QAri");

var _RouteNameDisplay2 = _interopRequireDefault(_RouteNameDisplay);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function RouteNameDisplay(_ref) {
  var routeName = _ref.routeName,
      fromLocationName = _ref.fromLocationName,
      toLocationName = _ref.toLocationName,
      status = _ref.status,
      className = _ref.className;

  var isReporting = status !== 'disconnected';

  return _react2.default.createElement(
    'div',
    { className: (0, _classnames2.default)(_RouteNameDisplay2.default.main, className) },
    isReporting ? _react2.default.createElement(_routeInline2.default, { className: _RouteNameDisplay2.default.routeIcon }) : _react2.default.createElement(_segmentSmallBrokenInline2.default, { className: _RouteNameDisplay2.default.routeIcon }),
    _react2.default.createElement(
      'div',
      { className: _RouteNameDisplay2.default.routeName },
      _react2.default.createElement(
        'div',
        null,
        routeName || fromLocationName
      ),
      _react2.default.createElement(
        'div',
        null,
        routeName ? '' : toLocationName
      )
    )
  );
}

RouteNameDisplay.propTypes = {
  routeName: _propTypes.string,
  fromLocationName: _propTypes.string,
  toLocationName: _propTypes.string,
  status: _segmentStatus2.default.isRequired,
  className: _propTypes.string
};
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(RouteNameDisplay, 'RouteNameDisplay', '/code/src/components/RouteNameDisplay/index.js');
}();

;

/***/ }),

/***/ "RhGX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"main":"GridRow-main--eVNYE","titleContainer":"GridRow-titleContainer--ixN5f","childrenContainer":"GridRow-childrenContainer--2tnFi","title":"GridRow-title--xZdkg"};

/***/ }),

/***/ "RzI6":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = LocationTooltip;

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _Tooltip = __webpack_require__("lhKr");

var _Tooltip2 = _interopRequireDefault(_Tooltip);

var _TooltipItem = __webpack_require__("my8f");

var _TooltipItem2 = _interopRequireDefault(_TooltipItem);

var _BatteryIcon = __webpack_require__("fNy8");

var _BatteryIcon2 = _interopRequireDefault(_BatteryIcon);

var _DeviceStatusText = __webpack_require__("t8Hm");

var _DeviceStatusText2 = _interopRequireDefault(_DeviceStatusText);

var _trackingDeviceShape = __webpack_require__("1oTp");

var _trackingDeviceShape2 = _interopRequireDefault(_trackingDeviceShape);

var _formatNextUpdate = __webpack_require__("7p3X");

var _formatNextUpdate2 = _interopRequireDefault(_formatNextUpdate);

var _formatLastUpdate = __webpack_require__("xPfo");

var _formatLastUpdate2 = _interopRequireDefault(_formatLastUpdate);

var _locationTooltip = __webpack_require__("+1dm");

var _locationTooltip2 = _interopRequireDefault(_locationTooltip);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function LocationTooltip(_ref) {
  var locationName = _ref.locationName,
      trackingDevice = _ref.trackingDevice;
  var batteryVoltage = trackingDevice.batteryVoltage,
      reportInterval = trackingDevice.reportInterval,
      lastUpdate = trackingDevice.lastUpdate,
      status = trackingDevice.status;

  var isDeviceOnline = status !== 'disconnected';

  return _react2.default.createElement(
    _Tooltip2.default,
    { className: _locationTooltip2.default['status-' + status], offset: [5.75, -45] },
    _react2.default.createElement(
      _TooltipItem2.default,
      { label: 'status', status: status, isLocation: true },
      _react2.default.createElement(
        'div',
        { className: _locationTooltip2.default.statusItem },
        _react2.default.createElement(
          'span',
          { className: _locationTooltip2.default.statusText },
          _react2.default.createElement(_DeviceStatusText2.default, { status: status })
        ),
        _react2.default.createElement(
          'span',
          { className: _locationTooltip2.default.batteryContainer },
          isDeviceOnline && _react2.default.createElement(_BatteryIcon2.default, { className: _locationTooltip2.default.batteryIcon, batteryVoltage: batteryVoltage })
        )
      )
    ),
    _react2.default.createElement(
      _TooltipItem2.default,
      { label: 'location' },
      locationName
    ),
    isDeviceOnline ? _react2.default.createElement(
      _TooltipItem2.default,
      { label: 'next update' },
      (0, _formatNextUpdate2.default)(lastUpdate, reportInterval)
    ) : _react2.default.createElement(
      _TooltipItem2.default,
      { label: 'last update' },
      (0, _formatLastUpdate2.default)(lastUpdate)
    )
  );
}

LocationTooltip.propTypes = {
  trackingDevice: _trackingDeviceShape2.default.isRequired,
  locationName: _propTypes.string.isRequired
};
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(LocationTooltip, 'LocationTooltip', '/code/src/components/Map/MapComponents/LocationTooltip/index.js');
}();

;

/***/ }),

/***/ "S5/n":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"main":"with-subtitle-main--2bliL","reversed":"with-subtitle-reversed--3OBh5","title":"with-subtitle-title--32avl","titleReversed":"with-subtitle-titleReversed--1AoTo","content":"with-subtitle-content--3I1OS","contentReversed":"with-subtitle-contentReversed--Amoxa"};

/***/ }),

/***/ "SKf6":
/***/ (function(module, exports) {

module.exports = "/location-active-problem-d3f42fae419e73af205f8c1f8731e65e.svg";

/***/ }),

/***/ "SLyG":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var List = function List(_ref) {
  var className = _ref.className,
      children = _ref.children;
  return _react2.default.createElement(
    'ul',
    { className: className },
    children
  );
};

List.propTypes = {
  className: _propTypes.string,
  children: _propTypes.node
};

var _default = List;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(List, 'List', '/code/src/components/MapPanel/List/index.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/code/src/components/MapPanel/List/index.js');
}();

;

/***/ }),

/***/ "TTVP":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SVG = function (_React$Component) {
  _inherits(SVG, _React$Component);

  function SVG() {
    _classCallCheck(this, SVG);

    return _possibleConstructorReturn(this, (SVG.__proto__ || Object.getPrototypeOf(SVG)).apply(this, arguments));
  }

  _createClass(SVG, [{
    key: "render",
    value: function render() {
      return _react2.default.createElement(
        "svg",
        _extends({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 12 12", fill: "currentColor" }, this.props),
        _react2.default.createElement("path", { d: "M0 1h11v11" })
      );
    }
  }]);

  return SVG;
}(_react2.default.Component);

var _default = SVG;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(SVG, "SVG", "/code/src/icons/active-link.inline.svg");

  __REACT_HOT_LOADER__.register(_default, "default", "/code/src/icons/active-link.inline.svg");
}();

;

/***/ }),

/***/ "TnwQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"trendIcon":"segment-trendIcon--1Ej2n","status-ok":"segment-status-ok--1hZZo","status-warning":"segment-status-warning--shmNf","status-problem":"segment-status-problem--QS_bx","status-disconnected":"segment-status-disconnected--3Nn7R"};

/***/ }),

/***/ "U2GG":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var List = function List(_ref) {
  var className = _ref.className,
      children = _ref.children;
  return _react2.default.createElement(
    'ul',
    { className: className },
    children
  );
};

List.propTypes = {
  className: _propTypes.string,
  children: _propTypes.node
};

var _default = List;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(List, 'List', '/code/src/components/DataPanel/Overview/List/index.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/code/src/components/DataPanel/Overview/List/index.js');
}();

;

/***/ }),

/***/ "U85F":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n  query Locations {\n    locations {\n      id\n      name\n      trackingDevice {\n        id\n        status\n      }\n    }\n    segments {\n      id\n      from {\n        id\n        name\n      }\n      to {\n        id\n        name\n      }\n    }\n  }\n'], ['\n  query Locations {\n    locations {\n      id\n      name\n      trackingDevice {\n        id\n        status\n      }\n    }\n    segments {\n      id\n      from {\n        id\n        name\n      }\n      to {\n        id\n        name\n      }\n    }\n  }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  mutation createPathSuggestions($fromId: ID!, $toId: ID!) {\n    createPathSuggestions(fromId: $fromId, toId: $toId) {\n      id\n      path\n      distance\n      expectedTravelTime\n    }\n  }\n'], ['\n  mutation createPathSuggestions($fromId: ID!, $toId: ID!) {\n    createPathSuggestions(fromId: $fromId, toId: $toId) {\n      id\n      path\n      distance\n      expectedTravelTime\n    }\n  }\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  mutation createSegment($fromId: ID!, $toId: ID!, $pathSuggestionId: ID!) {\n    createSegment(fromId: $fromId, toId: $toId, pathSuggestionId: $pathSuggestionId) {\n      id\n    }\n  }\n'], ['\n  mutation createSegment($fromId: ID!, $toId: ID!, $pathSuggestionId: ID!) {\n    createSegment(fromId: $fromId, toId: $toId, pathSuggestionId: $pathSuggestionId) {\n      id\n    }\n  }\n']);

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _reactApollo = __webpack_require__("3zLD");

var _reactRedux = __webpack_require__("RH2O");

var _propTypes = __webpack_require__("KSGD");

var _segmentCreation = __webpack_require__("ZaDe");

var _map = __webpack_require__("YByT");

var _lodash = __webpack_require__("M4fF");

var _coord = __webpack_require__("w0mN");

var _coord2 = _interopRequireDefault(_coord);

var _filterAvailableLocations = __webpack_require__("xM1A");

var _filterAvailableLocations2 = _interopRequireDefault(_filterAvailableLocations);

var _Live = __webpack_require__("NsJu");

var _LoadingIndicator = __webpack_require__("G+3p");

var _LoadingIndicator2 = _interopRequireDefault(_LoadingIndicator);

var _LocationStatusIcon = __webpack_require__("fu+b");

var _LocationStatusIcon2 = _interopRequireDefault(_LocationStatusIcon);

var _LocationsHeader = __webpack_require__("aNTX");

var _LocationsHeader2 = _interopRequireDefault(_LocationsHeader);

var _List = __webpack_require__("SLyG");

var _List2 = _interopRequireDefault(_List);

var _ListItem = __webpack_require__("j9gU");

var _ListItem2 = _interopRequireDefault(_ListItem);

var _Footer = __webpack_require__("7H5I");

var _Footer2 = _interopRequireDefault(_Footer);

var _Title = __webpack_require__("o77h");

var _Title2 = _interopRequireDefault(_Title);

var _CreateSegment = __webpack_require__("suLB");

var _CreateSegment2 = _interopRequireDefault(_CreateSegment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var API_ERROR = '__error__';

var CreateSegmentQuery = (0, _reactApollo.gql)(_templateObject);

var CreatePathSuggestionsMutation = (0, _reactApollo.gql)(_templateObject2);

var CreateSegmentMutation = (0, _reactApollo.gql)(_templateObject3);

var CreateSegment = function (_Component) {
  _inherits(CreateSegment, _Component);

  function CreateSegment() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, CreateSegment);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CreateSegment.__proto__ || Object.getPrototypeOf(CreateSegment)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      waitForResponse: false
    }, _this.handleDone = function () {
      var _this2;

      return (_this2 = _this).__handleDone__REACT_HOT_LOADER__.apply(_this2, arguments);
    }, _this.handleClose = function () {
      var _this3;

      return (_this3 = _this).__handleClose__REACT_HOT_LOADER__.apply(_this3, arguments);
    }, _this.handleCancel = function () {
      var _this4;

      return (_this4 = _this).__handleCancel__REACT_HOT_LOADER__.apply(_this4, arguments);
    }, _this.handleNew = function () {
      var _this5;

      return (_this5 = _this).__handleNew__REACT_HOT_LOADER__.apply(_this5, arguments);
    }, _this.handleClick = function () {
      var _this6;

      return (_this6 = _this).__handleClick__REACT_HOT_LOADER__.apply(_this6, arguments);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(CreateSegment, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this7 = this;

      var selectedLocations = nextProps.selectedLocations,
          pathSuggestions = nextProps.pathSuggestions,
          createPathSuggestions = nextProps.createPathSuggestions,
          setPathSuggestions = nextProps.setPathSuggestions;
      var waitForResponse = this.state.waitForResponse;

      var hasTwoLocations = selectedLocations && selectedLocations.length === 2;

      if (!waitForResponse && hasTwoLocations && !pathSuggestions) {
        createPathSuggestions().then(function (result) {
          setPathSuggestions(result.data.createPathSuggestions);
          _this7.setState({ waitForResponse: false });
        }).catch(function (err) {
          _this7.setState({ waitForResponse: false });
          // eslint-disable-next-line no-console
          console.error('Failed to create path suggestions: ' + err.message);
        });

        this.setState({ waitForResponse: true });
      }
    }
  }, {
    key: '__handleDone__REACT_HOT_LOADER__',
    value: function __handleDone__REACT_HOT_LOADER__() {
      var _this8 = this;

      var _props = this.props,
          createSegment = _props.createSegment,
          setCreatedSegmentId = _props.setCreatedSegmentId;

      createSegment().then(function (result) {
        setCreatedSegmentId(result.data.createSegment.id);
        _this8.setState({ waitForResponse: false });
      }).catch(function (err) {
        _this8.setState({ waitForResponse: false });
        // eslint-disable-next-line no-console
        console.error('Failed to create new segment: ' + err.message);
      });

      this.setState({ waitForResponse: true });
    }
  }, {
    key: '__handleClose__REACT_HOT_LOADER__',
    value: function __handleClose__REACT_HOT_LOADER__() {
      var finishCreateSegment = this.props.finishCreateSegment;

      finishCreateSegment();
    }
  }, {
    key: '__handleCancel__REACT_HOT_LOADER__',
    value: function __handleCancel__REACT_HOT_LOADER__() {
      var finishCreateSegment = this.props.finishCreateSegment;

      finishCreateSegment();
    }
  }, {
    key: '__handleNew__REACT_HOT_LOADER__',
    value: function __handleNew__REACT_HOT_LOADER__() {
      var clearCreateSegment = this.props.clearCreateSegment;

      clearCreateSegment();
    }
  }, {
    key: '__handleClick__REACT_HOT_LOADER__',
    value: function __handleClick__REACT_HOT_LOADER__(locationId) {
      this.props.selectLocation(locationId);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this9 = this;

      var _props2 = this.props,
          _props2$data = _props2.data,
          loading = _props2$data.loading,
          locations = _props2$data.locations,
          segments = _props2$data.segments,
          deselectLocation = _props2.deselectLocation,
          selectedLocations = _props2.selectedLocations,
          selectedPathSuggestion = _props2.selectedPathSuggestion,
          createdSegmentId = _props2.createdSegmentId,
          currentHover = _props2.currentHover,
          enterEntity = _props2.enterEntity,
          leaveEntity = _props2.leaveEntity;


      if (loading) {
        return _react2.default.createElement(_LoadingIndicator2.default, null);
      }

      var step = null;
      var hasNoLocations = !selectedLocations || selectedLocations.length === 0;
      var hasTwoLocations = selectedLocations && selectedLocations.length === 2;

      if (hasNoLocations) {
        step = 1;
      } else if (selectedLocations && !hasTwoLocations) {
        step = 2;
      } else if (hasTwoLocations) {
        step = 3;

        if (selectedPathSuggestion) {
          step = 4;
        }

        if (createdSegmentId) {
          step = 5;
        }
      }

      // Do not show the to/from header if nothing was selected
      var showHeader = step > 1;

      // Show the list if to/from selection is not complete
      var showList = !hasTwoLocations;

      var fromLocation = null;
      var toLocation = null;
      var isFinalStep = step === 4;
      var isFinished = Boolean(createdSegmentId);
      var hasError = createdSegmentId === API_ERROR;

      if (selectedLocations) {
        fromLocation = locations.find(function (_ref2) {
          var id = _ref2.id;
          return id === (0, _lodash.first)(selectedLocations, 'id');
        });
      }

      // If have selected one location, only show possible next steps
      var filteredLocations = (0, _filterAvailableLocations2.default)(locations, segments, selectedLocations);

      if (hasTwoLocations) {
        toLocation = locations.find(function (_ref3) {
          var id = _ref3.id;
          return id === (0, _lodash.last)(selectedLocations, 'id');
        });
      }

      var waitForResponse = this.state.waitForResponse;


      var createLocationListItem = function createLocationListItem(location) {
        var isActive = currentHover && currentHover.id === location.id;
        var locationStatus = location.trackingDevice.status;
        return _react2.default.createElement(
          _ListItem2.default,
          {
            key: location.id,
            id: location.id,
            isActive: isActive,
            status: locationStatus,
            onMouseOver: function onMouseOver() {
              return enterEntity({ id: location.id, type: 'location' });
            },
            onMouseOut: function onMouseOut() {
              return leaveEntity({ id: location.id, type: 'location' });
            },
            onClick: function onClick() {
              return _this9.handleClick(location.id, locations);
            }
          },
          _react2.default.createElement(_LocationStatusIcon2.default, { status: locationStatus, className: _CreateSegment2.default.locationIcon }),
          location.name
        ); // Don't show locations that are found in existing segments
      };

      // We have already filtered out already connecting segments for the panel
      // On the map we want to show the current selected marker, in the panel we do not.
      // That's why we do an extra filter in the panel.
      var availableLocations = selectedLocations.length > 0 ? filteredLocations.filter(function (location) {
        // Don't show a location we have already selected
        if (selectedLocations.includes(location.id)) {
          return false;
        }
        // Otherwise just show the location in the list
        return true;
      }) : filteredLocations;

      return _react2.default.createElement(
        'div',
        { className: _CreateSegment2.default.main },
        _react2.default.createElement(
          'div',
          { className: _CreateSegment2.default.top },
          _react2.default.createElement(
            _Title2.default,
            null,
            'Create new segment'
          ),
          showHeader && _react2.default.createElement(_LocationsHeader2.default, {
            fromLocation: fromLocation,
            toLocation: toLocation,
            removeLocation: deselectLocation,
            isFinished: isFinished
          }),
          hasNoLocations ? _react2.default.createElement(
            'h3',
            { className: _CreateSegment2.default.subtitle },
            'Select origin'
          ) : !hasTwoLocations ? _react2.default.createElement(
            'h3',
            { className: _CreateSegment2.default.subtitle },
            'Select destination'
          ) : null
        ),
        _react2.default.createElement(
          'div',
          { className: _CreateSegment2.default.content },
          showList && _react2.default.createElement(
            _List2.default,
            { className: _CreateSegment2.default.list },
            availableLocations.map(createLocationListItem)
          ),
          isFinished ? hasError ? _react2.default.createElement(
            'div',
            { className: _CreateSegment2.default.text },
            'An error occurred. This has been reported.'
          ) : _react2.default.createElement(
            'div',
            { className: _CreateSegment2.default.text },
            'You have successfully created a new segment. '
          ) : null
        ),
        _react2.default.createElement(_Footer2.default, {
          className: _CreateSegment2.default.footer,
          onCancel: this.handleCancel,
          onDone: this.handleDone,
          onNew: this.handleNew,
          onClose: this.handleClose,
          isFinalStep: isFinalStep,
          isFinished: isFinished,
          waitForResponse: waitForResponse
        })
      );
    }
  }]);

  return CreateSegment;
}(_react.Component);

CreateSegment.propTypes = {
  data: (0, _propTypes.shape)({
    loading: _propTypes.bool.isRequired,
    location: (0, _propTypes.shape)({}),
    segments: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
      id: _propTypes.string,
      name: _propTypes.string
    }))
  }),
  selectedLocations: (0, _propTypes.arrayOf)(_propTypes.string),
  pathSuggestions: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    id: _propTypes.string.isRequired,
    path: (0, _propTypes.arrayOf)(_coord2.default).isRequired
  })),
  selectedPathSuggestion: (0, _propTypes.shape)({
    id: _propTypes.string.isRequired
  }),
  selectLocation: _propTypes.func.isRequired,
  deselectLocation: _propTypes.func.isRequired,
  createdSegmentId: _propTypes.string,
  setPathSuggestions: _propTypes.func.isRequired,
  setCreatedSegmentId: _propTypes.func.isRequired,

  createSegment: _propTypes.func.isRequired,
  finishCreateSegment: _propTypes.func.isRequired,
  clearCreateSegment: _propTypes.func.isRequired,
  createPathSuggestions: _propTypes.func.isRequired,
  currentHover: (0, _propTypes.shape)({ id: _propTypes.string }),
  enterEntity: _propTypes.func.isRequired,
  leaveEntity: _propTypes.func.isRequired
};

var mapStateToProps = function mapStateToProps(_ref4) {
  var map = _ref4.map,
      segmentCreation = _ref4.segmentCreation;
  return {
    currentHover: map.currentHover,
    selectedLocations: segmentCreation.selectedLocations,
    pathSuggestions: segmentCreation.pathSuggestions,
    selectedPathSuggestion: segmentCreation.selectedPathSuggestion,
    createdSegmentId: segmentCreation.createdSegmentId
  };
};

var ConnectedCreateSegmentWithData = (0, _reactApollo.compose)((0, _reactRedux.connect)(mapStateToProps, _extends({}, _map.operations, _segmentCreation.operations)), (0, _reactApollo.graphql)(CreateSegmentQuery, {}), (0, _reactApollo.graphql)(CreatePathSuggestionsMutation, {
  props: function props(_ref5) {
    var mutate = _ref5.mutate,
        selectedLocations = _ref5.ownProps.selectedLocations;
    return {
      createPathSuggestions: function createPathSuggestions() {
        return mutate({
          variables: {
            fromId: (0, _lodash.first)(selectedLocations),
            toId: (0, _lodash.last)(selectedLocations)
          }
        });
      }
    };
  }
}), (0, _reactApollo.graphql)(CreateSegmentMutation, {
  props: function props(_ref6) {
    var mutate = _ref6.mutate,
        _ref6$ownProps = _ref6.ownProps,
        selectedLocations = _ref6$ownProps.selectedLocations,
        selectedPathSuggestion = _ref6$ownProps.selectedPathSuggestion;
    return {
      createSegment: function createSegment() {
        return mutate({
          variables: {
            fromId: (0, _lodash.first)(selectedLocations),
            toId: (0, _lodash.last)(selectedLocations),
            pathSuggestionId: selectedPathSuggestion.id
          },
          refetchQueries: [{
            query: _Live.LiveMapQuery
          }]
        });
      }
    };
  }
}))(CreateSegment);

var _default = ConnectedCreateSegmentWithData;
exports.default = _default;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(API_ERROR, 'API_ERROR', '/code/src/components/MapPanel/CreateSegment/index.js');

  __REACT_HOT_LOADER__.register(CreateSegmentQuery, 'CreateSegmentQuery', '/code/src/components/MapPanel/CreateSegment/index.js');

  __REACT_HOT_LOADER__.register(CreatePathSuggestionsMutation, 'CreatePathSuggestionsMutation', '/code/src/components/MapPanel/CreateSegment/index.js');

  __REACT_HOT_LOADER__.register(CreateSegmentMutation, 'CreateSegmentMutation', '/code/src/components/MapPanel/CreateSegment/index.js');

  __REACT_HOT_LOADER__.register(CreateSegment, 'CreateSegment', '/code/src/components/MapPanel/CreateSegment/index.js');

  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/code/src/components/MapPanel/CreateSegment/index.js');

  __REACT_HOT_LOADER__.register(ConnectedCreateSegmentWithData, 'ConnectedCreateSegmentWithData', '/code/src/components/MapPanel/CreateSegment/index.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/code/src/components/MapPanel/CreateSegment/index.js');
}();

;

/***/ }),

/***/ "UVvc":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRouterRedux = __webpack_require__("jZgO");

var _actions = __webpack_require__("iDB7");

var actions = _interopRequireWildcard(_actions);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

/*
  These operations use a bit of defensive programming to make sure that
  actions are only fired when certain conditions are met. It should not be
  possible to trigger these from the UI in wrong conditions, because the
  elements would simply not be availble to trigger them (like a flip button),
  but it's nice to be absolutely sure and throw errors if unexpected conditions
  occur.
*/

/*
  Select a location on the map. This can be location a or b.
*/
var selectLocation = function selectLocation(id) {
  return function (dispatch, getState) {
    var _getState = getState(),
        selectedLocations = _getState.segmentCreation.selectedLocations;

    if (selectedLocations && selectedLocations.length === 2) {
      throw new Error('Can not select more then two locations at once');
    }

    dispatch(actions.selectLocation(id));
  };
};

var deselectLocation = function deselectLocation(id) {
  return function (dispatch, getState) {
    var _getState2 = getState(),
        selectedLocations = _getState2.segmentCreation.selectedLocations;

    if (!selectedLocations || !selectedLocations.includes(id)) {
      throw new Error('Can not deselect id ' + id + ' because the current selection is ' + selectedLocations);
    }

    dispatch(actions.deselectLocation(id));
  };
};

var flipSelectedLocations = function flipSelectedLocations() {
  return function (dispatch, getState) {
    var _getState3 = getState(),
        selectedLocations = _getState3.segmentCreation.selectedLocations;

    if (!selectedLocations || !selectedLocations.length === 2) {
      throw new Error('It takes two to flip');
    }

    dispatch(actions.flipSelectedLocations());
  };
};

var setPathSuggestions = function setPathSuggestions(pathSuggestions) {
  return function (dispatch) {
    // store the path suggestions and also pre-select the first one
    dispatch(actions.setPathSuggestions(pathSuggestions));
  };
};

var selectPathSuggestion = function selectPathSuggestion(id) {
  return function (dispatch, getState) {
    var _getState4 = getState(),
        pathSuggestions = _getState4.segmentCreation.pathSuggestions;

    if (!pathSuggestions || pathSuggestions.length === 0) {
      throw new Error('There are no segment path options to select from');
    }

    var pathSuggestion = pathSuggestions.find(function (option) {
      return option.id === id;
    });

    if (!pathSuggestion) {
      throw new Error('There is no segment path option with id ' + id);
    }

    dispatch(actions.selectPathSuggestion(pathSuggestion));
  };
};

var finishCreateSegment = function finishCreateSegment() {
  return function (dispatch) {
    dispatch(actions.clearCreateSegment());
    dispatch((0, _reactRouterRedux.push)('/map/live'));
  };
};

var clearCreateSegment = function clearCreateSegment() {
  return function (dispatch) {
    dispatch(actions.clearCreateSegment());
  };
};

var startCreateOppositeSegment = function startCreateOppositeSegment() {
  return function (dispatch, getState) {
    var _getState5 = getState(),
        selectedLocations = _getState5.segmentCreation.selectedLocations;

    if (!selectedLocations || !selectedLocations.length === 2) {
      throw new Error('In order to create the opposite segment two locations need to be selected');
    }

    dispatch(actions.startCreateOppositeSegment());
  };
};

var _default = {
  selectLocation: selectLocation,
  deselectLocation: deselectLocation,
  flipSelectedLocations: flipSelectedLocations,
  setPathSuggestions: setPathSuggestions,
  selectPathSuggestion: selectPathSuggestion,
  setCreatedSegmentId: actions.setCreatedSegmentId,
  finishCreateSegment: finishCreateSegment,
  clearCreateSegment: clearCreateSegment,
  startCreateOppositeSegment: startCreateOppositeSegment
};
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(selectLocation, 'selectLocation', '/code/src/state/ducks/segmentCreation/operations.js');

  __REACT_HOT_LOADER__.register(deselectLocation, 'deselectLocation', '/code/src/state/ducks/segmentCreation/operations.js');

  __REACT_HOT_LOADER__.register(flipSelectedLocations, 'flipSelectedLocations', '/code/src/state/ducks/segmentCreation/operations.js');

  __REACT_HOT_LOADER__.register(setPathSuggestions, 'setPathSuggestions', '/code/src/state/ducks/segmentCreation/operations.js');

  __REACT_HOT_LOADER__.register(selectPathSuggestion, 'selectPathSuggestion', '/code/src/state/ducks/segmentCreation/operations.js');

  __REACT_HOT_LOADER__.register(finishCreateSegment, 'finishCreateSegment', '/code/src/state/ducks/segmentCreation/operations.js');

  __REACT_HOT_LOADER__.register(clearCreateSegment, 'clearCreateSegment', '/code/src/state/ducks/segmentCreation/operations.js');

  __REACT_HOT_LOADER__.register(startCreateOppositeSegment, 'startCreateOppositeSegment', '/code/src/state/ducks/segmentCreation/operations.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/code/src/state/ducks/segmentCreation/operations.js');
}();

;

/***/ }),

/***/ "UitP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"main":"segment-tooltip-main--nq3Ya","distance":"segment-tooltip-distance--3PHqr"};

/***/ }),

/***/ "W6I0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"trendIcon":"route-trendIcon--241sU","status-ok":"route-status-ok--1vePw","status-warning":"route-status-warning--1Alhs","status-problem":"route-status-problem--12z06","status-disconnected":"route-status-disconnected--kIr3f"};

/***/ }),

/***/ "WDbj":
/***/ (function(module, exports) {

module.exports = "/location-inactive-warning-007df52e38c3478e7fc83445fe0d6bff.svg";

/***/ }),

/***/ "Wh2a":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _lodash = __webpack_require__("M4fF");

var _invariant = __webpack_require__("crWv");

var _invariant2 = _interopRequireDefault(_invariant);

var _reactVis = __webpack_require__("WOjX");

var _WithSubtitle = __webpack_require__("j/Bm");

var _WithSubtitle2 = _interopRequireDefault(_WithSubtitle);

var _Chart = __webpack_require__("rFqV");

var _Chart2 = _interopRequireDefault(_Chart);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Chart = function (_Component) {
  _inherits(Chart, _Component);

  function Chart() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Chart);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Chart.__proto__ || Object.getPrototypeOf(Chart)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      crosshairIndex: null
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Chart, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var crosshairIndex = this.state.crosshairIndex;
      var _props = this.props,
          title = _props.title,
          reportedValues = _props.reportedValues,
          expectedValues = _props.expectedValues,
          calculateCrosshairA = _props.calculateCrosshairA,
          calculateCrosshairB = _props.calculateCrosshairB;


      var showExpectedValues = expectedValues && expectedValues.length > 0;
      (0, _invariant2.default)(reportedValues.length > 0, 'Chart needs at least 1 reported value');

      var mappedReportedValues = reportedValues.map(function (_ref2) {
        var timestamp = _ref2.timestamp,
            value = _ref2.value;
        return {
          x: new Date(timestamp),
          y: value
        };
      });

      var mappedExpectedValues = showExpectedValues ? expectedValues.map(function (_ref3) {
        var timestamp = _ref3.timestamp,
            value = _ref3.value;
        return {
          x: new Date(timestamp),
          y: value
        };
      }) : [];

      var tickMargin = Math.floor(reportedValues.length / 10);

      // Increase the domain size by this amount to create a bit of padding
      var yDomainPadding = 1.5;

      // Define tick values per render so we can show the current highlighted line based on the nearest mouse X value
      var startDate = (0, _lodash.first)(mappedReportedValues).x;
      var endDate = (0, _lodash.last)(mappedReportedValues).x;

      var tickValues = [];
      var crosshairValuesReported = null;
      var crosshairValuesExpected = null;
      var crosshairA = null;
      var crosshairB = null;
      var showCrosshair = crosshairIndex !== null;

      // if crosshair is overlapping with start, don't render start
      if (!showCrosshair || crosshairIndex > tickMargin) {
        tickValues.push(startDate);
      }

      if (showCrosshair) {
        crosshairValuesReported = (0, _lodash.get)(mappedReportedValues, crosshairIndex);
        crosshairValuesExpected = showExpectedValues ? (0, _lodash.get)(mappedExpectedValues, crosshairIndex) : null;

        if (crosshairIndex > 0 && crosshairIndex < mappedReportedValues.length - 1) {
          tickValues.push(crosshairValuesReported.x);
        }

        crosshairA = calculateCrosshairA({
          reported: crosshairValuesReported.y,
          expected: crosshairValuesExpected && crosshairValuesExpected.y
        });
        crosshairB = calculateCrosshairB && // b is optional
        calculateCrosshairB({
          reported: crosshairValuesReported.y,
          expected: crosshairValuesExpected && crosshairValuesExpected.y
        });
      }

      // if crosshair is overlapping with end, don't render end
      if (!showCrosshair || crosshairIndex <= mappedReportedValues.length - tickMargin) {
        tickValues.push(endDate);
      }

      var maxValueReported = reportedValues.reduce(function (acc, _ref4) {
        var value = _ref4.value;

        if (acc < value) return value;
        return acc;
      }, 0);

      var maxValueExpected = expectedValues ? expectedValues.reduce(function (acc, _ref5) {
        var value = _ref5.value;

        if (acc < value) return value;
        return acc;
      }, 0) : 0;

      var maxValue = Math.max(maxValueReported, maxValueExpected);

      return _react2.default.createElement(
        'div',
        { className: _Chart2.default.main },
        _react2.default.createElement(
          'h3',
          { className: _Chart2.default.title },
          title
        ),
        _react2.default.createElement(
          _reactVis.FlexibleWidthXYPlot,
          {
            xType: 'time',
            xDomain: [startDate, endDate],
            yDomain: [0, maxValue * yDomainPadding],
            onMouseLeave: function onMouseLeave() {
              return _this2.setState({ crosshairIndex: null });
            },
            height: 160,
            margin: {
              left: 16,
              right: 16,
              top: 0,
              bottom: 32
            }
          },
          _react2.default.createElement(_reactVis.XAxis, {
            tickValues: tickValues,
            style: {
              text: {
                stroke: 'none',
                fill: 'rgb(0, 0, 0)',
                fontWeight: 600
              }
            }
          }),
          showExpectedValues && _react2.default.createElement(_reactVis.LineSeries, {
            data: mappedExpectedValues,
            strokeWidth: 2,
            color: 'rgb(135, 145, 170)',
            strokeDasharray: '2 2'
          }),
          _react2.default.createElement(_reactVis.AreaSeries, { data: mappedReportedValues, stroke: 'none', fill: 'rgba(0, 0, 255, 0.05)' }),
          _react2.default.createElement(_reactVis.LineSeries, {
            data: mappedReportedValues,
            color: 'rgb(0, 0, 255)',
            strokeWidth: 2,
            onNearestX: function onNearestX(value, _ref6) {
              var index = _ref6.index;

              _this2.setState({
                crosshairIndex: index
              });
            }
          }),
          showCrosshair && showExpectedValues ? _react2.default.createElement(
            _reactVis.Crosshair,
            { values: [crosshairValuesReported, crosshairValuesExpected] },
            _react2.default.createElement(
              'div',
              { className: _Chart2.default.crosshair },
              crosshairA && _react2.default.createElement(
                _WithSubtitle2.default,
                { reversed: true, title: crosshairA.title, className: _Chart2.default.value },
                crosshairA.value
              ),
              crosshairB && _react2.default.createElement(
                _WithSubtitle2.default,
                { reversed: true, title: crosshairB.title, className: _Chart2.default.value },
                crosshairB.value
              )
            )
          ) : _react2.default.createElement(
            _reactVis.Crosshair,
            { values: [crosshairValuesReported] },
            _react2.default.createElement(
              'div',
              { className: _Chart2.default.crosshair },
              crosshairA && _react2.default.createElement(
                _WithSubtitle2.default,
                { reversed: true, title: crosshairA.title, className: _Chart2.default.value },
                crosshairA.value
              ),
              crosshairB && _react2.default.createElement(
                _WithSubtitle2.default,
                { reversed: true, title: crosshairB.title, className: _Chart2.default.value },
                crosshairB.value
              )
            )
          ),
          showCrosshair && _react2.default.createElement(_reactVis.MarkSeries, {
            color: 'rgba(0, 0, 255, 0.8)',
            stroke: 'white',
            strokeWidth: 2,
            size: 5,
            data: [crosshairValuesReported]
          })
        )
      );
    }
  }]);

  return Chart;
}(_react.Component);

var _default = Chart;
exports.default = _default;

Chart.propTypes = {
  title: _propTypes.string,
  reportedValues: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    timestamp: _propTypes.string.isRequired,
    value: _propTypes.number.isRequired
  }).isRequired),
  expectedValues: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    timestamp: _propTypes.string.isRequired,
    value: _propTypes.number.isRequired
  })),
  calculateCrosshairA: _propTypes.func.isRequired,
  calculateCrosshairB: _propTypes.func
};
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(Chart, 'Chart', '/code/src/components/DataPanel/Details/Chart/index.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/code/src/components/DataPanel/Details/Chart/index.js');
}();

;

/***/ }),

/***/ "Y51B":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n  query CreateRouteMap {\n    locations {\n      id\n      lat\n      lng\n      name\n      trackingDevice {\n        id\n        name\n        status\n        batteryVoltage\n        temperature\n        reportInterval\n        lastUpdate\n        numberOfHitsToday\n      }\n    }\n    segments {\n      id\n      status\n      path\n      bounds\n      liveTravelTime\n      expectedTravelTime\n      from {\n        id\n        name\n      }\n      to {\n        id\n        name\n      }\n    }\n  }\n'], ['\n  query CreateRouteMap {\n    locations {\n      id\n      lat\n      lng\n      name\n      trackingDevice {\n        id\n        name\n        status\n        batteryVoltage\n        temperature\n        reportInterval\n        lastUpdate\n        numberOfHitsToday\n      }\n    }\n    segments {\n      id\n      status\n      path\n      bounds\n      liveTravelTime\n      expectedTravelTime\n      from {\n        id\n        name\n      }\n      to {\n        id\n        name\n      }\n    }\n  }\n']);

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _reactApollo = __webpack_require__("3zLD");

var _reactRedux = __webpack_require__("RH2O");

var _lodash = __webpack_require__("M4fF");

var _locationShape = __webpack_require__("1itO");

var _locationShape2 = _interopRequireDefault(_locationShape);

var _coord = __webpack_require__("w0mN");

var _coord2 = _interopRequireDefault(_coord);

var _routeCreation = __webpack_require__("tEHQ");

var _map = __webpack_require__("YByT");

var _LoadingIndicator = __webpack_require__("G+3p");

var _LoadingIndicator2 = _interopRequireDefault(_LoadingIndicator);

var _LocationMarkerGroup = __webpack_require__("qoCU");

var _LocationMarkerGroup2 = _interopRequireDefault(_LocationMarkerGroup);

var _SegmentGroup = __webpack_require__("vNMZ");

var _SegmentGroup2 = _interopRequireDefault(_SegmentGroup);

var _CreateRoute = __webpack_require__("wNIN");

var _CreateRoute2 = _interopRequireDefault(_CreateRoute);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var CreateRouteMapQuery = (0, _reactApollo.gql)(_templateObject);

var CreateRouteMap = function (_Component) {
  _inherits(CreateRouteMap, _Component);

  function CreateRouteMap() {
    _classCallCheck(this, CreateRouteMap);

    return _possibleConstructorReturn(this, (CreateRouteMap.__proto__ || Object.getPrototypeOf(CreateRouteMap)).apply(this, arguments));
  }

  _createClass(CreateRouteMap, [{
    key: 'componentWillUpdate',
    value: function componentWillUpdate(nextProps) {
      var locations = nextProps.data.locations,
          setAllFeatureBounds = nextProps.setAllFeatureBounds;

      /* only update bounds on first data render */

      if (this.props.data.loading && !nextProps.loading) {
        var bounds = locations.reduce(function (acc, v) {
          return [].concat(_toConsumableArray(acc), [[v.lat, v.lng]]);
        }, []);
        setAllFeatureBounds(bounds);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          params = _props.params,
          _props$data = _props.data,
          loading = _props$data.loading,
          locations = _props$data.locations,
          segments = _props$data.segments,
          selectedSegments = _props.selectedSegments,
          createdRouteId = _props.createdRouteId;


      if (loading) {
        return _react2.default.createElement(_LoadingIndicator2.default, null);
      }

      var isFlowFinished = Boolean(createdRouteId);

      var availableOrSelectedSegments = segments.reduce(function (acc, segment) {
        // if nothing is selected, all segmenets should be available
        if (selectedSegments.length === 0) {
          return [].concat(_toConsumableArray(acc), [_extends({ isAvailable: true }, segment)]);
        }

        if (selectedSegments.includes(segment.id)) {
          return [].concat(_toConsumableArray(acc), [_extends({ isSelected: true }, segment)]);
        }

        var lastSelectedSegment = segments.find(function (seg) {
          return seg.id === (0, _lodash.last)(selectedSegments);
        });

        if (lastSelectedSegment && lastSelectedSegment.to.id === segment.from.id) {
          return [].concat(_toConsumableArray(acc), [_extends({ isAvailable: true }, segment)]);
        }

        return acc;
      }, []);

      return _react2.default.createElement(
        'div',
        { className: _CreateRoute2.default.main },
        _react2.default.createElement(_LocationMarkerGroup2.default, {
          locations: locations,
          segments: segments,
          selectedSegments: selectedSegments,
          routeParams: params
        }),
        _react2.default.createElement(_SegmentGroup2.default, {
          segments: availableOrSelectedSegments.length === 0 ? segments : availableOrSelectedSegments,
          lastSelectedSegment: (0, _lodash.last)(selectedSegments),
          disableInteraction: isFlowFinished
        })
      );
    }
  }]);

  return CreateRouteMap;
}(_react.Component);

CreateRouteMap.propTypes = {
  data: (0, _propTypes.shape)({
    loading: _propTypes.bool.isRequired,
    locations: (0, _propTypes.arrayOf)(_locationShape2.default),
    segments: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
      id: _propTypes.string,
      path: (0, _propTypes.arrayOf)(_coord2.default),
      from: _locationShape2.default,
      to: _locationShape2.default
    }))
  }).isRequired,
  selectedSegments: (0, _propTypes.arrayOf)(_propTypes.string).isRequired,
  params: (0, _propTypes.shape)({}),
  createdRouteId: _propTypes.string
};

var mapStateToProps = function mapStateToProps(_ref) {
  var map = _ref.map,
      routeCreation = _ref.routeCreation;
  return {
    viewMode: map.viewMode,
    selectedSegments: routeCreation.selectedSegments,
    createdRouteId: routeCreation.createdRouteId
  };
};

var ConnectedCreateRouteMapWithData = (0, _reactApollo.compose)((0, _reactRedux.connect)(mapStateToProps, _extends({}, _map.operations, _routeCreation.operations)), (0, _reactApollo.graphql)(CreateRouteMapQuery, {}))(CreateRouteMap);

var _default = ConnectedCreateRouteMapWithData;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(CreateRouteMapQuery, 'CreateRouteMapQuery', '/code/src/components/Map/CreateRoute/index.js');

  __REACT_HOT_LOADER__.register(CreateRouteMap, 'CreateRouteMap', '/code/src/components/Map/CreateRoute/index.js');

  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/code/src/components/Map/CreateRoute/index.js');

  __REACT_HOT_LOADER__.register(ConnectedCreateRouteMapWithData, 'ConnectedCreateRouteMapWithData', '/code/src/components/Map/CreateRoute/index.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/code/src/components/Map/CreateRoute/index.js');
}();

;

/***/ }),

/***/ "Y5R4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"main":"SpeedDisplay-main--1ev16","status-ok":"SpeedDisplay-status-ok--3AhmP","status-warning":"SpeedDisplay-status-warning--21dgL","status-problem":"SpeedDisplay-status-problem--dY0EE","status-disconnected":"SpeedDisplay-status-disconnected--3NB4c","unit":"SpeedDisplay-unit--3iDjD","trend":"SpeedDisplay-trend---e9dT","trend-down":"SpeedDisplay-trend-down--ae3LZ"};

/***/ }),

/***/ "YByT":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reducers = __webpack_require__("yqCZ");

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_reducers).default;
  }
});

var _types = __webpack_require__("+1+X");

Object.defineProperty(exports, 'types', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_types).default;
  }
});

var _selectors = __webpack_require__("FQ83");

Object.defineProperty(exports, 'selectors', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_selectors).default;
  }
});

var _operations = __webpack_require__("eM2G");

Object.defineProperty(exports, 'operations', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_operations).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }
}();

;

/***/ }),

/***/ "YCC+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"main":"loading-indicator-main--3Ou5x","text":"loading-indicator-text--235Xz"};

/***/ }),

/***/ "YI/7":
/***/ (function(module, exports) {

module.exports = "/location-inactive-warning-007df52e38c3478e7fc83445fe0d6bff.svg";

/***/ }),

/***/ "YkDd":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Navigation;

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__("CIox");

var _bluecyberIconInline = __webpack_require__("dKEg");

var _bluecyberIconInline2 = _interopRequireDefault(_bluecyberIconInline);

var _bluecyberWordmarkInline = __webpack_require__("/De5");

var _bluecyberWordmarkInline2 = _interopRequireDefault(_bluecyberWordmarkInline);

var _activeLinkInline = __webpack_require__("TTVP");

var _activeLinkInline2 = _interopRequireDefault(_activeLinkInline);

var _navigation = __webpack_require__("3kDo");

var _navigation2 = _interopRequireDefault(_navigation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Navigation() {
  return _react2.default.createElement(
    'nav',
    { className: _navigation2.default.main },
    _react2.default.createElement(
      'span',
      { className: _navigation2.default.logo },
      _react2.default.createElement(_bluecyberIconInline2.default, { className: _navigation2.default.icon }),
      _react2.default.createElement(_bluecyberWordmarkInline2.default, { className: _navigation2.default.wordmark })
    ),
    _react2.default.createElement(
      'ul',
      { className: _navigation2.default.list },
      _react2.default.createElement(
        'li',
        { className: _navigation2.default.item },
        _react2.default.createElement(
          _reactRouter.Link,
          {
            to: '/',
            className: _navigation2.default.link,
            activeClassName: _navigation2.default.activeLink,
            onlyActiveOnIndex: true
          },
          _react2.default.createElement(_activeLinkInline2.default, { className: _navigation2.default.corner }),
          'Dashboard',
          _react2.default.createElement(_activeLinkInline2.default, { className: _navigation2.default.corner })
        )
      ),
      _react2.default.createElement(
        'li',
        { className: _navigation2.default.item },
        _react2.default.createElement(
          _reactRouter.Link,
          { to: '/map/live', className: _navigation2.default.link, activeClassName: _navigation2.default.activeLink },
          _react2.default.createElement(_activeLinkInline2.default, { className: _navigation2.default.corner }),
          'Live Map',
          _react2.default.createElement(_activeLinkInline2.default, { className: _navigation2.default.corner })
        )
      )
    )
  );
}
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(Navigation, 'Navigation', '/code/src/components/Navigation/index.js');
}();

;

/***/ }),

/***/ "Yu6W":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.SegmentGroup = SegmentGroup;

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _reactRedux = __webpack_require__("RH2O");

var _locationShape = __webpack_require__("1itO");

var _locationShape2 = _interopRequireDefault(_locationShape);

var _coord = __webpack_require__("w0mN");

var _coord2 = _interopRequireDefault(_coord);

var _map = __webpack_require__("YByT");

var _segmentCreation = __webpack_require__("ZaDe");

var _ExistingSegment = __webpack_require__("FerD");

var _ExistingSegment2 = _interopRequireDefault(_ExistingSegment);

var _PathSuggestion = __webpack_require__("laZn");

var _PathSuggestion2 = _interopRequireDefault(_PathSuggestion);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var noop = function noop(_) {
  return null;
};

function SegmentGroup(_ref) {
  var segments = _ref.segments,
      enterEntity = _ref.enterEntity,
      leaveEntity = _ref.leaveEntity,
      currentHover = _ref.currentHover,
      showPathSuggestions = _ref.showPathSuggestions,
      pathSuggestions = _ref.pathSuggestions,
      selectedPathSuggestion = _ref.selectedPathSuggestion,
      selectPathSuggestion = _ref.selectPathSuggestion,
      disableInteraction = _ref.disableInteraction;

  // eslint-disable-next-line global-require
  var SortingFeatureGroup = __webpack_require__("x6bV").default;
  // eslint-disable-next-line global-require
  var PriorityFeatureGroup = __webpack_require__("c9LL").default;
  var hoveredId = currentHover && currentHover.id;

  // eslint-disable-next-line one-var
  var selectedItem = void 0,
      unselectedItems = void 0,
      showUnselected = void 0;

  if (showPathSuggestions) {
    selectedItem = pathSuggestions.find(function (_ref2) {
      var id = _ref2.id;
      return id === selectedPathSuggestion.id;
    });
    unselectedItems = pathSuggestions.filter(function (_ref3) {
      var id = _ref3.id;
      return id !== selectedPathSuggestion.id;
    });
    showUnselected = !disableInteraction && unselectedItems.length > 0;
  }

  return _react2.default.createElement(
    SortingFeatureGroup,
    null,
    showPathSuggestions && _react2.default.createElement(
      PriorityFeatureGroup,
      { priority: 20 },
      _react2.default.createElement(_PathSuggestion2.default, _extends({
        key: selectedItem.id + '-isSelected}'
      }, selectedItem, {
        isSelected: true,
        onSelect: disableInteraction ? noop : function () {
          selectPathSuggestion(selectedItem.id);
        }
      }))
    ),
    showUnselected && _react2.default.createElement(
      PriorityFeatureGroup,
      { priority: 15 },
      _react2.default.createElement(
        'div',
        null,
        unselectedItems.map(function (suggestion) {
          return _react2.default.createElement(_PathSuggestion2.default, _extends({
            key: '' + suggestion.id
          }, suggestion, {
            isSelected: false,
            onSelect: disableInteraction ? noop : function () {
              selectPathSuggestion(suggestion.id);
            }
          }));
        })
      )
    ),
    Boolean(segments.length) && segments.map(function (segment) {
      var segmentId = segment.id;

      var isActive = segmentId === hoveredId;

      return _react2.default.createElement(_ExistingSegment2.default, {
        key: 'segment-' + segmentId + (isActive && '-active'),
        priority: isActive ? 30 : 10,
        segment: segment,
        isActive: isActive,
        onEnter: function onEnter() {
          return enterEntity({
            id: segmentId,
            type: 'segment'
          });
        },
        onLeave: function onLeave() {
          return leaveEntity({
            id: segmentId,
            type: 'segment'
          });
        }
      });
    })
  );
}

SegmentGroup.propTypes = {
  segments: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    id: _propTypes.string,
    path: (0, _propTypes.arrayOf)(_coord2.default),
    from: _locationShape2.default,
    to: _locationShape2.default
  })).isRequired,
  enterEntity: _propTypes.func.isRequired,
  leaveEntity: _propTypes.func.isRequired,
  currentHover: (0, _propTypes.shape)({
    id: _propTypes.string.isRequired
  }),
  showPathSuggestions: _propTypes.bool.isRequired,
  pathSuggestions: (0, _propTypes.oneOfType)([_propTypes.bool, (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    id: _propTypes.string.isRequired,
    path: (0, _propTypes.arrayOf)(_coord2.default).isRequired
  }))]),
  selectedPathSuggestion: (0, _propTypes.oneOfType)([_propTypes.bool, (0, _propTypes.shape)({
    id: _propTypes.string.isRequired
  })]),
  selectPathSuggestion: _propTypes.func,
  disableInteraction: _propTypes.bool.isRequired
};

var mapStateToProps = function mapStateToProps(_ref4) {
  var map = _ref4.map;
  return {
    currentHover: map.currentHover
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps, _extends({}, _map.operations, _segmentCreation.operations))(SegmentGroup);

exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(noop, 'noop', '/code/src/components/Map/CreateSegment/SegmentGroup/index.js');

  __REACT_HOT_LOADER__.register(SegmentGroup, 'SegmentGroup', '/code/src/components/Map/CreateSegment/SegmentGroup/index.js');

  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/code/src/components/Map/CreateSegment/SegmentGroup/index.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/code/src/components/Map/CreateSegment/SegmentGroup/index.js');
}();

;

/***/ }),

/***/ "Z8ef":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"main":"icon-layout-main--3xLKN","alignMiddle":"icon-layout-alignMiddle--1ExR0"};

/***/ }),

/***/ "ZUXP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ZaDe":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reducers = __webpack_require__("OSwL");

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_reducers).default;
  }
});

var _types = __webpack_require__("5QWJ");

Object.defineProperty(exports, 'types', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_types).default;
  }
});

var _selectors = __webpack_require__("yVhY");

Object.defineProperty(exports, 'selectors', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_selectors).default;
  }
});

var _operations = __webpack_require__("UVvc");

Object.defineProperty(exports, 'operations', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_operations).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }
}();

;

/***/ }),

/***/ "Zkig":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"main":"LocationsHeader-main--54SC5","groupedItems":"LocationsHeader-groupedItems--8z7RI","label":"LocationsHeader-label--p8uGf","labelContent":"LocationsHeader-labelContent--2uM_1","item":"LocationsHeader-item--bo2rb","icon":"LocationsHeader-icon--uPcOp","hint":"LocationsHeader-hint--1oWuk","noLocation":"LocationsHeader-noLocation--11mRu"};

/***/ }),

/***/ "aNTX":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = LocationsHeader;

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__("HW6M");

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = __webpack_require__("KSGD");

var _WithSubtitle = __webpack_require__("j/Bm");

var _WithSubtitle2 = _interopRequireDefault(_WithSubtitle);

var _InlineButton = __webpack_require__("tcGo");

var _InlineButton2 = _interopRequireDefault(_InlineButton);

var _segmentLargeInline = __webpack_require__("Pr6M");

var _segmentLargeInline2 = _interopRequireDefault(_segmentLargeInline);

var _closeInline = __webpack_require__("2bM4");

var _closeInline2 = _interopRequireDefault(_closeInline);

var _LocationsHeader = __webpack_require__("Zkig");

var _LocationsHeader2 = _interopRequireDefault(_LocationsHeader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function LocationsHeader(_ref) {
  var fromLocation = _ref.fromLocation,
      toLocation = _ref.toLocation,
      className = _ref.className,
      removeLocation = _ref.removeLocation,
      isFinished = _ref.isFinished;

  var noLocation = !toLocation;

  return _react2.default.createElement(
    'div',
    { className: (0, _classnames2.default)(_LocationsHeader2.default.main, className) },
    _react2.default.createElement(_segmentLargeInline2.default, { className: _LocationsHeader2.default.icon }),
    _react2.default.createElement(
      'div',
      { className: _LocationsHeader2.default.groupedItems },
      fromLocation && _react2.default.createElement(
        'div',
        { className: _LocationsHeader2.default.item },
        _react2.default.createElement(
          _WithSubtitle2.default,
          {
            title: 'from',
            className: _LocationsHeader2.default.label,
            contentClassName: _LocationsHeader2.default.labelContent
          },
          fromLocation.name
        ),
        !isFinished && _react2.default.createElement(
          _InlineButton2.default,
          { hasContextCreationPanel: true, onClick: function onClick() {
              return removeLocation(fromLocation.id);
            } },
          _react2.default.createElement(_closeInline2.default, null)
        )
      ),
      fromLocation && _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)(_LocationsHeader2.default.item, _defineProperty({}, _LocationsHeader2.default.noLocation, noLocation)) },
        _react2.default.createElement(
          _WithSubtitle2.default,
          {
            title: 'to',
            className: _LocationsHeader2.default.label,
            contentClassName: _LocationsHeader2.default.labelContent
          },
          !toLocation && _react2.default.createElement(
            'span',
            { className: _LocationsHeader2.default.hint },
            '\u2026'
          ),
          toLocation && toLocation.name
        ),
        !isFinished && toLocation && _react2.default.createElement(
          _InlineButton2.default,
          { hasContextCreationPanel: true, onClick: function onClick() {
              return removeLocation(toLocation.id);
            } },
          _react2.default.createElement(_closeInline2.default, null)
        )
      )
    )
  );
}

LocationsHeader.propTypes = {
  fromLocation: (0, _propTypes.shape)({ name: _propTypes.string, id: _propTypes.string }),
  toLocation: (0, _propTypes.shape)({ name: _propTypes.string, id: _propTypes.string }),
  removeLocation: _propTypes.func.isRequired,
  className: _propTypes.string,
  isFinished: _propTypes.bool.isRequired
};
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(LocationsHeader, 'LocationsHeader', '/code/src/components/MapPanel/CreateSegment/LocationsHeader/index.js');
}();

;

/***/ }),

/***/ "ajpx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = filterSegmentsByFrom;

var _lodash = __webpack_require__("M4fF");

function filterSegmentsByFrom(segments, selectedSegmentIds) {
  if (selectedSegmentIds.length === 0) return segments;

  var lastSelectedSegment = segments.find(function (segment) {
    return segment.id === (0, _lodash.last)(selectedSegmentIds);
  });

  return segments.filter(function (segment) {
    return segment.from.id === lastSelectedSegment.to.id;
  });
}
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(filterSegmentsByFrom, 'filterSegmentsByFrom', '/code/src/helpers/filterSegmentsByFrom.js');
}();

;

/***/ }),

/***/ "an/p":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"buttonBase":"RoutesListItem-buttonBase--1GXpD","shadowBottom":"RoutesListItem-shadowBottom--3mQRl","shadowBottomHover":"RoutesListItem-shadowBottomHover--SqfC7","shadowListItem":"RoutesListItem-shadowListItem--NkXag","shadowRight":"RoutesListItem-shadowRight--2NtIK","shadowLeft":"RoutesListItem-shadowLeft--x5oM8","shadowAround":"RoutesListItem-shadowAround--mGrJJ","shadowAroundHover":"RoutesListItem-shadowAroundHover--2_b6l","shadowButton":"RoutesListItem-shadowButton--mHLu3","shadowButtonHover":"RoutesListItem-shadowButtonHover--3JZAH","main":"RoutesListItem-main--hl-3R","liveDisplay":"RoutesListItem-liveDisplay--pej2P","segment":"RoutesListItem-segment--3uE2P","numberDisplay":"RoutesListItem-numberDisplay--26CVs","trendLine":"RoutesListItem-trendLine--34Tmp","route":"RoutesListItem-route--2yu83","statusText":"RoutesListItem-statusText--e5ZyG","trendIcon":"RoutesListItem-trendIcon--16lG0"};

/***/ }),

/***/ "ay0U":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"outlineBase":"SegmentPath-outlineBase--1gv2l","isActive":"SegmentPath-isActive--1SopR","selected":"SegmentPath-selected--JXlhq","underlineBase":"SegmentPath-underlineBase--3j7zM","lineBase":"SegmentPath-lineBase--4x14M","marching_ants":"SegmentPath-marching_ants--1xgfk","outline":"SegmentPath-outline--3glE4 SegmentPath-outlineBase--1gv2l","underline":"SegmentPath-underline--1p_RO SegmentPath-underlineBase--3j7zM","isDisconnected":"SegmentPath-isDisconnected--1Pegu","line":"SegmentPath-line--38vdE SegmentPath-lineBase--4x14M","statusSelected":"SegmentPath-statusSelected--36dUq"};

/***/ }),

/***/ "baLt":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"buttonBase":"LocationHeader-buttonBase--2Wsiy","shadowBottom":"LocationHeader-shadowBottom--ablNm","shadowBottomHover":"LocationHeader-shadowBottomHover--1UX1i","shadowListItem":"LocationHeader-shadowListItem--1l-wc","shadowRight":"LocationHeader-shadowRight--1m1UI","shadowLeft":"LocationHeader-shadowLeft--2S-LV","shadowAround":"LocationHeader-shadowAround--2VLmy","shadowAroundHover":"LocationHeader-shadowAroundHover--1I5Ok","shadowButton":"LocationHeader-shadowButton--2l70p","shadowButtonHover":"LocationHeader-shadowButtonHover--xJtkK","main":"LocationHeader-main--n4qhD LocationHeader-shadowAround--2VLmy","label":"LocationHeader-label--vBFy1","content":"LocationHeader-content--lN4dT","isLoading":"LocationHeader-isLoading--2dCDv"};

/***/ }),

/***/ "blEK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"outlineBase":"PathSuggestions-outlineBase--1xUwG","isActive":"PathSuggestions-isActive--1x5QK","selected":"PathSuggestions-selected--3SVcm","underlineBase":"PathSuggestions-underlineBase--22_zX","lineBase":"PathSuggestions-lineBase--1iEr8","marching_ants":"PathSuggestions-marching_ants--hlHkh","outline":"PathSuggestions-outline--1yU23 PathSuggestions-outlineBase--1xUwG","underline":"PathSuggestions-underline--16sWV PathSuggestions-underlineBase--22_zX","line":"PathSuggestions-line--IcXma PathSuggestions-lineBase--1iEr8"};

/***/ }),

/***/ "c9LL":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _reactLeaflet = __webpack_require__("Zz/N");

var _leaflet = __webpack_require__("nrd6");

var _lodash = __webpack_require__("M4fF");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var OPTIONS = ['priority'];

/*
 * @TODO There are several things to sort out here still to make sure we know
 * what's going on.
 *
 * The onLeafletUpdate callback is used to get a hold of the leafletElement from
 * a parent. In a normal react world this would be done via ref, but these don't
 * work for leaflet apparently or it is broken in PriorityFeatureGroup. The ref
 * function of the PriorityFeatureGroup is called serveral times, but often also
 * with null. Also they seem to be called all the time for all children on hover
 * and other interactive states.
 *
 * The onLeafletUpdate callback is used to get the lat/lng bounds of the segments
 * it contains, once on creation time. Since these properties don't change later
 * the callback is not called in updateLeafletElement, for performance reasons,
 * but it could be if feasable.
 *
 * Anyway we have to make sure we understand how React and Leaflet play together
 * in this regard, and document why each of the functions below do what they do.
 */

var LeafletPriorityFeatureGroup = _leaflet.FeatureGroup.extend({
  initialize: function initialize(layers) {
    // eslint-disable-next-line no-underscore-dangle
    this._layers = {};
    this.options = (0, _lodash.pick)(layers, OPTIONS);

    if (layers) {
      // eslint-disable-next-line no-plusplus
      for (var i = 0; i < layers.length; i++) {
        this.addLayer(layers[i]);
      }
    }
  }
});

var PriorityFeatureGroup = function (_FeatureGroup) {
  _inherits(PriorityFeatureGroup, _FeatureGroup);

  function PriorityFeatureGroup() {
    _classCallCheck(this, PriorityFeatureGroup);

    return _possibleConstructorReturn(this, (PriorityFeatureGroup.__proto__ || Object.getPrototypeOf(PriorityFeatureGroup)).apply(this, arguments));
  }

  _createClass(PriorityFeatureGroup, [{
    key: 'createLeafletElement',
    value: function createLeafletElement(props) {
      var leafletElement = new LeafletPriorityFeatureGroup(this.getOptions(props));

      if (typeof props.onLeafletUpdate === 'function') {
        props.onLeafletUpdate(leafletElement);
      }

      return leafletElement;
    }
  }, {
    key: 'updateLeafletElement',
    value: function updateLeafletElement(fromProps, toProps) {
      var layer = this.leafletElement;

      if (layer && layer.options) {
        layer.options = _extends({}, layer.options, (0, _lodash.pick)(toProps, OPTIONS));
      }
    }
  }]);

  return PriorityFeatureGroup;
}(_reactLeaflet.FeatureGroup);

var _default = PriorityFeatureGroup;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(OPTIONS, 'OPTIONS', '/code/src/components/Map/MapComponents/PriorityFeatureGroup/index.js');

  __REACT_HOT_LOADER__.register(LeafletPriorityFeatureGroup, 'LeafletPriorityFeatureGroup', '/code/src/components/Map/MapComponents/PriorityFeatureGroup/index.js');

  __REACT_HOT_LOADER__.register(PriorityFeatureGroup, 'PriorityFeatureGroup', '/code/src/components/Map/MapComponents/PriorityFeatureGroup/index.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/code/src/components/Map/MapComponents/PriorityFeatureGroup/index.js');
}();

;

/***/ }),

/***/ "cH2h":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Trendline;

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _reactTrend = __webpack_require__("vMPV");

var _reactTrend2 = _interopRequireDefault(_reactTrend);

var _propTypes = __webpack_require__("KSGD");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Trendline(_ref) {
  var trendData = _ref.trendData,
      width = _ref.width,
      height = _ref.height;

  return _react2.default.createElement(_reactTrend2.default, {
    autoDraw: true,
    autoDrawDuration: 600,
    autoDrawEasing: 'ease-out',
    data: trendData,
    stroke: '#00f',
    strokeWidth: 1.5,
    width: width,
    height: height,
    padding: 2,
    strokeLinecap: 'square'
  });
}

Trendline.propTypes = {
  trendData: (0, _propTypes.arrayOf)(_propTypes.number),
  width: _propTypes.number.isRequired,
  height: _propTypes.number.isRequired
};
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(Trendline, 'Trendline', '/code/src/components/Trendline/index.js');
}();

;

/***/ }),

/***/ "cI+y":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"buttonBase":"CreateRoute-buttonBase--24KKs","shadowBottom":"CreateRoute-shadowBottom--3vL_b","shadowBottomHover":"CreateRoute-shadowBottomHover--3Rt0k","shadowListItem":"CreateRoute-shadowListItem--1ndAY","shadowRight":"CreateRoute-shadowRight--2X7aV","shadowLeft":"CreateRoute-shadowLeft--2Bpha","shadowAround":"CreateRoute-shadowAround--N5pWT","shadowAroundHover":"CreateRoute-shadowAroundHover--2e1Qv","shadowButton":"CreateRoute-shadowButton--378A7","shadowButtonHover":"CreateRoute-shadowButtonHover--2Gpzy","main":"CreateRoute-main--13Hmr","top":"CreateRoute-top--3ubCc CreateRoute-shadowBottom--3vL_b","content":"CreateRoute-content--24Tg8","text":"CreateRoute-text--38dyP","footer":"CreateRoute-footer--1Ynkk","subtitle":"CreateRoute-subtitle--3CKlm"};

/***/ }),

/***/ "cKPi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"buttonBase":"SegmentsListItem-buttonBase--2MOP5","shadowBottom":"SegmentsListItem-shadowBottom--1fbE6","shadowBottomHover":"SegmentsListItem-shadowBottomHover--1t5VE","shadowListItem":"SegmentsListItem-shadowListItem--2lzcE","shadowRight":"SegmentsListItem-shadowRight--31WV1","shadowLeft":"SegmentsListItem-shadowLeft--3USp5","shadowAround":"SegmentsListItem-shadowAround--2h1RC","shadowAroundHover":"SegmentsListItem-shadowAroundHover--1oF-D","shadowButton":"SegmentsListItem-shadowButton--AznNC","shadowButtonHover":"SegmentsListItem-shadowButtonHover--2zs6m","main":"SegmentsListItem-main--o66ox","liveDisplay":"SegmentsListItem-liveDisplay--DhN9x","segment":"SegmentsListItem-segment--1gkBt","numberDisplay":"SegmentsListItem-numberDisplay--2nmWg","trendLine":"SegmentsListItem-trendLine--2_agJ","statusText":"SegmentsListItem-statusText--SIK6r","trendIcon":"SegmentsListItem-trendIcon--2FsX3"};

/***/ }),

/***/ "cf0Y":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"buttonBase":"Sorting-buttonBase--3ttrt","shadowBottom":"Sorting-shadowBottom--CZ3po","shadowBottomHover":"Sorting-shadowBottomHover--2Ubeq","shadowListItem":"Sorting-shadowListItem--2tMm-","shadowRight":"Sorting-shadowRight--3i0SP","shadowLeft":"Sorting-shadowLeft--19MXk","shadowAround":"Sorting-shadowAround--Va6To","shadowAroundHover":"Sorting-shadowAroundHover--mmTOf","shadowButton":"Sorting-shadowButton--b2Oc4","shadowButtonHover":"Sorting-shadowButtonHover--Hd0LK","header":"Sorting-header--3717t","label":"Sorting-label--25cdg","buttonList":"Sorting-buttonList--1EbUO","buttonListItem":"Sorting-buttonListItem--37mdM","button":"Sorting-button--2f8rL Sorting-buttonBase--3ttrt Sorting-shadowButton--b2Oc4 Sorting-shadowButtonHover--Hd0LK","isActive":"Sorting-isActive--1eL_8","sortOrderIndicator":"Sorting-sortOrderIndicator--2lJHU","flip":"Sorting-flip--2T_FY","sortIcon":"Sorting-sortIcon--3oEVv"};

/***/ }),

/***/ "ciM9":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRouterRedux = __webpack_require__("jZgO");

var _actions = __webpack_require__("Azcd");

var actions = _interopRequireWildcard(_actions);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

/*
  Select a segment on the map.
*/
var selectSegment = function selectSegment(id) {
  return function (dispatch) {
    // We could check here if the segments' from and to points match, so we're sure we're creating a route
    // However, I'm not sure if I'm meant to pass a whole segment object here.
    dispatch(actions.selectSegment(id));
  };
};

var deselectSegment = function deselectSegment(id) {
  return function (dispatch, getState) {
    var _getState = getState(),
        selectedSegments = _getState.routeCreation.selectedSegments;

    if (!selectedSegments || !selectedSegments.includes(id)) {
      throw new Error('Can not deselect id ' + id + ' because the current selection is ' + selectedSegments);
    }

    dispatch(actions.deselectSegment(id));
  };
};

var finishCreateRoute = function finishCreateRoute() {
  return function (dispatch) {
    dispatch(actions.clearCreateRoute());
    dispatch((0, _reactRouterRedux.push)('/map/live'));
  };
};

var _default = {
  selectSegment: selectSegment,
  deselectSegment: deselectSegment,
  setCreatedRouteId: actions.setCreatedRouteId,
  finishCreateRoute: finishCreateRoute,
  clearCreateRoute: actions.clearCreateRoute
};
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(selectSegment, 'selectSegment', '/code/src/state/ducks/routeCreation/operations.js');

  __REACT_HOT_LOADER__.register(deselectSegment, 'deselectSegment', '/code/src/state/ducks/routeCreation/operations.js');

  __REACT_HOT_LOADER__.register(finishCreateRoute, 'finishCreateRoute', '/code/src/state/ducks/routeCreation/operations.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/code/src/state/ducks/routeCreation/operations.js');
}();

;

/***/ }),

/***/ "d4HL":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = RouteHeader;

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _reactRouter = __webpack_require__("CIox");

var _classnames = __webpack_require__("HW6M");

var _classnames2 = _interopRequireDefault(_classnames);

var _panelRouteInline = __webpack_require__("+vyF");

var _panelRouteInline2 = _interopRequireDefault(_panelRouteInline);

var _panelRouteBrokenInline = __webpack_require__("eF7P");

var _panelRouteBrokenInline2 = _interopRequireDefault(_panelRouteBrokenInline);

var _panelSwitchInline = __webpack_require__("7jAy");

var _panelSwitchInline2 = _interopRequireDefault(_panelSwitchInline);

var _RouteHeader = __webpack_require__("sHKi");

var _RouteHeader2 = _interopRequireDefault(_RouteHeader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function RouteHeader(_ref) {
  var fromName = _ref.fromName,
      toName = _ref.toName,
      status = _ref.status,
      oppositeRouteId = _ref.oppositeRouteId,
      isLoading = _ref.isLoading;

  return _react2.default.createElement(
    'div',
    {
      className: (0, _classnames2.default)(_RouteHeader2.default.main, _defineProperty({}, _RouteHeader2.default.isLoading, isLoading))
    },
    _react2.default.createElement(
      'header',
      { className: _RouteHeader2.default.header },
      _react2.default.createElement(
        'h1',
        { className: _RouteHeader2.default.title },
        'Route'
      )
    ),
    _react2.default.createElement(
      'div',
      { className: _RouteHeader2.default.content },
      _react2.default.createElement(
        'div',
        { className: _RouteHeader2.default.icon },
        status !== 'disconnected' ? _react2.default.createElement(_panelRouteInline2.default, { height: 72 }) : _react2.default.createElement(_panelRouteBrokenInline2.default, { height: 72 })
      ),
      _react2.default.createElement(
        'h1',
        { className: _RouteHeader2.default.text },
        _react2.default.createElement(
          'div',
          { className: _RouteHeader2.default.textGroup },
          _react2.default.createElement(
            'div',
            { className: _RouteHeader2.default.label },
            'from'
          ),
          _react2.default.createElement(
            'div',
            { className: _RouteHeader2.default.name },
            fromName
          )
        ),
        _react2.default.createElement(
          'div',
          { className: _RouteHeader2.default.textGroup },
          _react2.default.createElement(
            'div',
            { className: _RouteHeader2.default.label },
            'to'
          ),
          _react2.default.createElement(
            'div',
            { className: _RouteHeader2.default.name },
            toName
          )
        )
      ),
      oppositeRouteId && _react2.default.createElement(
        'div',
        { className: _RouteHeader2.default.switchButtonWrapper },
        _react2.default.createElement(
          _reactRouter.Link,
          { to: '/map/live/routes/' + oppositeRouteId, className: _RouteHeader2.default.switchButton },
          _react2.default.createElement(_panelSwitchInline2.default, { className: _RouteHeader2.default.switchButtonIcon, style: { width: '1.5em' } })
        )
      )
    )
  );
}

RouteHeader.propTypes = {
  fromName: _propTypes.string.isRequired,
  toName: _propTypes.string.isRequired,
  status: _propTypes.string.isRequired,
  oppositeRouteId: _propTypes.string,
  isLoading: _propTypes.bool
};
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(RouteHeader, 'RouteHeader', '/code/src/components/DataPanel/Details/RouteHeader/index.js');
}();

;

/***/ }),

/***/ "dKEg":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SVG = function (_React$Component) {
  _inherits(SVG, _React$Component);

  function SVG() {
    _classCallCheck(this, SVG);

    return _possibleConstructorReturn(this, (SVG.__proto__ || Object.getPrototypeOf(SVG)).apply(this, arguments));
  }

  _createClass(SVG, [{
    key: "render",
    value: function render() {
      return _react2.default.createElement(
        "svg",
        _extends({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 29 42.1", fill: "currentColor" }, this.props),
        _react2.default.createElement("path", { d: "M.4 0C.2 0 0 .2 0 .4v15.3c0 .2.1.6.3.7l4.1 4.1c.2.2.3.1.3-.1V.4c0-.2-.2-.4-.4-.4H.4zM29 18.4c0-1.2-1-2.2-2.2-2.2H10.2c-.2 0-.6.1-.7.3l-4.1 4.1c-.2.2-.1.3.1.3h18.8v15.8c0 .2.1.3.3.1l4.1-4.1c.2-.2.3-.5.3-.7V18.4zm-5.5 19H4.7V21.6c0-.2-.1-.3-.3-.1L.3 25.6c-.2.2-.3.5-.3.7v13.6c0 1.2 1 2.2 2.2 2.2h16.6c.2 0 .6-.1.7-.3l4.1-4.1c.2-.1.1-.3-.1-.3z" })
      );
    }
  }]);

  return SVG;
}(_react2.default.Component);

var _default = SVG;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(SVG, "SVG", "/code/src/icons/bluecyber-icon.inline.svg");

  __REACT_HOT_LOADER__.register(_default, "default", "/code/src/icons/bluecyber-icon.inline.svg");
}();

;

/***/ }),

/***/ "dYRO":
/***/ (function(module, exports) {

module.exports = "/location-problem-7a1c216ccb7a909962e0a32cc0832ae8.svg";

/***/ }),

/***/ "daf4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"isFaded":"LocationMarker-isFaded--1-qWG"};

/***/ }),

/***/ "ddva":
/***/ (function(module, exports) {

module.exports = "/location-active-warning-9d2879fdb9a5f368ee09ccdefbf953c4.svg";

/***/ }),

/***/ "dki3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"main":"route-tooltip-main--3pYIT","distance":"route-tooltip-distance--BOWh2","liveTravelTime":"route-tooltip-liveTravelTime--3D8CT","route":"route-tooltip-route--2X8sC","statusText":"route-tooltip-statusText--3Xo_F","speedNumber":"route-tooltip-speedNumber--Kb7QZ","unit":"route-tooltip-unit--3c8Sp","trendIcon":"route-tooltip-trendIcon--2h3uM","routeIcon":"route-tooltip-routeIcon--1DkVI","routeName":"route-tooltip-routeName--1bWZW"};

/***/ }),

/***/ "duV/":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SVG = function (_React$Component) {
  _inherits(SVG, _React$Component);

  function SVG() {
    _classCallCheck(this, SVG);

    return _possibleConstructorReturn(this, (SVG.__proto__ || Object.getPrototypeOf(SVG)).apply(this, arguments));
  }

  _createClass(SVG, [{
    key: "render",
    value: function render() {
      return _react2.default.createElement(
        "svg",
        _extends({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 8 40" }, this.props),
        _react2.default.createElement(
          "title",
          null,
          "segment (small)"
        ),
        _react2.default.createElement("path", { className: "st0", d: "M1.9 0L0 1.9v6.3l4 3.7 4-3.7V0H1.9zm0 28L0 29.9v6.3l4 3.7 4-3.7V28H1.9zM3 15h2v10H3z", fill: "currentColor" })
      );
    }
  }]);

  return SVG;
}(_react2.default.Component);

var _default = SVG;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(SVG, "SVG", "/code/src/icons/segment-small.inline.svg");

  __REACT_HOT_LOADER__.register(_default, "default", "/code/src/icons/segment-small.inline.svg");
}();

;

/***/ }),

/***/ "eF7P":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SVG = function (_React$Component) {
  _inherits(SVG, _React$Component);

  function SVG() {
    _classCallCheck(this, SVG);

    return _possibleConstructorReturn(this, (SVG.__proto__ || Object.getPrototypeOf(SVG)).apply(this, arguments));
  }

  _createClass(SVG, [{
    key: "render",
    value: function render() {
      return _react2.default.createElement(
        "svg",
        _extends({ xmlns: "http://www.w3.org/2000/svg", fill: "currentColor", viewBox: "0 0 14 91" }, this.props),
        _react2.default.createElement("path", { d: "M3.2 0L0 3.3v11.3l7 6.7 7-6.7V0zM4.8 39.4L3 41.3v6.4l4 3.8 4-3.8v-8.3H4.8zM3.2 69.1L0 72.4v11.3l7 6.7 7-6.7V69.1zM6 25.4h2v4.1H6zM6 31.3h2v4.1H6zM6 55.4h2v4.1H6zM6 61.3h2v4.1H6z" })
      );
    }
  }]);

  return SVG;
}(_react2.default.Component);

var _default = SVG;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(SVG, "SVG", "/code/src/icons/panel-route-broken.inline.svg");

  __REACT_HOT_LOADER__.register(_default, "default", "/code/src/icons/panel-route-broken.inline.svg");
}();

;

/***/ }),

/***/ "eM2G":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRouterRedux = __webpack_require__("jZgO");

var _actions = __webpack_require__("xHQJ");

var actions = _interopRequireWildcard(_actions);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

/**
 * Some operations are directly mapped to actions, but this would change if we
 * need more complex behavior.
 */

var selectEntity = function selectEntity(_ref) {
  var id = _ref.id,
      type = _ref.type;
  return function (dispatch) {
    /**
     * Doing the routing via an action like this instead of a direct link
     * - prevents you from hardcoding url logic on a component level
     * - adds the ability to dispatch and listen for other events related to this action
     */
    switch (type) {
      case 'route':
        dispatch((0, _reactRouterRedux.push)('/map/live/routes/' + id));
        break;
      case 'location':
        dispatch((0, _reactRouterRedux.push)('/map/live/locations/' + id));
        break;
      case 'segment':
        dispatch((0, _reactRouterRedux.push)('/map/live/segments/' + id));
        break;
      default:
        throw new TypeError('Invalid entity type ' + type);
    }
  };
};

var unsetHoverState = function unsetHoverState() {
  return function (dispatch, getState) {
    var _getState = getState(),
        currentHover = _getState.map.currentHover;

    /**
      An operation to kill all hover state. This is required because the leaflet
      event handlers are not robust enough. The map triggers this on mouse-over
      for example.
       This unset action only needs to be fired if there is actually an element
      in the current hover state, so we make the dispatch conditional here
      to minize action noise and unnecessary re-rendering.
    */


    if (!currentHover) {
      return;
    }

    dispatch(actions.unsetHoverState());
  };
};

var toggleMapPanel = function toggleMapPanel() {
  return function (dispatch, getState) {
    var _getState2 = getState(),
        isMapPanelOpen = _getState2.map.isMapPanelOpen;

    if (isMapPanelOpen) {
      dispatch(actions.closeMapPanel());
    } else {
      dispatch(actions.openMapPanel());
    }
  };
};

/**
 * Some of the actions that don't need any extra logic, are mapped directly
 * to the exported operations.
 */
var _default = {
  enterEntity: actions.enterEntity,
  leaveEntity: actions.leaveEntity,
  selectEntity: selectEntity,
  unsetHoverState: unsetHoverState,
  setBounds: actions.setBounds,
  setAllFeatureBounds: actions.setAllFeatureBounds,
  setCenter: actions.setCenter,
  setViewMode: actions.setViewMode,
  toggleMapPanel: toggleMapPanel
};
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(selectEntity, 'selectEntity', '/code/src/state/ducks/map/operations.js');

  __REACT_HOT_LOADER__.register(unsetHoverState, 'unsetHoverState', '/code/src/state/ducks/map/operations.js');

  __REACT_HOT_LOADER__.register(toggleMapPanel, 'toggleMapPanel', '/code/src/state/ducks/map/operations.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/code/src/state/ducks/map/operations.js');
}();

;

/***/ }),

/***/ "eq+V":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"main":"HorizontalSection-main--1zOiV","center":"HorizontalSection-center--3fcb2"};

/***/ }),

/***/ "f1z1":
/***/ (function(module, exports) {

module.exports = "/location-active-warning-9d2879fdb9a5f368ee09ccdefbf953c4.svg";

/***/ }),

/***/ "fChq":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SVG = function (_React$Component) {
  _inherits(SVG, _React$Component);

  function SVG() {
    _classCallCheck(this, SVG);

    return _possibleConstructorReturn(this, (SVG.__proto__ || Object.getPrototypeOf(SVG)).apply(this, arguments));
  }

  _createClass(SVG, [{
    key: "render",
    value: function render() {
      return _react2.default.createElement(
        "svg",
        _extends({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 7.85 9.48", fill: "currentColor" }, this.props),
        _react2.default.createElement("path", { d: "M3.93 0L0 3.93l.78.78 2.59-2.6v7.37h1.11V2.11l2.59 2.6.78-.78L3.93 0z" })
      );
    }
  }]);

  return SVG;
}(_react2.default.Component);

var _default = SVG;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(SVG, "SVG", "/code/src/icons/trend.inline.svg");

  __REACT_HOT_LOADER__.register(_default, "default", "/code/src/icons/trend.inline.svg");
}();

;

/***/ }),

/***/ "fNy8":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = BatteryIcon;

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _classnames = __webpack_require__("HW6M");

var _classnames2 = _interopRequireDefault(_classnames);

var _d3Scale = __webpack_require__("Q1TF");

var _batterySpriteInline = __webpack_require__("+EKX");

var _batterySpriteInline2 = _interopRequireDefault(_batterySpriteInline);

var _batteryIcon = __webpack_require__("mRdt");

var _batteryIcon2 = _interopRequireDefault(_batteryIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var ICON_COUNT = 7;
var ICON_WIDTH = 32;
var ICON_HEIGHT = 18;
var ICON_GRID_HEIGHT = 18;

var batteryLevels = [].concat(_toConsumableArray(Array(ICON_COUNT).keys()));

function convertVoltageToBatteryLevel(voltage) {
  /*
    The batteryVoltage has a range between ~11.5V and ~14.4V.
    The batteries shut off automatically at 11.5V to avoid wear.
    [min, avg, max]
    [11.5, 12.7, 14.4]
  */
  var batteryLevelScale = (0, _d3Scale.scaleThreshold)().domain([11.5, 11.7, 12.2, 12.7, 13.7, 14.4]).range(batteryLevels);

  return batteryLevelScale(voltage);
}

function BatteryIcon(_ref) {
  var batteryVoltage = _ref.batteryVoltage,
      className = _ref.className;

  var level = convertVoltageToBatteryLevel(batteryVoltage);
  var yOffset = (ICON_COUNT - level - 1) * ICON_GRID_HEIGHT;
  var viewBox = '0 ' + yOffset + ' ' + ICON_WIDTH + ' ' + ICON_HEIGHT;

  return _react2.default.createElement(_batterySpriteInline2.default, { viewBox: viewBox, className: (0, _classnames2.default)(_batteryIcon2.default.main, _batteryIcon2.default['level-' + level], className) });
}

BatteryIcon.propTypes = {
  className: _propTypes.string,
  batteryVoltage: _propTypes.number.isRequired
};
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ICON_COUNT, 'ICON_COUNT', '/code/src/components/BatteryIcon/index.js');

  __REACT_HOT_LOADER__.register(ICON_WIDTH, 'ICON_WIDTH', '/code/src/components/BatteryIcon/index.js');

  __REACT_HOT_LOADER__.register(ICON_HEIGHT, 'ICON_HEIGHT', '/code/src/components/BatteryIcon/index.js');

  __REACT_HOT_LOADER__.register(ICON_GRID_HEIGHT, 'ICON_GRID_HEIGHT', '/code/src/components/BatteryIcon/index.js');

  __REACT_HOT_LOADER__.register(batteryLevels, 'batteryLevels', '/code/src/components/BatteryIcon/index.js');

  __REACT_HOT_LOADER__.register(convertVoltageToBatteryLevel, 'convertVoltageToBatteryLevel', '/code/src/components/BatteryIcon/index.js');

  __REACT_HOT_LOADER__.register(BatteryIcon, 'BatteryIcon', '/code/src/components/BatteryIcon/index.js');
}();

;

/***/ }),

/***/ "fUSz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"listLabels":"ListLabels-listLabels--3IQd9"};

/***/ }),

/***/ "fX1p":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("KSGD");

var _default = (0, _propTypes.oneOf)(['ok', 'warning', 'problem', 'disconnected']);

exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_default, 'default', '/code/src/propTypes/segmentStatus.js');
}();

;

/***/ }),

/***/ "fu+b":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = LocationStatusIcon;

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _locationActiveInline = __webpack_require__("HiU3");

var _locationActiveInline2 = _interopRequireDefault(_locationActiveInline);

var _locationActiveWarningInline = __webpack_require__("h9Nw");

var _locationActiveWarningInline2 = _interopRequireDefault(_locationActiveWarningInline);

var _classnames = __webpack_require__("HW6M");

var _classnames2 = _interopRequireDefault(_classnames);

var _deviceStatus = __webpack_require__("2Ejm");

var _deviceStatus2 = _interopRequireDefault(_deviceStatus);

var _locationStatusIcon = __webpack_require__("JNc/");

var _locationStatusIcon2 = _interopRequireDefault(_locationStatusIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getIconForStatus(status, className) {
  var classes = (0, _classnames2.default)(_locationStatusIcon2.default.main, className);

  switch (status) {
    case 'ok':
      return _react2.default.createElement(_locationActiveInline2.default, { className: classes });
    case 'warning':
    case 'disconnected':
      return _react2.default.createElement(_locationActiveWarningInline2.default, { className: classes });
    default:
      return _react2.default.createElement(
        'span',
        { className: classes },
        'Invalid status ' + status
      );
  }
}

function LocationStatusIcon(_ref) {
  var status = _ref.status,
      className = _ref.className;

  return getIconForStatus(status, className);
}

LocationStatusIcon.propTypes = {
  status: _deviceStatus2.default.isRequired,
  className: _propTypes.string
};
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(getIconForStatus, 'getIconForStatus', '/code/src/components/LocationStatusIcon/index.js');

  __REACT_HOT_LOADER__.register(LocationStatusIcon, 'LocationStatusIcon', '/code/src/components/LocationStatusIcon/index.js');
}();

;

/***/ }),

/***/ "fwK8":
/***/ (function(module, exports) {

module.exports = "/location-0f9ee7d5ed4f2c2a61cb7bb50d8b60d2.svg";

/***/ }),

/***/ "g7vI":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = SpeedDisplay;

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__("HW6M");

var _classnames2 = _interopRequireDefault(_classnames);

var _lodash = __webpack_require__("M4fF");

var _propTypes = __webpack_require__("KSGD");

var _segmentStatus = __webpack_require__("fX1p");

var _segmentStatus2 = _interopRequireDefault(_segmentStatus);

var _trendInline = __webpack_require__("fChq");

var _trendInline2 = _interopRequireDefault(_trendInline);

var _SpeedDisplay = __webpack_require__("Y5R4");

var _SpeedDisplay2 = _interopRequireDefault(_SpeedDisplay);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function SpeedDisplay(_ref) {
  var value = _ref.value,
      unit = _ref.unit,
      status = _ref.status,
      trend = _ref.trend,
      isHovered = _ref.isHovered;

  return _react2.default.createElement(
    'span',
    { className: (0, _classnames2.default)(_SpeedDisplay2.default.main, _defineProperty({}, _SpeedDisplay2.default['status-' + status], isHovered)) },
    (0, _lodash.round)(value, 1),
    unit && _react2.default.createElement(
      'sup',
      { className: _SpeedDisplay2.default.unit },
      unit
    ),
    trend && _react2.default.createElement(_trendInline2.default, {
      className: (0, _classnames2.default)(_SpeedDisplay2.default.trend, _defineProperty({}, _SpeedDisplay2.default['trend-' + trend], trend))
    })
  );
}

SpeedDisplay.defaultProps = {
  unit: 'mph'
};
SpeedDisplay.propTypes = {
  value: _propTypes.number.isRequired,
  unit: _propTypes.string,
  status: _segmentStatus2.default,
  isHovered: _propTypes.bool,
  trend: (0, _propTypes.oneOf)(['up', 'down'])
};
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(SpeedDisplay, 'SpeedDisplay', '/code/src/components/SpeedDisplay/index.js');
}();

;

/***/ }),

/***/ "h5Sy":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _NavigationBar = __webpack_require__("MtHf");

var _NavigationBar2 = _interopRequireDefault(_NavigationBar);

var _Layout = __webpack_require__("Fv2x");

var _Layout2 = _interopRequireDefault(_Layout);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Layout(_ref) {
  var title = _ref.title,
      children = _ref.children,
      backTo = _ref.backTo,
      header = _ref.header;

  return _react2.default.createElement(
    'section',
    { className: _Layout2.default.main },
    _react2.default.createElement(
      'div',
      { className: _Layout2.default.top },
      _react2.default.createElement(_NavigationBar2.default, { closeTo: '/map/live', backTo: backTo, title: title })
    ),
    _react2.default.createElement(
      'div',
      { className: _Layout2.default.content },
      header,
      _react2.default.createElement(
        'div',
        { className: _Layout2.default.subContent },
        children
      )
    )
  );
}

Layout.propTypes = {
  title: _propTypes.string.isRequired,
  backTo: _propTypes.string.isRequired,
  header: _propTypes.node.isRequired,
  children: _propTypes.node.isRequired
};

var _default = Layout;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(Layout, 'Layout', '/code/src/components/DataPanel/Details/Layout/index.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/code/src/components/DataPanel/Details/Layout/index.js');
}();

;

/***/ }),

/***/ "h9Nw":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SVG = function (_React$Component) {
  _inherits(SVG, _React$Component);

  function SVG() {
    _classCallCheck(this, SVG);

    return _possibleConstructorReturn(this, (SVG.__proto__ || Object.getPrototypeOf(SVG)).apply(this, arguments));
  }

  _createClass(SVG, [{
    key: "render",
    value: function render() {
      return _react2.default.createElement(
        "svg",
        _extends({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 30 43.86" }, this.props),
        _react2.default.createElement(
          "title",
          null,
          "location-active-warning"
        ),
        _react2.default.createElement("path", { fill: "currentColor", stroke: "#fff", strokeMiterlimit: "10", strokeWidth: "2", d: "M1 29.5v-22L7.5 1H29v28.5l-14 13-14-13z" }),
        _react2.default.createElement("path", { fill: "#fff", d: "M13.95 11h3v10h-3zm0 12h3v3h-3z" })
      );
    }
  }]);

  return SVG;
}(_react2.default.Component);

var _default = SVG;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(SVG, "SVG", "/code/src/icons/location-active-warning.inline.svg");

  __REACT_HOT_LOADER__.register(_default, "default", "/code/src/icons/location-active-warning.inline.svg");
}();

;

/***/ }),

/***/ "hYpx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reduxApiMiddleware = __webpack_require__("mIXc");

var _actions = __webpack_require__("2usA");

var _types = __webpack_require__("yyqx");

var _types2 = _interopRequireDefault(_types);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var LOGIN_REQUEST = _types2.default.LOGIN_REQUEST,
    LOGIN_SUCCESS = _types2.default.LOGIN_SUCCESS,
    LOGIN_FAILURE = _types2.default.LOGIN_FAILURE;


function loginUser(creds) {
  return _defineProperty({}, _reduxApiMiddleware.CALL_API, {
    endpoint: '/api/v1/auth/login?email=' + creds.email + '&password=' + creds.password,
    method: 'get',
    types: [LOGIN_REQUEST, LOGIN_SUCCESS, LOGIN_FAILURE]
  });
}

var _default = {
  loginUser: loginUser,
  logoutUser: _actions.requestLogout
};
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(LOGIN_REQUEST, 'LOGIN_REQUEST', '/code/src/state/ducks/auth/operations.js');

  __REACT_HOT_LOADER__.register(LOGIN_SUCCESS, 'LOGIN_SUCCESS', '/code/src/state/ducks/auth/operations.js');

  __REACT_HOT_LOADER__.register(LOGIN_FAILURE, 'LOGIN_FAILURE', '/code/src/state/ducks/auth/operations.js');

  __REACT_HOT_LOADER__.register(loginUser, 'loginUser', '/code/src/state/ducks/auth/operations.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/code/src/state/ducks/auth/operations.js');
}();

;

/***/ }),

/***/ "hoL6":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = RouteTooltip;

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _classnames = __webpack_require__("HW6M");

var _classnames2 = _interopRequireDefault(_classnames);

var _lodash = __webpack_require__("M4fF");

var _formatMinutesSeconds = __webpack_require__("/rNx");

var _formatMinutesSeconds2 = _interopRequireDefault(_formatMinutesSeconds);

var _Tooltip = __webpack_require__("lhKr");

var _Tooltip2 = _interopRequireDefault(_Tooltip);

var _TooltipItem = __webpack_require__("my8f");

var _TooltipItem2 = _interopRequireDefault(_TooltipItem);

var _SpeedTrendIcon = __webpack_require__("sCW4");

var _SpeedTrendIcon2 = _interopRequireDefault(_SpeedTrendIcon);

var _panelRouteInline = __webpack_require__("+vyF");

var _panelRouteInline2 = _interopRequireDefault(_panelRouteInline);

var _panelRouteBrokenInline = __webpack_require__("eF7P");

var _panelRouteBrokenInline2 = _interopRequireDefault(_panelRouteBrokenInline);

var _routeTooltip = __webpack_require__("dki3");

var _routeTooltip2 = _interopRequireDefault(_routeTooltip);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// @TODO use new components: WithTrend, SpeedDisplay, TimeDisplay, SegmentNameDisplay
function RouteTooltip(_ref) {
  var status = _ref.status,
      name = _ref.name,
      liveTravelTime = _ref.liveTravelTime,
      travelTimeTrend = _ref.travelTimeTrend,
      distance = _ref.distance;

  var isReporting = status !== 'disconnected';

  return _react2.default.createElement(
    _Tooltip2.default,
    { sticky: true, offset: [5, -10], className: (0, _classnames2.default)(_routeTooltip2.default.main, _routeTooltip2.default['status-' + status]) },
    _react2.default.createElement(
      _TooltipItem2.default,
      { label: isReporting ? 'travel time' : 'status', status: status },
      isReporting ? _react2.default.createElement(
        'div',
        { className: _routeTooltip2.default.liveTravelTime },
        travelTimeTrend && _react2.default.createElement(_SpeedTrendIcon2.default, { trend: travelTimeTrend, className: _routeTooltip2.default.trendIcon }),
        _react2.default.createElement(
          'span',
          { className: _routeTooltip2.default.speedNumber },
          (0, _formatMinutesSeconds2.default)(liveTravelTime, { useClockFormat: true })
        )
      ) : _react2.default.createElement(
        'div',
        { className: _routeTooltip2.default.statusText },
        'Disconnected'
      )
    ),
    _react2.default.createElement(
      _TooltipItem2.default,
      { label: 'route' },
      _react2.default.createElement(
        'div',
        { className: _routeTooltip2.default.route },
        isReporting ? _react2.default.createElement(_panelRouteInline2.default, { width: 6, className: _routeTooltip2.default.routeIcon }) : _react2.default.createElement(_panelRouteBrokenInline2.default, { width: 6, className: _routeTooltip2.default.routeIcon }),
        _react2.default.createElement(
          'div',
          { className: _routeTooltip2.default.routeName },
          _react2.default.createElement(
            'div',
            null,
            name.from
          ),
          _react2.default.createElement(
            'div',
            null,
            name.to
          )
        )
      )
    ),
    _react2.default.createElement(
      _TooltipItem2.default,
      { label: 'distance' },
      _react2.default.createElement(
        'div',
        { className: _routeTooltip2.default.distance },
        _react2.default.createElement(
          'span',
          { className: _routeTooltip2.default.distanceNumber },
          (0, _lodash.round)(distance, 2),
          ' ',
          _react2.default.createElement(
            'span',
            { className: _routeTooltip2.default.unit },
            'miles'
          )
        )
      )
    )
  );
}

RouteTooltip.propTypes = {
  status: (0, _propTypes.oneOf)(['ok', 'warning', 'problem', 'disconnected']).isRequired,
  name: (0, _propTypes.shape)({ to: _propTypes.string.isRequired, from: _propTypes.string.isRequired }).isRequired,
  liveTravelTime: _propTypes.number.isRequired,
  travelTimeTrend: (0, _propTypes.oneOf)(['up', 'down']),
  distance: _propTypes.number.isRequired
};
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(RouteTooltip, 'RouteTooltip', '/code/src/components/Map/MapComponents/RouteTooltip/index.js');
}();

;

/***/ }),

/***/ "iDB7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectLocation = selectLocation;
exports.deselectLocation = deselectLocation;
exports.flipSelectedLocations = flipSelectedLocations;
exports.setPathSuggestions = setPathSuggestions;
exports.selectPathSuggestion = selectPathSuggestion;
exports.setCreatedSegmentId = setCreatedSegmentId;
exports.clearCreateSegment = clearCreateSegment;
exports.startCreateOppositeSegment = startCreateOppositeSegment;

var _types = __webpack_require__("5QWJ");

var _types2 = _interopRequireDefault(_types);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function selectLocation(id) {
  return {
    type: _types2.default.SELECT_LOCATION,
    payload: {
      id: id
    }
  };
}

function deselectLocation(id) {
  return {
    type: _types2.default.DESELECT_LOCATION,
    payload: {
      id: id
    }
  };
}

function flipSelectedLocations() {
  return {
    type: _types2.default.FLIP_SELECTED_LOCATIONS
  };
}

function setPathSuggestions(pathSuggestions) {
  return {
    type: _types2.default.SET_PATH_SUGGESTIONS,
    payload: {
      pathSuggestions: pathSuggestions
    }
  };
}

function selectPathSuggestion(pathSuggestion) {
  return {
    type: _types2.default.SELECT_PATH_SUGGESTION,
    payload: {
      pathSuggestion: pathSuggestion
    }
  };
}

function setCreatedSegmentId(id) {
  return {
    type: _types2.default.SET_CREATED_SEGMENT_ID,
    payload: {
      id: id
    }
  };
}

function clearCreateSegment() {
  return {
    type: _types2.default.CLEAR_CREATE_SEGMENT
  };
}

function startCreateOppositeSegment() {
  return {
    type: _types2.default.START_CREATE_OPPOSITE_SEGMENT
  };
}
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(selectLocation, 'selectLocation', '/code/src/state/ducks/segmentCreation/actions.js');

  __REACT_HOT_LOADER__.register(deselectLocation, 'deselectLocation', '/code/src/state/ducks/segmentCreation/actions.js');

  __REACT_HOT_LOADER__.register(flipSelectedLocations, 'flipSelectedLocations', '/code/src/state/ducks/segmentCreation/actions.js');

  __REACT_HOT_LOADER__.register(setPathSuggestions, 'setPathSuggestions', '/code/src/state/ducks/segmentCreation/actions.js');

  __REACT_HOT_LOADER__.register(selectPathSuggestion, 'selectPathSuggestion', '/code/src/state/ducks/segmentCreation/actions.js');

  __REACT_HOT_LOADER__.register(setCreatedSegmentId, 'setCreatedSegmentId', '/code/src/state/ducks/segmentCreation/actions.js');

  __REACT_HOT_LOADER__.register(clearCreateSegment, 'clearCreateSegment', '/code/src/state/ducks/segmentCreation/actions.js');

  __REACT_HOT_LOADER__.register(startCreateOppositeSegment, 'startCreateOppositeSegment', '/code/src/state/ducks/segmentCreation/actions.js');
}();

;

/***/ }),

/***/ "iUeW":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactHelmet = __webpack_require__("PIAa");

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _Navigation = __webpack_require__("YkDd");

var _Navigation2 = _interopRequireDefault(_Navigation);

var _app = __webpack_require__("2ShL");

var _app2 = _interopRequireDefault(_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function App(_ref) {
  var children = _ref.children;

  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(
      _reactHelmet2.default,
      { titleTemplate: 'BLUEMAC: %s' },
      _react2.default.createElement(
        'title',
        null,
        'BLUEMAC'
      ),
      _react2.default.createElement('meta', { name: 'description', content: 'The BLUEMAC dashboard' }),
      _react2.default.createElement('meta', { property: 'og:site_name', content: 'BLUEMAC Starter Kyt' }),
      _react2.default.createElement('meta', { property: 'og:image', content: '' }),
      _react2.default.createElement('meta', { property: 'og:locale', content: 'en_US' }),
      _react2.default.createElement('meta', { property: 'og:title', content: 'BLUEMAC React Universal Starter Kyt' }),
      _react2.default.createElement('meta', {
        property: 'og:description',
        content: 'A starter kyt with React, Redux, SSR and data fetching.'
      }),
      _react2.default.createElement('meta', { property: 'og:card', content: 'summary' }),
      _react2.default.createElement('meta', { property: 'og:site', content: '@cleverfranke' }),
      _react2.default.createElement('meta', { property: 'og:creator', content: '@cleverfranke' }),
      _react2.default.createElement('meta', { property: 'og:image:width', content: '200' }),
      _react2.default.createElement('meta', { property: 'og:image:height', content: '200' })
    ),
    _react2.default.createElement(
      'header',
      { className: _app2.default.header },
      _react2.default.createElement(_Navigation2.default, null)
    ),
    _react2.default.createElement(
      'div',
      { className: _app2.default.content },
      children
    )
  );
}
App.propTypes = {
  children: _propTypes2.default.node.isRequired
};

var _default = App;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(App, 'App', '/code/src/containers/App/index.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/code/src/containers/App/index.js');
}();

;

/***/ }),

/***/ "ilXI":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SVG = function (_React$Component) {
  _inherits(SVG, _React$Component);

  function SVG() {
    _classCallCheck(this, SVG);

    return _possibleConstructorReturn(this, (SVG.__proto__ || Object.getPrototypeOf(SVG)).apply(this, arguments));
  }

  _createClass(SVG, [{
    key: "render",
    value: function render() {
      return _react2.default.createElement(
        "svg",
        _extends({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 8 40" }, this.props),
        _react2.default.createElement(
          "title",
          null,
          "Broken segment (small)"
        ),
        _react2.default.createElement("path", { d: "M1.9 0L0 1.9v6.3l4 3.7 4-3.7V0H1.9zm0 28L0 29.9v6.3l4 3.7 4-3.7V28H1.9zM3 15h2v4H3zm0 6h2v4H3z", fill: "currentColor" })
      );
    }
  }]);

  return SVG;
}(_react2.default.Component);

var _default = SVG;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(SVG, "SVG", "/code/src/icons/segment-small-broken.inline.svg");

  __REACT_HOT_LOADER__.register(_default, "default", "/code/src/icons/segment-small-broken.inline.svg");
}();

;

/***/ }),

/***/ "j/Bm":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _bind = __webpack_require__("T2Un");

var _bind2 = _interopRequireDefault(_bind);

var _propTypes = __webpack_require__("KSGD");

var _withSubtitle = __webpack_require__("S5/n");

var _withSubtitle2 = _interopRequireDefault(_withSubtitle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var cx = _bind2.default.bind(_withSubtitle2.default);
/*
 Note that the order of header and content is reversed with styling to keep the
 markup optimal.
 */
var WithSubtitle = function WithSubtitle(_ref) {
  var _cx, _cx2;

  var children = _ref.children,
      title = _ref.title,
      className = _ref.className,
      contentClassName = _ref.contentClassName,
      reversed = _ref.reversed;

  var mainStyle = cx(_withSubtitle2.default.main, (_cx = {}, _defineProperty(_cx, '' + className, className), _defineProperty(_cx, 'reversed', reversed), _cx));
  var titleStyle = cx(_withSubtitle2.default.title, {
    titleReversed: reversed
  });
  var contentStyle = cx(_withSubtitle2.default.content, (_cx2 = {}, _defineProperty(_cx2, '' + contentClassName, contentClassName), _defineProperty(_cx2, 'contentReversed', reversed), _cx2));

  return _react2.default.createElement(
    'div',
    { className: mainStyle },
    _react2.default.createElement(
      'div',
      { className: contentStyle },
      _react2.default.createElement(
        'header',
        { className: titleStyle },
        title
      ),
      children
    )
  );
};

WithSubtitle.propTypes = {
  title: _propTypes.string.isRequired,
  children: _propTypes.node.isRequired,
  className: _propTypes.string,
  contentClassName: _propTypes.string,
  /* Indicates that you want to flip the order of the title and the child embedded in this decorator */
  reversed: _propTypes.bool
};

var _default = WithSubtitle;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(cx, 'cx', '/code/src/components/WithSubtitle/index.js');

  __REACT_HOT_LOADER__.register(WithSubtitle, 'WithSubtitle', '/code/src/components/WithSubtitle/index.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/code/src/components/WithSubtitle/index.js');
}();

;

/***/ }),

/***/ "j9gU":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__("HW6M");

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = __webpack_require__("KSGD");

var _plusInline = __webpack_require__("Htlj");

var _plusInline2 = _interopRequireDefault(_plusInline);

var _ListItem = __webpack_require__("4cE6");

var _ListItem2 = _interopRequireDefault(_ListItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var ListItem = function ListItem(_ref) {
  var id = _ref.id,
      className = _ref.className,
      children = _ref.children,
      isActive = _ref.isActive,
      _onClick = _ref.onClick,
      onMouseOver = _ref.onMouseOver,
      onMouseOut = _ref.onMouseOut;
  return _react2.default.createElement(
    'li',
    {
      className: (0, _classnames2.default)(_ListItem2.default.main, className, _defineProperty({}, _ListItem2.default.isActive, isActive))
    },
    _react2.default.createElement(
      'a',
      {
        className: _ListItem2.default.link,
        href: '/map/create/segment/' + id // we dont' have offline urls for this
        , onClick: function onClick(evt) {
          evt.preventDefault();
          _onClick();
        },
        onMouseOver: onMouseOver,
        onMouseOut: onMouseOut
      },
      _react2.default.createElement(
        'span',
        null,
        children
      ),
      _react2.default.createElement(
        'span',
        { className: _ListItem2.default.plus },
        _react2.default.createElement(_plusInline2.default, { className: _ListItem2.default.plusIcon })
      )
    )
  );
};

ListItem.propTypes = {
  id: _propTypes.string.isRequired,
  className: _propTypes.string,
  children: _propTypes.node,
  isActive: _propTypes.bool,
  onClick: _propTypes.func.isRequired,
  onMouseOver: _propTypes.func.isRequired,
  onMouseOut: _propTypes.func.isRequired
};

var _default = ListItem;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ListItem, 'ListItem', '/code/src/components/MapPanel/ListItem/index.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/code/src/components/MapPanel/ListItem/index.js');
}();

;

/***/ }),

/***/ "jCS6":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  query Segment($id: ID!) {\n    segment(id: $id) {\n      id\n      status\n      name\n      normalSpeed\n      liveSpeed\n      speedLimit\n      expectedTravelTime\n      travelTimeIndex\n      liveTravelTime\n      numberOfTripsToday\n      numberOfTripsSinceLastUpdate\n      oppositeSegmentId\n      liveTravelTimeToday {\n        timestamp\n        value\n      }\n      expectedTravelTimeToday {\n        timestamp\n        value\n      }\n      to {\n        id\n        name\n        trackingDevice {\n          id\n          status\n          lastUpdate\n          reportInterval\n        }\n      }\n      from {\n        id\n        name\n        trackingDevice {\n          id\n          status\n          lastUpdate\n          reportInterval\n        }\n      }\n    }\n  }\n'], ['\n  query Segment($id: ID!) {\n    segment(id: $id) {\n      id\n      status\n      name\n      normalSpeed\n      liveSpeed\n      speedLimit\n      expectedTravelTime\n      travelTimeIndex\n      liveTravelTime\n      numberOfTripsToday\n      numberOfTripsSinceLastUpdate\n      oppositeSegmentId\n      liveTravelTimeToday {\n        timestamp\n        value\n      }\n      expectedTravelTimeToday {\n        timestamp\n        value\n      }\n      to {\n        id\n        name\n        trackingDevice {\n          id\n          status\n          lastUpdate\n          reportInterval\n        }\n      }\n      from {\n        id\n        name\n        trackingDevice {\n          id\n          status\n          lastUpdate\n          reportInterval\n        }\n      }\n    }\n  }\n']);

exports.Segment = Segment;

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _reactApollo = __webpack_require__("3zLD");

var _IconButton = __webpack_require__("Lj8m");

var _IconButton2 = _interopRequireDefault(_IconButton);

var _LoadingIndicator = __webpack_require__("G+3p");

var _LoadingIndicator2 = _interopRequireDefault(_LoadingIndicator);

var _SpeedDisplay = __webpack_require__("g7vI");

var _SpeedDisplay2 = _interopRequireDefault(_SpeedDisplay);

var _TimeDisplay = __webpack_require__("7Jp7");

var _TimeDisplay2 = _interopRequireDefault(_TimeDisplay);

var _formatNextUpdate = __webpack_require__("7p3X");

var _formatNextUpdate2 = _interopRequireDefault(_formatNextUpdate);

var _formatLastUpdate = __webpack_require__("xPfo");

var _formatLastUpdate2 = _interopRequireDefault(_formatLastUpdate);

var _formatInteger = __webpack_require__("r4MO");

var _formatInteger2 = _interopRequireDefault(_formatInteger);

var _formatFloat = __webpack_require__("MyD5");

var _formatFloat2 = _interopRequireDefault(_formatFloat);

var _formatMinutesSeconds = __webpack_require__("/rNx");

var _formatMinutesSeconds2 = _interopRequireDefault(_formatMinutesSeconds);

var _chevronInline = __webpack_require__("PRyc");

var _chevronInline2 = _interopRequireDefault(_chevronInline);

var _classnames = __webpack_require__("HW6M");

var _classnames2 = _interopRequireDefault(_classnames);

var _Layout = __webpack_require__("h5Sy");

var _Layout2 = _interopRequireDefault(_Layout);

var _SegmentHeader = __webpack_require__("5qIW");

var _SegmentHeader2 = _interopRequireDefault(_SegmentHeader);

var _TripletRow = __webpack_require__("5En4");

var _TripletRow2 = _interopRequireDefault(_TripletRow);

var _TripletItem = __webpack_require__("uqaq");

var _TripletItem2 = _interopRequireDefault(_TripletItem);

var _HorizontalSection = __webpack_require__("uNFV");

var _HorizontalSection2 = _interopRequireDefault(_HorizontalSection);

var _Chart = __webpack_require__("Wh2a");

var _Chart2 = _interopRequireDefault(_Chart);

var _GridRow = __webpack_require__("DWOx");

var _GridRow2 = _interopRequireDefault(_GridRow);

var _GridItem = __webpack_require__("3/U4");

var _GridItem2 = _interopRequireDefault(_GridItem);

var _SpeedTrendIcon = __webpack_require__("sCW4");

var _SpeedTrendIcon2 = _interopRequireDefault(_SpeedTrendIcon);

var _segment = __webpack_require__("TnwQ");

var _segment2 = _interopRequireDefault(_segment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var SegmentQuery = (0, _reactApollo.gql)(_templateObject);

function Segment(_ref) {
  var data = _ref.data;

  if (data.loading) {
    return _react2.default.createElement(
      _Layout2.default,
      {
        backTo: '/map/live/segments',
        title: 'All segments',
        header: _react2.default.createElement(_SegmentHeader2.default, { status: 'ok', fromName: '...', toName: '...', isLoading: true })
      },
      _react2.default.createElement(_LoadingIndicator2.default, null)
    );
  }

  if (!data.segment) {
    return _react2.default.createElement(
      'div',
      null,
      'Failed to find segment for id: ',
      data.variables.id
    );
  }

  var _data$segment = data.segment,
      id = _data$segment.id,
      status = _data$segment.status,
      normalSpeed = _data$segment.normalSpeed,
      liveSpeed = _data$segment.liveSpeed,
      speedLimit = _data$segment.speedLimit,
      expectedTravelTime = _data$segment.expectedTravelTime,
      liveTravelTime = _data$segment.liveTravelTime,
      travelTimeIndex = _data$segment.travelTimeIndex,
      numberOfTripsToday = _data$segment.numberOfTripsToday,
      numberOfTripsSinceLastUpdate = _data$segment.numberOfTripsSinceLastUpdate,
      oppositeSegmentId = _data$segment.oppositeSegmentId,
      liveTravelTimeToday = _data$segment.liveTravelTimeToday,
      expectedTravelTimeToday = _data$segment.expectedTravelTimeToday,
      _data$segment$from = _data$segment.from,
      fromDevice = _data$segment$from.trackingDevice,
      fromLocationName = _data$segment$from.name,
      _data$segment$to = _data$segment.to,
      toDevice = _data$segment$to.trackingDevice,
      toLocationName = _data$segment$to.name;


  var isReporting = status !== 'disconnected';

  /* @TODO sort this out. Data based on the two devices. We need to move this to
  GQL probably
  */
  var reportInterval = Math.max(fromDevice.reportInterval, toDevice.reportInterval);
  var lastUpdate = fromDevice.lastUpdate;

  var speedTrend = 'up';

  return _react2.default.createElement(
    _Layout2.default,
    {
      backTo: '/map/live/segments',
      title: 'All segments',
      header: _react2.default.createElement(_SegmentHeader2.default, {
        status: status,
        fromName: fromLocationName,
        toName: toLocationName,
        oppositeSegmentId: oppositeSegmentId
      })
    },
    isReporting ? _react2.default.createElement(
      _TripletRow2.default,
      { title: 'Travel time' },
      _react2.default.createElement(
        _TripletItem2.default,
        { title: 'live', unitName: 'min', status: status },
        _react2.default.createElement(_TimeDisplay2.default, { value: liveTravelTime, status: status }),
        _react2.default.createElement(_SpeedTrendIcon2.default, {
          trend: speedTrend,
          className: (0, _classnames2.default)(_segment2.default.trendIcon, _defineProperty({}, _segment2.default['status-' + status], status))
        })
      ),
      _react2.default.createElement(
        _TripletItem2.default,
        { title: 'expected', unitName: 'min' },
        _react2.default.createElement(_TimeDisplay2.default, { value: expectedTravelTime })
      ),
      _react2.default.createElement(
        _TripletItem2.default,
        { title: 'index' },
        (0, _formatFloat2.default)(travelTimeIndex)
      )
    ) : _react2.default.createElement(
      _TripletRow2.default,
      { title: 'Travel time' },
      _react2.default.createElement(
        _TripletItem2.default,
        { title: 'live', unitName: 'min', status: status },
        _react2.default.createElement(
          'span',
          null,
          '-'
        )
      ),
      _react2.default.createElement(
        _TripletItem2.default,
        { title: 'expected', unitName: 'min', status: status },
        _react2.default.createElement(
          'span',
          null,
          '-'
        )
      ),
      _react2.default.createElement(
        _TripletItem2.default,
        { title: 'index', status: status },
        _react2.default.createElement(
          'span',
          null,
          '-'
        )
      )
    ),
    _react2.default.createElement(_Chart2.default, {
      reportedValues: liveTravelTimeToday,
      expectedValues: expectedTravelTimeToday,
      title: 'Number of hits today',
      calculateCrosshairA: function calculateCrosshairA(_ref2) {
        var reported = _ref2.reported;
        return {
          value: (0, _formatMinutesSeconds2.default)(reported, {
            useClockFormat: true
          }),
          title: 'TT'
        };
      },
      calculateCrosshairB: function calculateCrosshairB(_ref3) {
        var reported = _ref3.reported,
            expected = _ref3.expected;
        return {
          value: (0, _formatFloat2.default)(reported / expected),
          title: 'TTI'
        };
      }
    }),
    _react2.default.createElement(
      _GridRow2.default,
      { title: 'Speed' },
      _react2.default.createElement(
        _GridItem2.default,
        { label: 'live speed', status: status },
        isReporting ? _react2.default.createElement(_SpeedDisplay2.default, { status: status, value: liveSpeed, unit: 'MPH', trend: speedTrend }) : '-'
      ),
      _react2.default.createElement(
        _GridItem2.default,
        { label: 'speed limit' },
        _react2.default.createElement(_SpeedDisplay2.default, { value: speedLimit, unit: 'MPH' })
      ),
      _react2.default.createElement(
        _GridItem2.default,
        { label: 'expected speed' },
        _react2.default.createElement(_SpeedDisplay2.default, { value: normalSpeed, unit: 'MPH' })
      )
    ),
    _react2.default.createElement(
      _GridRow2.default,
      { title: 'Updates' },
      _react2.default.createElement(
        _GridItem2.default,
        { label: 'trips today' },
        (0, _formatInteger2.default)(numberOfTripsToday)
      ),
      _react2.default.createElement(
        _GridItem2.default,
        { label: 'trips last update' },
        (0, _formatInteger2.default)(numberOfTripsSinceLastUpdate)
      ),
      isReporting ? _react2.default.createElement(
        _GridItem2.default,
        { label: 'next update' },
        (0, _formatNextUpdate2.default)(lastUpdate, reportInterval)
      ) : _react2.default.createElement(
        _GridItem2.default,
        { label: 'last update' },
        (0, _formatLastUpdate2.default)(lastUpdate)
      )
    ),
    _react2.default.createElement(
      _HorizontalSection2.default,
      { center: true },
      _react2.default.createElement(
        _IconButton2.default,
        { label: 'details page', linkTo: '/segments/' + id, disabled: true, asLink: true, iconRight: true },
        _react2.default.createElement(_chevronInline2.default, null)
      )
    )
  );
}

Segment.propTypes = {
  data: (0, _propTypes.shape)({
    loading: _propTypes.bool.isRequired,
    location: (0, _propTypes.shape)({})
  }).isRequired
};

var SegmentWithData = (0, _reactApollo.graphql)(SegmentQuery, {
  options: function options(_ref4) {
    var params = _ref4.params;
    return {
      variables: {
        id: params.id
      }
    };
  }
})(Segment);

var _default = SegmentWithData;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(SegmentQuery, 'SegmentQuery', '/code/src/components/DataPanel/Details/Segment/index.js');

  __REACT_HOT_LOADER__.register(Segment, 'Segment', '/code/src/components/DataPanel/Details/Segment/index.js');

  __REACT_HOT_LOADER__.register(SegmentWithData, 'SegmentWithData', '/code/src/components/DataPanel/Details/Segment/index.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/code/src/components/DataPanel/Details/Segment/index.js');
}();

;

/***/ }),

/***/ "ju2b":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"buttonBase":"icon-button-buttonBase--1I-wW","shadowBottom":"icon-button-shadowBottom--1Kz3-","shadowBottomHover":"icon-button-shadowBottomHover--3KTvP","shadowListItem":"icon-button-shadowListItem--3_0PC","shadowRight":"icon-button-shadowRight--2FybV","shadowLeft":"icon-button-shadowLeft--1ItR-","shadowAround":"icon-button-shadowAround--2Nz4N","shadowAroundHover":"icon-button-shadowAroundHover--3NOmD","shadowButton":"icon-button-shadowButton--2vhhn","shadowButtonHover":"icon-button-shadowButtonHover--2hhz1","transitionBase":"icon-button-transitionBase--2dC2F","main":"icon-button-main--3Omkc icon-button-transitionBase--2dC2F","label":"icon-button-label--drudO icon-button-transitionBase--2dC2F","iconContainer":"icon-button-iconContainer--2FvjT icon-button-transitionBase--2dC2F","asLink":"icon-button-asLink--1tE0n","layout":"icon-button-layout--1f1DF","icon":"icon-button-icon--3Mb07","labelText":"icon-button-labelText--2dUJL","isPrimary":"icon-button-isPrimary--272Lw","isSecondary":"icon-button-isSecondary--1rarJ","iconRight":"icon-button-iconRight--nI8vo","hasContextBlue":"icon-button-hasContextBlue--2fkYj","withShadow":"icon-button-withShadow--RLiq0 icon-button-shadowAround--2Nz4N","withShadowHover":"icon-button-withShadowHover--3iAqu icon-button-shadowAroundHover--3NOmD"};

/***/ }),

/***/ "k+jW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"main":"number-display-main--1_Kkj","status-ok":"number-display-status-ok--2tOLr","status-warning":"number-display-status-warning--1BdNR","status-problem":"number-display-status-problem--1xH3-","status-disconnected":"number-display-status-disconnected--1Yb_V","value":"number-display-value--3wFmw","unit":"number-display-unit--17_DL"};

/***/ }),

/***/ "k3R6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"main":"InlineButton-main--38M16","layout":"InlineButton-layout--3OEum","icon":"InlineButton-icon--2MDYS","label":"InlineButton-label--1bYiU","hiddenLabel":"InlineButton-hiddenLabel--2KCZf"};

/***/ }),

/***/ "k5Ik":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = LocationHeader;

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _classnames = __webpack_require__("HW6M");

var _classnames2 = _interopRequireDefault(_classnames);

var _LocationHeader = __webpack_require__("baLt");

var _LocationHeader2 = _interopRequireDefault(_LocationHeader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function LocationHeader(_ref) {
  var name = _ref.name,
      isLoading = _ref.isLoading;

  return _react2.default.createElement(
    'div',
    {
      className: (0, _classnames2.default)(_LocationHeader2.default.main, _defineProperty({}, _LocationHeader2.default.isLoading, isLoading))
    },
    _react2.default.createElement(
      'div',
      { className: _LocationHeader2.default.text },
      _react2.default.createElement(
        'h1',
        { className: _LocationHeader2.default.label },
        'Location'
      ),
      _react2.default.createElement(
        'h2',
        { className: _LocationHeader2.default.content },
        name
      )
    )
  );
}

LocationHeader.propTypes = {
  name: _propTypes.string.isRequired,
  isLoading: _propTypes.bool
};
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(LocationHeader, 'LocationHeader', '/code/src/components/DataPanel/Details/LocationHeader/index.js');
}();

;

/***/ }),

/***/ "k9w0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = SegmentNameDisplay;

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__("HW6M");

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = __webpack_require__("KSGD");

var _segmentStatus = __webpack_require__("fX1p");

var _segmentStatus2 = _interopRequireDefault(_segmentStatus);

var _segmentSmallInline = __webpack_require__("duV/");

var _segmentSmallInline2 = _interopRequireDefault(_segmentSmallInline);

var _segmentSmallBrokenInline = __webpack_require__("ilXI");

var _segmentSmallBrokenInline2 = _interopRequireDefault(_segmentSmallBrokenInline);

var _segmentNameDisplay = __webpack_require__("sEPu");

var _segmentNameDisplay2 = _interopRequireDefault(_segmentNameDisplay);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function SegmentNameDisplay(_ref) {
  var segmentName = _ref.segmentName,
      fromLocationName = _ref.fromLocationName,
      toLocationName = _ref.toLocationName,
      status = _ref.status,
      className = _ref.className;

  var isReporting = status !== 'disconnected';

  return _react2.default.createElement(
    'div',
    { className: (0, _classnames2.default)(_segmentNameDisplay2.default.main, className) },
    isReporting ? _react2.default.createElement(_segmentSmallInline2.default, { width: 8, className: _segmentNameDisplay2.default.segmentIcon }) : _react2.default.createElement(_segmentSmallBrokenInline2.default, { width: 8, className: _segmentNameDisplay2.default.segmentIcon }),
    _react2.default.createElement(
      'div',
      { className: _segmentNameDisplay2.default.segmentName },
      _react2.default.createElement(
        'div',
        null,
        segmentName || fromLocationName
      ),
      _react2.default.createElement(
        'div',
        null,
        segmentName ? '' : toLocationName
      )
    )
  );
}

SegmentNameDisplay.propTypes = {
  segmentName: _propTypes.string,
  fromLocationName: _propTypes.string,
  toLocationName: _propTypes.string,
  status: _segmentStatus2.default.isRequired,
  className: _propTypes.string
};
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(SegmentNameDisplay, 'SegmentNameDisplay', '/code/src/components/SegmentNameDisplay/index.js');
}();

;

/***/ }),

/***/ "l2jl":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }
}();

;

/***/ }),

/***/ "laZn":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = PathSuggestion;

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _classnames = __webpack_require__("HW6M");

var _classnames2 = _interopRequireDefault(_classnames);

var _coord = __webpack_require__("w0mN");

var _coord2 = _interopRequireDefault(_coord);

var _PathSuggestionTooltip = __webpack_require__("+NKF");

var _PathSuggestionTooltip2 = _interopRequireDefault(_PathSuggestionTooltip);

var _PathSuggestions = __webpack_require__("blEK");

var _PathSuggestions2 = _interopRequireDefault(_PathSuggestions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function PathSuggestion(_ref) {
  var path = _ref.path,
      isSelected = _ref.isSelected,
      onSelect = _ref.onSelect,
      distance = _ref.distance,
      expectedTravelTime = _ref.expectedTravelTime;

  // eslint-disable-next-line global-require
  var _require = __webpack_require__("Zz/N"),
      FeatureGroup = _require.FeatureGroup,
      Polyline = _require.Polyline;

  return _react2.default.createElement(
    FeatureGroup,
    { onClick: onSelect },
    _react2.default.createElement(Polyline, {
      classNames: (0, _classnames2.default)(_PathSuggestions2.default.outline, _defineProperty({}, _PathSuggestions2.default.selected, isSelected)),
      positions: path
    }),
    isSelected && _react2.default.createElement(Polyline, { className: _PathSuggestions2.default.underline, positions: path }),
    _react2.default.createElement(Polyline, {
      className: (0, _classnames2.default)(_PathSuggestions2.default.line, _defineProperty({}, _PathSuggestions2.default.selected, isSelected)),
      positions: path
    }),
    _react2.default.createElement(_PathSuggestionTooltip2.default, { distance: distance, expectedTravelTime: expectedTravelTime })
  );
}

PathSuggestion.propTypes = {
  path: (0, _propTypes.arrayOf)(_coord2.default).isRequired,
  distance: _propTypes.number.isRequired,
  expectedTravelTime: _propTypes.number.isRequired,
  isSelected: _propTypes.bool.isRequired,
  onSelect: _propTypes.func.isRequired
};
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(PathSuggestion, 'PathSuggestion', '/code/src/components/Map/CreateSegment/PathSuggestion/index.js');
}();

;

/***/ }),

/***/ "lhKr":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Tooltip;

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _classnames = __webpack_require__("HW6M");

var _classnames2 = _interopRequireDefault(_classnames);

var _twoNumbers = __webpack_require__("5iSJ");

var _twoNumbers2 = _interopRequireDefault(_twoNumbers);

var _tooltip = __webpack_require__("ZUXP");

var _tooltip2 = _interopRequireDefault(_tooltip);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function Tooltip(_ref) {
  var className = _ref.className,
      children = _ref.children,
      offset = _ref.offset,
      sticky = _ref.sticky;

  // eslint-disable-next-line global-require
  var _require = __webpack_require__("Zz/N"),
      LeafletTooltip = _require.Tooltip;
  // eslint-disable-next-line global-require


  var _require2 = __webpack_require__("nrd6"),
      Point = _require2.Point;

  return _react2.default.createElement(
    LeafletTooltip,
    { opacity: 1, offset: new (Function.prototype.bind.apply(Point, [null].concat(_toConsumableArray(offset))))(), direction: 'top', sticky: sticky },
    _react2.default.createElement(
      'div',
      { className: (0, _classnames2.default)(_tooltip2.default.main, className) },
      _react2.default.createElement(
        'ul',
        { className: _tooltip2.default.list },
        children
      )
    )
  );
}

Tooltip.propTypes = {
  className: _propTypes.string,
  offset: _twoNumbers2.default,
  sticky: _propTypes.bool,
  children: _propTypes.node.isRequired
};
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(Tooltip, 'Tooltip', '/code/src/components/Map/MapComponents/Tooltip/index.js');
}();

;

/***/ }),

/***/ "li8v":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = EmptyPanelState;

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _IconButton = __webpack_require__("Lj8m");

var _IconButton2 = _interopRequireDefault(_IconButton);

var _emptystateNothingFoundInline = __webpack_require__("wQMD");

var _emptystateNothingFoundInline2 = _interopRequireDefault(_emptystateNothingFoundInline);

var _chevronInline = __webpack_require__("PRyc");

var _chevronInline2 = _interopRequireDefault(_chevronInline);

var _EmptyPanelState = __webpack_require__("wR0u");

var _EmptyPanelState2 = _interopRequireDefault(_EmptyPanelState);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function EmptyPanelState(_ref) {
  var panelType = _ref.panelType,
      hideIcon = _ref.hideIcon,
      showLink = _ref.showLink;

  var panelMessage = panelType === 'alert' ? 'You have no alerts at this time.' : 'You haven\'t defined any ' + panelType + 's yet!';
  return _react2.default.createElement(
    'div',
    { className: _EmptyPanelState2.default.EmptyPanelState },
    !hideIcon && _react2.default.createElement(_emptystateNothingFoundInline2.default, { className: _EmptyPanelState2.default.emptyStateIcon }),
    _react2.default.createElement(
      'p',
      { className: _EmptyPanelState2.default.errorMessage },
      panelMessage
    ),
    showLink && _react2.default.createElement(
      _IconButton2.default,
      {
        asLink: true,
        iconRight: true,
        linkTo: '/map/create/' + panelType,
        label: 'Create a ' + panelType,
        withShadow: true,
        withShadowHover: true
      },
      _react2.default.createElement(_chevronInline2.default, null)
    )
  );
}

EmptyPanelState.propTypes = {
  panelType: _propTypes.string.isRequired,
  hideIcon: _propTypes.bool,
  showLink: _propTypes.bool
};
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(EmptyPanelState, 'EmptyPanelState', '/code/src/components/DataPanel/Overview/EmptyPanelState/index.js');
}();

;

/***/ }),

/***/ "lk4o":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SVG = function (_React$Component) {
  _inherits(SVG, _React$Component);

  function SVG() {
    _classCallCheck(this, SVG);

    return _possibleConstructorReturn(this, (SVG.__proto__ || Object.getPrototypeOf(SVG)).apply(this, arguments));
  }

  _createClass(SVG, [{
    key: "render",
    value: function render() {
      return _react2.default.createElement(
        "svg",
        _extends({ viewBox: "0 0 14 91", xmlns: "http://www.w3.org/2000/svg", fill: "currentColor" }, this.props),
        _react2.default.createElement("path", { d: "M3.2 0L0 3.3v11.3l7 6.7 7-6.7V0M3.2 69.1L0 72.4v11.3l7 6.7 7-6.7V69.1M6 27h2v36H6z" })
      );
    }
  }]);

  return SVG;
}(_react2.default.Component);

var _default = SVG;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(SVG, "SVG", "/code/src/icons/panel-segment.inline.svg");

  __REACT_HOT_LOADER__.register(_default, "default", "/code/src/icons/panel-segment.inline.svg");
}();

;

/***/ }),

/***/ "lpq2":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Settings = Settings;

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__("RH2O");

var _reactRouter = __webpack_require__("CIox");

var _map = __webpack_require__("YByT");

var _propTypes = __webpack_require__("KSGD");

var _Settings = __webpack_require__("5R4Q");

var _Settings2 = _interopRequireDefault(_Settings);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Settings(_ref) {
  var setViewMode = _ref.setViewMode,
      viewMode = _ref.viewMode,
      isMapPanelOpen = _ref.isMapPanelOpen;

  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(
      'form',
      { className: _Settings2.default.main },
      _react2.default.createElement(
        'fieldset',
        null,
        _react2.default.createElement(
          'div',
          { className: _Settings2.default.fieldsetContent },
          _react2.default.createElement(
            'legend',
            null,
            'Map view'
          ),
          _react2.default.createElement(
            'div',
            { className: _Settings2.default.radioInput },
            _react2.default.createElement('input', {
              id: 'segments',
              type: 'radio',
              name: 'segments',
              value: 'segments',
              tabIndex: isMapPanelOpen ? -1 : 0,
              checked: viewMode === 'segments',
              onChange: function onChange() {
                return setViewMode('segments');
              }
            }),
            _react2.default.createElement(
              'label',
              { htmlFor: 'segments' },
              'Segments'
            )
          ),
          _react2.default.createElement(
            'div',
            { className: _Settings2.default.radioInput },
            _react2.default.createElement('input', {
              id: 'routes',
              type: 'radio',
              name: 'routes',
              value: 'routes',
              tabIndex: isMapPanelOpen ? -1 : 0,
              checked: viewMode === 'routes',
              onChange: function onChange() {
                return setViewMode('routes');
              }
            }),
            _react2.default.createElement(
              'label',
              { htmlFor: 'routes' },
              'Routes'
            )
          )
        )
      )
    ),
    _react2.default.createElement(
      'ul',
      { className: _Settings2.default.createLinks },
      _react2.default.createElement(
        'h3',
        null,
        'Edit map'
      ),
      _react2.default.createElement(
        'li',
        null,
        _react2.default.createElement(
          _reactRouter.Link,
          { className: _Settings2.default.createLink, to: '/map/create/segment' },
          _react2.default.createElement(
            'span',
            null,
            '+'
          ),
          ' Add segments'
        )
      ),
      _react2.default.createElement(
        'li',
        null,
        _react2.default.createElement(
          _reactRouter.Link,
          { className: _Settings2.default.createLink, to: '/map/create/route' },
          _react2.default.createElement(
            'span',
            null,
            '+'
          ),
          ' Add routes'
        )
      )
    )
  );
}

Settings.propTypes = {
  setViewMode: _propTypes.func.isRequired,
  isMapPanelOpen: _propTypes.bool,
  viewMode: _propTypes.string
};

var mapStateToProps = function mapStateToProps(_ref2) {
  var map = _ref2.map;
  return {
    isMapPanelOpen: map.isMapPanelOpen,
    viewMode: map.viewMode
  };
};

var ConnectedSettings = (0, _reactRedux.connect)(mapStateToProps, _map.operations)(Settings);

var _default = ConnectedSettings;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(Settings, 'Settings', '/code/src/components/MapPanel/Settings/index.js');

  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/code/src/components/MapPanel/Settings/index.js');

  __REACT_HOT_LOADER__.register(ConnectedSettings, 'ConnectedSettings', '/code/src/components/MapPanel/Settings/index.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/code/src/components/MapPanel/Settings/index.js');
}();

;

/***/ }),

/***/ "m9jy":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__("HW6M");

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = __webpack_require__("KSGD");

var _segmentStatus = __webpack_require__("fX1p");

var _segmentStatus2 = _interopRequireDefault(_segmentStatus);

var _ListItem = __webpack_require__("G4cM");

var _ListItem2 = _interopRequireDefault(_ListItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var ListItem = function ListItem(_ref) {
  var _cx;

  var id = _ref.id,
      className = _ref.className,
      children = _ref.children,
      isActive = _ref.isActive,
      status = _ref.status,
      contentType = _ref.contentType,
      _onClick = _ref.onClick,
      onMouseOver = _ref.onMouseOver,
      onMouseOut = _ref.onMouseOut;
  return _react2.default.createElement(
    'li',
    {
      className: (0, _classnames2.default)(_ListItem2.default.main, className, _ListItem2.default['status-' + status], (_cx = {}, _defineProperty(_cx, _ListItem2.default.isActive, isActive), _defineProperty(_cx, _ListItem2.default.location, contentType === 'location'), _defineProperty(_cx, _ListItem2.default.segment, contentType === 'segment'), _defineProperty(_cx, _ListItem2.default.route, contentType === 'route'), _cx))
    },
    _react2.default.createElement(
      'a',
      {
        className: _ListItem2.default.link,
        href: '/map/live/' + contentType + 's/' + id,
        onClick: function onClick(evt) {
          evt.preventDefault();
          _onClick();
        },
        onMouseOver: onMouseOver,
        onMouseOut: onMouseOut
      },
      children
    )
  );
};

ListItem.propTypes = {
  id: _propTypes.string.isRequired,
  className: _propTypes.string,
  contentType: (0, _propTypes.oneOf)(['segment', 'location', 'route']),
  children: _propTypes.node,
  isActive: _propTypes.bool,
  status: _segmentStatus2.default.isRequired,
  onClick: _propTypes.func.isRequired,
  onMouseOver: _propTypes.func.isRequired,
  onMouseOut: _propTypes.func.isRequired
};

var _default = ListItem;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ListItem, 'ListItem', '/code/src/components/DataPanel/Overview/ListItem/index.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/code/src/components/DataPanel/Overview/ListItem/index.js');
}();

;

/***/ }),

/***/ "mRdt":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"main":"battery-icon-main--1PMhc","level-0":"battery-icon-level-0--3r8PP","level-1":"battery-icon-level-1--36vuI","level-2":"battery-icon-level-2--2Q5Bw","level-3":"battery-icon-level-3--2v07m","level-4":"battery-icon-level-4--1Qf31","level-5":"battery-icon-level-5--1b5tP","level-6":"battery-icon-level-6--C7yh3"};

/***/ }),

/***/ "my8f":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = TooltipItem;

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__("HW6M");

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = __webpack_require__("KSGD");

var _segmentStatus = __webpack_require__("fX1p");

var _segmentStatus2 = _interopRequireDefault(_segmentStatus);

var _tooltipItem = __webpack_require__("/4Jr");

var _tooltipItem2 = _interopRequireDefault(_tooltipItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function TooltipItem(_ref) {
  var _cx;

  var label = _ref.label,
      children = _ref.children,
      status = _ref.status,
      isLocation = _ref.isLocation;

  return _react2.default.createElement(
    'li',
    {
      className: (0, _classnames2.default)(_tooltipItem2.default.main, (_cx = {}, _defineProperty(_cx, _tooltipItem2.default['status-' + status], status), _defineProperty(_cx, _tooltipItem2.default.isLocation, isLocation), _cx)),
      key: label
    },
    _react2.default.createElement(
      'div',
      { className: _tooltipItem2.default.label },
      label
    ),
    _react2.default.createElement(
      'div',
      { className: _tooltipItem2.default.content },
      children
    )
  );
}

TooltipItem.propTypes = {
  label: _propTypes.string.isRequired,
  children: _propTypes.node.isRequired,
  status: _segmentStatus2.default,
  isLocation: _propTypes.bool
};
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(TooltipItem, 'TooltipItem', '/code/src/components/Map/MapComponents/TooltipItem/index.js');
}();

;

/***/ }),

/***/ "nG+W":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ExistingSegmentPath;

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _classnames = __webpack_require__("HW6M");

var _classnames2 = _interopRequireDefault(_classnames);

var _coord = __webpack_require__("w0mN");

var _coord2 = _interopRequireDefault(_coord);

var _ExistingSegmentPath = __webpack_require__("9pd4");

var _ExistingSegmentPath2 = _interopRequireDefault(_ExistingSegmentPath);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function ExistingSegmentPath(_ref) {
  var latLngList = _ref.latLngList,
      isActive = _ref.isActive;

  // eslint-disable-next-line global-require
  var _require = __webpack_require__("Zz/N"),
      Polyline = _require.Polyline;

  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(Polyline, {
      className: (0, _classnames2.default)(_ExistingSegmentPath2.default.outline, _defineProperty({}, _ExistingSegmentPath2.default.isActive, isActive)),
      positions: latLngList
    }),
    isActive && _react2.default.createElement(Polyline, { positions: latLngList, className: _ExistingSegmentPath2.default.underline }),
    _react2.default.createElement(Polyline, {
      positions: latLngList,
      className: (0, _classnames2.default)(_ExistingSegmentPath2.default.line, _defineProperty({}, _ExistingSegmentPath2.default.isActive, isActive))
    })
  );
}

ExistingSegmentPath.propTypes = {
  latLngList: (0, _propTypes.arrayOf)(_coord2.default).isRequired,
  isActive: _propTypes.bool.isRequired
};
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ExistingSegmentPath, 'ExistingSegmentPath', '/code/src/components/Map/CreateSegment/ExistingSegmentPath/index.js');
}();

;

/***/ }),

/***/ "nRxE":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _ListLabels = __webpack_require__("fUSz");

var _ListLabels2 = _interopRequireDefault(_ListLabels);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ListLabels(_ref) {
  var sortValue = _ref.sortValue,
      location = _ref.location;

  return _react2.default.createElement(
    'div',
    { className: _ListLabels2.default.listLabels },
    _react2.default.createElement(
      'span',
      null,
      'trend'
    ),
    _react2.default.createElement(
      'span',
      null,
      location
    ),
    _react2.default.createElement(
      'span',
      null,
      sortValue === 'tti' ? 'tti' : 'live speed'
    ),
    _react2.default.createElement(
      'span',
      null,
      'last hr'
    )
  );
}

ListLabels.propTypes = {
  sortValue: _propTypes.string.isRequired,
  location: _propTypes.string.isRequired
};

var _default = ListLabels;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ListLabels, 'ListLabels', '/code/src/components/DataPanel/Overview/ListLabels/index.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/code/src/components/DataPanel/Overview/ListLabels/index.js');
}();

;

/***/ }),

/***/ "nvBr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"main":"CreateSegment-main--2SinG","border":"CreateSegment-border--LxWEp"};

/***/ }),

/***/ "o77h":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Title;

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _Title = __webpack_require__("FXLg");

var _Title2 = _interopRequireDefault(_Title);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Title(_ref) {
  var children = _ref.children;

  return _react2.default.createElement(
    'h2',
    { className: _Title2.default.main },
    children
  );
}

Title.propTypes = {
  children: _propTypes.string.isRequired
};
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(Title, 'Title', '/code/src/components/MapPanel/Title/index.js');
}();

;

/***/ }),

/***/ "oHD+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"buttonBase":"RouteSegments-buttonBase--WGfvq","shadowBottom":"RouteSegments-shadowBottom--3FqU5","shadowBottomHover":"RouteSegments-shadowBottomHover--3nxYi","shadowListItem":"RouteSegments-shadowListItem--2pbA4","shadowRight":"RouteSegments-shadowRight--1Q64B","shadowLeft":"RouteSegments-shadowLeft--3J_eC","shadowAround":"RouteSegments-shadowAround--1rTn1","shadowAroundHover":"RouteSegments-shadowAroundHover--3yeMQ","shadowButton":"RouteSegments-shadowButton--2-F8N","shadowButtonHover":"RouteSegments-shadowButtonHover--_2NRF","segments":"RouteSegments-segments--3VZ3w","listHeading":"RouteSegments-listHeading--SOddV"};

/***/ }),

/***/ "paDu":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = RouteSegments;

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _sortSegments = __webpack_require__("C/D4");

var _sortSegments2 = _interopRequireDefault(_sortSegments);

var _List = __webpack_require__("U2GG");

var _List2 = _interopRequireDefault(_List);

var _ListItem = __webpack_require__("m9jy");

var _ListItem2 = _interopRequireDefault(_ListItem);

var _SegmentsListItem = __webpack_require__("QNwT");

var _SegmentsListItem2 = _interopRequireDefault(_SegmentsListItem);

var _RouteSegments = __webpack_require__("oHD+");

var _RouteSegments2 = _interopRequireDefault(_RouteSegments);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function RouteSegments(_ref) {
  var title = _ref.title,
      segments = _ref.segments,
      selectEntity = _ref.selectEntity,
      enterEntity = _ref.enterEntity,
      leaveEntity = _ref.leaveEntity;

  return _react2.default.createElement(
    'section',
    { className: _RouteSegments2.default.segments },
    _react2.default.createElement(
      'h2',
      { className: _RouteSegments2.default.listHeading },
      title
    ),
    _react2.default.createElement(
      _List2.default,
      null,
      (0, _sortSegments2.default)(segments, 'tti', 'asc').map(function (segment) {
        var id = segment.id,
            status = segment.status;


        return _react2.default.createElement(
          _ListItem2.default,
          {
            id: id,
            key: id,
            status: status,
            contentType: 'segment',
            onClick: function onClick() {
              return selectEntity({ id: id, type: 'segment' });
            },
            onMouseOver: function onMouseOver() {
              return enterEntity({ id: id, type: 'segment' });
            },
            onMouseOut: function onMouseOut() {
              return leaveEntity({ id: id, type: 'segment' });
            }
          },
          _react2.default.createElement(_SegmentsListItem2.default, { segment: segment, sortValue: 'tti' })
        );
      })
    )
  );
}

RouteSegments.propTypes = {
  title: _propTypes.string.isRequired,
  segments: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    id: _propTypes.string,
    status: _propTypes.string,
    expectedTravelTime: _propTypes.number,
    travelTimeIndex: _propTypes.number,
    numberOfTripsToday: _propTypes.number,
    numberOfTripsSinceLastUpdate: _propTypes.number,
    from: (0, _propTypes.shape)({
      name: _propTypes.string
    }),
    to: (0, _propTypes.shape)({
      name: _propTypes.string
    })
  })).isRequired,
  selectEntity: _propTypes.func.isRequired,
  enterEntity: _propTypes.func.isRequired,
  leaveEntity: _propTypes.func.isRequired
};
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(RouteSegments, 'RouteSegments', '/code/src/components/DataPanel/Details/RouteSegments/index.js');
}();

;

/***/ }),

/***/ "pgZ4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _SegmentPath = __webpack_require__("LoGb");

var _SegmentPath2 = _interopRequireDefault(_SegmentPath);

var _SegmentTooltip = __webpack_require__("9/r9");

var _SegmentTooltip2 = _interopRequireDefault(_SegmentTooltip);

var _segmentStatus = __webpack_require__("fX1p");

var _segmentStatus2 = _interopRequireDefault(_segmentStatus);

var _coord = __webpack_require__("w0mN");

var _coord2 = _interopRequireDefault(_coord);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Segment = function (_Component) {
  _inherits(Segment, _Component);

  function Segment() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Segment);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Segment.__proto__ || Object.getPrototypeOf(Segment)).call.apply(_ref, [this].concat(args))), _this), _this.defaultProps = {
      priority: 0
    }, _this.state = {
      speedTrend: null
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Segment, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var trend = nextProps.segment.liveTravelTime >= this.props.segment.liveTravelTime ? 'up' : 'down';
      this.setState({ speedTrend: trend });
    }
  }, {
    key: 'render',
    value: function render() {
      // eslint-disable-next-line global-require
      var PriorityFeatureGroup = __webpack_require__("c9LL").default;

      var _props = this.props,
          segment = _props.segment,
          onEnter = _props.onEnter,
          onLeave = _props.onLeave,
          onSelect = _props.onSelect,
          isActive = _props.isActive;
      var id = segment.id,
          fromName = segment.from.name,
          toName = segment.to.name,
          path = segment.path,
          liveTravelTime = segment.liveTravelTime,
          status = segment.status;

      var name = { from: fromName, to: toName };

      return _react2.default.createElement(
        PriorityFeatureGroup,
        {
          key: 'Segment-' + id + '-' + status + (isActive ? '-active' : ''),
          onMouseover: onEnter,
          onMouseout: onLeave,
          onClick: onSelect,
          priority: this.props.priority
        },
        _react2.default.createElement(_SegmentPath2.default, { latLngList: path, status: status, isActive: isActive }),
        _react2.default.createElement(_SegmentTooltip2.default, {
          status: status,
          name: name,
          liveTravelTime: liveTravelTime,
          speedTrend: this.state.speedTrend
        })
      );
    }
  }]);

  return Segment;
}(_react.Component);

Segment.propTypes = {
  onSelect: _propTypes.func.isRequired,
  onEnter: _propTypes.func.isRequired,
  onLeave: _propTypes.func.isRequired,
  isActive: _propTypes.bool.isRequired,
  priority: _propTypes.number,
  segment: (0, _propTypes.shape)({
    id: _propTypes.string,
    path: (0, _propTypes.arrayOf)(_coord2.default),
    liveTravelTime: _propTypes.number.isRequired,
    status: _segmentStatus2.default.isRequired
  }).isRequired
};
var _default = Segment;
exports.default = _default;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(Segment, 'Segment', '/code/src/components/Map/MapComponents/Segment/index.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/code/src/components/Map/MapComponents/Segment/index.js');
}();

;

/***/ }),

/***/ "ptpK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"main":"segment-tooltip-main--123qc","liveTravelTime":"segment-tooltip-liveTravelTime--1l3PI","status-ok":"segment-tooltip-status-ok--3QV9v","status-warning":"segment-tooltip-status-warning--22ny5","status-problem":"segment-tooltip-status-problem--3dXEG","status-disconnected":"segment-tooltip-status-disconnected--3K4_j","statusText":"segment-tooltip-statusText--3M6qe","speedNumber":"segment-tooltip-speedNumber--3OSrs","trendIcon":"segment-tooltip-trendIcon--NMj5M","segment":"segment-tooltip-segment--2g-OE","segmentIcon":"segment-tooltip-segmentIcon--2h1b7","segmentName":"segment-tooltip-segmentName--1Y3aq"};

/***/ }),

/***/ "qjr7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = formatDaysHoursMinutesSeconds;

var _formatMinutesSeconds = __webpack_require__("/rNx");

var _formatMinutesSeconds2 = _interopRequireDefault(_formatMinutesSeconds);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function formatDaysHoursMinutesSeconds(seconds) {
  var secondsPerHour = 60 * 60;
  var secondsPerDay = 24 * secondsPerHour;

  var days = Math.floor(seconds / secondsPerDay);
  var remainingHours = Math.floor((seconds - days * secondsPerDay) / secondsPerHour);

  if (days <= 0) {
    if (remainingHours <= 0) {
      return (0, _formatMinutesSeconds2.default)(seconds);
    }
    return remainingHours + ' ' + (remainingHours > 1 ? 'hours' : 'hour');
  }

  return days + ' ' + (days > 1 ? 'days' : 'day');
}
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(formatDaysHoursMinutesSeconds, 'formatDaysHoursMinutesSeconds', '/code/src/helpers/formatDaysHoursMinutesSeconds.js');
}();

;

/***/ }),

/***/ "qoCU":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _locationShape = __webpack_require__("1itO");

var _locationShape2 = _interopRequireDefault(_locationShape);

var _LocationMarker = __webpack_require__("wQ+0");

var _LocationMarker2 = _interopRequireDefault(_LocationMarker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * isLocationActive checks if the location is present in one of the segments in the selectedSegments array.
 * @param {any} { location, segments, selectedSegments, hoveredId }
 * @returns
 */
function isLocationActive(_ref) {
  var location = _ref.location,
      segments = _ref.segments,
      selectedSegments = _ref.selectedSegments,
      hoveredId = _ref.hoveredId;

  // checks if the object.id matches the hovered state or is present in one of the currently selected segments for the newly created route
  var idMatchesActiveStates = function idMatchesActiveStates(_ref2) {
    var id = _ref2.id;
    return id === hoveredId || segments.reduce(function (acc, segment) {
      if (selectedSegments.includes(segment.id)) {
        return acc || segment.from.id === location.id || segment.to.id === location.id;
      }

      return acc;
    }, false);
  };

  if (idMatchesActiveStates(location)) return true;

  // check whether id a segment which is connected to the location
  var activeSegment = segments.find(idMatchesActiveStates);

  return activeSegment && (activeSegment.from.id === location.id || activeSegment.to.id === location.id);
}

function LocationMarkerGroup(_ref3) {
  var locations = _ref3.locations,
      segments = _ref3.segments,
      selectedSegments = _ref3.selectedSegments,
      currentHover = _ref3.currentHover;

  // eslint-disable-next-line global-require
  var _require = __webpack_require__("Zz/N"),
      FeatureGroup = _require.FeatureGroup;

  var hoveredId = currentHover && currentHover.id;

  return _react2.default.createElement(
    FeatureGroup,
    null,
    locations.map(function (location) {
      var id = location.id,
          trackingDevice = location.trackingDevice,
          lat = location.lat,
          lng = location.lng,
          name = location.name;


      var isActive = isLocationActive({
        location: location,
        segments: segments,
        selectedSegments: selectedSegments,
        hoveredId: hoveredId
      });

      return _react2.default.createElement(_LocationMarker2.default, {
        key: '' + id,
        trackingDevice: trackingDevice,
        position: [lat, lng],
        name: name,
        id: id,
        isActive: isActive,
        isFaded: !isActive
      });
    })
  );
}

LocationMarkerGroup.propTypes = {
  locations: (0, _propTypes.arrayOf)(_locationShape2.default).isRequired,
  segments: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    id: _propTypes.string.isRequired,
    from: (0, _propTypes.shape)({ name: _propTypes.string }).isRequired,
    to: (0, _propTypes.shape)({ name: _propTypes.string }).isRequired
  })).isRequired,
  selectedSegments: (0, _propTypes.arrayOf)(_propTypes.string).isRequired,
  currentHover: (0, _propTypes.shape)({
    id: _propTypes.string.isRequired
  })
};

var _default = LocationMarkerGroup;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(isLocationActive, 'isLocationActive', '/code/src/components/Map/CreateRoute/LocationMarkerGroup/index.js');

  __REACT_HOT_LOADER__.register(LocationMarkerGroup, 'LocationMarkerGroup', '/code/src/components/Map/CreateRoute/LocationMarkerGroup/index.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/code/src/components/Map/CreateRoute/LocationMarkerGroup/index.js');
}();

;

/***/ }),

/***/ "r4MO":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = formatInteger;
function formatInteger(value) {
  if (value < 1000) {
    return '' + value;
  }

  var thousands = Math.floor(value / 1000);
  var remainder = value - thousands * 1000;
  var remainderStr = ('' + remainder).padStart(3, '0');

  return thousands + ',' + remainderStr;
}
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(formatInteger, 'formatInteger', '/code/src/helpers/formatInteger.js');
}();

;

/***/ }),

/***/ "r6f7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = sortRoutes;

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var isOffline = function isOffline(_ref) {
  var status = _ref.status;
  return status === 'disconnected';
};

var sortRoutesAscending = function sortRoutesAscending(property) {
  return function (a, b) {
    var aIsOffline = isOffline(a);
    var bIsOffline = isOffline(b);

    if (aIsOffline) return -1; // sort a after b
    if (bIsOffline) return 1; // sort a before b

    return a[property] >= b[property] ? 1 : -1;
  };
};

function sortRoutes(routes, value, order) {
  var result = [].concat(_toConsumableArray(routes));

  switch (value) {
    case 'tti':
      result.sort(sortRoutesAscending('travelTimeIndex'));
      break;
    case 'speed':
      result.sort(sortRoutesAscending('liveSpeed'));
      break;
    default:
  }

  return order === 'asc' ? result : result.reverse();
}
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(isOffline, 'isOffline', '/code/src/helpers/sortRoutes.js');

  __REACT_HOT_LOADER__.register(sortRoutesAscending, 'sortRoutesAscending', '/code/src/helpers/sortRoutes.js');

  __REACT_HOT_LOADER__.register(sortRoutes, 'sortRoutes', '/code/src/helpers/sortRoutes.js');
}();

;

/***/ }),

/***/ "rFqV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"main":"Chart-main--2iQLq","title":"Chart-title--1uhCl","crosshair":"Chart-crosshair--1D8Lm","value":"Chart-value--3ecMu","sharedTriangleLogic":"Chart-sharedTriangleLogic--oBdUV"};

/***/ }),

/***/ "rm5e":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SVG = function (_React$Component) {
  _inherits(SVG, _React$Component);

  function SVG() {
    _classCallCheck(this, SVG);

    return _possibleConstructorReturn(this, (SVG.__proto__ || Object.getPrototypeOf(SVG)).apply(this, arguments));
  }

  _createClass(SVG, [{
    key: "render",
    value: function render() {
      return _react2.default.createElement(
        "svg",
        _extends({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 14 91", fill: "currentColor" }, this.props),
        _react2.default.createElement("path", { d: "M3.2 0L0 3.3v11.3l7 6.7 7-6.7V0zM3.2 69.1L0 72.4v11.3l7 6.7 7-6.7V69.1zM6 27.4h2v4H6zM6 59.4h2v4H6zM6 51.4h2v4H6zM6 43.4h2v4H6zM6 35.4h2v4H6z" })
      );
    }
  }]);

  return SVG;
}(_react2.default.Component);

var _default = SVG;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(SVG, "SVG", "/code/src/icons/panel-segment-broken.inline.svg");

  __REACT_HOT_LOADER__.register(_default, "default", "/code/src/icons/panel-segment-broken.inline.svg");
}();

;

/***/ }),

/***/ "sCW4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = SpeedTrendIcon;

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _IconLayout = __webpack_require__("tVKc");

var _IconLayout2 = _interopRequireDefault(_IconLayout);

var _trendInline = __webpack_require__("fChq");

var _trendInline2 = _interopRequireDefault(_trendInline);

var _speedTrendIcon = __webpack_require__("uHvf");

var _speedTrendIcon2 = _interopRequireDefault(_speedTrendIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function SpeedTrendIcon(_ref) {
  var trend = _ref.trend,
      className = _ref.className,
      alignMiddle = _ref.alignMiddle;

  return _react2.default.createElement(
    _IconLayout2.default,
    { className: className, alignMiddle: alignMiddle },
    _react2.default.createElement(_trendInline2.default, { className: trend === 'up' ? _speedTrendIcon2.default.up : _speedTrendIcon2.default.down })
  );
}

SpeedTrendIcon.propTypes = {
  trend: (0, _propTypes.oneOf)(['up', 'down']).isRequired,
  className: _propTypes.string,
  alignMiddle: _propTypes.bool
};
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(SpeedTrendIcon, 'SpeedTrendIcon', '/code/src/components/SpeedTrendIcon/index.js');
}();

;

/***/ }),

/***/ "sEPu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"main":"segment-name-display-main--18PsV","segmentIcon":"segment-name-display-segmentIcon--KjTdG","segmentName":"segment-name-display-segmentName--3d0rb"};

/***/ }),

/***/ "sHKi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"buttonBase":"RouteHeader-buttonBase--2Ig2L","shadowBottom":"RouteHeader-shadowBottom--1gsty","shadowBottomHover":"RouteHeader-shadowBottomHover--Mnz9C","shadowListItem":"RouteHeader-shadowListItem--FAzrp","shadowRight":"RouteHeader-shadowRight--5rjc_","shadowLeft":"RouteHeader-shadowLeft--2keHh","shadowAround":"RouteHeader-shadowAround--1beKN","shadowAroundHover":"RouteHeader-shadowAroundHover--3hSth","shadowButton":"RouteHeader-shadowButton--pAOqr","shadowButtonHover":"RouteHeader-shadowButtonHover--BsfI9","main":"RouteHeader-main--vVKHu RouteHeader-shadowAround--1beKN","title":"RouteHeader-title--miw8j","content":"RouteHeader-content--1uVvx","text":"RouteHeader-text--hfLM5","textGroup":"RouteHeader-textGroup--3hCdF","label":"RouteHeader-label--2koq4","name":"RouteHeader-name--2yHLZ","isLoading":"RouteHeader-isLoading--TYOzJ","switchButtonWrapper":"RouteHeader-switchButtonWrapper--3AR9v","switchButton":"RouteHeader-switchButton--ocPep"};

/***/ }),

/***/ "sod9":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _templateObject = _taggedTemplateLiteral(['\n  query Locations {\n    locations {\n      id\n      name\n      trackingDevice {\n        id\n        name\n        status\n        batteryVoltage\n        temperature\n        reportInterval\n        lastUpdate\n        numberOfHitsToday\n        hitsToday\n      }\n    }\n  }\n'], ['\n  query Locations {\n    locations {\n      id\n      name\n      trackingDevice {\n        id\n        name\n        status\n        batteryVoltage\n        temperature\n        reportInterval\n        lastUpdate\n        numberOfHitsToday\n        hitsToday\n      }\n    }\n  }\n']);

exports.Locations = Locations;

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _reactApollo = __webpack_require__("3zLD");

var _reactRedux = __webpack_require__("RH2O");

var _map = __webpack_require__("YByT");

var _LoadingIndicator = __webpack_require__("G+3p");

var _LoadingIndicator2 = _interopRequireDefault(_LoadingIndicator);

var _List = __webpack_require__("U2GG");

var _List2 = _interopRequireDefault(_List);

var _ListItem = __webpack_require__("m9jy");

var _ListItem2 = _interopRequireDefault(_ListItem);

var _LocationsListItem = __webpack_require__("Cvct");

var _LocationsListItem2 = _interopRequireDefault(_LocationsListItem);

var _EmptyPanelState = __webpack_require__("li8v");

var _EmptyPanelState2 = _interopRequireDefault(_EmptyPanelState);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var LocationsQuery = (0, _reactApollo.gql)(_templateObject);

function Locations(_ref) {
  var data = _ref.data,
      selectEntity = _ref.selectEntity,
      enterEntity = _ref.enterEntity,
      leaveEntity = _ref.leaveEntity,
      currentHover = _ref.currentHover;

  if (data.loading) {
    return _react2.default.createElement(_LoadingIndicator2.default, null);
  }

  // We don't have any segments yet
  if (!data.locations || data.locations.length === 0) {
    return _react2.default.createElement(_EmptyPanelState2.default, { panelType: 'location' });
  }

  var items = data.locations.map(function (location) {
    var id = location.id,
        trackingDevice = location.trackingDevice;

    var status = trackingDevice.status;
    var isActive = currentHover && currentHover.id === id;

    return _react2.default.createElement(
      _ListItem2.default,
      {
        id: id,
        key: id,
        status: status,
        isActive: isActive,
        onClick: function onClick() {
          return selectEntity({ id: id, type: 'location' });
        },
        onMouseOver: function onMouseOver() {
          return enterEntity({ id: id, type: 'location' });
        },
        onMouseOut: function onMouseOut() {
          return leaveEntity({ id: id, type: 'location' });
        },
        contentType: 'location'
      },
      _react2.default.createElement(_LocationsListItem2.default, { location: location })
    );
  });

  return _react2.default.createElement(
    _List2.default,
    null,
    items
  );
}

Locations.propTypes = {
  data: (0, _propTypes.shape)({
    loading: _propTypes.bool.isRequired,
    location: (0, _propTypes.shape)({})
  }).isRequired,
  selectEntity: _propTypes.func.isRequired,
  enterEntity: _propTypes.func.isRequired,
  leaveEntity: _propTypes.func.isRequired,
  currentHover: (0, _propTypes.shape)({
    id: _propTypes.string.isRequired
  })
};

var mapStateToProps = function mapStateToProps(_ref2, ownProps) {
  var map = _ref2.map;
  return _extends({
    currentHover: map.currentHover
  }, ownProps);
};

var ConnectedLocationsWithData = (0, _reactApollo.compose)((0, _reactRedux.connect)(mapStateToProps, _map.operations), (0, _reactApollo.graphql)(LocationsQuery, {
  options: function options(_ref3) {
    var params = _ref3.params;
    return {
      variables: {
        id: params.id
      }
    };
  }
}))(Locations);

var _default = ConnectedLocationsWithData;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(LocationsQuery, 'LocationsQuery', '/code/src/components/DataPanel/Overview/Locations/index.js');

  __REACT_HOT_LOADER__.register(Locations, 'Locations', '/code/src/components/DataPanel/Overview/Locations/index.js');

  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/code/src/components/DataPanel/Overview/Locations/index.js');

  __REACT_HOT_LOADER__.register(ConnectedLocationsWithData, 'ConnectedLocationsWithData', '/code/src/components/DataPanel/Overview/Locations/index.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/code/src/components/DataPanel/Overview/Locations/index.js');
}();

;

/***/ }),

/***/ "sppZ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SVG = function (_React$Component) {
  _inherits(SVG, _React$Component);

  function SVG() {
    _classCallCheck(this, SVG);

    return _possibleConstructorReturn(this, (SVG.__proto__ || Object.getPrototypeOf(SVG)).apply(this, arguments));
  }

  _createClass(SVG, [{
    key: "render",
    value: function render() {
      return _react2.default.createElement(
        "svg",
        _extends({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16", fill: "currentColor" }, this.props),
        _react2.default.createElement("path", { d: "M14 12H2l6-8z" })
      );
    }
  }]);

  return SVG;
}(_react2.default.Component);

var _default = SVG;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(SVG, "SVG", "/code/src/icons/sort.inline.svg");

  __REACT_HOT_LOADER__.register(_default, "default", "/code/src/icons/sort.inline.svg");
}();

;

/***/ }),

/***/ "suLB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"buttonBase":"CreateSegment-buttonBase--3qV7O","shadowBottom":"CreateSegment-shadowBottom--fcxX1","shadowBottomHover":"CreateSegment-shadowBottomHover--3Ijdu","shadowListItem":"CreateSegment-shadowListItem--16Osv","shadowRight":"CreateSegment-shadowRight--3U1G9","shadowLeft":"CreateSegment-shadowLeft--1AcHf","shadowAround":"CreateSegment-shadowAround--1YgkI","shadowAroundHover":"CreateSegment-shadowAroundHover--3FPh_","shadowButton":"CreateSegment-shadowButton--3uMRa","shadowButtonHover":"CreateSegment-shadowButtonHover--GwjDv","main":"CreateSegment-main--3-_H7","locationIcon":"CreateSegment-locationIcon--3sCtd","top":"CreateSegment-top--16iEP CreateSegment-shadowBottom--fcxX1","subtitle":"CreateSegment-subtitle--gJfJn","content":"CreateSegment-content--3w94u","text":"CreateSegment-text--2RLRK","footer":"CreateSegment-footer--3Iz44"};

/***/ }),

/***/ "t8Hm":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _deviceStatus = __webpack_require__("2Ejm");

var _deviceStatus2 = _interopRequireDefault(_deviceStatus);

var _deviceStatusText = __webpack_require__("NX5i");

var _deviceStatusText2 = _interopRequireDefault(_deviceStatusText);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function mapStatusToText(status) {
  switch (status) {
    case 'ok':
      return 'OK';
    case 'warning':
      return 'Warning';
    case 'disconnected':
      return 'Disconnected';
    default:
      return 'Unknown status: ' + status;
  }
}

var DeviceStatusText = function DeviceStatusText(_ref) {
  var status = _ref.status;
  return _react2.default.createElement(
    'span',
    { className: _deviceStatusText2.default['status-' + status] },
    mapStatusToText(status)
  );
};

DeviceStatusText.propTypes = {
  status: _deviceStatus2.default.isRequired
};

var _default = DeviceStatusText;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(mapStatusToText, 'mapStatusToText', '/code/src/components/DeviceStatusText/index.js');

  __REACT_HOT_LOADER__.register(DeviceStatusText, 'DeviceStatusText', '/code/src/components/DeviceStatusText/index.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/code/src/components/DeviceStatusText/index.js');
}();

;

/***/ }),

/***/ "tEHQ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reducers = __webpack_require__("5d5i");

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_reducers).default;
  }
});

var _types = __webpack_require__("3pOm");

Object.defineProperty(exports, 'types', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_types).default;
  }
});

var _selectors = __webpack_require__("8R2t");

Object.defineProperty(exports, 'selectors', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_selectors).default;
  }
});

var _operations = __webpack_require__("ciM9");

Object.defineProperty(exports, 'operations', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_operations).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }
}();

;

/***/ }),

/***/ "tVKc":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = IconLayout;

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _classnames = __webpack_require__("HW6M");

var _classnames2 = _interopRequireDefault(_classnames);

var _iconLayout = __webpack_require__("Z8ef");

var _iconLayout2 = _interopRequireDefault(_iconLayout);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/*
  This component scales and aligns a child svg inline with the text. By default
  the icon is aligned with the text baseline. The alignMiddle option centers
  the icon vertically.
*/

function IconLayout(_ref) {
  var children = _ref.children,
      className = _ref.className,
      alignMiddle = _ref.alignMiddle;

  return _react2.default.createElement(
    'span',
    {
      className: (0, _classnames2.default)(_iconLayout2.default.main, className, _defineProperty({}, _iconLayout2.default.alignMiddle, alignMiddle))
    },
    children
  );
}

IconLayout.propTypes = {
  children: _propTypes.node.isRequired,
  className: _propTypes.string,
  alignMiddle: _propTypes.bool
};

IconLayout.defaultProps = {
  alignMiddle: false
};
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(IconLayout, 'IconLayout', '/code/src/components/IconLayout/index.js');
}();

;

/***/ }),

/***/ "tZDw":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ExistingSegmentTooltip;

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _Tooltip = __webpack_require__("lhKr");

var _Tooltip2 = _interopRequireDefault(_Tooltip);

var _TooltipItem = __webpack_require__("my8f");

var _TooltipItem2 = _interopRequireDefault(_TooltipItem);

var _segmentSmallInline = __webpack_require__("duV/");

var _segmentSmallInline2 = _interopRequireDefault(_segmentSmallInline);

var _ExistingSegmentTooltip = __webpack_require__("vRF7");

var _ExistingSegmentTooltip2 = _interopRequireDefault(_ExistingSegmentTooltip);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// @TODO use new components: WithTrend, SpeedDisplay, TimeDisplay, SegmentNameDisplay
function ExistingSegmentTooltip(_ref) {
  var name = _ref.name;

  return _react2.default.createElement(
    _Tooltip2.default,
    { sticky: true, offset: [5, -10], className: _ExistingSegmentTooltip2.default.main },
    _react2.default.createElement(
      _TooltipItem2.default,
      { label: 'segment' },
      _react2.default.createElement(
        'div',
        { className: _ExistingSegmentTooltip2.default.segment },
        _react2.default.createElement(_segmentSmallInline2.default, { className: _ExistingSegmentTooltip2.default.segmentIcon }),
        _react2.default.createElement(
          'div',
          { className: _ExistingSegmentTooltip2.default.segmentName },
          _react2.default.createElement(
            'div',
            { className: _ExistingSegmentTooltip2.default.segmentNameFrom },
            name.from
          ),
          _react2.default.createElement(
            'div',
            null,
            name.to
          )
        )
      )
    )
  );
}

ExistingSegmentTooltip.propTypes = {
  name: (0, _propTypes.shape)({ to: _propTypes.string.isRequired, from: _propTypes.string.isRequired }).isRequired
};
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ExistingSegmentTooltip, 'ExistingSegmentTooltip', '/code/src/components/Map/CreateSegment/ExistingSegmentTooltip/index.js');
}();

;

/***/ }),

/***/ "tbgJ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _classnames = __webpack_require__("HW6M");

var _classnames2 = _interopRequireDefault(_classnames);

var _trackingDeviceShape = __webpack_require__("1oTp");

var _trackingDeviceShape2 = _interopRequireDefault(_trackingDeviceShape);

var _LocationTooltip = __webpack_require__("RzI6");

var _LocationTooltip2 = _interopRequireDefault(_LocationTooltip);

var _location = __webpack_require__("N7A0");

var _location2 = _interopRequireDefault(_location);

var _locationActive = __webpack_require__("R4EL");

var _locationActive2 = _interopRequireDefault(_locationActive);

var _locationInactive = __webpack_require__("Nk6q");

var _locationInactive2 = _interopRequireDefault(_locationInactive);

var _locationWarning = __webpack_require__("7uQU");

var _locationWarning2 = _interopRequireDefault(_locationWarning);

var _locationActiveWarning = __webpack_require__("ddva");

var _locationActiveWarning2 = _interopRequireDefault(_locationActiveWarning);

var _locationInactiveWarning = __webpack_require__("YI/7");

var _locationInactiveWarning2 = _interopRequireDefault(_locationInactiveWarning);

var _locationProblem = __webpack_require__("ADHu");

var _locationProblem2 = _interopRequireDefault(_locationProblem);

var _locationActiveProblem = __webpack_require__("SKf6");

var _locationActiveProblem2 = _interopRequireDefault(_locationActiveProblem);

var _LocationMarker = __webpack_require__("daf4");

var _LocationMarker2 = _interopRequireDefault(_LocationMarker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var icons = {
  ok: {
    default: _location2.default,
    active: _locationActive2.default,
    inactive: _locationInactive2.default
  },
  warning: {
    default: _locationWarning2.default,
    active: _locationActiveWarning2.default,
    inactive: _locationInactiveWarning2.default
  },
  disconnected: {
    default: _locationProblem2.default,
    active: _locationActiveProblem2.default,
    inactive: _locationInactiveWarning2.default
  }
};

function getMarkerIcon(statusLabel, isActive, isFaded) {
  if (isActive) {
    return icons[statusLabel].active;
  }

  if (isFaded) {
    return icons[statusLabel].inactive;
  }

  return icons[statusLabel].default;
}

/* eslint-disable global-require */
function LocationMarker(_ref) {
  var trackingDevice = _ref.trackingDevice,
      name = _ref.name,
      position = _ref.position,
      size = _ref.size,
      anchor = _ref.anchor,
      isActive = _ref.isActive,
      isFaded = _ref.isFaded,
      onSelect = _ref.onSelect,
      onEnter = _ref.onEnter,
      onLeave = _ref.onLeave;

  // eslint-disable-next-line global-require
  var _require = __webpack_require__("Zz/N"),
      Marker = _require.Marker;
  // eslint-disable-next-line global-require


  var _require2 = __webpack_require__("nrd6"),
      icon = _require2.icon;

  var markerIcon = getMarkerIcon(trackingDevice.status, isActive, isFaded);

  var isCreate = location.pathname.includes('/create');

  return _react2.default.createElement(
    Marker,
    {
      position: position,
      icon: icon({
        iconUrl: markerIcon,
        iconSize: size,
        iconAnchor: anchor,
        className: (0, _classnames2.default)(_defineProperty({}, _LocationMarker2.default.isFaded, isCreate && isFaded))
      }),
      alt: 'Location: ' + name + ', status: ' + trackingDevice.status,
      keyboard: true,
      riseOnHover: true,
      interactive: !isCreate || !isFaded,
      onMouseover: onEnter,
      onMouseout: onLeave,
      onClick: onSelect
    },
    _react2.default.createElement(_LocationTooltip2.default, { trackingDevice: trackingDevice, locationName: name })
  );
}

LocationMarker.propTypes = {
  size: (0, _propTypes.arrayOf)(_propTypes.number),
  anchor: (0, _propTypes.arrayOf)(_propTypes.number),
  trackingDevice: _trackingDeviceShape2.default.isRequired,
  position: (0, _propTypes.arrayOf)(_propTypes.number).isRequired,
  name: _propTypes.string.isRequired,
  onSelect: _propTypes.func.isRequired,
  onEnter: _propTypes.func.isRequired,
  onLeave: _propTypes.func.isRequired,
  isActive: _propTypes.bool,
  isFaded: _propTypes.bool
};

LocationMarker.defaultProps = {
  size: [20, 30], // [x, y]
  anchor: [10, 30] // [1/2 of size.x, 100% of size.y]
};

var _default = LocationMarker;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(icons, 'icons', '/code/src/components/Map/MapComponents/LocationMarker/index.js');

  __REACT_HOT_LOADER__.register(getMarkerIcon, 'getMarkerIcon', '/code/src/components/Map/MapComponents/LocationMarker/index.js');

  __REACT_HOT_LOADER__.register(LocationMarker, 'LocationMarker', '/code/src/components/Map/MapComponents/LocationMarker/index.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/code/src/components/Map/MapComponents/LocationMarker/index.js');
}();

;

/***/ }),

/***/ "tcGo":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = InlineButton;

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _classnames = __webpack_require__("HW6M");

var _classnames2 = _interopRequireDefault(_classnames);

var _InlineButton = __webpack_require__("k3R6");

var _InlineButton2 = _interopRequireDefault(_InlineButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function InlineButton(_ref) {
  var children = _ref.children,
      className = _ref.className,
      onClick = _ref.onClick,
      label = _ref.label,
      showLabel = _ref.showLabel;

  return _react2.default.createElement(
    'button',
    { className: (0, _classnames2.default)(_InlineButton2.default.main, className), onClick: onClick },
    _react2.default.createElement(
      'div',
      { className: _InlineButton2.default.layout },
      _react2.default.createElement(
        'div',
        { className: _InlineButton2.default.icon },
        children
      ),
      _react2.default.createElement(
        'div',
        {
          className: (0, _classnames2.default)(_InlineButton2.default.label, _defineProperty({}, _InlineButton2.default.hiddenLabel, !showLabel))
        },
        label
      )
    )
  );
}

InlineButton.propTypes = {
  children: _propTypes.node,
  className: _propTypes.string,
  onClick: _propTypes.func.isRequired,
  label: _propTypes.string,
  showLabel: _propTypes.bool
};
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(InlineButton, 'InlineButton', '/code/src/components/InlineButton/index.js');
}();

;

/***/ }),

/***/ "tz4E":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"buttonBase":"LocationsListItem-buttonBase--DiooT","shadowBottom":"LocationsListItem-shadowBottom--3lcDC","shadowBottomHover":"LocationsListItem-shadowBottomHover--3PQhR","shadowListItem":"LocationsListItem-shadowListItem--3eR0j","shadowRight":"LocationsListItem-shadowRight--3nLAt","shadowLeft":"LocationsListItem-shadowLeft--3_9pp","shadowAround":"LocationsListItem-shadowAround--3Yb-D","shadowAroundHover":"LocationsListItem-shadowAroundHover--2X54t","shadowButton":"LocationsListItem-shadowButton--19QHI","shadowButtonHover":"LocationsListItem-shadowButtonHover--1w6Q6","main":"LocationsListItem-main--3MRaw","textContainer":"LocationsListItem-textContainer--1dm0_","dataContainer":"LocationsListItem-dataContainer--39sWh","locationIcon":"LocationsListItem-locationIcon--1Qxwq","battery":"LocationsListItem-battery--1QJCM","batteryIcon":"LocationsListItem-batteryIcon--388gl","sparkLine":"LocationsListItem-sparkLine--1ULfc"};

/***/ }),

/***/ "uHvf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"down":"speed-trend-icon-down--ki_P2"};

/***/ }),

/***/ "uNFV":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = HorizontalSection;

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _classnames = __webpack_require__("HW6M");

var _classnames2 = _interopRequireDefault(_classnames);

var _HorizontalSection = __webpack_require__("eq+V");

var _HorizontalSection2 = _interopRequireDefault(_HorizontalSection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function HorizontalSection(_ref) {
  var children = _ref.children,
      center = _ref.center;

  return _react2.default.createElement(
    'div',
    { className: (0, _classnames2.default)(_HorizontalSection2.default.main, _defineProperty({}, _HorizontalSection2.default.center, center)) },
    children
  );
}

HorizontalSection.propTypes = {
  center: _propTypes.bool,
  children: _propTypes.node.isRequired
};
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(HorizontalSection, 'HorizontalSection', '/code/src/components/DataPanel/HorizontalSection/index.js');
}();

;

/***/ }),

/***/ "uqaq":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = TripletItem;

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _bind = __webpack_require__("T2Un");

var _bind2 = _interopRequireDefault(_bind);

var _TripletItem = __webpack_require__("G3SD");

var _TripletItem2 = _interopRequireDefault(_TripletItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var cx = _bind2.default.bind(_TripletItem2.default);

/**
 * Note that order of title and content is reversed by CSS in order to keep
 * markup correct.
 */
function TripletItem(_ref) {
  var _cx;

  var title = _ref.title,
      unitName = _ref.unitName,
      status = _ref.status,
      children = _ref.children,
      className = _ref.className,
      containsDevice = _ref.containsDevice;

  return _react2.default.createElement(
    'div',
    {
      className: cx((_cx = {
        TripletItem: TripletItem
      }, _defineProperty(_cx, className, !!className), _defineProperty(_cx, 'status-' + status, status), _defineProperty(_cx, _TripletItem2.default.containsDevice, containsDevice), _cx))
    },
    _react2.default.createElement(
      'dt',
      { className: _TripletItem2.default.context },
      _react2.default.createElement(
        'span',
        { className: _TripletItem2.default.title },
        title
      ),
      unitName && _react2.default.createElement(
        'span',
        null,
        unitName
      )
    ),
    _react2.default.createElement(
      'dd',
      { className: _TripletItem2.default.smallerText },
      children
    )
  );
}

TripletItem.propTypes = {
  title: _propTypes.string.isRequired,
  unitName: _propTypes.string,
  status: _propTypes.string,
  children: _propTypes.node.isRequired,
  className: _propTypes.string,
  containsDevice: _propTypes.bool
};
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(cx, 'cx', '/code/src/components/DataPanel/TripletItem/index.js');

  __REACT_HOT_LOADER__.register(TripletItem, 'TripletItem', '/code/src/components/DataPanel/TripletItem/index.js');
}();

;

/***/ }),

/***/ "vNMZ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.SegmentGroup = SegmentGroup;

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _reactRedux = __webpack_require__("RH2O");

var _locationShape = __webpack_require__("1itO");

var _locationShape2 = _interopRequireDefault(_locationShape);

var _coord = __webpack_require__("w0mN");

var _coord2 = _interopRequireDefault(_coord);

var _map = __webpack_require__("YByT");

var _routeCreation = __webpack_require__("tEHQ");

var _addObjectPriority = __webpack_require__("E4O7");

var _addObjectPriority2 = _interopRequireDefault(_addObjectPriority);

var _Segment = __webpack_require__("JJgR");

var _Segment2 = _interopRequireDefault(_Segment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var noop = function noop(_) {
  return _;
};

function SegmentGroup(_ref) {
  var segments = _ref.segments,
      selectSegment = _ref.selectSegment,
      deselectSegment = _ref.deselectSegment,
      enterEntity = _ref.enterEntity,
      leaveEntity = _ref.leaveEntity,
      currentHover = _ref.currentHover,
      lastSelectedSegment = _ref.lastSelectedSegment,
      disableInteraction = _ref.disableInteraction;

  // eslint-disable-next-line global-require
  var SortingFeatureGroup = __webpack_require__("x6bV").default;
  var hoveredId = currentHover && currentHover.id;

  var sortedSegmentsWithStateAndPriority = segments.map(function (segment) {
    return (0, _addObjectPriority2.default)(segment, hoveredId);
  }).sort(function (segmentA, segmentB) {
    return segmentA.priority - segmentB.priority;
  });

  return _react2.default.createElement(
    SortingFeatureGroup,
    null,
    sortedSegmentsWithStateAndPriority.map(function (segment) {
      var segmentId = segment.id,
          priority = segment.priority,
          isSelected = segment.isSelected,
          isAvailable = segment.isAvailable;


      var selectHandler = lastSelectedSegment === segmentId ? function () {
        return deselectSegment(segmentId);
      } : isAvailable ? function () {
        return selectSegment(segmentId);
      } : noop;

      return _react2.default.createElement(_Segment2.default, {
        key: 'segment-' + segmentId + (isSelected && '-selected') + (isAvailable && '-available'),
        priority: segment.isSelected ? 15 : priority,
        segment: segment,
        isActive: isSelected || segmentId === hoveredId,
        isSelected: isSelected,
        onSelect: disableInteraction ? noop : selectHandler,
        onEnter: disableInteraction ? noop : function () {
          return enterEntity({
            id: segmentId,
            type: 'segment'
          });
        },
        onLeave: disableInteraction ? noop : function () {
          return leaveEntity({
            id: segmentId,
            type: 'segment'
          });
        }
      });
    })
  );
}

SegmentGroup.propTypes = {
  segments: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    id: _propTypes.string,
    path: (0, _propTypes.arrayOf)(_coord2.default),
    from: _locationShape2.default,
    to: _locationShape2.default
  })).isRequired,
  selectSegment: _propTypes.func.isRequired,
  deselectSegment: _propTypes.func.isRequired,
  enterEntity: _propTypes.func.isRequired,
  leaveEntity: _propTypes.func.isRequired,
  currentHover: (0, _propTypes.shape)({
    id: _propTypes.string.isRequired
  }),
  lastSelectedSegment: _propTypes.string,
  disableInteraction: _propTypes.bool.isRequired
};

var mapStateToProps = function mapStateToProps(_ref2) {
  var map = _ref2.map;
  return {
    currentHover: map.currentHover
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps, _extends({}, _map.operations, _routeCreation.operations))(SegmentGroup);

exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(noop, 'noop', '/code/src/components/Map/CreateRoute/SegmentGroup/index.js');

  __REACT_HOT_LOADER__.register(SegmentGroup, 'SegmentGroup', '/code/src/components/Map/CreateRoute/SegmentGroup/index.js');

  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/code/src/components/Map/CreateRoute/SegmentGroup/index.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/code/src/components/Map/CreateRoute/SegmentGroup/index.js');
}();

;

/***/ }),

/***/ "vRF7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"main":"ExistingSegmentTooltip-main--hoGHb","segment":"ExistingSegmentTooltip-segment--3gVqe","segmentIcon":"ExistingSegmentTooltip-segmentIcon--yNqAG","segmentName":"ExistingSegmentTooltip-segmentName--Y5r8L"};

/***/ }),

/***/ "w0mN":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _twoNumbers = __webpack_require__("5iSJ");

var _twoNumbers2 = _interopRequireDefault(_twoNumbers);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var coord = _twoNumbers2.default; /* Re-use the two numbers check for coordinates. Makes the code more readable. */
var _default = coord;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(coord, 'coord', '/code/src/propTypes/coord.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/code/src/propTypes/coord.js');
}();

;

/***/ }),

/***/ "wNIN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"main":"CreateRoute-main--gJdM9","border":"CreateRoute-border--306r4"};

/***/ }),

/***/ "wQ+0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _trackingDeviceShape = __webpack_require__("1oTp");

var _trackingDeviceShape2 = _interopRequireDefault(_trackingDeviceShape);

var _LocationTooltip = __webpack_require__("RzI6");

var _LocationTooltip2 = _interopRequireDefault(_LocationTooltip);

var _location = __webpack_require__("fwK8");

var _location2 = _interopRequireDefault(_location);

var _locationActive = __webpack_require__("MuZ3");

var _locationActive2 = _interopRequireDefault(_locationActive);

var _locationInactive = __webpack_require__("IcA+");

var _locationInactive2 = _interopRequireDefault(_locationInactive);

var _locationWarning = __webpack_require__("1BE/");

var _locationWarning2 = _interopRequireDefault(_locationWarning);

var _locationActiveWarning = __webpack_require__("f1z1");

var _locationActiveWarning2 = _interopRequireDefault(_locationActiveWarning);

var _locationInactiveWarning = __webpack_require__("WDbj");

var _locationInactiveWarning2 = _interopRequireDefault(_locationInactiveWarning);

var _locationProblem = __webpack_require__("dYRO");

var _locationProblem2 = _interopRequireDefault(_locationProblem);

var _locationActiveProblem = __webpack_require__("Ojwz");

var _locationActiveProblem2 = _interopRequireDefault(_locationActiveProblem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var icons = {
  ok: {
    default: _location2.default,
    active: _locationActive2.default,
    inactive: _locationInactive2.default
  },
  warning: {
    default: _locationWarning2.default,
    active: _locationActiveWarning2.default,
    inactive: _locationInactiveWarning2.default
  },
  disconnected: {
    default: _locationProblem2.default,
    active: _locationActiveProblem2.default,
    inactive: _locationInactiveWarning2.default
  }
};

function getMarkerIcon(statusLabel, isActive, isFaded) {
  if (isActive) {
    return icons[statusLabel].active;
  }

  if (isFaded) {
    return icons[statusLabel].inactive;
  }

  return icons[statusLabel].default;
}

/* eslint-disable global-require */
function LocationMarker(_ref) {
  var trackingDevice = _ref.trackingDevice,
      name = _ref.name,
      position = _ref.position,
      size = _ref.size,
      anchor = _ref.anchor,
      isActive = _ref.isActive,
      isFaded = _ref.isFaded;

  // eslint-disable-next-line global-require
  var _require = __webpack_require__("Zz/N"),
      Marker = _require.Marker;

  // eslint-disable-next-line global-require


  var _require2 = __webpack_require__("nrd6"),
      icon = _require2.icon;

  var markerIcon = getMarkerIcon(trackingDevice.status, isActive, isFaded);

  return _react2.default.createElement(
    Marker,
    {
      position: position,
      icon: icon({
        iconUrl: markerIcon,
        iconSize: size,
        iconAnchor: anchor
      }),
      alt: 'Location: ' + name + ', status: ' + trackingDevice.status,
      keyboard: true,
      riseOnHover: true
    },
    _react2.default.createElement(_LocationTooltip2.default, { trackingDevice: trackingDevice, locationName: name })
  );
}

LocationMarker.propTypes = {
  size: (0, _propTypes.arrayOf)(_propTypes.number),
  anchor: (0, _propTypes.arrayOf)(_propTypes.number),
  trackingDevice: _trackingDeviceShape2.default.isRequired,
  position: (0, _propTypes.arrayOf)(_propTypes.number).isRequired,
  name: _propTypes.string.isRequired,
  isActive: _propTypes.bool,
  isFaded: _propTypes.bool
};

LocationMarker.defaultProps = {
  size: [23, 35], // [x, y]
  anchor: [11.5, 35] // [1/2 of size.x, 100% of size.y]
};

var _default = LocationMarker;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(icons, 'icons', '/code/src/components/Map/CreateRoute/LocationMarkerGroup/LocationMarker/index.js');

  __REACT_HOT_LOADER__.register(getMarkerIcon, 'getMarkerIcon', '/code/src/components/Map/CreateRoute/LocationMarkerGroup/LocationMarker/index.js');

  __REACT_HOT_LOADER__.register(LocationMarker, 'LocationMarker', '/code/src/components/Map/CreateRoute/LocationMarkerGroup/LocationMarker/index.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/code/src/components/Map/CreateRoute/LocationMarkerGroup/LocationMarker/index.js');
}();

;

/***/ }),

/***/ "wQMD":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SVG = function (_React$Component) {
  _inherits(SVG, _React$Component);

  function SVG() {
    _classCallCheck(this, SVG);

    return _possibleConstructorReturn(this, (SVG.__proto__ || Object.getPrototypeOf(SVG)).apply(this, arguments));
  }

  _createClass(SVG, [{
    key: "render",
    value: function render() {
      return _react2.default.createElement(
        "svg",
        _extends({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 49 51" }, this.props),
        _react2.default.createElement(
          "title",
          null,
          "No items found"
        ),
        _react2.default.createElement("circle", { cx: "21", cy: "21", r: "18", fill: "none", strokeWidth: "4", stroke: "currentColor" }),
        _react2.default.createElement("path", { stroke: "currentColor", strokeWidth: "4", d: "M33.5 34.8l13.7 13.6M29.1 12.9L12.9 29.1m0-16.2l16.2 16.2" })
      );
    }
  }]);

  return SVG;
}(_react2.default.Component);

var _default = SVG;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(SVG, "SVG", "/code/src/icons/emptystate-nothing-found.inline.svg");

  __REACT_HOT_LOADER__.register(_default, "default", "/code/src/icons/emptystate-nothing-found.inline.svg");
}();

;

/***/ }),

/***/ "wR0u":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"buttonBase":"EmptyPanelState-buttonBase--nVzTV","shadowBottom":"EmptyPanelState-shadowBottom--1LKtS","shadowBottomHover":"EmptyPanelState-shadowBottomHover--238lu","shadowListItem":"EmptyPanelState-shadowListItem--2nonQ","shadowRight":"EmptyPanelState-shadowRight--2QcOr","shadowLeft":"EmptyPanelState-shadowLeft--3-LZd","shadowAround":"EmptyPanelState-shadowAround--11vVR","shadowAroundHover":"EmptyPanelState-shadowAroundHover--1amZP","shadowButton":"EmptyPanelState-shadowButton--Z_zM6","shadowButtonHover":"EmptyPanelState-shadowButtonHover--3MAbR","EmptyPanelState":"EmptyPanelState-EmptyPanelState--2RGLS","emptyStateIcon":"EmptyPanelState-emptyStateIcon--2HnNr","errorMessage":"EmptyPanelState-errorMessage--3z1u6"};

/***/ }),

/***/ "x6bV":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _reactLeaflet = __webpack_require__("Zz/N");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SortingFeatureGroup = function (_FeatureGroup) {
  _inherits(SortingFeatureGroup, _FeatureGroup);

  function SortingFeatureGroup() {
    _classCallCheck(this, SortingFeatureGroup);

    return _possibleConstructorReturn(this, (SortingFeatureGroup.__proto__ || Object.getPrototypeOf(SortingFeatureGroup)).apply(this, arguments));
  }

  _createClass(SortingFeatureGroup, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      /*
       * Leaflet GeoJSON layers have no concept of z-index. To achieve a similar
       * effect we use a "priority" prop to determine the order in which
       * "bringToFront()" calls are made. This should behave very similarly to z-index.
       */
      this.updateLeafletElement(prevProps, this.props);

      // eslint-disable-next-line no-underscore-dangle
      var layers = this.leafletElement._layers;

      Object.values(layers).sort(function (layerA, layerB) {
        return layerA.options.priority - layerB.options.priority;
      }).forEach(function (layer) {
        layer.bringToFront();
      });
    }
  }]);

  return SortingFeatureGroup;
}(_reactLeaflet.FeatureGroup);

var _default = SortingFeatureGroup;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(SortingFeatureGroup, 'SortingFeatureGroup', '/code/src/components/Map/MapComponents/SortingFeatureGroup/index.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/code/src/components/Map/MapComponents/SortingFeatureGroup/index.js');
}();

;

/***/ }),

/***/ "xHQJ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.enterEntity = enterEntity;
exports.leaveEntity = leaveEntity;
exports.unsetHoverState = unsetHoverState;
exports.setBounds = setBounds;
exports.setAllFeatureBounds = setAllFeatureBounds;
exports.setCenter = setCenter;
exports.closeMapPanel = closeMapPanel;
exports.openMapPanel = openMapPanel;
exports.setViewMode = setViewMode;

var _types = __webpack_require__("+1+X");

var _types2 = _interopRequireDefault(_types);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function enterEntity(_ref) {
  var id = _ref.id,
      type = _ref.type;

  return {
    type: _types2.default.ENTER_ENTITY,
    payload: {
      id: id,
      type: type
    }
  };
}

function leaveEntity(_ref2) {
  var id = _ref2.id,
      type = _ref2.type;

  return {
    type: _types2.default.LEAVE_ENTITY,
    payload: {
      id: id,
      type: type
    }
  };
}

function unsetHoverState() {
  return {
    type: _types2.default.UNSET_HOVER_STATE,
    payload: null
  };
}

function setBounds(bounds) {
  return {
    type: _types2.default.SET_BOUNDS,
    payload: bounds
  };
}

function setAllFeatureBounds(allFeatureBounds) {
  return {
    type: _types2.default.SET_ALL_FEATURE_BOUNDS,
    payload: allFeatureBounds
  };
}

function setCenter(center) {
  return {
    type: _types2.default.SET_CENTER,
    payload: center
  };
}

function closeMapPanel() {
  return {
    type: _types2.default.CLOSE_MAP_PANEL
  };
}

function openMapPanel() {
  return {
    type: _types2.default.OPEN_MAP_PANEL
  };
}

function setViewMode(viewMode) {
  return {
    type: _types2.default.SET_VIEW_MODE,
    payload: viewMode
  };
}
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(enterEntity, 'enterEntity', '/code/src/state/ducks/map/actions.js');

  __REACT_HOT_LOADER__.register(leaveEntity, 'leaveEntity', '/code/src/state/ducks/map/actions.js');

  __REACT_HOT_LOADER__.register(unsetHoverState, 'unsetHoverState', '/code/src/state/ducks/map/actions.js');

  __REACT_HOT_LOADER__.register(setBounds, 'setBounds', '/code/src/state/ducks/map/actions.js');

  __REACT_HOT_LOADER__.register(setAllFeatureBounds, 'setAllFeatureBounds', '/code/src/state/ducks/map/actions.js');

  __REACT_HOT_LOADER__.register(setCenter, 'setCenter', '/code/src/state/ducks/map/actions.js');

  __REACT_HOT_LOADER__.register(closeMapPanel, 'closeMapPanel', '/code/src/state/ducks/map/actions.js');

  __REACT_HOT_LOADER__.register(openMapPanel, 'openMapPanel', '/code/src/state/ducks/map/actions.js');

  __REACT_HOT_LOADER__.register(setViewMode, 'setViewMode', '/code/src/state/ducks/map/actions.js');
}();

;

/***/ }),

/***/ "xM1A":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = filterAvailableLocations;

var _lodash = __webpack_require__("M4fF");

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function filterAvailableLocations(locations, segments, selectedLocations) {
  // If we didn't select a location yet just return all locations
  if (selectedLocations.length === 0) {
    return locations;
  }

  // We only need to loop over segments connected to this location
  var existingSegments = segments.filter(function (segment) {
    return segment.from.id === (0, _lodash.first)(selectedLocations);
  });

  // Filter out all available locations
  if (selectedLocations.length === 1) {
    return locations.reduce(function (acc, curr) {
      // if it is not in the to object of any segment, keep it in the array
      if (!existingSegments.find(function (segment) {
        return segment.to.id === curr.id;
      })) {
        return [].concat(_toConsumableArray(acc), [curr]);
      }
      return acc;
    }, []);
  }

  // If you already selection two locations (in which case this function shouldn't even be called) just return the two selected items
  if (selectedLocations.length === 2) {
    return locations.filter(function (location) {
      return selectedLocations.includes(location.id);
    });
  }
  return locations;
}
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(filterAvailableLocations, 'filterAvailableLocations', '/code/src/helpers/filterAvailableLocations.js');
}();

;

/***/ }),

/***/ "xPfo":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = formatLastUpdate;
function formatLastUpdate(lastUpdate) {
  var lastUpdateDate = new Date(lastUpdate);
  var isToday = new Date(lastUpdate).setHours(0, 0, 0, 0) === new Date().setHours(0, 0, 0, 0);
  var options = isToday ? {
    hour12: false,
    hour: '2-digit',
    minute: '2-digit'
  } : {
    hour12: false,
    hour: '2-digit',
    minute: '2-digit',
    month: 'short',
    day: '2-digit'
  };
  var lastUpdateString = lastUpdateDate.toLocaleString('en-US', options);

  if (isToday) {
    return 'Today, ' + lastUpdateString;
  }
  return lastUpdateString;
}
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(formatLastUpdate, 'formatLastUpdate', '/code/src/helpers/formatLastUpdate.js');
}();

;

/***/ }),

/***/ "xTTB":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _templateObject = _taggedTemplateLiteral(['\n  query Routes {\n    routes {\n      id\n      status\n      from {\n        id\n        name\n      }\n      to {\n        id\n        name\n      }\n      expectedTravelTime\n      speedLastHour\n      liveSpeed\n      travelTimeIndex\n      segments {\n        id\n        status\n        path\n        liveTravelTime\n        expectedTravelTime\n        speedLastHour\n        liveSpeed\n      }\n    }\n  }\n'], ['\n  query Routes {\n    routes {\n      id\n      status\n      from {\n        id\n        name\n      }\n      to {\n        id\n        name\n      }\n      expectedTravelTime\n      speedLastHour\n      liveSpeed\n      travelTimeIndex\n      segments {\n        id\n        status\n        path\n        liveTravelTime\n        expectedTravelTime\n        speedLastHour\n        liveSpeed\n      }\n    }\n  }\n']);

exports.Routes = Routes;

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _reactApollo = __webpack_require__("3zLD");

var _reactRedux = __webpack_require__("RH2O");

var _map = __webpack_require__("YByT");

var _reactRouterRedux = __webpack_require__("jZgO");

var _LoadingIndicator = __webpack_require__("G+3p");

var _LoadingIndicator2 = _interopRequireDefault(_LoadingIndicator);

var _locationShape = __webpack_require__("1itO");

var _locationShape2 = _interopRequireDefault(_locationShape);

var _sortRoutes = __webpack_require__("r6f7");

var _sortRoutes2 = _interopRequireDefault(_sortRoutes);

var _List = __webpack_require__("U2GG");

var _List2 = _interopRequireDefault(_List);

var _ListLabels = __webpack_require__("nRxE");

var _ListLabels2 = _interopRequireDefault(_ListLabels);

var _ListItem = __webpack_require__("m9jy");

var _ListItem2 = _interopRequireDefault(_ListItem);

var _RoutesListItem = __webpack_require__("/x1K");

var _RoutesListItem2 = _interopRequireDefault(_RoutesListItem);

var _Sorting = __webpack_require__("3C90");

var _Sorting2 = _interopRequireDefault(_Sorting);

var _EmptyPanelState = __webpack_require__("li8v");

var _EmptyPanelState2 = _interopRequireDefault(_EmptyPanelState);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var RoutesQuery = (0, _reactApollo.gql)(_templateObject);

function Routes(_ref) {
  var data = _ref.data,
      currentHover = _ref.currentHover,
      selectEntity = _ref.selectEntity,
      enterEntity = _ref.enterEntity,
      leaveEntity = _ref.leaveEntity,
      location = _ref.location,
      historyReplace = _ref.historyReplace;

  if (data.loading) {
    return _react2.default.createElement(_LoadingIndicator2.default, null);
  }

  // We don't have any segments yet
  if (!data.routes || data.routes.length === 0) {
    return _react2.default.createElement(_EmptyPanelState2.default, { panelType: 'route', showLink: true });
  }

  return _react2.default.createElement(
    _Sorting2.default,
    {
      text: 'sort by',
      queryValueKey: 'sort',
      queryOrderKey: 'order',
      options: [{
        label: 'tti',
        queryValue: 'tti',
        initialOrder: 'dsc',
        isDefault: true
      }, { label: 'speed', queryValue: 'speed', initialOrder: 'asc' }],
      location: location,
      historyReplace: historyReplace
    },
    function (_ref2) {
      var sortValue = _ref2.sortValue,
          sortOrder = _ref2.sortOrder;
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_ListLabels2.default, { sortValue: sortValue, location: 'route' }),
        _react2.default.createElement(
          _List2.default,
          null,
          (0, _sortRoutes2.default)(data.routes, sortValue, sortOrder).map(function (route) {
            var id = route.id,
                status = route.status;

            var isActive = currentHover && currentHover.id === id;

            return _react2.default.createElement(
              _ListItem2.default,
              {
                status: status,
                id: id,
                key: id,
                contentType: 'route',
                isActive: isActive,
                onClick: function onClick() {
                  return selectEntity({ id: id, type: 'route' });
                },
                onMouseOver: function onMouseOver() {
                  return enterEntity({ id: id, type: 'route' });
                },
                onMouseOut: function onMouseOut() {
                  return leaveEntity({ id: id, type: 'route' });
                }
              },
              _react2.default.createElement(_RoutesListItem2.default, { route: route, sortValue: sortValue })
            );
          })
        )
      );
    }
  );
}

Routes.propTypes = {
  data: (0, _propTypes.shape)({
    loading: _propTypes.bool.isRequired,
    routes: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
      id: _propTypes.string.required,
      status: _propTypes.string.required,
      segments: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
        id: _propTypes.string
      }))
    }))
  }).isRequired,
  currentHover: (0, _propTypes.shape)({ id: _propTypes.string.isRequired }),
  selectEntity: _propTypes.func.isRequired,
  enterEntity: _propTypes.func.isRequired,
  leaveEntity: _propTypes.func.isRequired,
  location: _locationShape2.default.isRequired,
  historyReplace: _propTypes.func.isRequired
};

var mapStateToProps = function mapStateToProps(_ref3, ownProps) {
  var map = _ref3.map;
  return _extends({
    currentHover: map.currentHover
  }, ownProps);
};

var ConnectedRoutesWithData = (0, _reactApollo.compose)((0, _reactRedux.connect)(mapStateToProps, _extends({}, _map.operations, { historyReplace: _reactRouterRedux.replace })), (0, _reactApollo.graphql)(RoutesQuery, {
  options: function options(_ref4) {
    var params = _ref4.params;
    return {
      variables: {
        id: params.id
      }
    };
  }
}))(Routes);

var _default = ConnectedRoutesWithData;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(RoutesQuery, 'RoutesQuery', '/code/src/components/DataPanel/Overview/Routes/index.js');

  __REACT_HOT_LOADER__.register(Routes, 'Routes', '/code/src/components/DataPanel/Overview/Routes/index.js');

  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/code/src/components/DataPanel/Overview/Routes/index.js');

  __REACT_HOT_LOADER__.register(ConnectedRoutesWithData, 'ConnectedRoutesWithData', '/code/src/components/DataPanel/Overview/Routes/index.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/code/src/components/DataPanel/Overview/Routes/index.js');
}();

;

/***/ }),

/***/ "yVhY":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }
}();

;

/***/ }),

/***/ "yqCZ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = map;

var _types = __webpack_require__("+1+X");

var _types2 = _interopRequireDefault(_types);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * In this reducer we capture the user interactions of the live map. If a certain
 * element is hovered over, the according data should be fetched.
 *
 * In the case of selection the url should change accordingly so that the panel
 * layout can change.
 *
 * Some considerations:
 * - if there a are going to be more types then devices and segments we might want to make a generic entity type.
 * - if all ids for devices and segments can be considered (or made) globally unique, we can simplify the reducer as well.
 */
function map() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    currentHover: null,
    bounds: null,
    allFeatureBounds: null,
    center: null,
    viewMode: 'segments',
    isMapPanelOpen: false
  };
  var action = arguments[1];

  switch (action.type) {
    case _types2.default.ENTER_ENTITY:
      return _extends({}, state, {
        currentHover: {
          id: action.payload.id,
          type: action.payload.type
        }
      });

    case _types2.default.LEAVE_ENTITY:
      /**
       * Only kill a hover if the leave event is about the current item. Not
       * sure if this is required, but would make it more robust possibly.
       */
      if (action.payload.id !== state.currentHover.id) return state;

      return _extends({}, state, {
        currentHover: null
      });

    case _types2.default.UNSET_HOVER_STATE:
      return _extends({}, state, {
        currentHover: null
      });

    case _types2.default.SET_BOUNDS:
      return _extends({}, state, {
        bounds: action.payload
      });

    case _types2.default.SET_ALL_FEATURE_BOUNDS:
      return _extends({}, state, {
        allFeatureBounds: action.payload
      });

    case _types2.default.SET_CENTER:
      return _extends({}, state, {
        center: action.payload
      });

    case _types2.default.SET_VIEW_MODE:
      return _extends({}, state, {
        viewMode: action.payload
      });

    case _types2.default.CLOSE_MAP_PANEL:
      return _extends({}, state, {
        isMapPanelOpen: false
      });

    case _types2.default.OPEN_MAP_PANEL:
      return _extends({}, state, {
        isMapPanelOpen: true
      });

    default:
      return state;
  }
}
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(map, 'map', '/code/src/state/ducks/map/reducers.js');
}();

;

/***/ }),

/***/ "yv7l":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"buttonBase":"SegmentHeader-buttonBase--tdIGY","shadowBottom":"SegmentHeader-shadowBottom--1NU3c","shadowBottomHover":"SegmentHeader-shadowBottomHover--2kEqm","shadowListItem":"SegmentHeader-shadowListItem--2GicF","shadowRight":"SegmentHeader-shadowRight--372en","shadowLeft":"SegmentHeader-shadowLeft--3yWQV","shadowAround":"SegmentHeader-shadowAround--3MQho","shadowAroundHover":"SegmentHeader-shadowAroundHover--1jodd","shadowButton":"SegmentHeader-shadowButton--3LSOx","shadowButtonHover":"SegmentHeader-shadowButtonHover--o3PTQ","main":"SegmentHeader-main--2EKpq SegmentHeader-shadowAround--3MQho","title":"SegmentHeader-title--3OAmV","content":"SegmentHeader-content--2r8Df","text":"SegmentHeader-text--20_g5","textGroup":"SegmentHeader-textGroup--NgywN","label":"SegmentHeader-label--pPzyy","name":"SegmentHeader-name--1uJt3","isLoading":"SegmentHeader-isLoading--3z-Wv","switchButtonWrapper":"SegmentHeader-switchButtonWrapper--kf2Dd","switchButton":"SegmentHeader-switchButton--2YVrT"};

/***/ }),

/***/ "yyqx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var _default = {
  LOGIN_REQUEST: 'auth/LOGIN_REQUEST',
  LOGIN_SUCCESS: 'auth/LOGIN_SUCCESS',
  LOGIN_FAILURE: 'auth/LOGIN_FAILURE',

  LOGOUT_REQUEST: 'auth/LOGOUT_REQUEST'
};
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_default, 'default', '/code/src/state/ducks/auth/types.js');
}();

;

/***/ }),

/***/ "z4D3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"main":"Header-main--32vOh","label":"Header-label--2KtJq","labelContent":"Header-labelContent--2iqPG","item":"Header-item--1ilFC","icon":"Header-icon--3gVjx","hint":"Header-hint--ANNY2","segmentNumber":"Header-segmentNumber--1U1MY","emptyListSegment":"Header-emptyListSegment--C1AGw"};

/***/ }),

/***/ "zHhQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"main":"segment-tooltip-main--38rmH","liveTravelTime":"segment-tooltip-liveTravelTime--19AzG","statusText":"segment-tooltip-statusText--2ABhH","speedNumber":"segment-tooltip-speedNumber--10fJR","trendIcon":"segment-tooltip-trendIcon--3JNvf","segment":"segment-tooltip-segment--2x871","segmentIcon":"segment-tooltip-segmentIcon--2xpHB","segmentName":"segment-tooltip-segmentName--3o9Rj"};

/***/ }),

/***/ "zILm":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = SegmentPath;

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _classnames = __webpack_require__("HW6M");

var _classnames2 = _interopRequireDefault(_classnames);

var _coord = __webpack_require__("w0mN");

var _coord2 = _interopRequireDefault(_coord);

var _SegmentPath = __webpack_require__("ay0U");

var _SegmentPath2 = _interopRequireDefault(_SegmentPath);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function SegmentPath(_ref) {
  var _cx2, _cx3;

  var latLngList = _ref.latLngList,
      isActive = _ref.isActive,
      isSelected = _ref.isSelected,
      isDisconnected = _ref.isDisconnected;

  // eslint-disable-next-line global-require
  var _require = __webpack_require__("Zz/N"),
      Polyline = _require.Polyline;

  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(Polyline, {
      className: (0, _classnames2.default)(_SegmentPath2.default.outline, _defineProperty({}, _SegmentPath2.default.isActive, isActive)),
      positions: latLngList
    }),
    isActive && _react2.default.createElement(Polyline, {
      positions: latLngList,
      className: (0, _classnames2.default)(_SegmentPath2.default.underline, (_cx2 = {}, _defineProperty(_cx2, _SegmentPath2.default.statusSelected, isSelected), _defineProperty(_cx2, _SegmentPath2.default.isDisconnected, isDisconnected), _cx2))
    }),
    _react2.default.createElement(Polyline, {
      positions: latLngList,
      className: (0, _classnames2.default)(_SegmentPath2.default.line, (_cx3 = {}, _defineProperty(_cx3, _SegmentPath2.default.statusSelected, isSelected), _defineProperty(_cx3, _SegmentPath2.default.isDisconnected, isDisconnected), _defineProperty(_cx3, _SegmentPath2.default.isActive, isActive), _cx3))
    })
  );
}

SegmentPath.propTypes = {
  latLngList: (0, _propTypes.arrayOf)(_coord2.default).isRequired,
  isActive: _propTypes.bool.isRequired,
  isSelected: _propTypes.bool,
  isDisconnected: _propTypes.bool.isRequired
};
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(SegmentPath, 'SegmentPath', '/code/src/components/Map/CreateRoute/SegmentPath/index.js');
}();

;

/***/ }),

/***/ "zWno":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = auth;

var _types = __webpack_require__("yyqx");

var _types2 = _interopRequireDefault(_types);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var canUseDom = "client" === 'client';

// The auth reducer. The starting state sets authentication
// based on a token being in local storage. In a real app,
// we would also want a util to check if the token is expired.
function auth() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    isFetching: false,
    isAuthenticated: canUseDom && localStorage && !!localStorage.getItem('id_token')
  };
  var action = arguments[1];

  switch (action.type) {
    case _types2.default.LOGIN_REQUEST:
      return _extends({}, state, {
        isFetching: true,
        isAuthenticated: false
      });
    case _types2.default.LOGIN_SUCCESS:
      return _extends({}, state, {
        isFetching: false,
        isAuthenticated: true,
        errorMessage: ''
      }, action.payload);
    case _types2.default.LOGIN_FAILURE:
      return _extends({}, state, {
        isFetching: false,
        isAuthenticated: false,
        errorMessage: action.payload.message
      });
    case _types2.default.LOGOUT_REQUEST:
      return _extends({}, state, {
        isAuthenticated: false,
        access_token: null
      });
    default:
      return state;
  }
}
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(canUseDom, 'canUseDom', '/code/src/state/ducks/auth/reducers.js');

  __REACT_HOT_LOADER__.register(auth, 'auth', '/code/src/state/ducks/auth/reducers.js');
}();

;

/***/ }),

/***/ "zdjT":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Route;

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _coord = __webpack_require__("w0mN");

var _coord2 = _interopRequireDefault(_coord);

var _locationShape = __webpack_require__("1itO");

var _locationShape2 = _interopRequireDefault(_locationShape);

var _segmentStatus = __webpack_require__("fX1p");

var _segmentStatus2 = _interopRequireDefault(_segmentStatus);

var _RouteSegment = __webpack_require__("BgS3");

var _RouteSegment2 = _interopRequireDefault(_RouteSegment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Route(_ref) {
  var route = _ref.route,
      onEnter = _ref.onEnter,
      onLeave = _ref.onLeave,
      onSelect = _ref.onSelect,
      isSelected = _ref.isSelected,
      isHovered = _ref.isHovered;

  // eslint-disable-next-line global-require
  var PriorityFeatureGroup = __webpack_require__("c9LL").default;

  var routeId = route.id,
      priority = route.priority;

  var isActive = Boolean(isSelected || isHovered);

  return _react2.default.createElement(
    PriorityFeatureGroup,
    {
      priority: priority,
      onMouseover: onEnter,
      onMouseout: onLeave,
      onClick: onSelect
    },
    route.segments.map(function (segment) {
      return _react2.default.createElement(_RouteSegment2.default, {
        key: 'RouteSegment-' + routeId + '-' + segment.id + (isActive ? '-active' : ''),
        segment: segment,
        route: {
          status: route.status,
          from: route.from,
          to: route.to,
          liveTravelTime: route.liveTravelTime,
          distance: route.distance
        },
        isSelected: isSelected,
        isActive: isActive
      });
    })
  );
}

Route.propTypes = {
  route: (0, _propTypes.shape)({
    id: _propTypes.string,
    name: _propTypes.string,
    priority: _propTypes.number,
    segments: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
      id: _propTypes.string,
      from: _locationShape2.default,
      to: _locationShape2.default,
      path: (0, _propTypes.arrayOf)(_coord2.default),
      liveTravelTime: _propTypes.number,
      status: _segmentStatus2.default
    }))
  }).isRequired,
  isSelected: _propTypes.bool,
  isHovered: _propTypes.bool,
  onSelect: _propTypes.func.isRequired,
  onEnter: _propTypes.func.isRequired,
  onLeave: _propTypes.func.isRequired
};
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(Route, 'Route', '/code/src/components/Map/MapComponents/Route/index.js');
}();

;

/***/ })

},[0]);


// WEBPACK FOOTER //
// main-3bdf237ba1faf66a0f75.js